/* ==========================================================================
   WSP Compatibility Engine - finder.js
   Ports the proven v7 finder logic into the theme:
   - Brand/model finder ([data-finder]) in 'navigate' and 'inline' modes
   - Compatibility results dashboard on /pages/compatibility-database
   - "Does this fit?" checker on product pages ([data-fitcheck])
   - Model memory (localStorage) powering the memory bar & cross-sell

   Compatibility is ONLY ever asserted from the backend database
   (getSearch -&gt; searchQuery terms -&gt; proof against product tags/SKUs).
   Products are never labelled compatible from names or partial numbers.
   ========================================================================== */
(function () {
  'use strict';

  var WSP = window.WSP || {};

  /* ---- finder i18n: JS strings can't use Liquid's | t, so we carry a
     per-locale dictionary here and look strings up via T(). English is the
     source (returned as-is when no translation exists). Add a locale by
     adding a block to I18N. ---- */
  var I18N = {
  "sv": {
    "Database updated": "Databasen uppdaterad",
    "Connecting Cables": "Anslutningskablar",
    "Antennas": "Antenner",
    "Rubber Feet": "Gummifötter",
    "Feet": "Fötter",
    "Lamps": "Lampor",
    "Switches": "Brytare",
    "Mats": "Mattor",
    "Weights": "Vikter",
    "Repair Kits": "Reparationssatser",
    "Tools & Calibration": "Verktyg och kalibrering",
    "Connectors": "Kontakter",
    "Cartridges": "Pickuper",
    "Heads": "Tonhuvuden",
    "Fits {m}": "Passar {m}",
    "Yes, I have it": "Ja, jag har den",
    "It snapped / in pieces": "Den gick av / i bitar",
    "No, it's gone": "Nej, den är borta",
    "Add photos of the mechanism": "Lägg till foton på mekanismen",
    "A photo of the belt path / mechanism tells us everything.": "Ett foto på rembanan / mekanismen säger oss allt.",
    "Open the machine and photograph the belt path / mechanism. JPG or PNG, we resize them for you.": "Öppna maskinen och fotografera rembanan / mekanismen. JPG eller PNG, vi ändrar storlek åt dig.",
    "Tell us anything that helps identify it: markings on the unit, the old belt's size if you measured it, what the machine is doing…": "Berätta allt som hjälper oss identifiera den: märkningar på apparaten, gamla remmens mått om du mätt den, vad maskinen gör…",
    "Photos of the mechanism &amp; the old belt": "Foton på mekanismen och den gamla remmen",
    "(this is what confirms the match)": "(det är detta som bekräftar matchningen)",
    "Claim my free belt →": "Hämta min gratisrem →",
    "A member of our team replies · Mon–Fri": "En medlem i vårt team svarar · mån–fre",
    "Grease for gears, levers and slide points, metal or plastic.": "Fett för kugghjul, hävarmar och glidpunkter, metall eller plast.",
    "A light drop on motor bearings and metal pivots after a repair.": "En lätt droppe på motorlager och metalltappar efter en reparation.",
    "Clinging oil for pivots and levers. Stays where you put it.": "Vidhäftande olja för tappar och hävarmar. Stannar där du lägger den.",
    "Cleans tape heads, guides and capstans. Dull sound is often just dirt.": "Rengör tonhuvuden, band­styrningar och capstan. Dovt ljud är ofta bara smuts.",
    "For sticky or slow cassette doors and lid hinges.": "För tröga eller långsamma kassettluckor och gångjärn.",
    "Grease for the metal gears and levers of the mechanism.": "Fett för mekanismens metallkugghjul och hävarmar.",
    "Oil for plastic gears, sliders and pivot points. Safe on plastic.": "Olja för plastkugghjul, skenor och tappar. Säker på plast.",
    "Recommended for your {m} repair": "Rekommenderat för reparation av din {m}",
    "Review cart &amp; checkout": "Granska varukorgen och gå till kassan",
    "Keep shopping": "Fortsätt handla",
    "We could not confirm this exact fit for <strong>{m}</strong>.": "Vi kunde inte bekräfta exakt passform för <strong>{m}</strong>.",
    "or": "eller",
    "Rated 5 out of 5 on Trustpilot": "Betyg 5 av 5 på Trustpilot",
    "No matches for that spelling. Model not in the database yet? We'll identify the right belt for you. <strong>Free, you only pay shipping</strong>.": "Inga träffar för den stavningen. Modellen inte i databasen än? Vi identifierar rätt rem åt dig. <strong>Gratis, du betalar bara frakten</strong>.",
    "Get your free belt →": "Få din gratis rem →",
    "<strong>{b}</strong>. Now type the model number, or pick it from the list.": "<strong>{b}</strong>. Skriv nu modellnumret, eller välj det i listan.",
    "<strong>{m}</strong> has no confirmed record yet. <strong>Send it to the workshop and we'll identify the right belt for you. Free, you only pay shipping.</strong>": "<strong>{m}</strong> har ingen bekräftad post än. <strong>Skicka den till verkstaden så identifierar vi rätt rem åt dig. Gratis, du betalar bara frakten.</strong>",
    "Claim the free belt →": "Hämta din gratis rem →",
    "Or <a href=\"/collections\">browse parts by category</a> / <a href=\"/collections/belts-by-size\">match a belt by its measurements</a>.": "Eller <a href=\"/collections\">bläddra bland delar efter kategori</a> / <a href=\"/collections/belts-by-size\">hitta en rem efter dess mått</a>.",
    "FREE BELT · YOU ONLY PAY SHIPPING": "GRATIS REM · DU BETALAR BARA FRAKTEN",
    "Lay the old belt flat and relaxed next to a ruler. Don’t stretch it. Tell us the <strong>length</strong> and whether the cross-section is <strong>flat, square or round</strong>. A photo like these is perfect.": "Lägg den gamla remmen platt och avslappnad bredvid en linjal. Sträck den inte. Berätta <strong>längden</strong> och om tvärsnittet är <strong>platt, fyrkantigt eller runt</strong>. Ett foto som dessa är perfekt.",
    "flat / folded loop, measure the length": "platt / vikt ögla, mät längden",
    "measure total length laid flat": "mät total längd utlagd platt",
    "flat-sided cross-section": "tvärsnitt med platta sidor",
    "circular cross-section": "runt tvärsnitt",
    "A photo of the belt next to the ruler, and one of the mechanism, tells us everything.": "Ett foto av remmen bredvid linjalen, och ett av mekanismen, säger oss allt.",
    "What’s the machine doing?": "Vad gör maskinen?",
    "Belt loose or snapped, tape won’t move, markings on the unit…": "Slak eller avsliten rem, bandet rör sig inte, märkningar på apparaten…",
    "{n} parts added to your cart": "{n} delar tillagda i varukorgen",
    "{n} part added to your cart": "{n} del tillagd i varukorgen",
    "Option": "Alternativ",
    "View full image": "Visa hela bilden",
    "Try another part type, or send us your model number. We check the database manually and add new references weekly.": "Prova en annan deltyp, eller skicka oss ditt modellnummer. Vi kontrollerar databasen manuellt och lägger till nya referenser varje vecka.",
    "No model-specific wear parts are listed for this model yet. Below are <strong>universal service items</strong> that suit any machine.": "Inga modellspecifika slitdelar är listade för denna modell än. Nedan finns <strong>universella servicedelar</strong> som passar alla maskiner.",
    "We check models manually.": "vi kontrollerar modeller manuellt.",
    "{n} more below in <strong>{c}</strong>": "{n} till nedan i <strong>{c}</strong>",
    "more categories": "fler kategorier",
    "We could not find <strong>{m}</strong> in the database. Check the spelling, or <a href=\"{u}\">ask technical support</a>.": "Vi kunde inte hitta <strong>{m}</strong> i databasen. Kontrollera stavningen, eller <a href=\"{u}\">fråga teknisk support</a>.",
    "We could not find that exact model in the database. Check the spelling, or <a href=\"{u}\">ask technical support</a> before ordering.": "Vi kunde inte hitta exakt den modellen i databasen. Kontrollera stavningen, eller <a href=\"{u}\">fråga teknisk support</a> innan du beställer.",
    "Checking the compatibility database…": "Kontrollerar kompatibilitetsdatabasen…",
    "parts for {m}": "delar för {m}",
    "Also confirmed for {m}:": "Även bekräftad för {m}:",
    "All {n}": "Alla {n}",
    "Universal service items": "Universella servicedelar",
    "See all {n} parts for {m}": "Se alla {n} delar för {m}",
    "See all {n} part for {m}": "Se {n} del för {m}",
    "Confirmed fit, <strong class=\"mono\">{m}</strong> · verified in our database": "Bekräftad passform, <strong class=\"mono\">{m}</strong> · verifierad i vår databas",
    "Checking the compatibility database for <strong class=\"mono\">": "Kontrollerar kompatibilitetsdatabasen för <strong class=\"mono\">",
    "All {n} confirmed parts for this exact model, shown below.": "Alla {n} bekräftade delar för exakt denna modell, visas nedan.",
    "your model": "din modell",
    "This page has the model-specific part. The items below suit any machine and help a fresh repair last: clean the path, lubricate the mechanism, protect the new part.": "Den här sidan har den modellspecifika delen. Delarna nedan passar alla maskiner och hjälper en färsk reparation att hålla: rengör banan, smörj mekanismen, skydda den nya delen.",
    "No other model-specific wear parts are listed for this model. Below are <strong>universal service items</strong> that suit any machine.": "Inga andra modellspecifika slitdelar är listade för denna modell. Nedan finns <strong>universella servicedelar</strong> som passar alla maskiner.",
    "Handy universal add-ons, suit any machine:": "Praktiska universaltillbehör, passar alla maskiner:",
    "See {n} universal service items (suit any machine)": "Se {n} universella servicedelar (passar alla maskiner)",
    "Please choose up to {n} photos. We kept the first {n}.": "Välj upp till {n} foton. Vi behöll de första {n}.",
    "The parts database is taking a moment to respond.": "Delsdatabasen behöver ett ögonblick för att svara.",
    "Connecting to the database. Your search will run automatically in a moment…": "Ansluter till databasen. Din sökning körs automatiskt om ett ögonblick…",
    "Pick your model from the list, or use the free identification below it.": "Välj din modell från listan, eller använd den kostnadsfria identifieringen nedan.",
    "Type the brand and model printed on your unit, e.g. <strong>Sony CDP-M301</strong>, then pick it from the list.": "Skriv märket och modellen som står på din apparat, t.ex. <strong>Sony CDP-M301</strong>, och välj den sedan i listan.",
    "<strong>{n} brands</strong> loaded. Try Sony TC-K611S, Pioneer CT-F850…": "<strong>{n} märken</strong> laddade. Prova Sony TC-K611S, Pioneer CT-F850…",
    "Retrying automatically. Meanwhile you can <a href=\"/search?type=product\">search by keyword</a> or <a href=\"{u}\">ask technical support</a>.": "Försöker igen automatiskt. Under tiden kan du <a href=\"/search?type=product\">söka på nyckelord</a> eller <a href=\"{u}\">fråga teknisk support</a>.",
    "or <a href=\"{u}\">contact technical support</a>.": "eller <a href=\"{u}\">kontakta teknisk support</a>.",
    "Checking the compatibility database for <strong>{m}</strong>…": "Kontrollerar kompatibilitetsdatabasen för <strong>{m}</strong>…",
    "The database is taking longer than usual, retrying for <strong>{m}</strong>…": "Databasen tar längre tid än vanligt, försöker igen för <strong>{m}</strong>…",
    "The database is still loading. Try again in a moment.": "Databasen laddas fortfarande. Försök igen om ett ögonblick.",
    "Universal add-ons, suit any machine": "Universaltillbehör, passar alla maskiner",
    "Find compatible parts": "Hitta kompatibla delar",
    "Enter brand and model…": "Ange märke och modell…",
    "Checking database…": "Kontrollerar databasen…",
    "Add to cart": "Lägg i varukorg",
    "Adding…": "Lägger till…",
    "Added to cart": "Tillagd i varukorgen",
    "Added OK": "Tillagd",
    "Add selected parts to cart": "Lägg valda delar i varukorg",
    "All stock in cart": "Allt lager i varukorgen",
    "Check fit": "Kontrollera passform",
    "In stock": "I lager",
    "Out of stock": "Slut i lager",
    "View details": "Visa detaljer",
    "See all parts for this model": "Se alla delar för denna modell",
    "Confirmed for your model": "Bekräftad för din modell",
    "confirmed parts": "bekräftade delar",
    "Description": "Beskrivning",
    "Price": "Pris",
    "Show only": "Visa endast",
    "Added": "Tillagd",
    "In cart:": "I varukorgen:",
    "Contact technical support": "Kontakta teknisk support",
    "Do you still have the original belt?": "Har du kvar originalremmen?",
    "Flat belt": "Platt drivrem",
    "Last unit left": "Sista enheten kvar",
    "Open the full finder": "Öppna hela sökaren",
    "Round belt": "Rund drivrem",
    "See everything for this model": "Se allt för denna modell",
    "Send message": "Skicka meddelande",
    "Square belt": "Fyrkantig drivrem",
    "Try again": "Försök igen",
    "View cart": "Visa varukorg",
    "We might have": "Vi kan ha",
    "more parts for": "fler delar till",
    "Your name": "Ditt namn",
    "Your email": "Din e-post",
    "Database loading, please wait…": "Databasen laddas, vänligen vänta…",
    "Close": "Stäng",
    "Add": "Lägg till",
    "These are always useful for a repair:": "Dessa är alltid användbara vid en reparation:",
    "Checkout securely": "Betala säkert",
    "Brand, keep typing the model": "Märke, fortsätt skriva modellen",
    "We will find it for you": "Vi hittar den åt dig",
    "before you pay": "innan du betalar",
    "Send your model or a photo": "Skicka din modell eller ett foto",
    "Free specialist support, answered by vintage audio repairers": "Gratis specialistsupport, besvarad av vintage-ljudreparatörer",
    "Taking longer than usual, retrying for": "Tar längre tid än vanligt, försöker igen för",
    "Gears & Mechanical Parts": "Kugghjul och mekaniska delar",
    "Belts & Belt Kits": "Remmar och remsatser",
    "Could not add": "Kunde inte lägga till",
    "No parts selected": "Inga delar valda",
    "Belt measuring tool": "Remmätverktyg",
    "Belts": "Remmar",
    "Belt Kit": "Remsats",
    "Flat Belt": "Platt drivrem",
    "Square Belt": "Fyrkantig drivrem",
    "Round Belt": "Rund drivrem",
    "Pinch Roller": "Tryckrulle",
    "Pinch Rollers & Tires": "Tryckrullar och utbytesgummin för mellanhjul",
    "Idler Tire": "Utbytesgummi för mellanhjul",
    "Gears": "Kugghjul",
    "Mechanical Parts": "Mekaniska delar",
    "Laser Pickups": "Laserspickuper",
    "Cleaning & Maintenance": "Rengöring och underhåll",
    "Motors": "Motorer",
    "Batteries": "Batterier",
    "Gear and mechanism grease": "Fett för kugghjul och mekanism",
    "Precision synthetic oil": "Syntetisk precisionsolja",
    "Precision lubricant": "Precisionssmörjmedel",
    "Rubber cleaner and revitaliser": "Gummirengöring och återfuktare",
    "Head cleaning fluid": "Rengöringsvätska för tonhuvuden",
    "Precision cleaning swabs": "Precisionsrengöringspinnar",
    "Service item": "Servicedel",
    "Grease, metal gears": "Fett, metallkugghjul",
    "Grease, metal & plastic": "Fett, metall & plast",
    "Silicone oil, plastic-safe": "Silikonolja, plastsäker",
    "Synthetic oil": "Syntetolja",
    "Lid & hinge lubricant": "Smörjmedel för lock & gångjärn",
    "Cleaning kit": "Rengöringssats",
    "Unavailable": "Ej tillgänglig",
    "Checking…": "Kontrollerar…",
    "All compatible parts": "Alla kompatibla delar",
    "All parts": "Alla delar",
    "Best matches": "Bästa träffar",
    "Confirmed parts": "Bekräftade delar",
    "Universal fit, suits all models": "Universell passform, passar alla modeller",
    "In stock, ready to ship": "I lager, redo att skickas",
    "Confirmed fit": "Bekräftad passform",
    "model-specific part": "modellspecifik del",
    "model-specific parts": "modellspecifika delar",
    "confirmed part": "bekräftad del",
    "universal service item": "universell servicedel",
    "universal service items": "universella servicedelar",
    "units": "enheter",
    "In stock, ": "I lager, ",
    " units": " enheter",
    "Ask technical support before ordering": "Fråga teknisk support innan du beställer",
    "see confirmed parts for your model": "se bekräftade delar för din modell",
    "(some sizes grouped)": "(vissa storlekar grupperade)",
    "Showing": "Visar",
    "of": "av",
    "parts": "delar",
    "Verified buyer": "Verifierad köpare",
    "Translated from the customer original language": "Översatt från kundens originalspråk",
    "Part no.": "Artikelnr.",
    "Stock": "Lager",
    "Show less": "Visa mindre",
    "Confirmed": "Bekräftad",
    "Checkout": "Till kassan",
    "Claim my free belt": "Hämta min gratis rem",
    "Claim the free belt": "Hämta den gratis remmen",
    "Claim your free belt": "Hämta din gratis rem",
    "Free specialist support": "Gratis specialistsupport",
    "Full details on the product page.": "Fullständiga uppgifter på produktsidan.",
    "Get your free belt": "Få din gratis rem",
    "How to measure your old belt": "Så mäter du din gamla rem",
    "Lay the old belt flat and relaxed next to a ruler": "Lägg den gamla remmen platt och avslappnad bredvid en linjal",
    "Loading description": "Laddar beskrivning",
    "No parts in this category": "Inga delar i denna kategori",
    "Open full page": "Öppna hela sidan",
    "Photos of the mechanism": "Foton av mekanismen",
    "Repairing a different model?": "Reparerar du en annan modell?",
    "Uploading photos…": "Laddar upp foton…",
    "A member of our team replies": "En medlem i vårt team svarar",
    "Ask us about specific parts": "Fråga oss om specifika delar",
    "Send": "Skicka",
    "Enter brand and model, e.g. Sony CDP-M301": "Ange märke och modell, t.ex. Sony CDP-M301",
    "None of these? We will identify the right belt for you. Free, you only pay shipping.": "Ingen av dessa? Vi identifierar rätt rem åt dig. Gratis, du betalar bara frakten.",
    "No belt listed for the": "Ingen rem listad för",
    "yet. We probably stock it.": "än. Vi har den troligen i lager.",
    "This model is in our database, but its belt has not been identified yet. Send a photo of the mechanism and tell us about the old belt. Once we confirm the match,": "Den här modellen finns i vår databas, men dess rem har inte identifierats än. Skicka ett foto av mekanismen och berätta om den gamla remmen. När vi bekräftat matchningen,",
    "the belt is free, you only cover shipping": "är remmen gratis, du står bara för frakten",
    "We have the belt for your": "Vi har remmen till din",
    "Help us confirm it.": "Hjälp oss bekräfta den.",
    "We stock the belt for the": "Vi har remmen i lager till",
    "We check every model by hand, and this one is not linked yet. There is a strong chance we already have the exact belt on the shelf. Confirm it with us and it is yours": "Vi kontrollerar varje modell för hand, och den här är inte kopplad än. Det är stor chans att vi redan har exakt rätt rem på hyllan. Bekräfta den med oss så är den din",
    "free, you only pay shipping": "gratis, du betalar bara frakten",
    "Send your details and a photo or two. We reply Mon-Fri.": "Skicka dina uppgifter och ett foto eller två. Vi svarar mån-fre.",
    "Confirmed fit for": "Bekräftad passform för",
    "in the compatibility database.": "i kompatibilitetsdatabasen.",
    "Markings on the unit, the old belt size if you measured it, what the machine is doing…": "Märkningar på apparaten, den gamla remmens storlek om du mätt den, vad maskinen gör…",
    "Details": "Detaljer",
    "FREE BELT": "GRATIS REM",
    "Send us the model number printed on your unit, or just a photo of the label or mechanism. We confirm the exact part within one working day,": "Skicka oss modellnumret som står på din apparat, eller bara ett foto av etiketten eller mekanismen. Vi bekräftar den exakta delen inom en arbetsdag,",
    "Could not add, try the product page": "Kunde inte lägga till, prova produktsidan",
    "Could not add that option. It may be out of stock.": "Kunde inte lägga till det alternativet. Det kan vara slut i lager.",
    "Could not add the selected parts. Please try again.": "Kunde inte lägga till de valda delarna. Försök igen.",
    "Free belt identification": "Gratis remidentifiering",
    "Fits ": "Passar ",
    "Read full description": "Läs hela beskrivningen",
    "Fuses": "Säkringar",
    "Lighting": "Belysning",
    "Insulators": "Isolatorer",
    "Passives": "Passiva komponenter",
    "Connectors & plugs": "Kontakter och pluggar",
    "Other compatible parts": "Andra kompatibla delar",
    "Head cleaner": "Tonhuvudsrengöring",
    "Cleaning swabs": "Rengöringspinnar",
    "Adhesive oil": "Vidhäftande olja",
    "Semiconductors": "Halvledare",
    "Please choose up to ": "Välj upp till ",
    "Photos uploaded, reference ": "Foton uppladdade, referens ",
    "Photos sent to our support inbox.": "Foton skickade till vår supportinkorg.",
    "Customer selected photos but the upload could not be confirmed. Ask them to reply to the confirmation email with photos.": "Kunden valde foton men uppladdningen kunde inte bekräftas. Be dem svara på bekräftelsemejlet med foton.",
    "Customer selected photos but the upload failed. Ask them to reply to the confirmation email with photos.": "Kunden valde foton men uppladdningen misslyckades. Be dem svara på bekräftelsemejlet med foton.",
    "Customer selected photos but upload is not configured. Ask them to reply to the confirmation email with photos.": "Kunden valde foton men uppladdning är inte konfigurerad. Be dem svara på bekräftelsemejlet med foton.",
    "{n} part selected": "{n} del vald",
    "{n} parts selected": "{n} delar valda",
    "Repairing a <strong class=\"mono\">{m}</strong>? The database is busy right now.": "Reparerar du en <strong class=\"mono\">{m}</strong>? Databasen är upptagen just nu.",
    "CL02-10 Laser Lens Cleaner · 1 ml": "CL02-10 laserlinsrengöring · 1 ml",
    "DAT & Video Head Cleaner · 10 ml": "Rengöring för DAT- och videohuvuden · 10 ml",
    "Mitsubishi C90 · Pack of 2": "Mitsubishi C90 · 2-pack",
    "Maxell UR90 · 90 min": "Maxell UR90 · 90 min",
    "Maxell UR60 · 60 min": "Maxell UR60 · 60 min",
    "Melted Belt Cleaner · 50 ml": "Rengöring för smälta remmar · 50 ml",
    "Tonearm Cueing Damping Oil 300k · 1 ml": "Dämpolja för tonarmslyft 300k · 1 ml",
    "Shell Gadus Grease · 7 ml": "Shell Gadus-fett · 7 ml",
    "Metal Gear & Lever Grease · 10 g": "Fett för metallkugghjul och hävarmar · 10 g",
    "Full Synthetic Oil · 1 ml": "Helsyntetisk olja · 1 ml",
    "Titanium Synthetic Oil · 1 ml": "Syntetolja med titanteknik · 1 ml",
    "Super Adhesive Oil · 1 ml": "Vidhäftande olja · 1 ml"
  },
  "de": {
    "Database updated": "Datenbank aktualisiert",
    "Connecting Cables": "Verbindungskabel",
    "Antennas": "Antennen",
    "Rubber Feet": "Gummifüße",
    "Feet": "Füße",
    "Lamps": "Lampen",
    "Switches": "Schalter",
    "Mats": "Matten",
    "Weights": "Gewichte",
    "Repair Kits": "Reparatursätze",
    "Tools & Calibration": "Werkzeuge & Kalibrierung",
    "Connectors": "Steckverbinder",
    "Cartridges": "Tonabnehmer",
    "Heads": "Tonköpfe",
    "Fits {m}": "Passend für {m}",
    "Yes, I have it": "Ja, ich habe ihn",
    "It snapped / in pieces": "Er ist gerissen / in Stücken",
    "No, it's gone": "Nein, er ist weg",
    "Add photos of the mechanism": "Fotos des Mechanismus hinzufügen",
    "A photo of the belt path / mechanism tells us everything.": "Ein Foto des Riemenverlaufs / Mechanismus sagt uns alles.",
    "Open the machine and photograph the belt path / mechanism. JPG or PNG, we resize them for you.": "Öffnen Sie das Gerät und fotografieren Sie den Riemenverlauf / Mechanismus. JPG oder PNG, wir passen die Größe an.",
    "Tell us anything that helps identify it: markings on the unit, the old belt's size if you measured it, what the machine is doing…": "Nennen Sie uns alles, was bei der Identifikation hilft: Markierungen am Gerät, die Maße des alten Riemens, falls gemessen, was die Maschine macht…",
    "Photos of the mechanism &amp; the old belt": "Fotos des Mechanismus &amp; des alten Riemens",
    "(this is what confirms the match)": "(genau das bestätigt die Übereinstimmung)",
    "Claim my free belt →": "Meinen kostenlosen Riemen anfordern →",
    "A member of our team replies · Mon–Fri": "Ein Mitglied unseres Teams antwortet · Mo–Fr",
    "Grease for gears, levers and slide points, metal or plastic.": "Fett für Zahnräder, Hebel und Gleitpunkte, Metall oder Kunststoff.",
    "A light drop on motor bearings and metal pivots after a repair.": "Ein leichter Tropfen auf Motorlager und Metallzapfen nach einer Reparatur.",
    "Clinging oil for pivots and levers. Stays where you put it.": "Haftendes Öl für Zapfen und Hebel. Bleibt, wo Sie es auftragen.",
    "Cleans tape heads, guides and capstans. Dull sound is often just dirt.": "Reinigt Tonköpfe, Bandführungen und Capstans. Dumpfer Klang ist oft nur Schmutz.",
    "For sticky or slow cassette doors and lid hinges.": "Für klemmende oder langsame Kassettenfächer und Deckelscharniere.",
    "Grease for the metal gears and levers of the mechanism.": "Fett für die Metallzahnräder und Hebel des Mechanismus.",
    "Oil for plastic gears, sliders and pivot points. Safe on plastic.": "Öl für Kunststoffzahnräder, Schieber und Drehpunkte. Kunststoffverträglich.",
    "or": "oder",
    "your model": "Ihr Modell",
    "Find compatible parts": "Kompatible Ersatzteile finden",
    "Add to cart": "In den Warenkorb",
    "Add selected parts to cart": "Ausgewählte Ersatzteile in den Warenkorb",
    "In stock": "Auf Lager",
    "Out of stock": "Nicht auf Lager",
    "View details": "Details ansehen",
    "See all parts for this model": "Alle Ersatzteile für dieses Modell ansehen",
    "confirmed parts": "bestätigte Ersatzteile",
    "In stock, ": "Auf Lager, ",
    "Description": "Beschreibung",
    "Price": "Preis",
    "Contact technical support": "Technischen Support kontaktieren",
    "Flat belt": "Flachriemen",
    "Last unit left": "Letztes Stück",
    "Round belt": "Rundriemen",
    "Send message": "Nachricht senden",
    "Square belt": "Vierkantriemen",
    "View cart": "Warenkorb ansehen",
    "Your name": "Ihr Name",
    "Your email": "Ihre E-Mail",
    "Add": "Hinzufügen",
    "Checkout securely": "Sicher zur Kasse",
    "before you pay": "bevor Sie zahlen",
    "Send your model or a photo": "Senden Sie Ihr Modell oder ein Foto",
    "No parts selected": "Keine Ersatzteile ausgewählt",
    "Belts": "Riemen",
    "Gears": "Zahnräder",
    "Recommended for your {m} repair": "Empfohlen für Ihre {m}-Reparatur",
    "Review cart &amp; checkout": "Warenkorb prüfen &amp; zur Kasse",
    "Keep shopping": "Weiter einkaufen",
    "We could not confirm this exact fit for <strong>{m}</strong>.": "Diese genaue Passform für <strong>{m}</strong> konnten wir nicht bestätigen.",
    "Rated 5 out of 5 on Trustpilot": "Mit 5 von 5 auf Trustpilot bewertet",
    "No matches for that spelling. Model not in the database yet? We'll identify the right belt for you. <strong>Free, you only pay shipping</strong>.": "Keine Treffer für diese Schreibweise. Modell noch nicht in der Datenbank? Wir identifizieren den richtigen Riemen für Sie. <strong>Kostenlos, Sie zahlen nur den Versand</strong>.",
    "Get your free belt →": "Holen Sie sich Ihren kostenlosen Riemen →",
    "<strong>{b}</strong>. Now type the model number, or pick it from the list.": "<strong>{b}</strong>. Geben Sie jetzt die Modellnummer ein oder wählen Sie sie aus der Liste.",
    "<strong>{m}</strong> has no confirmed record yet. <strong>Send it to the workshop and we'll identify the right belt for you. Free, you only pay shipping.</strong>": "<strong>{m}</strong> hat noch keinen bestätigten Eintrag. <strong>Senden Sie es an die Werkstatt, und wir identifizieren den richtigen Riemen für Sie. Kostenlos, Sie zahlen nur den Versand.</strong>",
    "Claim the free belt →": "Den kostenlosen Riemen anfordern →",
    "Or <a href=\"/collections\">browse parts by category</a> / <a href=\"/collections/belts-by-size\">match a belt by its measurements</a>.": "Oder <a href=\"/collections\">Ersatzteile nach Kategorie durchstöbern</a> / <a href=\"/collections/belts-by-size\">einen Riemen anhand seiner Maße zuordnen</a>.",
    "FREE BELT · YOU ONLY PAY SHIPPING": "KOSTENLOSER RIEMEN · SIE ZAHLEN NUR DEN VERSAND",
    "Lay the old belt flat and relaxed next to a ruler. Don’t stretch it. Tell us the <strong>length</strong> and whether the cross-section is <strong>flat, square or round</strong>. A photo like these is perfect.": "Legen Sie den alten Riemen flach und entspannt neben ein Lineal. Nicht dehnen. Nennen Sie uns die <strong>Länge</strong> und ob der Querschnitt <strong>flach, vierkantig oder rund</strong> ist. Ein Foto wie diese ist perfekt.",
    "flat / folded loop, measure the length": "flache / gefaltete Schlaufe, Länge messen",
    "measure total length laid flat": "Gesamtlänge flach liegend messen",
    "flat-sided cross-section": "flacher Querschnitt",
    "circular cross-section": "runder Querschnitt",
    "A photo of the belt next to the ruler, and one of the mechanism, tells us everything.": "Ein Foto des Riemens neben dem Lineal und eines des Mechanismus sagt uns alles.",
    "What’s the machine doing?": "Was macht die Maschine?",
    "Belt loose or snapped, tape won’t move, markings on the unit…": "Riemen lose oder gerissen, Band bewegt sich nicht, Markierungen am Gerät…",
    "{n} parts added to your cart": "{n} Ersatzteile in den Warenkorb gelegt",
    "{n} part added to your cart": "{n} Ersatzteil in den Warenkorb gelegt",
    "Option": "Option",
    "View full image": "Bild in voller Größe ansehen",
    "Try another part type, or send us your model number. We check the database manually and add new references weekly.": "Versuchen Sie einen anderen Ersatzteiltyp oder senden Sie uns Ihre Modellnummer. Wir prüfen die Datenbank manuell und fügen wöchentlich neue Referenzen hinzu.",
    "No model-specific wear parts are listed for this model yet. Below are <strong>universal service items</strong> that suit any machine.": "Für dieses Modell sind noch keine modellspezifischen Verschleißteile aufgeführt. Unten stehen <strong>universelle Serviceartikel</strong>, die zu jedem Gerät passen.",
    "We check models manually.": "Wir prüfen Modelle manuell.",
    "{n} more below in <strong>{c}</strong>": "{n} weitere unten in <strong>{c}</strong>",
    "more categories": "weitere Kategorien",
    "We could not find <strong>{m}</strong> in the database. Check the spelling, or <a href=\"{u}\">ask technical support</a>.": "Wir konnten <strong>{m}</strong> nicht in der Datenbank finden. Prüfen Sie die Schreibweise oder <a href=\"{u}\">fragen Sie den technischen Support</a>.",
    "We could not find that exact model in the database. Check the spelling, or <a href=\"{u}\">ask technical support</a> before ordering.": "Wir konnten dieses genaue Modell nicht in der Datenbank finden. Prüfen Sie die Schreibweise oder <a href=\"{u}\">fragen Sie den technischen Support</a>, bevor Sie bestellen.",
    "Checking the compatibility database…": "Kompatibilitätsdatenbank wird geprüft…",
    "parts for {m}": "Ersatzteile für {m}",
    "Also confirmed for {m}:": "Ebenfalls bestätigt für {m}:",
    "All {n}": "Alle {n}",
    "Universal service items": "Universelle Serviceartikel",
    "See all {n} parts for {m}": "Alle {n} Ersatzteile für {m} ansehen",
    "See all {n} part for {m}": "{n} Ersatzteil für {m} ansehen",
    "Confirmed fit, <strong class=\"mono\">{m}</strong> · verified in our database": "Bestätigte Passform, <strong class=\"mono\">{m}</strong> · in unserer Datenbank geprüft",
    "Checking the compatibility database for <strong class=\"mono\">": "Kompatibilitätsdatenbank wird geprüft für <strong class=\"mono\">",
    "All {n} confirmed parts for this exact model, shown below.": "Alle {n} bestätigten Ersatzteile für genau dieses Modell, unten aufgeführt.",
    "This page has the model-specific part. The items below suit any machine and help a fresh repair last: clean the path, lubricate the mechanism, protect the new part.": "Diese Seite zeigt das modellspezifische Ersatzteil. Die Artikel unten passen zu jedem Gerät und lassen eine frische Reparatur länger halten: Bandweg reinigen, Mechanismus schmieren, das neue Teil schützen.",
    "No other model-specific wear parts are listed for this model. Below are <strong>universal service items</strong> that suit any machine.": "Für dieses Modell sind keine weiteren modellspezifischen Verschleißteile aufgeführt. Unten stehen <strong>universelle Serviceartikel</strong>, die zu jedem Gerät passen.",
    "Handy universal add-ons, suit any machine:": "Praktische universelle Ergänzungen, passen zu jedem Gerät:",
    "See {n} universal service items (suit any machine)": "{n} universelle Serviceartikel ansehen (passen zu jedem Gerät)",
    "Please choose up to {n} photos. We kept the first {n}.": "Bitte wählen Sie bis zu {n} Fotos. Wir haben die ersten {n} behalten.",
    "The parts database is taking a moment to respond.": "Die Ersatzteildatenbank braucht einen Moment, um zu antworten.",
    "Connecting to the database. Your search will run automatically in a moment…": "Verbindung zur Datenbank wird hergestellt. Ihre Suche startet gleich automatisch…",
    "Pick your model from the list, or use the free identification below it.": "Wählen Sie Ihr Modell aus der Liste oder nutzen Sie die kostenlose Identifikation darunter.",
    "Type the brand and model printed on your unit, e.g. <strong>Sony CDP-M301</strong>, then pick it from the list.": "Geben Sie Marke und Modell ein, die auf Ihrem Gerät stehen, z. B. <strong>Sony CDP-M301</strong>, und wählen Sie es dann aus der Liste.",
    "<strong>{n} brands</strong> loaded. Try Sony TC-K611S, Pioneer CT-F850…": "<strong>{n} Marken</strong> geladen. Versuchen Sie Sony TC-K611S, Pioneer CT-F850…",
    "Retrying automatically. Meanwhile you can <a href=\"/search?type=product\">search by keyword</a> or <a href=\"{u}\">ask technical support</a>.": "Automatischer neuer Versuch. In der Zwischenzeit können Sie <a href=\"/search?type=product\">nach Stichwort suchen</a> oder <a href=\"{u}\">den technischen Support fragen</a>.",
    "or <a href=\"{u}\">contact technical support</a>.": "oder <a href=\"{u}\">kontaktieren Sie den technischen Support</a>.",
    "Checking the compatibility database for <strong>{m}</strong>…": "Kompatibilitätsdatenbank wird geprüft für <strong>{m}</strong>…",
    "The database is taking longer than usual, retrying for <strong>{m}</strong>…": "Die Datenbank braucht länger als üblich, neuer Versuch für <strong>{m}</strong>…",
    "The database is still loading. Try again in a moment.": "Die Datenbank lädt noch. Versuchen Sie es gleich erneut.",
    "Universal add-ons, suit any machine": "Universelle Ergänzungen, passen zu jedem Gerät",
    "Enter brand and model…": "Marke und Modell eingeben…",
    "Checking database…": "Datenbank wird geprüft…",
    "Checking…": "Wird geprüft…",
    "Adding…": "Wird hinzugefügt…",
    "Added to cart": "In den Warenkorb gelegt",
    "Added OK": "Hinzugefügt",
    "All stock in cart": "Gesamter Bestand im Warenkorb",
    "All compatible parts": "Alle kompatiblen Ersatzteile",
    "All parts": "Alle Ersatzteile",
    "Best matches": "Beste Treffer",
    "Confirmed parts": "Bestätigte Ersatzteile",
    "Check fit": "Passform prüfen",
    "Universal fit, suits all models": "Universelle Passform, passt zu allen Modellen",
    "In stock, ready to ship": "Auf Lager, versandbereit",
    "Confirmed fit": "Bestätigte Passform",
    "Confirmed for your model": "Bestätigt für Ihr Modell",
    "model-specific part": "modellspezifisches Ersatzteil",
    "model-specific parts": "modellspezifische Ersatzteile",
    "confirmed part": "bestätigtes Ersatzteil",
    "universal service item": "universeller Serviceartikel",
    "universal service items": "universelle Serviceartikel",
    "units": "Stück",
    " units": " Stück",
    "Ask technical support before ordering": "Fragen Sie den technischen Support vor der Bestellung",
    "see confirmed parts for your model": "bestätigte Ersatzteile für Ihr Modell ansehen",
    "(some sizes grouped)": "(einige Größen zusammengefasst)",
    "Showing": "Angezeigt:",
    "of": "von",
    "parts": "Ersatzteile",
    "Verified buyer": "Verifizierter Käufer",
    "Translated from the customer original language": "Übersetzt aus der Originalsprache des Kunden",
    "Part no.": "Teilenr.",
    "Stock": "Bestand",
    "Show less": "Weniger anzeigen",
    "Confirmed": "Bestätigt",
    "Show only": "Nur anzeigen:",
    "Added": "Hinzugefügt",
    "In cart:": "Im Warenkorb:",
    "Checkout": "Zur Kasse",
    "Claim my free belt": "Meinen kostenlosen Riemen anfordern",
    "Claim the free belt": "Den kostenlosen Riemen anfordern",
    "Claim your free belt": "Ihren kostenlosen Riemen anfordern",
    "Do you still have the original belt?": "Haben Sie den Originalriemen noch?",
    "Free specialist support": "Kostenloser Fachsupport",
    "Full details on the product page.": "Alle Details auf der Produktseite.",
    "Get your free belt": "Holen Sie sich Ihren kostenlosen Riemen",
    "How to measure your old belt": "So messen Sie Ihren alten Riemen",
    "Lay the old belt flat and relaxed next to a ruler": "Legen Sie den alten Riemen flach und entspannt neben ein Lineal",
    "Loading description": "Beschreibung wird geladen",
    "No parts in this category": "Keine Ersatzteile in dieser Kategorie",
    "Open full page": "Ganze Seite öffnen",
    "Open the full finder": "Den vollständigen Finder öffnen",
    "Photos of the mechanism": "Fotos des Mechanismus",
    "Repairing a different model?": "Reparieren Sie ein anderes Modell?",
    "See everything for this model": "Alles für dieses Modell ansehen",
    "Try again": "Erneut versuchen",
    "Uploading photos…": "Fotos werden hochgeladen…",
    "A member of our team replies": "Ein Mitglied unseres Teams antwortet",
    "Ask us about specific parts": "Fragen Sie uns nach bestimmten Ersatzteilen",
    "Send": "Senden",
    "We might have": "Wir haben möglicherweise",
    "more parts for": "weitere Ersatzteile für",
    "Enter brand and model, e.g. Sony CDP-M301": "Marke und Modell eingeben, z. B. Sony CDP-M301",
    "None of these? We will identify the right belt for you. Free, you only pay shipping.": "Keiner davon? Wir identifizieren den richtigen Riemen für Sie. Kostenlos, Sie zahlen nur den Versand.",
    "No belt listed for the": "Kein Riemen aufgeführt für den",
    "yet. We probably stock it.": "bisher. Wahrscheinlich haben wir ihn auf Lager.",
    "This model is in our database, but its belt has not been identified yet. Send a photo of the mechanism and tell us about the old belt. Once we confirm the match,": "Dieses Modell ist in unserer Datenbank, aber sein Riemen wurde noch nicht identifiziert. Senden Sie ein Foto des Mechanismus und erzählen Sie uns vom alten Riemen. Sobald wir die Übereinstimmung bestätigen,",
    "the belt is free, you only cover shipping": "ist der Riemen kostenlos, Sie übernehmen nur den Versand",
    "We have the belt for your": "Wir haben den Riemen für Ihren",
    "Help us confirm it.": "Helfen Sie uns, ihn zu bestätigen.",
    "We stock the belt for the": "Wir führen den Riemen für den",
    "We check every model by hand, and this one is not linked yet. There is a strong chance we already have the exact belt on the shelf. Confirm it with us and it is yours": "Wir prüfen jedes Modell von Hand, und dieses ist noch nicht verknüpft. Die Chance ist groß, dass wir den exakten Riemen bereits im Regal haben. Bestätigen Sie ihn mit uns, und er gehört Ihnen",
    "free, you only pay shipping": "kostenlos, Sie zahlen nur den Versand",
    "Send your details and a photo or two. We reply Mon-Fri.": "Senden Sie Ihre Angaben und ein bis zwei Fotos. Wir antworten Mo-Fr.",
    "Confirmed fit for": "Bestätigte Passform für",
    "in the compatibility database.": "in der Kompatibilitätsdatenbank.",
    "Markings on the unit, the old belt size if you measured it, what the machine is doing…": "Markierungen am Gerät, die Maße des alten Riemens, falls gemessen, was die Maschine macht…",
    "Details": "Details",
    "FREE BELT": "KOSTENLOSER RIEMEN",
    "Database loading, please wait…": "Datenbank lädt, bitte warten…",
    "Close": "Schließen",
    "These are always useful for a repair:": "Diese sind bei einer Reparatur immer nützlich:",
    "Brand, keep typing the model": "Marke, tippen Sie das Modell weiter",
    "We will find it for you": "Wir finden es für Sie",
    "Send us the model number printed on your unit, or just a photo of the label or mechanism. We confirm the exact part within one working day,": "Senden Sie uns die auf Ihrem Gerät aufgedruckte Modellnummer oder einfach ein Foto des Typenschilds oder Mechanismus. Wir bestätigen das genaue Ersatzteil innerhalb eines Werktags,",
    "Free specialist support, answered by vintage audio repairers": "Kostenloser Fachsupport, beantwortet von Reparaturprofis für klassische Audiogeräte",
    "Taking longer than usual, retrying for": "Dauert länger als üblich, neuer Versuch für",
    "Gears & Mechanical Parts": "Zahnräder & mechanische Teile",
    "Belts & Belt Kits": "Riemen & Riemensätze",
    "Could not add": "Konnte nicht hinzugefügt werden",
    "Could not add, try the product page": "Konnte nicht hinzugefügt werden, versuchen Sie die Produktseite",
    "Could not add that option. It may be out of stock.": "Diese Option konnte nicht hinzugefügt werden. Möglicherweise ist sie nicht auf Lager.",
    "Could not add the selected parts. Please try again.": "Die ausgewählten Ersatzteile konnten nicht hinzugefügt werden. Bitte versuchen Sie es erneut.",
    "Free belt identification": "Kostenlose Riemenidentifikation",
    "Fits ": "Passend für ",
    "Read full description": "Vollständige Beschreibung lesen",
    "Belt measuring tool": "Riemen-Messwerkzeug",
    "Belt Kit": "Riemensatz",
    "Flat Belt": "Flachriemen",
    "Square Belt": "Vierkantriemen",
    "Round Belt": "Rundriemen",
    "Pinch Roller": "Andruckrolle",
    "Pinch Rollers & Tires": "Andruckrollen & Zwischenradgummis",
    "Idler Tire": "Zwischenradgummi",
    "Mechanical Parts": "Mechanische Teile",
    "Laser Pickups": "Laserabtasteinheiten",
    "Cleaning & Maintenance": "Reinigung & Wartung",
    "Motors": "Motoren",
    "Batteries": "Batterien",
    "Fuses": "Sicherungen",
    "Lighting": "Beleuchtung",
    "Insulators": "Isolatoren",
    "Passives": "Passive Bauteile",
    "Connectors & plugs": "Steckverbinder & Stecker",
    "Other compatible parts": "Weitere kompatible Ersatzteile",
    "Gear and mechanism grease": "Zahnrad- und Mechanismusfett",
    "Precision synthetic oil": "Synthetisches Präzisionsöl",
    "Precision lubricant": "Präzisionsschmiermittel",
    "Rubber cleaner and revitaliser": "Gummireiniger und -auffrischer",
    "Head cleaner": "Tonkopfreiniger",
    "Head cleaning fluid": "Tonkopf-Reinigungsflüssigkeit",
    "Cleaning swabs": "Reinigungsstäbchen",
    "Precision cleaning swabs": "Präzisions-Reinigungsstäbchen",
    "Adhesive oil": "Haftöl",
    "Service item": "Serviceartikel",
    "Grease, metal gears": "Fett, Metallzahnräder",
    "Grease, metal & plastic": "Fett, Metall & Kunststoff",
    "Silicone oil, plastic-safe": "Silikonöl, kunststoffsicher",
    "Synthetic oil": "Synthetiköl",
    "Lid & hinge lubricant": "Deckel- & Scharnierschmiermittel",
    "Cleaning kit": "Reinigungsset",
    "Unavailable": "Nicht verfügbar",
    "Semiconductors": "Halbleiter",
    "Please choose up to ": "Bitte wählen Sie bis zu ",
    "Photos uploaded, reference ": "Fotos hochgeladen, Referenz ",
    "Photos sent to our support inbox.": "Fotos an unser Support-Postfach gesendet.",
    "Customer selected photos but the upload could not be confirmed. Ask them to reply to the confirmation email with photos.": "Der Kunde hat Fotos ausgewählt, aber der Upload konnte nicht bestätigt werden. Bitten Sie ihn, mit Fotos auf die Bestätigungs-E-Mail zu antworten.",
    "Customer selected photos but the upload failed. Ask them to reply to the confirmation email with photos.": "Der Kunde hat Fotos ausgewählt, aber der Upload ist fehlgeschlagen. Bitten Sie ihn, mit Fotos auf die Bestätigungs-E-Mail zu antworten.",
    "Customer selected photos but upload is not configured. Ask them to reply to the confirmation email with photos.": "Der Kunde hat Fotos ausgewählt, aber der Upload ist nicht konfiguriert. Bitten Sie ihn, mit Fotos auf die Bestätigungs-E-Mail zu antworten.",
    "{n} part selected": "{n} Teil ausgewählt",
    "{n} parts selected": "{n} Teile ausgewählt",
    "Repairing a <strong class=\"mono\">{m}</strong>? The database is busy right now.": "Reparieren Sie einen <strong class=\"mono\">{m}</strong>? Die Datenbank ist momentan ausgelastet.",
    "CL02-10 Laser Lens Cleaner · 1 ml": "CL02-10 Laserlinsenreiniger · 1 ml",
    "DAT & Video Head Cleaner · 10 ml": "DAT- und Videokopfreiniger · 10 ml",
    "Mitsubishi C90 · Pack of 2": "Mitsubishi C90 · 2er-Pack",
    "Maxell UR90 · 90 min": "Maxell UR90 · 90 Min.",
    "Maxell UR60 · 60 min": "Maxell UR60 · 60 Min.",
    "Melted Belt Cleaner · 50 ml": "Reiniger für geschmolzene Riemen · 50 ml",
    "Tonearm Cueing Damping Oil 300k · 1 ml": "Dämpfungsöl für Tonarmlift 300k · 1 ml",
    "Shell Gadus Grease · 7 ml": "Shell Gadus Fett · 7 ml",
    "Metal Gear & Lever Grease · 10 g": "Fett für Metallzahnräder und Hebel · 10 g",
    "Full Synthetic Oil · 1 ml": "Vollsynthetisches Öl · 1 ml",
    "Titanium Synthetic Oil · 1 ml": "Synthetiköl mit Titantechnologie · 1 ml",
    "Super Adhesive Oil · 1 ml": "Haftöl · 1 ml"
  },
  "it": {
    "Database updated": "Database aggiornato",
    "Connecting Cables": "Cavi di collegamento",
    "Antennas": "Antenne",
    "Rubber Feet": "Piedini in gomma",
    "Feet": "Piedini",
    "Lamps": "Lampade",
    "Switches": "Interruttori",
    "Mats": "Tappetini",
    "Weights": "Contrappesi",
    "Repair Kits": "Kit di riparazione",
    "Tools & Calibration": "Attrezzi e calibrazione",
    "Connectors": "Connettori",
    "Cartridges": "Testine fono",
    "Heads": "Testine",
    "Fits {m}": "Compatibile con {m}",
    "Yes, I have it": "Sì, ce l'ho",
    "It snapped / in pieces": "Si è spezzata / in pezzi",
    "No, it's gone": "No, non c'è più",
    "Add photos of the mechanism": "Aggiungi foto del meccanismo",
    "A photo of the belt path / mechanism tells us everything.": "Una foto del percorso della cinghia / del meccanismo ci dice tutto.",
    "Open the machine and photograph the belt path / mechanism. JPG or PNG, we resize them for you.": "Apri l'apparecchio e fotografa il percorso della cinghia / il meccanismo. JPG o PNG, li ridimensioniamo noi.",
    "Tell us anything that helps identify it: markings on the unit, the old belt's size if you measured it, what the machine is doing…": "Dicci tutto ciò che aiuta a identificarla: marcature sull'apparecchio, la misura della vecchia cinghia se l'hai misurata, cosa fa la macchina…",
    "Photos of the mechanism &amp; the old belt": "Foto del meccanismo e della vecchia cinghia",
    "(this is what confirms the match)": "(è questo che conferma l'abbinamento)",
    "Claim my free belt →": "Richiedi la mia cinghia gratuita →",
    "A member of our team replies · Mon–Fri": "Risponde un membro del nostro team · lun–ven",
    "Grease for gears, levers and slide points, metal or plastic.": "Grasso per ingranaggi, leve e punti di scorrimento, metallo o plastica.",
    "A light drop on motor bearings and metal pivots after a repair.": "Una goccia leggera sui cuscinetti del motore e sui perni metallici dopo una riparazione.",
    "Clinging oil for pivots and levers. Stays where you put it.": "Olio adesivo per perni e leve. Resta dove lo metti.",
    "Cleans tape heads, guides and capstans. Dull sound is often just dirt.": "Pulisce testine, guide e capstan. Il suono spento spesso è solo sporco.",
    "For sticky or slow cassette doors and lid hinges.": "Per sportelli cassette e cerniere lenti o che si incastrano.",
    "Grease for the metal gears and levers of the mechanism.": "Grasso per gli ingranaggi e le leve in metallo del meccanismo.",
    "Oil for plastic gears, sliders and pivot points. Safe on plastic.": "Olio per ingranaggi in plastica, slitte e perni. Sicuro sulla plastica.",
    "or": "oppure",
    "your model": "il tuo modello",
    "Find compatible parts": "Trova ricambi compatibili",
    "Add to cart": "Aggiungi al carrello",
    "Add selected parts to cart": "Aggiungi i ricambi selezionati al carrello",
    "In stock": "Disponibile",
    "Out of stock": "Esaurito",
    "View details": "Vedi i dettagli",
    "See all parts for this model": "Vedi tutti i ricambi per questo modello",
    "confirmed parts": "ricambi confermati",
    "In stock, ": "Disponibile,",
    "Description": "Descrizione",
    "Price": "Prezzo",
    "Contact technical support": "Contatta l'assistenza tecnica",
    "Flat belt": "Cinghia piatta",
    "Last unit left": "Ultimo pezzo rimasto",
    "Round belt": "Cinghia tonda",
    "Send message": "Invia messaggio",
    "Square belt": "Cinghia quadrata",
    "View cart": "Vedi il carrello",
    "Your name": "Il tuo nome",
    "Your email": "La tua email",
    "Add": "Aggiungi",
    "Checkout securely": "Vai al checkout sicuro",
    "before you pay": "prima che tu paghi",
    "Send your model or a photo": "Invia il tuo modello o una foto",
    "No parts selected": "Nessun ricambio selezionato",
    "Belts": "Cinghie",
    "Gears": "Ingranaggi",
    "Recommended for your {m} repair": "Consigliati per la riparazione del tuo {m}",
    "Review cart &amp; checkout": "Controlla il carrello e vai al checkout",
    "Keep shopping": "Continua lo shopping",
    "We could not confirm this exact fit for <strong>{m}</strong>.": "Non abbiamo potuto confermare questa compatibilità esatta per <strong>{m}</strong>.",
    "Rated 5 out of 5 on Trustpilot": "Valutato 5 su 5 su Trustpilot",
    "No matches for that spelling. Model not in the database yet? We'll identify the right belt for you. <strong>Free, you only pay shipping</strong>.": "Nessuna corrispondenza per quella grafia. Il modello non è ancora nel database? Identificheremo noi la cinghia giusta per te. <strong>Gratis, paghi solo la spedizione</strong>.",
    "Get your free belt →": "Ricevi la tua cinghia gratuita →",
    "<strong>{b}</strong>. Now type the model number, or pick it from the list.": "<strong>{b}</strong>. Ora digita il numero del modello, oppure sceglilo dall'elenco.",
    "<strong>{m}</strong> has no confirmed record yet. <strong>Send it to the workshop and we'll identify the right belt for you. Free, you only pay shipping.</strong>": "<strong>{m}</strong> non ha ancora un record confermato. <strong>Invialo al laboratorio e identificheremo noi la cinghia giusta per te. Gratis, paghi solo la spedizione.</strong>",
    "Claim the free belt →": "Richiedi la cinghia gratuita →",
    "Or <a href=\"/collections\">browse parts by category</a> / <a href=\"/collections/belts-by-size\">match a belt by its measurements</a>.": "Oppure <a href=\"/collections\">sfoglia i ricambi per categoria</a> / <a href=\"/collections/belts-by-size\">trova una cinghia dalle sue misure</a>.",
    "FREE BELT · YOU ONLY PAY SHIPPING": "CINGHIA GRATUITA · PAGHI SOLO LA SPEDIZIONE",
    "Lay the old belt flat and relaxed next to a ruler. Don’t stretch it. Tell us the <strong>length</strong> and whether the cross-section is <strong>flat, square or round</strong>. A photo like these is perfect.": "Adagia la vecchia cinghia in piano e rilassata accanto a un righello. Non tenderla. Dicci la <strong>lunghezza</strong> e se la sezione è <strong>piatta, quadrata o tonda</strong>. Una foto come queste è perfetta.",
    "flat / folded loop, measure the length": "anello piatto / piegato, misura la lunghezza",
    "measure total length laid flat": "misura la lunghezza totale in piano",
    "flat-sided cross-section": "sezione a lati piatti",
    "circular cross-section": "sezione circolare",
    "A photo of the belt next to the ruler, and one of the mechanism, tells us everything.": "Una foto della cinghia accanto al righello, e una del meccanismo, ci dice tutto.",
    "What’s the machine doing?": "Cosa fa l'apparecchio?",
    "Belt loose or snapped, tape won’t move, markings on the unit…": "Cinghia lenta o spezzata, il nastro non si muove, marcature sull'apparecchio…",
    "{n} parts added to your cart": "{n} ricambi aggiunti al carrello",
    "{n} part added to your cart": "{n} ricambio aggiunto al carrello",
    "Option": "Opzione",
    "View full image": "Vedi l'immagine completa",
    "Try another part type, or send us your model number. We check the database manually and add new references weekly.": "Prova un altro tipo di ricambio, o inviaci il numero del tuo modello. Controlliamo il database manualmente e aggiungiamo nuovi riferimenti ogni settimana.",
    "No model-specific wear parts are listed for this model yet. Below are <strong>universal service items</strong> that suit any machine.": "Nessun ricambio soggetto a usura specifico per questo modello è ancora elencato. Qui sotto trovi <strong>articoli universali di servizio</strong> adatti a qualsiasi apparecchio.",
    "We check models manually.": "controlliamo i modelli manualmente.",
    "{n} more below in <strong>{c}</strong>": "altri {n} qui sotto in <strong>{c}</strong>",
    "more categories": "altre categorie",
    "We could not find <strong>{m}</strong> in the database. Check the spelling, or <a href=\"{u}\">ask technical support</a>.": "Non abbiamo trovato <strong>{m}</strong> nel database. Controlla la grafia, oppure <a href=\"{u}\">chiedi all'assistenza tecnica</a>.",
    "We could not find that exact model in the database. Check the spelling, or <a href=\"{u}\">ask technical support</a> before ordering.": "Non abbiamo trovato quel modello esatto nel database. Controlla la grafia, oppure <a href=\"{u}\">chiedi all'assistenza tecnica</a> prima di ordinare.",
    "Checking the compatibility database…": "Verifica del database di compatibilità…",
    "parts for {m}": "ricambi per {m}",
    "Also confirmed for {m}:": "Confermato anche per {m}:",
    "All {n}": "Tutti {n}",
    "Universal service items": "Articoli di servizio universali",
    "See all {n} parts for {m}": "Vedi tutti i {n} ricambi per {m}",
    "See all {n} part for {m}": "Vedi {n} ricambio per {m}",
    "Confirmed fit, <strong class=\"mono\">{m}</strong> · verified in our database": "Compatibilità confermata, <strong class=\"mono\">{m}</strong> · verificata nel nostro database",
    "Checking the compatibility database for <strong class=\"mono\">": "Verifica del database di compatibilità per <strong class=\"mono\">",
    "All {n} confirmed parts for this exact model, shown below.": "Tutti i {n} ricambi confermati per questo modello esatto, mostrati qui sotto.",
    "This page has the model-specific part. The items below suit any machine and help a fresh repair last: clean the path, lubricate the mechanism, protect the new part.": "Questa pagina ha il ricambio specifico per il modello. Gli articoli qui sotto sono adatti a qualsiasi apparecchio e aiutano una riparazione fresca a durare: pulisci il percorso, lubrifica il meccanismo, proteggi il ricambio nuovo.",
    "No other model-specific wear parts are listed for this model. Below are <strong>universal service items</strong> that suit any machine.": "Nessun altro ricambio soggetto a usura specifico per questo modello è elencato. Qui sotto trovi <strong>articoli universali di servizio</strong> adatti a qualsiasi apparecchio.",
    "Handy universal add-ons, suit any machine:": "Accessori universali utili, adatti a qualsiasi apparecchio:",
    "See {n} universal service items (suit any machine)": "Vedi {n} articoli universali di servizio (adatti a qualsiasi apparecchio)",
    "Please choose up to {n} photos. We kept the first {n}.": "Scegli al massimo {n} foto. Abbiamo tenuto le prime {n}.",
    "The parts database is taking a moment to respond.": "Il database dei ricambi sta impiegando un momento a rispondere.",
    "Connecting to the database. Your search will run automatically in a moment…": "Connessione al database. La tua ricerca partirà automaticamente tra un istante…",
    "Pick your model from the list, or use the free identification below it.": "Scegli il tuo modello dall'elenco, oppure usa l'identificazione gratuita qui sotto.",
    "Type the brand and model printed on your unit, e.g. <strong>Sony CDP-M301</strong>, then pick it from the list.": "Digita la marca e il modello stampati sul tuo apparecchio, es. <strong>Sony CDP-M301</strong>, poi sceglilo dall'elenco.",
    "<strong>{n} brands</strong> loaded. Try Sony TC-K611S, Pioneer CT-F850…": "<strong>{n} marche</strong> caricate. Prova Sony TC-K611S, Pioneer CT-F850…",
    "Retrying automatically. Meanwhile you can <a href=\"/search?type=product\">search by keyword</a> or <a href=\"{u}\">ask technical support</a>.": "Nuovo tentativo automatico. Nel frattempo puoi <a href=\"/search?type=product\">cercare per parola chiave</a> o <a href=\"{u}\">chiedere all'assistenza tecnica</a>.",
    "or <a href=\"{u}\">contact technical support</a>.": "oppure <a href=\"{u}\">contatta l'assistenza tecnica</a>.",
    "Checking the compatibility database for <strong>{m}</strong>…": "Verifica del database di compatibilità per <strong>{m}</strong>…",
    "The database is taking longer than usual, retrying for <strong>{m}</strong>…": "Il database ci sta mettendo più del solito, nuovo tentativo per <strong>{m}</strong>…",
    "The database is still loading. Try again in a moment.": "Il database si sta ancora caricando. Riprova tra un istante.",
    "Universal add-ons, suit any machine": "Accessori universali, adatti a qualsiasi apparecchio",
    "Enter brand and model…": "Inserisci marca e modello…",
    "Checking database…": "Verifica del database…",
    "Checking…": "Verifica…",
    "Adding…": "Aggiunta in corso…",
    "Added to cart": "Aggiunto al carrello",
    "Added OK": "Aggiunto",
    "All stock in cart": "Tutta la disponibilità è nel carrello",
    "All compatible parts": "Tutti i ricambi compatibili",
    "All parts": "Tutti i ricambi",
    "Best matches": "Migliori corrispondenze",
    "Confirmed parts": "Ricambi confermati",
    "Check fit": "Verifica la compatibilità",
    "Universal fit, suits all models": "Compatibilità universale, adatto a tutti i modelli",
    "In stock, ready to ship": "Disponibile, pronto per la spedizione",
    "Confirmed fit": "Compatibilità confermata",
    "Confirmed for your model": "Confermato per il tuo modello",
    "model-specific part": "ricambio specifico per modello",
    "model-specific parts": "ricambi specifici per modello",
    "confirmed part": "ricambio confermato",
    "universal service item": "articolo universale di servizio",
    "universal service items": "articoli universali di servizio",
    "units": "pezzi",
    " units": " pezzi",
    "Ask technical support before ordering": "Chiedi all'assistenza tecnica prima di ordinare",
    "see confirmed parts for your model": "vedi i ricambi confermati per il tuo modello",
    "(some sizes grouped)": "(alcune misure raggruppate)",
    "Showing": "Mostrati",
    "of": "di",
    "parts": "ricambi",
    "Verified buyer": "Acquirente verificato",
    "Translated from the customer original language": "Tradotto dalla lingua originale del cliente",
    "Part no.": "Cod. art.",
    "Stock": "Disponibilità",
    "Show less": "Mostra meno",
    "Confirmed": "Confermato",
    "Show only": "Mostra solo",
    "Added": "Aggiunto",
    "In cart:": "Nel carrello:",
    "Checkout": "Vai al checkout",
    "Claim my free belt": "Richiedi la mia cinghia gratuita",
    "Claim the free belt": "Richiedi la cinghia gratuita",
    "Claim your free belt": "Richiedi la tua cinghia gratuita",
    "Do you still have the original belt?": "Hai ancora la cinghia originale?",
    "Free specialist support": "Assistenza specialistica gratuita",
    "Full details on the product page.": "Tutti i dettagli nella pagina prodotto.",
    "Get your free belt": "Ricevi la tua cinghia gratuita",
    "How to measure your old belt": "Come misurare la tua vecchia cinghia",
    "Lay the old belt flat and relaxed next to a ruler": "Adagia la vecchia cinghia in piano e rilassata accanto a un righello",
    "Loading description": "Caricamento della descrizione",
    "No parts in this category": "Nessun ricambio in questa categoria",
    "Open full page": "Apri la pagina completa",
    "Open the full finder": "Apri la ricerca completa",
    "Photos of the mechanism": "Foto del meccanismo",
    "Repairing a different model?": "Stai riparando un altro modello?",
    "See everything for this model": "Vedi tutto per questo modello",
    "Try again": "Riprova",
    "Uploading photos…": "Caricamento delle foto…",
    "A member of our team replies": "Un membro del nostro team risponde",
    "Ask us about specific parts": "Chiedici di ricambi specifici",
    "Send": "Invia",
    "We might have": "Potremmo avere",
    "more parts for": "altri ricambi per",
    "Enter brand and model, e.g. Sony CDP-M301": "Inserisci marca e modello, es. Sony CDP-M301",
    "None of these? We will identify the right belt for you. Free, you only pay shipping.": "Nessuna di queste? Identificheremo noi la cinghia giusta per te. Gratis, paghi solo la spedizione.",
    "No belt listed for the": "Nessuna cinghia elencata per",
    "yet. We probably stock it.": "per ora. Probabilmente ce l'abbiamo a stock.",
    "This model is in our database, but its belt has not been identified yet. Send a photo of the mechanism and tell us about the old belt. Once we confirm the match,": "Questo modello è nel nostro database, ma la sua cinghia non è ancora stata identificata. Invia una foto del meccanismo e parlaci della vecchia cinghia. Una volta confermato l'abbinamento,",
    "the belt is free, you only cover shipping": "la cinghia è gratuita, paghi solo la spedizione",
    "We have the belt for your": "Abbiamo la cinghia per il tuo",
    "Help us confirm it.": "Aiutaci a confermarla.",
    "We stock the belt for the": "Abbiamo a stock la cinghia per",
    "We check every model by hand, and this one is not linked yet. There is a strong chance we already have the exact belt on the shelf. Confirm it with us and it is yours": "Controlliamo ogni modello a mano, e questo non è ancora collegato. C'è un'alta probabilità che la cinghia esatta sia già sul nostro scaffale. Confermala con noi ed è tua",
    "free, you only pay shipping": "gratis, paghi solo la spedizione",
    "Send your details and a photo or two. We reply Mon-Fri.": "Invia i tuoi dati e una o due foto. Rispondiamo lun-ven.",
    "Confirmed fit for": "Compatibilità confermata per",
    "in the compatibility database.": "nel database di compatibilità.",
    "Markings on the unit, the old belt size if you measured it, what the machine is doing…": "Marcature sull'apparecchio, la misura della vecchia cinghia se l'hai presa, cosa fa l'apparecchio…",
    "Details": "Dettagli",
    "FREE BELT": "CINGHIA GRATUITA",
    "Database loading, please wait…": "Caricamento del database, attendi…",
    "Close": "Chiudi",
    "These are always useful for a repair:": "Questi sono sempre utili per una riparazione:",
    "Brand, keep typing the model": "Marca, continua a digitare il modello",
    "We will find it for you": "Lo troveremo noi per te",
    "Send us the model number printed on your unit, or just a photo of the label or mechanism. We confirm the exact part within one working day,": "Inviaci il numero di modello stampato sul tuo apparecchio, o anche solo una foto dell'etichetta o del meccanismo. Confermiamo il ricambio esatto entro un giorno lavorativo,",
    "Free specialist support, answered by vintage audio repairers": "Assistenza specialistica gratuita, risponde chi ripara audio vintage",
    "Taking longer than usual, retrying for": "Ci sta mettendo più del solito, nuovo tentativo per",
    "Gears & Mechanical Parts": "Ingranaggi e parti meccaniche",
    "Belts & Belt Kits": "Cinghie e kit cinghie",
    "Could not add": "Impossibile aggiungere",
    "Could not add, try the product page": "Impossibile aggiungere, prova dalla pagina prodotto",
    "Could not add that option. It may be out of stock.": "Impossibile aggiungere quell'opzione. Potrebbe essere esaurita.",
    "Could not add the selected parts. Please try again.": "Impossibile aggiungere i ricambi selezionati. Riprova.",
    "Free belt identification": "Identificazione gratuita della cinghia",
    "Fits ": "Compatibile con ",
    "Read full description": "Leggi la descrizione completa",
    "Belt measuring tool": "Strumento di misurazione cinghie",
    "Belt Kit": "Kit cinghie",
    "Flat Belt": "Cinghia piatta",
    "Square Belt": "Cinghia quadrata",
    "Round Belt": "Cinghia tonda",
    "Pinch Roller": "Rullo pressore",
    "Pinch Rollers & Tires": "Rulli pressori e gomme delle ruote folli",
    "Idler Tire": "Gomma della ruota folle",
    "Mechanical Parts": "Parti meccaniche",
    "Laser Pickups": "Gruppi ottici laser",
    "Cleaning & Maintenance": "Pulizia e manutenzione",
    "Motors": "Motori",
    "Batteries": "Batterie",
    "Fuses": "Fusibili",
    "Lighting": "Illuminazione",
    "Insulators": "Isolatori",
    "Passives": "Componenti passivi",
    "Connectors & plugs": "Connettori e spine",
    "Other compatible parts": "Altri ricambi compatibili",
    "Gear and mechanism grease": "Grasso per ingranaggi e meccanismi",
    "Precision synthetic oil": "Olio sintetico di precisione",
    "Precision lubricant": "Lubrificante di precisione",
    "Rubber cleaner and revitaliser": "Detergente e rigenerante per gomma",
    "Head cleaner": "Detergente per testine",
    "Head cleaning fluid": "Liquido per la pulizia delle testine",
    "Cleaning swabs": "Bastoncini per la pulizia",
    "Precision cleaning swabs": "Bastoncini di precisione per la pulizia",
    "Adhesive oil": "Olio adesivo",
    "Service item": "Articolo di servizio",
    "Grease, metal gears": "Grasso, ingranaggi in metallo",
    "Grease, metal & plastic": "Grasso, metallo e plastica",
    "Silicone oil, plastic-safe": "Olio siliconico, per plastica",
    "Synthetic oil": "Olio sintetico",
    "Lid & hinge lubricant": "Lubrificante per sportelli e cerniere",
    "Cleaning kit": "Kit di pulizia",
    "Unavailable": "Non disponibile",
    "Semiconductors": "Semiconduttori",
    "Please choose up to ": "Scegli al massimo ",
    "Photos uploaded, reference ": "Foto caricate, riferimento ",
    "Photos sent to our support inbox.": "Foto inviate alla nostra casella di assistenza.",
    "Customer selected photos but the upload could not be confirmed. Ask them to reply to the confirmation email with photos.": "Il cliente ha selezionato delle foto, ma non è stato possibile confermare il caricamento. Chiedigli di rispondere all’e-mail di conferma allegando le foto.",
    "Customer selected photos but the upload failed. Ask them to reply to the confirmation email with photos.": "Il cliente ha selezionato delle foto, ma il caricamento non è riuscito. Chiedigli di rispondere all’e-mail di conferma allegando le foto.",
    "Customer selected photos but upload is not configured. Ask them to reply to the confirmation email with photos.": "Il cliente ha selezionato delle foto, ma il caricamento non è configurato. Chiedigli di rispondere all’e-mail di conferma allegando le foto.",
    "{n} part selected": "{n} ricambio selezionato",
    "{n} parts selected": "{n} ricambi selezionati",
    "Repairing a <strong class=\"mono\">{m}</strong>? The database is busy right now.": "Stai riparando un <strong class=\"mono\">{m}</strong>? Il database è momentaneamente occupato.",
    "CL02-10 Laser Lens Cleaner · 1 ml": "Detergente per lente laser CL02-10 · 1 ml",
    "DAT & Video Head Cleaner · 10 ml": "Detergente per testine DAT e video · 10 ml",
    "Mitsubishi C90 · Pack of 2": "Mitsubishi C90 · confezione da 2",
    "Maxell UR90 · 90 min": "Maxell UR90 · 90 min",
    "Maxell UR60 · 60 min": "Maxell UR60 · 60 min",
    "Melted Belt Cleaner · 50 ml": "Detergente per cinghie fuse · 50 ml",
    "Tonearm Cueing Damping Oil 300k · 1 ml": "Olio smorzante per alzabraccio 300k · 1 ml",
    "Shell Gadus Grease · 7 ml": "Grasso Shell Gadus · 7 ml",
    "Metal Gear & Lever Grease · 10 g": "Grasso per ingranaggi metallici e leve · 10 g",
    "Full Synthetic Oil · 1 ml": "Olio completamente sintetico · 1 ml",
    "Titanium Synthetic Oil · 1 ml": "Olio sintetico con tecnologia al titanio · 1 ml",
    "Super Adhesive Oil · 1 ml": "Olio adesivo · 1 ml"
  },
  "fr": {
    "Database updated": "Base de données mise à jour",
    "Connecting Cables": "Câbles de connexion",
    "Antennas": "Antennes",
    "Rubber Feet": "Pieds en caoutchouc",
    "Feet": "Pieds",
    "Lamps": "Lampes",
    "Switches": "Interrupteurs",
    "Mats": "Couvre-plateaux",
    "Weights": "Contrepoids",
    "Repair Kits": "Kits de réparation",
    "Tools & Calibration": "Outils & calibration",
    "Connectors": "Connecteurs",
    "Cartridges": "Cellules phono",
    "Heads": "Têtes de lecture",
    "Fits {m}": "Compatible avec {m}",
    "Yes, I have it": "Oui, je l'ai",
    "It snapped / in pieces": "Elle a cassé / en morceaux",
    "No, it's gone": "Non, elle a disparu",
    "Add photos of the mechanism": "Ajoutez des photos du mécanisme",
    "A photo of the belt path / mechanism tells us everything.": "Une photo du trajet de la courroie / du mécanisme nous dit tout.",
    "Open the machine and photograph the belt path / mechanism. JPG or PNG, we resize them for you.": "Ouvrez l'appareil et photographiez le trajet de la courroie / le mécanisme. JPG ou PNG, nous les redimensionnons pour vous.",
    "Tell us anything that helps identify it: markings on the unit, the old belt's size if you measured it, what the machine is doing…": "Dites-nous tout ce qui aide à l'identifier : marquages sur l'appareil, taille de l'ancienne courroie si vous l'avez mesurée, ce que fait la machine…",
    "Photos of the mechanism &amp; the old belt": "Photos du mécanisme &amp; de l'ancienne courroie",
    "(this is what confirms the match)": "(c'est ce qui confirme la correspondance)",
    "Claim my free belt →": "Réclamer ma courroie gratuite →",
    "A member of our team replies · Mon–Fri": "Un membre de notre équipe vous répond · lun–ven",
    "Grease for gears, levers and slide points, metal or plastic.": "Graisse pour engrenages, leviers et points de glissement, métal ou plastique.",
    "A light drop on motor bearings and metal pivots after a repair.": "Une goutte légère sur les paliers de moteur et pivots métalliques après une réparation.",
    "Clinging oil for pivots and levers. Stays where you put it.": "Huile adhérente pour pivots et leviers. Reste où vous la mettez.",
    "Cleans tape heads, guides and capstans. Dull sound is often just dirt.": "Nettoie têtes de lecture, guides et cabestans. Un son terne, c'est souvent juste de la saleté.",
    "For sticky or slow cassette doors and lid hinges.": "Pour les trappes cassette collantes ou lentes et les charnières de capot.",
    "Grease for the metal gears and levers of the mechanism.": "Graisse pour les engrenages et leviers métalliques du mécanisme.",
    "Oil for plastic gears, sliders and pivot points. Safe on plastic.": "Huile pour engrenages en plastique, coulisseaux et points de pivot. Sans danger pour le plastique.",
    "or": "ou",
    "your model": "votre modèle",
    "Find compatible parts": "Trouver des pièces compatibles",
    "Add to cart": "Ajouter au panier",
    "Add selected parts to cart": "Ajouter les pièces sélectionnées au panier",
    "In stock": "En stock",
    "Out of stock": "Rupture de stock",
    "View details": "Voir les détails",
    "See all parts for this model": "Voir toutes les pièces pour ce modèle",
    "confirmed parts": "pièces confirmées",
    "In stock, ": "En stock, ",
    "Description": "Description",
    "Price": "Prix",
    "Contact technical support": "Contacter l'assistance technique",
    "Flat belt": "Courroie plate",
    "Last unit left": "Dernière unité disponible",
    "Round belt": "Courroie ronde",
    "Send message": "Envoyer le message",
    "Square belt": "Courroie carrée",
    "View cart": "Voir le panier",
    "Your name": "Votre nom",
    "Your email": "Votre e-mail",
    "Add": "Ajouter",
    "Checkout securely": "Paiement sécurisé",
    "before you pay": "avant de payer",
    "Send your model or a photo": "Envoyez votre modèle ou une photo",
    "No parts selected": "Aucune pièce sélectionnée",
    "Belts": "Courroies",
    "Gears": "Engrenages",
    "Recommended for your {m} repair": "Recommandé pour la réparation de votre {m}",
    "Review cart &amp; checkout": "Vérifier le panier &amp; payer",
    "Keep shopping": "Continuer vos achats",
    "We could not confirm this exact fit for <strong>{m}</strong>.": "Nous n'avons pas pu confirmer cette compatibilité exacte pour <strong>{m}</strong>.",
    "Rated 5 out of 5 on Trustpilot": "Noté 5 sur 5 sur Trustpilot",
    "No matches for that spelling. Model not in the database yet? We'll identify the right belt for you. <strong>Free, you only pay shipping</strong>.": "Aucun résultat pour cette orthographe. Modèle pas encore dans la base ? Nous identifierons la bonne courroie pour vous. <strong>Gratuit, vous ne payez que l'expédition</strong>.",
    "Get your free belt →": "Obtenez votre courroie gratuite →",
    "<strong>{b}</strong>. Now type the model number, or pick it from the list.": "<strong>{b}</strong>. Saisissez maintenant le numéro de modèle, ou choisissez-le dans la liste.",
    "<strong>{m}</strong> has no confirmed record yet. <strong>Send it to the workshop and we'll identify the right belt for you. Free, you only pay shipping.</strong>": "<strong>{m}</strong> n'a pas encore de fiche confirmée. <strong>Envoyez-le à l'atelier et nous identifierons la bonne courroie pour vous. Gratuit, vous ne payez que l'expédition.</strong>",
    "Claim the free belt →": "Réclamer la courroie gratuite →",
    "Or <a href=\"/collections\">browse parts by category</a> / <a href=\"/collections/belts-by-size\">match a belt by its measurements</a>.": "Ou <a href=\"/collections\">parcourez les pièces par catégorie</a> / <a href=\"/collections/belts-by-size\">trouvez une courroie par ses mesures</a>.",
    "FREE BELT · YOU ONLY PAY SHIPPING": "COURROIE GRATUITE · VOUS NE PAYEZ QUE L'EXPÉDITION",
    "Lay the old belt flat and relaxed next to a ruler. Don’t stretch it. Tell us the <strong>length</strong> and whether the cross-section is <strong>flat, square or round</strong>. A photo like these is perfect.": "Posez l'ancienne courroie à plat et détendue à côté d'une règle. Ne l'étirez pas. Indiquez-nous la <strong>longueur</strong> et si la section est <strong>plate, carrée ou ronde</strong>. Une photo comme celles-ci est parfaite.",
    "flat / folded loop, measure the length": "boucle à plat / pliée, mesurez la longueur",
    "measure total length laid flat": "mesurez la longueur totale posée à plat",
    "flat-sided cross-section": "section à côtés plats",
    "circular cross-section": "section circulaire",
    "A photo of the belt next to the ruler, and one of the mechanism, tells us everything.": "Une photo de la courroie à côté de la règle, et une du mécanisme, nous disent tout.",
    "What’s the machine doing?": "Que fait la machine ?",
    "Belt loose or snapped, tape won’t move, markings on the unit…": "Courroie détendue ou cassée, la bande n'avance pas, marquages sur l'appareil…",
    "{n} parts added to your cart": "{n} pièces ajoutées à votre panier",
    "{n} part added to your cart": "{n} pièce ajoutée à votre panier",
    "Option": "Option",
    "View full image": "Voir l'image en grand",
    "Try another part type, or send us your model number. We check the database manually and add new references weekly.": "Essayez un autre type de pièce, ou envoyez-nous votre numéro de modèle. Nous vérifions la base manuellement et ajoutons de nouvelles références chaque semaine.",
    "No model-specific wear parts are listed for this model yet. Below are <strong>universal service items</strong> that suit any machine.": "Aucune pièce d'usure spécifique n'est encore répertoriée pour ce modèle. Ci-dessous, des <strong>articles d'entretien universels</strong> qui conviennent à toute machine.",
    "We check models manually.": "Nous vérifions les modèles manuellement.",
    "{n} more below in <strong>{c}</strong>": "{n} de plus ci-dessous dans <strong>{c}</strong>",
    "more categories": "autres catégories",
    "We could not find <strong>{m}</strong> in the database. Check the spelling, or <a href=\"{u}\">ask technical support</a>.": "Nous n'avons pas trouvé <strong>{m}</strong> dans la base. Vérifiez l'orthographe, ou <a href=\"{u}\">demandez à l'assistance technique</a>.",
    "We could not find that exact model in the database. Check the spelling, or <a href=\"{u}\">ask technical support</a> before ordering.": "Nous n'avons pas trouvé ce modèle exact dans la base. Vérifiez l'orthographe, ou <a href=\"{u}\">demandez à l'assistance technique</a> avant de commander.",
    "Checking the compatibility database…": "Vérification de la base de compatibilité…",
    "parts for {m}": "pièces pour {m}",
    "Also confirmed for {m}:": "Également confirmé pour {m} :",
    "All {n}": "Tout voir ({n})",
    "Universal service items": "Articles d'entretien universels",
    "See all {n} parts for {m}": "Voir les {n} pièces pour {m}",
    "See all {n} part for {m}": "Voir {n} pièce pour {m}",
    "Confirmed fit, <strong class=\"mono\">{m}</strong> · verified in our database": "Compatibilité confirmée, <strong class=\"mono\">{m}</strong> · vérifiée dans notre base",
    "Checking the compatibility database for <strong class=\"mono\">": "Vérification de la base de compatibilité pour <strong class=\"mono\">",
    "All {n} confirmed parts for this exact model, shown below.": "Les {n} pièces confirmées pour ce modèle exact, affichées ci-dessous.",
    "This page has the model-specific part. The items below suit any machine and help a fresh repair last: clean the path, lubricate the mechanism, protect the new part.": "Cette page contient la pièce spécifique au modèle. Les articles ci-dessous conviennent à toute machine et aident une réparation fraîche à durer : nettoyez le trajet, lubrifiez le mécanisme, protégez la pièce neuve.",
    "No other model-specific wear parts are listed for this model. Below are <strong>universal service items</strong> that suit any machine.": "Aucune autre pièce d'usure spécifique n'est répertoriée pour ce modèle. Ci-dessous, des <strong>articles d'entretien universels</strong> qui conviennent à toute machine.",
    "Handy universal add-ons, suit any machine:": "Compléments universels pratiques, pour toute machine :",
    "See {n} universal service items (suit any machine)": "Voir {n} articles d'entretien universels (pour toute machine)",
    "Please choose up to {n} photos. We kept the first {n}.": "Veuillez choisir jusqu'à {n} photos. Nous avons gardé les {n} premières.",
    "The parts database is taking a moment to respond.": "La base de pièces met un moment à répondre.",
    "Connecting to the database. Your search will run automatically in a moment…": "Connexion à la base. Votre recherche se lancera automatiquement dans un instant…",
    "Pick your model from the list, or use the free identification below it.": "Choisissez votre modèle dans la liste, ou utilisez l'identification gratuite en dessous.",
    "Type the brand and model printed on your unit, e.g. <strong>Sony CDP-M301</strong>, then pick it from the list.": "Saisissez la marque et le modèle imprimés sur votre appareil, ex. <strong>Sony CDP-M301</strong>, puis choisissez-le dans la liste.",
    "<strong>{n} brands</strong> loaded. Try Sony TC-K611S, Pioneer CT-F850…": "<strong>{n} marques</strong> chargées. Essayez Sony TC-K611S, Pioneer CT-F850…",
    "Retrying automatically. Meanwhile you can <a href=\"/search?type=product\">search by keyword</a> or <a href=\"{u}\">ask technical support</a>.": "Nouvelle tentative automatique. En attendant, vous pouvez <a href=\"/search?type=product\">chercher par mot-clé</a> ou <a href=\"{u}\">demander à l'assistance technique</a>.",
    "or <a href=\"{u}\">contact technical support</a>.": "ou <a href=\"{u}\">contactez l'assistance technique</a>.",
    "Checking the compatibility database for <strong>{m}</strong>…": "Vérification de la base de compatibilité pour <strong>{m}</strong>…",
    "The database is taking longer than usual, retrying for <strong>{m}</strong>…": "La base met plus de temps que d'habitude, nouvelle tentative pour <strong>{m}</strong>…",
    "The database is still loading. Try again in a moment.": "La base est encore en cours de chargement. Réessayez dans un instant.",
    "Universal add-ons, suit any machine": "Compléments universels, pour toute machine",
    "Enter brand and model…": "Saisissez la marque et le modèle…",
    "Checking database…": "Vérification de la base…",
    "Checking…": "Vérification…",
    "Adding…": "Ajout…",
    "Added to cart": "Ajouté au panier",
    "Added OK": "Bien ajouté",
    "All stock in cart": "Tout le stock est dans le panier",
    "All compatible parts": "Toutes les pièces compatibles",
    "All parts": "Toutes les pièces",
    "Best matches": "Meilleures correspondances",
    "Confirmed parts": "Pièces confirmées",
    "Check fit": "Vérifier la compatibilité",
    "Universal fit, suits all models": "Compatibilité universelle, convient à tous les modèles",
    "In stock, ready to ship": "En stock, prêt à partir",
    "Confirmed fit": "Compatibilité confirmée",
    "Confirmed for your model": "Confirmé pour votre modèle",
    "model-specific part": "pièce spécifique au modèle",
    "model-specific parts": "pièces spécifiques au modèle",
    "confirmed part": "pièce confirmée",
    "universal service item": "article d'entretien universel",
    "universal service items": "articles d'entretien universels",
    "units": "unités",
    " units": " unités",
    "Ask technical support before ordering": "Demandez à l'assistance technique avant de commander",
    "see confirmed parts for your model": "voir les pièces confirmées pour votre modèle",
    "(some sizes grouped)": "(certaines tailles regroupées)",
    "Showing": "Affichage de",
    "of": "sur",
    "parts": "pièces",
    "Verified buyer": "Acheteur vérifié",
    "Translated from the customer original language": "Traduit de la langue d'origine du client",
    "Part no.": "Réf.",
    "Stock": "Stock",
    "Show less": "Voir moins",
    "Confirmed": "Confirmé",
    "Show only": "Afficher uniquement",
    "Added": "Ajouté",
    "In cart:": "Dans le panier :",
    "Checkout": "Paiement",
    "Claim my free belt": "Réclamer ma courroie gratuite",
    "Claim the free belt": "Réclamer la courroie gratuite",
    "Claim your free belt": "Réclamez votre courroie gratuite",
    "Do you still have the original belt?": "Avez-vous encore la courroie d'origine ?",
    "Free specialist support": "Assistance spécialisée gratuite",
    "Full details on the product page.": "Tous les détails sur la page produit.",
    "Get your free belt": "Obtenez votre courroie gratuite",
    "How to measure your old belt": "Comment mesurer votre ancienne courroie",
    "Lay the old belt flat and relaxed next to a ruler": "Posez l'ancienne courroie à plat et détendue à côté d'une règle",
    "Loading description": "Chargement de la description",
    "No parts in this category": "Aucune pièce dans cette catégorie",
    "Open full page": "Ouvrir la page complète",
    "Open the full finder": "Ouvrir le moteur complet",
    "Photos of the mechanism": "Photos du mécanisme",
    "Repairing a different model?": "Vous réparez un autre modèle ?",
    "See everything for this model": "Tout voir pour ce modèle",
    "Try again": "Réessayer",
    "Uploading photos…": "Envoi des photos…",
    "A member of our team replies": "Un membre de notre équipe vous répond",
    "Ask us about specific parts": "Interrogez-nous sur des pièces précises",
    "Send": "Envoyer",
    "We might have": "Nous avons peut-être",
    "more parts for": "plus de pièces pour",
    "Enter brand and model, e.g. Sony CDP-M301": "Saisissez la marque et le modèle, ex. Sony CDP-M301",
    "None of these? We will identify the right belt for you. Free, you only pay shipping.": "Aucun de ceux-ci ? Nous identifierons la bonne courroie pour vous. Gratuit, vous ne payez que l'expédition.",
    "No belt listed for the": "Aucune courroie répertoriée pour le",
    "yet. We probably stock it.": "pour l'instant. Nous l'avons probablement en stock.",
    "This model is in our database, but its belt has not been identified yet. Send a photo of the mechanism and tell us about the old belt. Once we confirm the match,": "Ce modèle est dans notre base, mais sa courroie n'a pas encore été identifiée. Envoyez une photo du mécanisme et parlez-nous de l'ancienne courroie. Une fois la correspondance confirmée,",
    "the belt is free, you only cover shipping": "la courroie est gratuite, vous ne réglez que l'expédition",
    "We have the belt for your": "Nous avons la courroie pour votre",
    "Help us confirm it.": "Aidez-nous à la confirmer.",
    "We stock the belt for the": "Nous stockons la courroie pour le",
    "We check every model by hand, and this one is not linked yet. There is a strong chance we already have the exact belt on the shelf. Confirm it with us and it is yours": "Nous vérifions chaque modèle à la main, et celui-ci n'est pas encore relié. Il y a de fortes chances que nous ayons déjà la courroie exacte en rayon. Confirmez-la avec nous et elle est à vous",
    "free, you only pay shipping": "gratuite, vous ne payez que l'expédition",
    "Send your details and a photo or two. We reply Mon-Fri.": "Envoyez vos coordonnées et une ou deux photos. Nous répondons du lundi au vendredi.",
    "Confirmed fit for": "Compatibilité confirmée pour",
    "in the compatibility database.": "dans la base de compatibilité.",
    "Markings on the unit, the old belt size if you measured it, what the machine is doing…": "Marquages sur l'appareil, taille de l'ancienne courroie si vous l'avez mesurée, ce que fait la machine…",
    "Details": "Détails",
    "FREE BELT": "COURROIE GRATUITE",
    "Database loading, please wait…": "Chargement de la base, veuillez patienter…",
    "Close": "Fermer",
    "These are always useful for a repair:": "Toujours utiles pour une réparation :",
    "Brand, keep typing the model": "Marque, continuez avec le modèle",
    "We will find it for you": "Nous la trouverons pour vous",
    "Send us the model number printed on your unit, or just a photo of the label or mechanism. We confirm the exact part within one working day,": "Envoyez-nous le numéro de modèle imprimé sur votre appareil, ou simplement une photo de l'étiquette ou du mécanisme. Nous confirmons la pièce exacte sous un jour ouvré,",
    "Free specialist support, answered by vintage audio repairers": "Assistance spécialisée gratuite, assurée par des réparateurs audio vintage",
    "Taking longer than usual, retrying for": "Plus long que d'habitude, nouvelle tentative pour",
    "Gears & Mechanical Parts": "Engrenages & pièces mécaniques",
    "Belts & Belt Kits": "Courroies et kits de courroies",
    "Could not add": "Impossible d'ajouter",
    "Could not add, try the product page": "Impossible d'ajouter, essayez la page produit",
    "Could not add that option. It may be out of stock.": "Impossible d'ajouter cette option. Elle est peut-être en rupture de stock.",
    "Could not add the selected parts. Please try again.": "Impossible d'ajouter les pièces sélectionnées. Veuillez réessayer.",
    "Free belt identification": "Identification de courroie gratuite",
    "Fits ": "Compatible avec ",
    "Read full description": "Lire la description complète",
    "Belt measuring tool": "Outil de mesure de courroie",
    "Belt Kit": "Kit de courroies",
    "Flat Belt": "Courroie plate",
    "Square Belt": "Courroie carrée",
    "Round Belt": "Courroie ronde",
    "Pinch Roller": "Galet presseur",
    "Pinch Rollers & Tires": "Galets presseurs et bandages de galet",
    "Idler Tire": "Bandage de galet",
    "Mechanical Parts": "Pièces mécaniques",
    "Laser Pickups": "Blocs optiques",
    "Cleaning & Maintenance": "Nettoyage et entretien",
    "Motors": "Moteurs",
    "Batteries": "Piles & batteries",
    "Fuses": "Fusibles",
    "Lighting": "Éclairage",
    "Insulators": "Isolants",
    "Passives": "Composants passifs",
    "Connectors & plugs": "Connecteurs & fiches",
    "Other compatible parts": "Autres pièces compatibles",
    "Gear and mechanism grease": "Graisse pour engrenages et mécanismes",
    "Precision synthetic oil": "Huile synthétique de précision",
    "Precision lubricant": "Lubrifiant de précision",
    "Rubber cleaner and revitaliser": "Nettoyant et revitalisant pour caoutchouc",
    "Head cleaner": "Nettoyant pour têtes",
    "Head cleaning fluid": "Liquide de nettoyage pour têtes",
    "Cleaning swabs": "Bâtonnets de nettoyage",
    "Precision cleaning swabs": "Bâtonnets de nettoyage de précision",
    "Adhesive oil": "Huile adhérente",
    "Service item": "Article d'entretien",
    "Grease, metal gears": "Graisse, engrenages métalliques",
    "Grease, metal & plastic": "Graisse, métal & plastique",
    "Silicone oil, plastic-safe": "Huile silicone, sans danger pour le plastique",
    "Synthetic oil": "Huile synthétique",
    "Lid & hinge lubricant": "Lubrifiant pour capots & charnières",
    "Cleaning kit": "Kit de nettoyage",
    "Unavailable": "Indisponible",
    "Semiconductors": "Semi-conducteurs",
    "Please choose up to ": "Veuillez choisir jusqu'à ",
    "Photos uploaded, reference ": "Photos envoyées, référence ",
    "Photos sent to our support inbox.": "Photos envoyées à notre boîte d'assistance.",
    "Customer selected photos but the upload could not be confirmed. Ask them to reply to the confirmation email with photos.": "Le client a sélectionné des photos mais l'envoi n'a pas pu être confirmé. Demandez-lui de répondre à l'e-mail de confirmation avec les photos.",
    "Customer selected photos but the upload failed. Ask them to reply to the confirmation email with photos.": "Le client a sélectionné des photos mais l'envoi a échoué. Demandez-lui de répondre à l'e-mail de confirmation avec les photos.",
    "Customer selected photos but upload is not configured. Ask them to reply to the confirmation email with photos.": "Le client a sélectionné des photos mais l'envoi n'est pas configuré. Demandez-lui de répondre à l'e-mail de confirmation avec les photos.",
    "{n} part selected": "{n} pièce sélectionnée",
    "{n} parts selected": "{n} pièces sélectionnées",
    "Repairing a <strong class=\"mono\">{m}</strong>? The database is busy right now.": "Vous réparez un <strong class=\"mono\">{m}</strong> ? La base de données est momentanément occupée.",
    "CL02-10 Laser Lens Cleaner · 1 ml": "Nettoyant pour lentille laser CL02-10 · 1 ml",
    "DAT & Video Head Cleaner · 10 ml": "Nettoyant pour têtes DAT et vidéo · 10 ml",
    "Mitsubishi C90 · Pack of 2": "Mitsubishi C90 · lot de 2",
    "Maxell UR90 · 90 min": "Maxell UR90 · 90 min",
    "Maxell UR60 · 60 min": "Maxell UR60 · 60 min",
    "Melted Belt Cleaner · 50 ml": "Nettoyant pour courroies fondues · 50 ml",
    "Tonearm Cueing Damping Oil 300k · 1 ml": "Huile d’amortissement pour lève-bras 300k · 1 ml",
    "Shell Gadus Grease · 7 ml": "Graisse Shell Gadus · 7 ml",
    "Metal Gear & Lever Grease · 10 g": "Graisse pour engrenages métalliques et leviers · 10 g",
    "Full Synthetic Oil · 1 ml": "Huile 100 % synthétique · 1 ml",
    "Titanium Synthetic Oil · 1 ml": "Huile synthétique à technologie titane · 1 ml",
    "Super Adhesive Oil · 1 ml": "Huile adhésive · 1 ml"
  },
  "pt": {
    "Database updated": "Base de dados atualizada",
    "Connecting Cables": "Cabos de ligação",
    "Antennas": "Antenas",
    "Rubber Feet": "Pés de borracha",
    "Feet": "Pés",
    "Lamps": "Lâmpadas",
    "Switches": "Interruptores",
    "Mats": "Tapetes",
    "Weights": "Pesos",
    "Repair Kits": "Kits de reparação",
    "Tools & Calibration": "Ferramentas e calibração",
    "Connectors": "Conectores",
    "Cartridges": "Cápsulas",
    "Heads": "Cabeças magnéticas",
    "Fits {m}": "Compatível com {m}",
    "Yes, I have it": "Sim, ainda a tenho",
    "It snapped / in pieces": "Partiu-se / está em pedaços",
    "No, it's gone": "Não, desapareceu",
    "Add photos of the mechanism": "Adicionar fotografias do mecanismo",
    "A photo of the belt path / mechanism tells us everything.": "Uma fotografia do percurso da correia ou do mecanismo fornece-nos toda a informação necessária.",
    "Open the machine and photograph the belt path / mechanism. JPG or PNG, we resize them for you.": "Abra o aparelho e fotografe o percurso da correia ou o mecanismo. Aceitamos JPG ou PNG e redimensionamos as imagens por si.",
    "Tell us anything that helps identify it: markings on the unit, the old belt's size if you measured it, what the machine is doing…": "Indique tudo o que possa ajudar na identificação: inscrições no aparelho, medidas da correia antiga, caso as tenha, e o comportamento da máquina…",
    "Photos of the mechanism &amp; the old belt": "Fotografias do mecanismo e da correia antiga",
    "(this is what confirms the match)": "(é isto que permite confirmar a correspondência)",
    "Claim my free belt →": "Pedir a minha correia gratuita →",
    "A member of our team replies · Mon–Fri": "Um membro da nossa equipa responde · seg.–sex.",
    "Grease for gears, levers and slide points, metal or plastic.": "Massa para engrenagens, alavancas e pontos de deslizamento em metal ou plástico.",
    "A light drop on motor bearings and metal pivots after a repair.": "Uma pequena gota nos rolamentos do motor e nos pivôs metálicos após a reparação.",
    "Clinging oil for pivots and levers. Stays where you put it.": "Óleo aderente para pivôs e alavancas. Mantém-se no ponto de aplicação.",
    "Cleans tape heads, guides and capstans. Dull sound is often just dirt.": "Limpa cabeças magnéticas, guias e capstans. Um som abafado deve-se frequentemente apenas a sujidade.",
    "For sticky or slow cassette doors and lid hinges.": "Para portas de cassetes e dobradiças de tampas presas ou lentas.",
    "Grease for the metal gears and levers of the mechanism.": "Massa para as engrenagens metálicas e as alavancas do mecanismo.",
    "Oil for plastic gears, sliders and pivot points. Safe on plastic.": "Óleo para engrenagens de plástico, corrediças e pontos de articulação. Seguro para plástico.",
    "Recommended for your {m} repair": "Recomendado para a reparação do seu {m}",
    "Review cart &amp; checkout": "Rever carrinho e finalizar compra",
    "Keep shopping": "Continuar a comprar",
    "We could not confirm this exact fit for <strong>{m}</strong>.": "Não foi possível confirmar a compatibilidade exata com <strong>{m}</strong>.",
    "or": "ou",
    "Rated 5 out of 5 on Trustpilot": "Classificação de 5 em 5 na Trustpilot",
    "No matches for that spelling. Model not in the database yet? We'll identify the right belt for you. <strong>Free, you only pay shipping</strong>.": "Não encontrámos resultados com essa grafia. O modelo ainda não está na base de dados? Identificamos a correia correta. <strong>A correia é gratuita; paga apenas os portes</strong>.",
    "Get your free belt →": "Obter a sua correia gratuita →",
    "<strong>{b}</strong>. Now type the model number, or pick it from the list.": "<strong>{b}</strong>. Introduza agora o número do modelo ou selecione-o na lista.",
    "<strong>{m}</strong> has no confirmed record yet. <strong>Send it to the workshop and we'll identify the right belt for you. Free, you only pay shipping.</strong>": "<strong>{m}</strong> ainda não tem um registo confirmado. <strong>Envie os dados para a oficina e identificaremos a correia correta. A correia é gratuita; paga apenas os portes.</strong>",
    "Claim the free belt →": "Pedir a correia gratuita →",
    "Or <a href=\"/collections\">browse parts by category</a> / <a href=\"/collections/belts-by-size\">match a belt by its measurements</a>.": "Em alternativa, <a href=\"/collections\">procure peças por categoria</a> ou <a href=\"/collections/belts-by-size\">encontre uma correia pelas medidas</a>.",
    "FREE BELT · YOU ONLY PAY SHIPPING": "CORREIA GRATUITA · PAGA APENAS OS PORTES",
    "Lay the old belt flat and relaxed next to a ruler. Don’t stretch it. Tell us the <strong>length</strong> and whether the cross-section is <strong>flat, square or round</strong>. A photo like these is perfect.": "Coloque a correia antiga estendida, sem tensão, junto a uma régua. Não a estique. Indique o <strong>comprimento</strong> e se a secção é <strong>plana, quadrada ou redonda</strong>. Uma fotografia como as apresentadas é ideal.",
    "flat / folded loop, measure the length": "plana ou dobrada em laço: medir o comprimento",
    "measure total length laid flat": "medir o comprimento total com a correia estendida",
    "flat-sided cross-section": "secção de lados planos",
    "circular cross-section": "secção circular",
    "A photo of the belt next to the ruler, and one of the mechanism, tells us everything.": "Uma fotografia da correia junto à régua e outra do mecanismo fornecem-nos toda a informação necessária.",
    "What’s the machine doing?": "O que está a acontecer com a máquina?",
    "Belt loose or snapped, tape won’t move, markings on the unit…": "Correia solta ou partida, fita sem movimento, inscrições no aparelho…",
    "{n} parts added to your cart": "{n} peças adicionadas ao carrinho",
    "{n} part added to your cart": "{n} peça adicionada ao carrinho",
    "Option": "Opção",
    "View full image": "Ver imagem completa",
    "Try another part type, or send us your model number. We check the database manually and add new references weekly.": "Experimente outro tipo de peça ou envie-nos o número do modelo. Verificamos a base de dados manualmente e adicionamos novas referências todas as semanas.",
    "No model-specific wear parts are listed for this model yet. Below are <strong>universal service items</strong> that suit any machine.": "Ainda não estão indicadas peças de desgaste específicas para este modelo. Abaixo encontra <strong>artigos de manutenção universais</strong> adequados a qualquer máquina.",
    "We check models manually.": "Verificamos os modelos manualmente.",
    "{n} more below in <strong>{c}</strong>": "Mais {n} abaixo em <strong>{c}</strong>",
    "more categories": "mais categorias",
    "We could not find <strong>{m}</strong> in the database. Check the spelling, or <a href=\"{u}\">ask technical support</a>.": "Não encontrámos <strong>{m}</strong> na base de dados. Verifique a grafia ou <a href=\"{u}\">contacte o suporte técnico</a>.",
    "We could not find that exact model in the database. Check the spelling, or <a href=\"{u}\">ask technical support</a> before ordering.": "Não encontrámos esse modelo exato na base de dados. Verifique a grafia ou <a href=\"{u}\">contacte o suporte técnico</a> antes de encomendar.",
    "Checking the compatibility database…": "A consultar a base de dados de compatibilidade…",
    "parts for {m}": "peças para {m}",
    "Also confirmed for {m}:": "Também confirmado para {m}:",
    "All {n}": "Todas ({n})",
    "Universal service items": "Artigos de manutenção universais",
    "See all {n} parts for {m}": "Ver todas as {n} peças para {m}",
    "See all {n} part for {m}": "Ver a peça para {m}",
    "Confirmed fit, <strong class=\"mono\">{m}</strong> · verified in our database": "Compatibilidade confirmada com <strong class=\"mono\">{m}</strong> · verificada na nossa base de dados",
    "Checking the compatibility database for <strong class=\"mono\">": "A consultar a base de dados de compatibilidade para <strong class=\"mono\">",
    "All {n} confirmed parts for this exact model, shown below.": "Abaixo são apresentadas as {n} peças confirmadas para este modelo exato.",
    "your model": "o seu modelo",
    "This page has the model-specific part. The items below suit any machine and help a fresh repair last: clean the path, lubricate the mechanism, protect the new part.": "Esta página contém a peça específica do modelo. Os artigos abaixo são adequados a qualquer máquina e ajudam a prolongar a reparação: limpar o percurso, lubrificar o mecanismo e proteger a peça nova.",
    "No other model-specific wear parts are listed for this model. Below are <strong>universal service items</strong> that suit any machine.": "Não estão indicadas outras peças de desgaste específicas para este modelo. Abaixo encontra <strong>artigos de manutenção universais</strong> adequados a qualquer máquina.",
    "Handy universal add-ons, suit any machine:": "Complementos universais úteis, adequados a qualquer máquina:",
    "See {n} universal service items (suit any machine)": "Ver {n} artigos de manutenção universais (adequados a qualquer máquina)",
    "Please choose up to {n} photos. We kept the first {n}.": "Selecione no máximo {n} fotografias. Mantivemos as primeiras {n}.",
    "The parts database is taking a moment to respond.": "A base de dados de peças está a demorar a responder.",
    "Connecting to the database. Your search will run automatically in a moment…": "A ligar à base de dados. A pesquisa será executada automaticamente dentro de instantes…",
    "Pick your model from the list, or use the free identification below it.": "Selecione o modelo na lista ou utilize a identificação gratuita apresentada abaixo.",
    "Type the brand and model printed on your unit, e.g. <strong>Sony CDP-M301</strong>, then pick it from the list.": "Introduza a marca e o modelo impressos no aparelho, por exemplo <strong>Sony CDP-M301</strong>, e selecione-o na lista.",
    "<strong>{n} brands</strong> loaded. Try Sony TC-K611S, Pioneer CT-F850…": "<strong>{n} marcas</strong> carregadas. Experimente Sony TC-K611S, Pioneer CT-F850…",
    "Retrying automatically. Meanwhile you can <a href=\"/search?type=product\">search by keyword</a> or <a href=\"{u}\">ask technical support</a>.": "A tentar novamente de forma automática. Entretanto, pode <a href=\"/search?type=product\">pesquisar por palavra-chave</a> ou <a href=\"{u}\">contactar o suporte técnico</a>.",
    "or <a href=\"{u}\">contact technical support</a>.": "ou <a href=\"{u}\">contacte o suporte técnico</a>.",
    "Checking the compatibility database for <strong>{m}</strong>…": "A consultar a base de dados de compatibilidade para <strong>{m}</strong>…",
    "The database is taking longer than usual, retrying for <strong>{m}</strong>…": "A base de dados está a demorar mais do que o habitual. A tentar novamente para <strong>{m}</strong>…",
    "The database is still loading. Try again in a moment.": "A base de dados ainda está a carregar. Tente novamente dentro de instantes.",
    "Universal add-ons, suit any machine": "Complementos universais adequados a qualquer máquina",
    "Find compatible parts": "Encontrar peças compatíveis",
    "Enter brand and model…": "Introduza a marca e o modelo…",
    "Checking database…": "A consultar a base de dados…",
    "Add to cart": "Adicionar ao carrinho",
    "Adding…": "A adicionar…",
    "Added to cart": "Adicionado ao carrinho",
    "Added OK": "Adicionado",
    "Add selected parts to cart": "Adicionar as peças selecionadas ao carrinho",
    "All stock in cart": "Todo o stock está no carrinho",
    "Check fit": "Verificar compatibilidade",
    "In stock": "Em stock",
    "Out of stock": "Esgotado",
    "View details": "Ver detalhes",
    "See all parts for this model": "Ver todas as peças para este modelo",
    "Confirmed for your model": "Confirmado para o seu modelo",
    "confirmed parts": "peças confirmadas",
    "Description": "Descrição",
    "Price": "Preço",
    "Show only": "Mostrar apenas",
    "Added": "Adicionado",
    "In cart:": "No carrinho:",
    "Contact technical support": "Contactar o suporte técnico",
    "Do you still have the original belt?": "Ainda tem a correia original?",
    "Flat belt": "Correia plana",
    "Last unit left": "Última unidade disponível",
    "Open the full finder": "Abrir o localizador completo",
    "Round belt": "Correia redonda",
    "See everything for this model": "Ver tudo para este modelo",
    "Send message": "Enviar mensagem",
    "Square belt": "Correia quadrada",
    "Try again": "Tentar novamente",
    "View cart": "Ver carrinho",
    "We might have": "Podemos ter",
    "more parts for": "mais peças para",
    "Your name": "O seu nome",
    "Your email": "O seu e-mail",
    "Database loading, please wait…": "A base de dados está a carregar. Aguarde…",
    "Close": "Fechar",
    "Add": "Adicionar",
    "These are always useful for a repair:": "Estes artigos são sempre úteis numa reparação:",
    "Checkout securely": "Finalizar compra em segurança",
    "Brand, keep typing the model": "Marca introduzida; continue a escrever o modelo",
    "We will find it for you": "Nós encontramo-la por si",
    "before you pay": "antes de pagar",
    "Send your model or a photo": "Envie o modelo ou uma fotografia",
    "Free specialist support, answered by vintage audio repairers": "Apoio especializado gratuito, prestado por técnicos de áudio vintage",
    "Taking longer than usual, retrying for": "Está a demorar mais do que o habitual; nova tentativa para",
    "Gears & Mechanical Parts": "Engrenagens e peças mecânicas",
    "Belts & Belt Kits": "Correias e kits de correias",
    "Could not add": "Não foi possível adicionar",
    "No parts selected": "Nenhuma peça selecionada",
    "Belt measuring tool": "Guia de medição de correias",
    "Belts": "Correias",
    "Belt Kit": "Kit de correias",
    "Flat Belt": "Correia plana",
    "Square Belt": "Correia quadrada",
    "Round Belt": "Correia redonda",
    "Pinch Roller": "Roda de pressão",
    "Pinch Rollers & Tires": "Rodas de pressão e borrachas",
    "Idler Tire": "Borracha da roda intermédia",
    "Gears": "Engrenagens",
    "Mechanical Parts": "Peças mecânicas",
    "Laser Pickups": "Unidades ópticas",
    "Cleaning & Maintenance": "Limpeza e manutenção",
    "Motors": "Motores",
    "Batteries": "Baterias",
    "Gear and mechanism grease": "Massa para engrenagens e mecanismos",
    "Precision synthetic oil": "Óleo sintético de precisão",
    "Precision lubricant": "Lubrificante de precisão",
    "Rubber cleaner and revitaliser": "Produto de limpeza e revitalização de borracha",
    "Head cleaning fluid": "Líquido de limpeza de cabeças magnéticas",
    "Precision cleaning swabs": "Cotonetes de limpeza de precisão",
    "Service item": "Artigo de manutenção",
    "Grease, metal gears": "Massa para engrenagens metálicas",
    "Grease, metal & plastic": "Massa para metal e plástico",
    "Silicone oil, plastic-safe": "Óleo de silicone seguro para plástico",
    "Synthetic oil": "Óleo sintético",
    "Lid & hinge lubricant": "Lubrificante para tampas e dobradiças",
    "Cleaning kit": "Kit de limpeza",
    "Unavailable": "Indisponível",
    "Checking…": "A verificar…",
    "All compatible parts": "Todas as peças compatíveis",
    "All parts": "Todas as peças",
    "Best matches": "Melhores correspondências",
    "Confirmed parts": "Peças confirmadas",
    "Universal fit, suits all models": "Aplicação universal, adequada a todos os modelos",
    "In stock, ready to ship": "Em stock, pronto para envio",
    "Confirmed fit": "Compatibilidade confirmada",
    "model-specific part": "peça específica do modelo",
    "model-specific parts": "peças específicas do modelo",
    "confirmed part": "peça confirmada",
    "universal service item": "artigo de manutenção universal",
    "universal service items": "artigos de manutenção universais",
    "units": "unidades",
    "In stock, ": "Em stock, ",
    " units": " unidades",
    "Ask technical support before ordering": "Contacte o suporte técnico antes de encomendar",
    "see confirmed parts for your model": "ver as peças confirmadas para o seu modelo",
    "(some sizes grouped)": "(alguns tamanhos agrupados)",
    "Showing": "A mostrar",
    "of": "de",
    "parts": "peças",
    "Verified buyer": "Comprador verificado",
    "Translated from the customer original language": "Traduzido do idioma original do cliente",
    "Part no.": "Ref. da peça",
    "Stock": "Stock",
    "Show less": "Mostrar menos",
    "Confirmed": "Confirmado",
    "Checkout": "Finalizar compra",
    "Claim my free belt": "Pedir a minha correia gratuita",
    "Claim the free belt": "Pedir a correia gratuita",
    "Claim your free belt": "Pedir a sua correia gratuita",
    "Free specialist support": "Apoio especializado gratuito",
    "Full details on the product page.": "Detalhes completos na página do produto.",
    "Get your free belt": "Obter a sua correia gratuita",
    "How to measure your old belt": "Como medir a correia antiga",
    "Lay the old belt flat and relaxed next to a ruler": "Coloque a correia antiga estendida, sem tensão, junto a uma régua",
    "Loading description": "A carregar a descrição",
    "No parts in this category": "Não existem peças nesta categoria",
    "Open full page": "Abrir a página completa",
    "Photos of the mechanism": "Fotografias do mecanismo",
    "Repairing a different model?": "Está a reparar outro modelo?",
    "Uploading photos…": "A carregar fotografias…",
    "A member of our team replies": "Um membro da nossa equipa responde",
    "Ask us about specific parts": "Pergunte-nos sobre peças específicas",
    "Send": "Enviar",
    "Enter brand and model, e.g. Sony CDP-M301": "Introduza a marca e o modelo, por exemplo Sony CDP-M301",
    "None of these? We will identify the right belt for you. Free, you only pay shipping.": "Nenhuma destas? Identificamos a correia correta. A correia é gratuita; paga apenas os portes.",
    "No belt listed for the": "Ainda não existe uma correia indicada para o",
    "yet. We probably stock it.": "É provável que a tenhamos em stock.",
    "This model is in our database, but its belt has not been identified yet. Send a photo of the mechanism and tell us about the old belt. Once we confirm the match,": "Este modelo está na nossa base de dados, mas a correia ainda não foi identificada. Envie uma fotografia do mecanismo e informações sobre a correia antiga. Depois de confirmarmos a correspondência,",
    "the belt is free, you only cover shipping": "a correia é gratuita; paga apenas os portes",
    "We have the belt for your": "Temos a correia para o seu",
    "Help us confirm it.": "Ajude-nos a confirmar a correspondência.",
    "We stock the belt for the": "Temos em stock a correia para o",
    "We check every model by hand, and this one is not linked yet. There is a strong chance we already have the exact belt on the shelf. Confirm it with us and it is yours": "Verificamos manualmente todos os modelos e este ainda não está associado. É muito provável que já tenhamos a correia exata em stock. Confirme-a connosco e será sua",
    "free, you only pay shipping": "gratuitamente; paga apenas os portes",
    "Send your details and a photo or two. We reply Mon-Fri.": "Envie os seus dados e uma ou duas fotografias. Respondemos de segunda a sexta-feira.",
    "Confirmed fit for": "Compatibilidade confirmada para",
    "in the compatibility database.": "na base de dados de compatibilidade.",
    "Markings on the unit, the old belt size if you measured it, what the machine is doing…": "Inscrições no aparelho, medidas da correia antiga, caso as tenha, e o comportamento da máquina…",
    "Details": "Detalhes",
    "FREE BELT": "CORREIA GRATUITA",
    "Send us the model number printed on your unit, or just a photo of the label or mechanism. We confirm the exact part within one working day,": "Envie-nos o número do modelo impresso no aparelho ou uma fotografia da etiqueta ou do mecanismo. Confirmamos a peça exata no prazo de um dia útil,",
    "Could not add, try the product page": "Não foi possível adicionar; tente através da página do produto",
    "Could not add that option. It may be out of stock.": "Não foi possível adicionar essa opção. Poderá estar esgotada.",
    "Could not add the selected parts. Please try again.": "Não foi possível adicionar as peças selecionadas. Tente novamente.",
    "Free belt identification": "Identificação gratuita da correia",
    "Fits ": "Compatível com ",
    "Read full description": "Ler descrição completa",
    "Fuses": "Fusíveis",
    "Lighting": "Iluminação",
    "Insulators": "Isoladores",
    "Passives": "Componentes passivos",
    "Connectors & plugs": "Conectores e fichas",
    "Other compatible parts": "Outras peças compatíveis",
    "Head cleaner": "Produto de limpeza de cabeças magnéticas",
    "Cleaning swabs": "Cotonetes de limpeza",
    "Adhesive oil": "Óleo aderente",
    "Semiconductors": "Semicondutores",
    "Please choose up to ": "Selecione no máximo ",
    "Photos uploaded, reference ": "Fotografias carregadas, referência ",
    "Photos sent to our support inbox.": "Fotografias enviadas para a caixa de entrada do suporte.",
    "Customer selected photos but the upload could not be confirmed. Ask them to reply to the confirmation email with photos.": "O cliente selecionou fotografias, mas não foi possível confirmar o carregamento. Peça-lhe que responda ao e-mail de confirmação anexando as fotografias.",
    "Customer selected photos but the upload failed. Ask them to reply to the confirmation email with photos.": "O cliente selecionou fotografias, mas o carregamento falhou. Peça-lhe que responda ao e-mail de confirmação anexando as fotografias.",
    "Customer selected photos but upload is not configured. Ask them to reply to the confirmation email with photos.": "O cliente selecionou fotografias, mas o carregamento não está configurado. Peça-lhe que responda ao e-mail de confirmação anexando as fotografias.",
    "{n} part selected": "{n} peça selecionada",
    "{n} parts selected": "{n} peças selecionadas",
    "Repairing a <strong class=\"mono\">{m}</strong>? The database is busy right now.": "Está a reparar um <strong class=\"mono\">{m}</strong>? A base de dados está temporariamente ocupada.",
    "CL02-10 Laser Lens Cleaner · 1 ml": "Líquido de limpeza para lente laser CL02-10 · 1 ml",
    "DAT & Video Head Cleaner · 10 ml": "Líquido de limpeza para cabeças magnéticas rotativas de vídeo e DAT · 10 ml",
    "Mitsubishi C90 · Pack of 2": "Mitsubishi C90 · embalagem de 2",
    "Maxell UR90 · 90 min": "Maxell UR90 · 90 min",
    "Maxell UR60 · 60 min": "Maxell UR60 · 60 min",
    "Melted Belt Cleaner · 50 ml": "Líquido de remoção de correias derretidas · 50 ml",
    "Tonearm Cueing Damping Oil 300k · 1 ml": "Óleo de amortecimento do elevador do braço 300k · 1 ml",
    "Shell Gadus Grease · 7 ml": "Massa Shell Gadus · 7 ml",
    "Metal Gear & Lever Grease · 10 g": "Massa para engrenagens metálicas e alavancas · 10 g",
    "Full Synthetic Oil · 1 ml": "Óleo totalmente sintético · 1 ml",
    "Titanium Synthetic Oil · 1 ml": "Óleo sintético com tecnologia de titânio · 1 ml",
    "Super Adhesive Oil · 1 ml": "Óleo aderente · 1 ml"
  },
  "ro": {
    "Database updated": "Baza de date actualizată",
    "Connecting Cables": "Cabluri de conectare",
    "Antennas": "Antene",
    "Rubber Feet": "Piciorușe de cauciuc",
    "Feet": "Piciorușe",
    "Lamps": "Lămpi",
    "Switches": "Comutatoare",
    "Mats": "Covorașe",
    "Weights": "Contragreutăți",
    "Repair Kits": "Kituri de reparație",
    "Tools & Calibration": "Unelte și calibrare",
    "Connectors": "Conectori",
    "Cartridges": "Doze",
    "Heads": "Capete",
    "Fits {m}": "Compatibil cu {m}",
    "Yes, I have it": "Da, o am",
    "It snapped / in pieces": "S-a rupt / în bucăți",
    "No, it's gone": "Nu, a dispărut",
    "Add photos of the mechanism": "Adaugă fotografii ale mecanismului",
    "A photo of the belt path / mechanism tells us everything.": "O fotografie a traseului curelei / mecanismului ne spune tot.",
    "Open the machine and photograph the belt path / mechanism. JPG or PNG, we resize them for you.": "Deschide aparatul și fotografiază traseul curelei / mecanismul. JPG sau PNG, le redimensionăm noi.",
    "Tell us anything that helps identify it: markings on the unit, the old belt's size if you measured it, what the machine is doing…": "Spune-ne orice ajută la identificare: marcaje pe aparat, mărimea vechii curele dacă ai măsurat-o, ce face aparatul…",
    "Photos of the mechanism &amp; the old belt": "Fotografii ale mecanismului și ale vechii curele",
    "(this is what confirms the match)": "(asta confirmă potrivirea)",
    "Claim my free belt →": "Solicită cureaua mea gratuită →",
    "A member of our team replies · Mon–Fri": "Răspunde un membru al echipei noastre · lun–vin",
    "Grease for gears, levers and slide points, metal or plastic.": "Vaselină pentru roți dințate, pârghii și puncte de glisare, metal sau plastic.",
    "A light drop on motor bearings and metal pivots after a repair.": "O picătură fină pe rulmenții motorului și pivoții metalici după o reparație.",
    "Clinging oil for pivots and levers. Stays where you put it.": "Ulei aderent pentru pivoți și pârghii. Rămâne unde îl pui.",
    "Cleans tape heads, guides and capstans. Dull sound is often just dirt.": "Curăță capetele, ghidajele și capstanul. Sunetul înfundat e adesea doar murdărie.",
    "For sticky or slow cassette doors and lid hinges.": "Pentru uși de casetofon și balamale lente sau înțepenite.",
    "Grease for the metal gears and levers of the mechanism.": "Vaselină pentru roțile dințate și pârghiile metalice ale mecanismului.",
    "Oil for plastic gears, sliders and pivot points. Safe on plastic.": "Ulei pentru roți dințate din plastic, glisiere și pivoți. Sigur pe plastic.",
    "Recommended for your {m} repair": "Recomandate pentru reparația {m}",
    "Review cart &amp; checkout": "Verifică coșul și finalizează",
    "Keep shopping": "Continuă cumpărăturile",
    "We could not confirm this exact fit for <strong>{m}</strong>.": "Nu am putut confirma compatibilitatea exactă pentru <strong>{m}</strong>.",
    "or": "sau",
    "Rated 5 out of 5 on Trustpilot": "Evaluat 5 din 5 pe Trustpilot",
    "No matches for that spelling. Model not in the database yet? We'll identify the right belt for you. <strong>Free, you only pay shipping</strong>.": "Nicio potrivire pentru această scriere. Modelul nu e încă în baza de date? Îți identificăm noi cureaua potrivită. <strong>Gratuit, plătești doar transportul</strong>.",
    "Get your free belt →": "Primește cureaua gratuită →",
    "<strong>{b}</strong>. Now type the model number, or pick it from the list.": "<strong>{b}</strong>. Acum scrie numărul modelului sau alege-l din listă.",
    "<strong>{m}</strong> has no confirmed record yet. <strong>Send it to the workshop and we'll identify the right belt for you. Free, you only pay shipping.</strong>": "<strong>{m}</strong> nu are încă o înregistrare confirmată. <strong>Trimite-l atelierului și îți identificăm cureaua potrivită. Gratuit, plătești doar transportul.</strong>",
    "Claim the free belt →": "Revendică cureaua gratuită →",
    "Or <a href=\"/collections\">browse parts by category</a> / <a href=\"/collections/belts-by-size\">match a belt by its measurements</a>.": "Sau <a href=\"/collections\">explorează piesele pe categorii</a> / <a href=\"/collections/belts-by-size\">găsește o curea după dimensiuni</a>.",
    "FREE BELT · YOU ONLY PAY SHIPPING": "CUREA GRATUITĂ · PLĂTEȘTI DOAR TRANSPORTUL",
    "Lay the old belt flat and relaxed next to a ruler. Don’t stretch it. Tell us the <strong>length</strong> and whether the cross-section is <strong>flat, square or round</strong>. A photo like these is perfect.": "Așază cureaua veche întinsă pe plat și relaxată lângă o riglă. Nu o tensiona. Spune-ne <strong>lungimea</strong> și dacă secțiunea este <strong>plată, pătrată sau rotundă</strong>. O fotografie ca acestea este perfectă.",
    "flat / folded loop, measure the length": "buclă plată / îndoită, măsoară lungimea",
    "measure total length laid flat": "măsoară lungimea totală întinsă pe plat",
    "flat-sided cross-section": "secțiune cu laturi plate",
    "circular cross-section": "secțiune circulară",
    "A photo of the belt next to the ruler, and one of the mechanism, tells us everything.": "O fotografie a curelei lângă riglă, și una a mecanismului, ne spune tot.",
    "What’s the machine doing?": "Ce face aparatul?",
    "Belt loose or snapped, tape won’t move, markings on the unit…": "Curea slăbită sau ruptă, banda nu se mișcă, marcaje pe aparat…",
    "{n} parts added to your cart": "{n} piese adăugate în coș",
    "{n} part added to your cart": "{n} piesă adăugată în coș",
    "Option": "Opțiune",
    "View full image": "Vezi imaginea completă",
    "Try another part type, or send us your model number. We check the database manually and add new references weekly.": "Încearcă alt tip de piesă sau trimite-ne numărul modelului. Verificăm baza de date manual și adăugăm referințe noi săptămânal.",
    "No model-specific wear parts are listed for this model yet. Below are <strong>universal service items</strong> that suit any machine.": "Nicio piesă de uzură specifică nu este listată încă pentru acest model. Mai jos sunt <strong>articole universale de service</strong> care se potrivesc oricărui aparat.",
    "We check models manually.": "verificăm modelele manual.",
    "{n} more below in <strong>{c}</strong>": "încă {n} mai jos în <strong>{c}</strong>",
    "more categories": "mai multe categorii",
    "We could not find <strong>{m}</strong> in the database. Check the spelling, or <a href=\"{u}\">ask technical support</a>.": "Nu am găsit <strong>{m}</strong> în baza de date. Verifică scrierea sau <a href=\"{u}\">întreabă suportul tehnic</a>.",
    "We could not find that exact model in the database. Check the spelling, or <a href=\"{u}\">ask technical support</a> before ordering.": "Nu am găsit exact acest model în baza de date. Verifică scrierea sau <a href=\"{u}\">întreabă suportul tehnic</a> înainte de a comanda.",
    "Checking the compatibility database…": "Se verifică baza de date de compatibilitate…",
    "parts for {m}": "piese pentru {m}",
    "Also confirmed for {m}:": "Confirmat și pentru {m}:",
    "All {n}": "Toate {n}",
    "Universal service items": "Articole de service universale",
    "See all {n} parts for {m}": "Vezi toate cele {n} piese pentru {m}",
    "See all {n} part for {m}": "Vezi {n} piesă pentru {m}",
    "Confirmed fit, <strong class=\"mono\">{m}</strong> · verified in our database": "Compatibilitate confirmată, <strong class=\"mono\">{m}</strong> · verificat în baza noastră de date",
    "Checking the compatibility database for <strong class=\"mono\">": "Se verifică baza de date de compatibilitate pentru <strong class=\"mono\">",
    "All {n} confirmed parts for this exact model, shown below.": "Toate cele {n} piese confirmate pentru exact acest model, afișate mai jos.",
    "your model": "modelul tău",
    "This page has the model-specific part. The items below suit any machine and help a fresh repair last: clean the path, lubricate the mechanism, protect the new part.": "Această pagină are piesa specifică modelului. Articolele de mai jos se potrivesc oricărui aparat și ajută o reparație proaspătă să dureze: curăță traseul, lubrifiază mecanismul, protejează piesa nouă.",
    "No other model-specific wear parts are listed for this model. Below are <strong>universal service items</strong> that suit any machine.": "Nicio altă piesă de uzură specifică nu este listată pentru acest model. Mai jos sunt <strong>articole universale de service</strong> care se potrivesc oricărui aparat.",
    "Handy universal add-ons, suit any machine:": "Accesorii universale utile, se potrivesc oricărui aparat:",
    "See {n} universal service items (suit any machine)": "Vezi {n} articole universale de service (se potrivesc oricărui aparat)",
    "Please choose up to {n} photos. We kept the first {n}.": "Alege cel mult {n} fotografii. Le-am păstrat pe primele {n}.",
    "The parts database is taking a moment to respond.": "Baza de date cu piese are nevoie de un moment pentru a răspunde.",
    "Connecting to the database. Your search will run automatically in a moment…": "Se conectează la baza de date. Căutarea ta va rula automat într-un moment…",
    "Pick your model from the list, or use the free identification below it.": "Alege modelul tău din listă, sau folosește identificarea gratuită de mai jos.",
    "Type the brand and model printed on your unit, e.g. <strong>Sony CDP-M301</strong>, then pick it from the list.": "Scrie marca și modelul tipărite pe aparatul tău, de ex. <strong>Sony CDP-M301</strong>, apoi alege-l din listă.",
    "<strong>{n} brands</strong> loaded. Try Sony TC-K611S, Pioneer CT-F850…": "<strong>{n} mărci</strong> încărcate. Încearcă Sony TC-K611S, Pioneer CT-F850…",
    "Retrying automatically. Meanwhile you can <a href=\"/search?type=product\">search by keyword</a> or <a href=\"{u}\">ask technical support</a>.": "Se reîncearcă automat. Între timp poți <a href=\"/search?type=product\">căuta după cuvânt-cheie</a> sau <a href=\"{u}\">întreba suportul tehnic</a>.",
    "or <a href=\"{u}\">contact technical support</a>.": "sau <a href=\"{u}\">contactează suportul tehnic</a>.",
    "Checking the compatibility database for <strong>{m}</strong>…": "Se verifică baza de date de compatibilitate pentru <strong>{m}</strong>…",
    "The database is taking longer than usual, retrying for <strong>{m}</strong>…": "Baza de date durează mai mult decât de obicei, se reîncearcă pentru <strong>{m}</strong>…",
    "The database is still loading. Try again in a moment.": "Baza de date încă se încarcă. Încearcă din nou într-un moment.",
    "Universal add-ons, suit any machine": "Accesorii universale, se potrivesc oricărui aparat",
    "Find compatible parts": "Găsește piese compatibile",
    "Enter brand and model…": "Introdu marca și modelul…",
    "Checking database…": "Se verifică baza de date…",
    "Checking…": "Se verifică…",
    "Add to cart": "Adaugă în coș",
    "Adding…": "Se adaugă…",
    "Added to cart": "Adăugat în coș",
    "Added OK": "Adăugat",
    "Add selected parts to cart": "Adaugă piesele selectate în coș",
    "All stock in cart": "Tot stocul în coș",
    "All compatible parts": "Toate piesele compatibile",
    "All parts": "Toate piesele",
    "Best matches": "Cele mai bune potriviri",
    "Confirmed parts": "Piese confirmate",
    "Check fit": "Verifică potrivirea",
    "Universal fit, suits all models": "Compatibilitate universală, se potrivește oricărui model",
    "In stock": "În stoc",
    "In stock, ready to ship": "În stoc, gata de expediere",
    "Out of stock": "Stoc epuizat",
    "View details": "Vezi detalii",
    "See all parts for this model": "Vezi toate piesele pentru acest model",
    "Confirmed fit": "Compatibilitate confirmată",
    "Confirmed for your model": "Confirmat pentru modelul tău",
    "model-specific part": "piesă specifică modelului",
    "model-specific parts": "piese specifice modelului",
    "confirmed part": "piesă confirmată",
    "confirmed parts": "piese confirmate",
    "universal service item": "articol de service universal",
    "universal service items": "articole de service universale",
    "units": "unități",
    "In stock, ": "În stoc, ",
    " units": " unități",
    "Ask technical support before ordering": "Întreabă suportul tehnic înainte de comandă",
    "see confirmed parts for your model": "vezi piesele confirmate pentru modelul tău",
    "(some sizes grouped)": "(unele dimensiuni grupate)",
    "Showing": "Se afișează",
    "of": "din",
    "parts": "piese",
    "Verified buyer": "Cumpărător verificat",
    "Translated from the customer original language": "Tradus din limba originală a clientului",
    "Description": "Descriere",
    "Part no.": "Nr. piesă",
    "Stock": "Stoc",
    "Price": "Preț",
    "Show less": "Arată mai puțin",
    "Confirmed": "Confirmat",
    "Show only": "Arată doar",
    "Added": "Adăugat",
    "In cart:": "În coș:",
    "Checkout": "Finalizează comanda",
    "Claim my free belt": "Revendică cureaua mea gratuită",
    "Claim the free belt": "Revendică cureaua gratuită",
    "Claim your free belt": "Revendică-ți cureaua gratuită",
    "Contact technical support": "Contactează suportul tehnic",
    "Do you still have the original belt?": "Mai ai cureaua originală?",
    "Flat belt": "Curea plată",
    "Free specialist support": "Suport specializat gratuit",
    "Full details on the product page.": "Detalii complete pe pagina produsului.",
    "Get your free belt": "Obține cureaua gratuită",
    "How to measure your old belt": "Cum să măsori cureaua veche",
    "Last unit left": "Ultima unitate",
    "Lay the old belt flat and relaxed next to a ruler": "Întinde cureaua veche, relaxată, lângă o riglă",
    "Loading description": "Se încarcă descrierea",
    "No parts in this category": "Nicio piesă în această categorie",
    "Open full page": "Deschide pagina completă",
    "Open the full finder": "Deschide căutarea completă",
    "Photos of the mechanism": "Fotografii ale mecanismului",
    "Repairing a different model?": "Repari un alt model?",
    "Round belt": "Curea rotundă",
    "See everything for this model": "Vezi tot pentru acest model",
    "Send message": "Trimite mesajul",
    "Square belt": "Curea pătrată",
    "Try again": "Încearcă din nou",
    "Uploading photos…": "Se încarcă fotografiile…",
    "View cart": "Vezi coșul",
    "A member of our team replies": "Un membru al echipei răspunde",
    "Ask us about specific parts": "Întreabă-ne despre piese anume",
    "Send": "Trimite",
    "We might have": "S-ar putea să avem",
    "more parts for": "mai multe piese pentru",
    "Enter brand and model, e.g. Sony CDP-M301": "Introdu marca și modelul, ex. Sony CDP-M301",
    "None of these? We will identify the right belt for you. Free, you only pay shipping.": "Niciuna dintre acestea? Identificăm cureaua potrivită pentru tine. Gratuit, plătești doar livrarea.",
    "No belt listed for the": "Nicio curea listată pentru",
    "yet. We probably stock it.": "încă. Probabil o avem în stoc.",
    "This model is in our database, but its belt has not been identified yet. Send a photo of the mechanism and tell us about the old belt. Once we confirm the match,": "Acest model este în baza noastră de date, dar cureaua lui nu a fost încă identificată. Trimite o fotografie a mecanismului și spune-ne despre cureaua veche. Odată ce confirmăm potrivirea,",
    "the belt is free, you only cover shipping": "cureaua este gratuită, plătești doar livrarea",
    "We have the belt for your": "Avem cureaua pentru",
    "Help us confirm it.": "Ajută-ne să o confirmăm.",
    "We stock the belt for the": "Avem în stoc cureaua pentru",
    "We check every model by hand, and this one is not linked yet. There is a strong chance we already have the exact belt on the shelf. Confirm it with us and it is yours": "Verificăm fiecare model manual, iar acesta nu este încă asociat. Sunt șanse mari să avem deja cureaua exactă pe raft. Confirm-o cu noi și este a ta",
    "free, you only pay shipping": "gratuit, plătești doar livrarea",
    "Send your details and a photo or two. We reply Mon-Fri.": "Trimite datele tale și o fotografie sau două. Răspundem Lun-Vin.",
    "Confirmed fit for": "Compatibilitate confirmată pentru",
    "in the compatibility database.": "în baza de date de compatibilitate.",
    "Markings on the unit, the old belt size if you measured it, what the machine is doing…": "Marcaje de pe aparat, dimensiunea curelei vechi dacă ai măsurat-o, ce face mașina…",
    "Details": "Detalii",
    "Your name": "Numele tău",
    "Your email": "Emailul tău",
    "FREE BELT": "CUREA GRATUITĂ",
    "Database loading, please wait…": "Baza de date se încarcă, te rugăm așteaptă…",
    "Close": "Închide",
    "Add": "Adaugă",
    "These are always useful for a repair:": "Acestea sunt mereu utile pentru o reparație:",
    "Checkout securely": "Finalizează comanda în siguranță",
    "Brand, keep typing the model": "Marcă, continuă să tastezi modelul",
    "We will find it for you": "O găsim pentru tine",
    "Send us the model number printed on your unit, or just a photo of the label or mechanism. We confirm the exact part within one working day,": "Trimite-ne numărul modelului imprimat pe aparatul tău, sau doar o fotografie a etichetei sau a mecanismului. Confirmăm piesa exactă în termen de o zi lucrătoare,",
    "before you pay": "înainte să plătești",
    "Send your model or a photo": "Trimite modelul tău sau o fotografie",
    "Free specialist support, answered by vintage audio repairers": "Suport specializat gratuit, oferit de reparatori de audio vintage",
    "Taking longer than usual, retrying for": "Durează mai mult decât de obicei, se reîncearcă pentru",
    "Gears & Mechanical Parts": "Roți dințate și piese mecanice",
    "Belts & Belt Kits": "Curele și seturi de curele",
    "Could not add": "Nu s-a putut adăuga",
    "Could not add, try the product page": "Nu s-a putut adăuga, încearcă pagina produsului",
    "Could not add that option. It may be out of stock.": "Nu s-a putut adăuga acea opțiune. Poate fi epuizată.",
    "Could not add the selected parts. Please try again.": "Nu s-au putut adăuga piesele selectate. Te rugăm încearcă din nou.",
    "No parts selected": "Nicio piesă selectată",
    "Free belt identification": "Identificare curea gratuită",
    "Fits ": "Se potrivește ",
    "Read full description": "Citește descrierea completă",
    "Belt measuring tool": "Instrument de măsurare curea",
    "Belts": "Curele",
    "Belt Kit": "Set curele",
    "Flat Belt": "Curea plată",
    "Square Belt": "Curea pătrată",
    "Round Belt": "Curea rotundă",
    "Pinch Roller": "Rolă presoare",
    "Pinch Rollers & Tires": "Role presoare și pneuri pentru roți intermediare",
    "Idler Tire": "Pneu pentru roată intermediară",
    "Gears": "Roți dințate",
    "Mechanical Parts": "Piese mecanice",
    "Laser Pickups": "Unități optice",
    "Cleaning & Maintenance": "Curățare & Întreținere",
    "Motors": "Motoare",
    "Batteries": "Baterii",
    "Fuses": "Siguranțe",
    "Lighting": "Iluminare",
    "Insulators": "Izolatoare",
    "Passives": "Componente pasive",
    "Connectors & plugs": "Conectori & fișe",
    "Other compatible parts": "Alte piese compatibile",
    "Gear and mechanism grease": "Vaselină pentru roți dințate și mecanism",
    "Precision synthetic oil": "Ulei sintetic de precizie",
    "Precision lubricant": "Lubrifiant de precizie",
    "Rubber cleaner and revitaliser": "Curățător și revitalizant pentru cauciuc",
    "Head cleaner": "Curățător de capete",
    "Head cleaning fluid": "Lichid de curățare a capetelor",
    "Cleaning swabs": "Tampoane de curățare",
    "Precision cleaning swabs": "Tampoane de curățare de precizie",
    "Adhesive oil": "Ulei adeziv",
    "Service item": "Articol de service",
    "Grease, metal gears": "Vaselină, roți dințate metalice",
    "Grease, metal & plastic": "Vaselină, metal și plastic",
    "Silicone oil, plastic-safe": "Ulei siliconic, sigur pentru plastic",
    "Synthetic oil": "Ulei sintetic",
    "Lid & hinge lubricant": "Lubrifiant pentru capac și balamale",
    "Cleaning kit": "Kit de curățare",
    "Unavailable": "Indisponibil",
    "Semiconductors": "Semiconductori",
    "Please choose up to ": "Te rugăm alege până la ",
    "Photos uploaded, reference ": "Fotografii încărcate, referință ",
    "Photos sent to our support inbox.": "Fotografii trimise către suportul nostru.",
    "Customer selected photos but the upload could not be confirmed. Ask them to reply to the confirmation email with photos.": "Clientul a selectat fotografii dar încărcarea nu a putut fi confirmată. Roagă-l să răspundă la emailul de confirmare cu fotografii.",
    "Customer selected photos but the upload failed. Ask them to reply to the confirmation email with photos.": "Clientul a selectat fotografii dar încărcarea a eșuat. Roagă-l să răspundă la emailul de confirmare cu fotografii.",
    "Customer selected photos but upload is not configured. Ask them to reply to the confirmation email with photos.": "Clientul a selectat fotografii dar încărcarea nu este configurată. Roagă-l să răspundă la emailul de confirmare cu fotografii.",
    "{n} part selected": "{n} piesă selectată",
    "{n} parts selected": "{n} piese selectate",
    "Repairing a <strong class=\"mono\">{m}</strong>? The database is busy right now.": "Repari un <strong class=\"mono\">{m}</strong>? Baza de date este ocupată momentan.",
    "CL02-10 Laser Lens Cleaner · 1 ml": "Soluție pentru curățarea lentilei laser CL02-10 · 1 ml",
    "DAT & Video Head Cleaner · 10 ml": "Soluție pentru curățarea capetelor DAT și video · 10 ml",
    "Mitsubishi C90 · Pack of 2": "Mitsubishi C90 · pachet de 2",
    "Maxell UR90 · 90 min": "Maxell UR90 · 90 min",
    "Maxell UR60 · 60 min": "Maxell UR60 · 60 min",
    "Melted Belt Cleaner · 50 ml": "Soluție pentru îndepărtarea curelelor topite · 50 ml",
    "Tonearm Cueing Damping Oil 300k · 1 ml": "Ulei de amortizare pentru liftul brațului 300k · 1 ml",
    "Shell Gadus Grease · 7 ml": "Vaselină Shell Gadus · 7 ml",
    "Metal Gear & Lever Grease · 10 g": "Vaselină pentru roți dințate metalice și pârghii · 10 g",
    "Full Synthetic Oil · 1 ml": "Ulei complet sintetic · 1 ml",
    "Titanium Synthetic Oil · 1 ml": "Ulei sintetic cu tehnologie pe bază de titan · 1 ml",
    "Super Adhesive Oil · 1 ml": "Ulei aderent · 1 ml"
  }
};
  function T(s) {
    var loc = (window.WSP && window.WSP.locale) || (document.documentElement && document.documentElement.lang) || 'en';
    loc = String(loc).toLowerCase().split('-')[0];
    var dict = I18N[loc];
    return (dict && dict[s]) || s;
  }
  /* backend endpoint is shipped reversed+base64 so the URL never appears
     in page source; decoded only at runtime */
  var BACKEND = (function () {
    if (WSP.backend) return WSP.backend; /* legacy plain config */
    try { return atob(WSP.be64 || '').split('').reverse().join(''); } catch (e) { return ''; }
  })();
  /* daily access token - the Apps Script backend can require this
     (see docs/APPS-SCRIPT-PROTECTION.md); harmless if not enforced yet */
  var TOKEN_SALT = [119,115,112,45,116,101,115,115,105,116,117,114,97,45,50,49,56,57].map(function (c) { return String.fromCharCode(c); }).join('');
  function accessToken() {
    var d = new Date();
    var day = d.getUTCFullYear() * 10000 + (d.getUTCMonth() + 1) * 100 + d.getUTCDate();
    try { return btoa(day + '|' + TOKEN_SALT).replace(/=+$/, ''); } catch (e) { return ''; }
  }
  function beUrl(params) {
    return BACKEND + (BACKEND.indexOf('?') === -1 ? '?' : '&') + params + '&k=' + encodeURIComponent(accessToken());
  }
  /* v4.63 - show when the compatibility database was last refreshed.
     One backend call per visitor per day (localStorage cache). */
  (function () {
    var el = document.querySelector('[data-db-updated]');
    if (!el || !BACKEND) return;
    function show(iso) {
      var d = new Date(iso);
      if (isNaN(+d)) return;
      var loc = (window.WSP && window.WSP.locale) || 'en';
      var txt = T('Database updated') + ': ' + d.toLocaleDateString(loc, { day: 'numeric', month: 'short', year: 'numeric' });
      el.textContent = txt;
      el.hidden = false;
    }
    var KEYNAME = 'wspDbMeta';
    try {
      var c = JSON.parse(localStorage.getItem(KEYNAME) || 'null');
      if (c && c.ts && (Date.now() - c.ts) < 86400000 && c.updated) { show(c.updated); return; }
    } catch (e) {}
    fetch(beUrl('action=dbmeta'))
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (j && j.updated) {
          try { localStorage.setItem(KEYNAME, JSON.stringify({ ts: Date.now(), updated: j.updated })); } catch (e) {}
          show(j.updated);
        }
      })
      .catch(function () {});
  })();
  /* headless scrapers (Puppeteer/Playwright defaults) get no database */
  function botLikely() {
    try {
      return !!navigator.webdriver || !navigator.languages || navigator.languages.length === 0;
    } catch (e) { return false; }
  }
  var COMPAT_URL = WSP.compatUrl || '/pages/compatibility-database';
  var CONTACT_URL = WSP.contactUrl || '/pages/contact';
  /* On localized markets Shopify serves the store under a locale root
     (e.g. /ro-ro). Storefront endpoints like /search/suggest.json must
     carry that prefix or they 404/redirect and the finder hangs. rootUrl
     is '/' on the primary market and '/ro-ro' etc. on others. */
  var ROOT = (WSP.rootUrl && WSP.rootUrl !== '/') ? WSP.rootUrl.replace(/\/$/, '') : '';
  /* Translated dictionary strings carry root-relative hrefs
     (href="/search...", href="/collections..."). Localize them before
     they hit innerHTML; run BEFORE filling {u}-style placeholders so
     already-localized values never get double-prefixed. */
  function lhtml(html) {
    if (!ROOT) return String(html);
    return String(html).replace(/href="\//g, 'href="' + ROOT + '/');
  }
  function lurl(path) {
    if (/^https?:/i.test(path)) return path;      /* absolute external */
    if (path.charAt(0) !== '/') return path;       /* relative, leave */
    if (ROOT && (path === ROOT || path.indexOf(ROOT + '/') === 0)) return path; /* already localized */
    return ROOT + path;                            /* prefix locale root */
  }
  var CACHE_KEY = 'wsp_db_v8';
  var RECENT_KEY = 'wsp_recent_v8';
  var MEMORY_KEY = 'wsp_model_memory_v1';
  function ERROR_MSG_T(){ return T('The parts database is taking a moment to respond.'); }

  /* ------------------------------------------------------------ helpers */
  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }
  function esc(s) {
    return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function lev(a, b, maxDistance) {
    var limit = typeof maxDistance === 'number' ? maxDistance : Math.max(a.length, b.length);
    var beyond = limit + 1;
    if (Math.abs(a.length - b.length) > limit) return beyond;
    if (!a.length) return Math.min(b.length, beyond);
    if (!b.length) return Math.min(a.length, beyond);
    var p = [], c = [];
    for (var j = 0; j <= b.length; j++) p[j] = Math.min(j, beyond);
    for (var i = 1; i <= a.length; i++) {
      var first = Math.max(1, i - limit), last = Math.min(b.length, i + limit);
      c[0] = Math.min(i, beyond);
      if (first > 1) c[first - 1] = beyond;
      var rowMin = c[0];
      for (var k = first; k <= last; k++) {
        c[k] = a[i - 1] === b[k - 1] ? p[k - 1] : 1 + Math.min(p[k], c[k - 1], p[k - 1]);
        rowMin = Math.min(rowMin, c[k]);
      }
      if (last < b.length) c[last + 1] = beyond;
      if (rowMin > limit) return beyond;
      var swap = p; p = c; c = swap;
    }
    return Math.min(p[b.length], beyond);
  }
  function debounce(fn, ms) {
    var t = null;
    return function () {
      var args = arguments, self = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(self, args); }, ms);
    };
  }
  /* ============ price correctness across currencies ============
     /search/suggest.json returns prices in the SHOP currency (EUR).
     The old fmtPrice formatted that EUR number with whatever currency
     the visitor selected - a pure symbol swap ("$8.60" for a part that
     costs $12.00 in the US market, since Markets prices include
     adjustments and rounding, not just FX). Rules now:
       - price numbers from /products/{handle}.js are presentment
         (cart) currency -> format with the ACTIVE currency;
       - suggest.json numbers are shop currency -> only shown when the
         active currency IS the shop currency; otherwise we render an
         empty price and hydrate the real one from product .js. */
  var SHOP_CURRENCY = (window.WSP && window.WSP.shopCurrency) || 'EUR';
  function activeCurrency() {
    return (window.WSP && window.WSP.currency) || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || SHOP_CURRENCY;
  }
  function needsPriceHydration(p) {
    return activeCurrency() !== SHOP_CURRENCY && !(p && p._priceFromProductJson);
  }
  /* fetch the authoritative presentment price and write it into a DOM
     node once ready (product .js responses are cached + deduped) */
  /* second-image-on-hover: cards flip to the product's second photo.
     Attributes are set post-hydration; one delegated listener pair
     handles every card the finder renders (results, strip, upsell). */
  function sizedImg(u, w) {
    if (!u) return '';
    u = String(u);
    if (u.indexOf('cdn.shopify') === -1 && u.indexOf('/cdn/') === -1) return u;
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + (w || 480);
  }
  function ensureHoverAlt(p, rootEl) {
    if (!rootEl) return;
    hydrateProduct(p).then(function () {
      if (!p._img2) return;
      var img = rootEl.querySelector('.crow__media img, .lrow__media img, .prodcompat__media img, .rsitem__media img');
      if (!img || img.getAttribute('data-alt-src')) return;
      img.setAttribute('data-base-src', img.getAttribute('src') || '');
      var altSrc = sizedImg(p._img2, 480);
      img.setAttribute('data-alt-src', altSrc);
      img.classList.add('has-altimg');
      var pre = new Image(); pre.src = altSrc; /* warm the cache */
    }).catch(function () {}); /* optional hover image, not compatibility proof */
  }
  function altImgFrom(e) {
    var t = e.target;
    if (!t || !t.closest) return null;
    /* the hovered element may be the media wrapper, the card, or the
       image itself - find the nearest card and its swappable image */
    var scope = t.closest('.crow, .lrow, .prodcompat__item, .rsitem, .csec__single, [data-quick]') || t.parentNode;
    return scope ? scope.querySelector('img[data-alt-src]') : null;
  }
  /* full-image lightbox: clicking the magnifier over a card image opens
     the photo at full size, without triggering the quick-view panel */
  var wspLightbox = null;
  function openLightbox(src) {
    if (!wspLightbox) {
      wspLightbox = document.createElement('div');
      wspLightbox.className = 'wsplightbox';
      wspLightbox.hidden = true;
      wspLightbox.innerHTML =
        '<div class="wsplightbox__backdrop" data-lb-close></div>' +
        '<div class="wsplightbox__stage">' +
          '<button class="wsplightbox__close" type="button" data-lb-close aria-label="Close">&#10005;</button>' +
          '<img class="wsplightbox__img" alt="">' +
        '</div>';
      document.body.appendChild(wspLightbox);
      wspLightbox.addEventListener('click', function (e) {
        if (e.target.closest('[data-lb-close]')) closeLightbox();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && wspLightbox && !wspLightbox.hidden) closeLightbox();
      });
    }
    var im = wspLightbox.querySelector('.wsplightbox__img');
    im.src = src;
    wspLightbox.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closeLightbox() {
    if (!wspLightbox) return;
    wspLightbox.hidden = true;
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var z = e.target.closest && e.target.closest('[data-zoom-src]');
    if (z) {
      e.preventDefault();
      e.stopPropagation();
      openLightbox(z.getAttribute('data-zoom-src'));
    }
  }, true);

  var _hoverCard = null;
  function cardFrom(t) {
    return t && t.closest ? t.closest('.crow, .lrow, .prodcompat__item, .rsitem, .csec__single, [data-quick]') : null;
  }
  document.addEventListener('mouseover', function (e) {
    var card = cardFrom(e.target);
    if (!card || card === _hoverCard) return;   /* still inside same card */
    _hoverCard = card;
    var img = card.querySelector('img[data-alt-src]');
    if (img) img.src = img.getAttribute('data-alt-src');
  });
  document.addEventListener('mouseout', function (e) {
    if (!_hoverCard) return;
    /* only revert when the pointer actually LEAVES the card */
    var to = e.relatedTarget;
    if (to && _hoverCard.contains(to)) return;
    var card = cardFrom(e.target);
    if (card !== _hoverCard) return;
    var img = _hoverCard.querySelector('img[data-alt-src]');
    if (img) img.src = img.getAttribute('data-base-src');
    _hoverCard = null;
  });

  function hydratePriceInto(p, el) {
    if (!el || !needsPriceHydration(p)) return;
    hydrateProduct(p).then(function () {
      if (p._priceFromProductJson) {
        var txt = fmtPrice(p.price, true);
        if (txt) el.textContent = txt;
      }
    }).catch(function () {}); /* optional refresh of an already-rendered price */
  }
  function fmtPrice(v, fromProductJson) {
    if (v === undefined || v === null || v === '') return '';
    var raw = String(v).replace(/[^0-9.]/g, '');
    var n = parseFloat(raw);
    if (isNaN(n)) return '';
    if (fromProductJson && String(v).indexOf('.') === -1) n = n / 100;
    else if (n > 500 && String(v).indexOf('.') === -1) n = n / 100;
    /* shop-currency data + foreign session: showing this number would
       be wrong in every case - leave blank, hydration fills it in */
    if (!fromProductJson && activeCurrency() !== SHOP_CURRENCY) return '';
    var curr = fromProductJson ? activeCurrency() : SHOP_CURRENCY;
    try {
      if (window.WSP && typeof window.WSP.formatMoney === 'function') return window.WSP.formatMoney(n * 100);
      var locale = document.documentElement.lang || (window.WSP && window.WSP.locale) || 'en-US';
      return n.toLocaleString(locale, { style: 'currency', currency: curr, minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } catch (e) { return n.toFixed(2); }
  }

  /* ============ post-add-to-cart upsell ============
     After anything is added, offer (a) the full model search when the
     product title reveals a model, and (b) universal cleaning /
     maintenance add-ons cached from previous searches. */
  var maintCache = [];
  function rememberMaintenance(products) {
    (products || []).forEach(function (p) {
      /* universal-only: greases/oils/lubricants that fit any machine.
         Machine-specific cleaners never enter the cross-model cache. */
      if (!isUniversalMaint(p) || !isAvailable(p)) return;
      var k = productMergeKey(p);
      if (maintCache.some(function (m) { return productMergeKey(m) === k; })) return;
      maintCache.push(p);
      /* Pre-hydration data (suggest.json / search rows) has no variants, so
         a used part titled "Synthetic oil" can pass the first check - its
         "Condition: Used - Original OEM" only arrives with product.js.
         Re-validate once hydrated and EVICT if it turns out second-hand.
         (Root cause of the used item appearing in the cart upsell.) */
      var needH = needsPriceHydration(p) || !pData(p);
      if (needH) {
        hydrateProduct(p).then(function (hp) {
          if (!isUniversalMaint(hp)) {
            var kk = productMergeKey(hp);
            maintCache = maintCache.filter(function (m) { return productMergeKey(m) !== kk; });
          }
        }).catch(function () {
          var kk = productMergeKey(p);
          maintCache = maintCache.filter(function (m) { return productMergeKey(m) !== kk; });
        });
      }
    });
    if (maintCache.length > 8) maintCache = maintCache.slice(0, 8);
  }
  function ensureMaintCache() {
    if (maintCache.length >= 2) return Promise.resolve(maintCache);
    /* Search only the universal lubrication families - grease, oil and
       lubricant. 'cleaning' was dropped: the store's cleaning products
       are vinyl-record fluids/kits and tape head cleaners, each tied to
       one deck type, so they don't belong in a "suits any machine" box. */
    return Promise.all(['grease', 'oil', 'lubricant'].map(function (q) {
      return fetch(lurl('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=4'), { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (res) { return (res.resources && res.resources.results && res.resources.results.products) || []; })
        .catch(function () { return []; });
    })).then(function (groups) {
      /* interleave the families round-robin so grease, oil AND lubricant
         are each represented, then keep only genuinely universal items.
         The old code flattened the groups and kept the first 4, which
         were always grease. */
      var flat = [], seen = {};
      var maxLen = groups.reduce(function (m, g) { return Math.max(m, g.length); }, 0);
      for (var col = 0; col < maxLen; col++) {
        for (var gi = 0; gi < groups.length; gi++) {
          var p = groups[gi][col];
          if (!p || !isUniversalMaint(p)) continue;
          var key = String(p.handle || p.id);
          if (seen[key]) continue;
          seen[key] = 1;
          flat.push(p);
        }
      }
      return Promise.all(flat.slice(0, 6).map(hydrateProduct)).then(function (hyd) {
        rememberMaintenance(hyd);
        return maintCache;
      });
    });
  }
  var upsellTimer = null;
  function hideUpsell() {
    window.__wspUpsellActive = false;
    var el = document.getElementById('wsp-upsell');
    if (el) { el.classList.remove('is-in'); setTimeout(function () { el.hidden = true; }, 220); }
  }
  function isMaintenanceTitle(t) {
    return /grease|oil|adhesive|cleaner|cleaning|lubricant|solvent|maintenance/i.test(String(t || ''));
  }
  function showCartUpsell(addedTitle) {
    if (document.body.dataset.wspUpsellBusy) return; /* adds from inside the panel */
    /* adding a cleaning/maintenance product shouldn't suggest more of the same */
    if (isMaintenanceTitle(addedTitle)) return;
    var el = document.getElementById('wsp-upsell');
    if (!el) {
      el = document.createElement('aside');
      el.id = 'wsp-upsell';
      el.hidden = true;
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    var match = detectModelFromText(addedTitle || '') || (function () {
      try { return JSON.parse(sessionStorage.getItem(MEMORY_KEY) || 'null'); } catch (e) { return null; }
    }());
    var modelHtml = '';
    if (match && match.brand && match.model) {
      modelHtml = '<p class="upsell__model">' + T('We might have') + ' <strong>' + T('more parts for') + ' ' + esc(match.brand + ' ' + match.model) + '</strong>.</p>' +
        '<a class="btn btn--primary btn--sm" href="' + esc(COMPAT_URL) + '?brand=' + encodeURIComponent(match.brand) + '&model=' + encodeURIComponent(match.model) + '">' + T('See everything for this model') + '</a>';
    }
    ensureMaintCache().then(function (items) {
      /* variety: never the just-added product, rotate through the pool */
      var pool = items.filter(function (p) { return p.title !== addedTitle && isUniversalMaint(p); });
      var rot = 0;
      try { rot = (parseInt(sessionStorage.getItem('wsp_upsell_rot') || '0', 10) + 1) % Math.max(pool.length, 1);
            sessionStorage.setItem('wsp_upsell_rot', String(rot)); } catch (e) {}
      var picks = pool.slice(rot).concat(pool.slice(0, rot)).slice(0, 2);
      function upsellImg(p) {
        var cand = p.featured_image || p.image || (p._d && p._d.featured_image) || '';
        var url = (cand && cand.url) ? cand.url : cand;
        return url ? String(url) : '';
      }
      function upsellLabel(p) {
        var t = stripLeadingProductCode(p.title || '');
        var low = t.toLowerCase();
        var map = [
          [/gear/, T('Gear and mechanism grease')],
          [/synthetic|precision oil|\boil\b/, 'Precision synthetic oil'],
          [/rubber|roller.*clean|reviv/, T('Rubber cleaner and revitaliser')],
          [/head.*clean|isoprop|ipa/, 'Head cleaning fluid'],
          [/swab|stick|bud/, 'Precision cleaning swabs'],
          [/lubric|grease/, 'Precision lubricant'],
          [/belt.*(gauge|measur)/, T('Belt measuring tool')]
        ];
        for (var i = 0; i < map.length; i++) { if (map[i][0].test(low)) return map[i][1]; }
        var words = t.split(/\s+/).slice(0, 4).join(' ');
        return words || T('Service item');
      }
      var chips = picks.map(function (p, i) {
        var price = fmtPrice(p.price, p._priceFromProductJson);
        var img = upsellImg(p);
        return '<div class="upsell__item">' +
          (img
            ? '<img class="upsell__item-img" src="' + esc(img) + '" alt="" width="48" height="48" loading="lazy">'
            : '<span class="upsell__item-img upsell__item-img--ph" aria-hidden="true"></span>') +
          '<span class="upsell__item-info">' +
            '<span class="upsell__item-name" title="' + esc(p.title) + '">' + esc(upsellLabel(p)) + '</span>' +
            '<span class="upsell__item-price mono">' + esc(price) + '</span>' +
          '</span>' +
          '<button class="btn btn--outline btn--sm" type="button" data-upsell-add="' + i + '">' + T('Add') + '</button>' +
        '</div>';
      }).join('');
      el.innerHTML =
        '<button class="upsell__close" type="button" data-upsell-close aria-label="' + T('Close') + '">&#10005;</button>' +
        '<p class="upsell__added">&#10003; ' + T('Added to cart') + '</p>' +
        '<div class="upsell__actions"><a class="btn btn--primary btn--sm upsell__checkout" href="' + lurl('/cart') + '">' + T('Review cart &amp; checkout') + ' &rarr;</a><a class="upsell__cartlink" href="' + lurl('/cart') + '">' + T('View cart') + '</a></div>' +
        modelHtml +
        (chips ? '<p class="upsell__maint">' + T('These are always useful for a repair:') + '</p><div class="upsell__items">' + chips + '</div>' : '');
      el.querySelectorAll('[data-upsell-add]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var p = picks[parseInt(btn.getAttribute('data-upsell-add'), 10)];
          btn.disabled = true; btn.textContent = T('Adding…');
          document.body.dataset.wspUpsellBusy = '1';
          addProductToCart(p)
            .then(function () { return loadCart(); })
            .then(function (cart) { bumpCartCount(cart.item_count); btn.innerHTML = T('Added') + ' &#10003;'; })
            .catch(function () { btn.textContent = T('Unavailable'); })
            .then(function () { delete document.body.dataset.wspUpsellBusy; });
        });
      });
      var closeBtn = el.querySelector('[data-upsell-close]');
      if (closeBtn) closeBtn.addEventListener('click', hideUpsell);
      el.hidden = false;
      window.__wspUpsellActive = true;
      requestAnimationFrame(function () { el.classList.add('is-in'); });
      if (upsellTimer) clearTimeout(upsellTimer);
      upsellTimer = setTimeout(hideUpsell, 14000);
    });
  }


  /* ============ line-art icon library ============
     House-style walnut/copper stroke icons for categories and
     subcategories - keyed by keyword match on the title. */
  var LINEART_HEAD = '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">';
  var LINEART = {
    deck: '<rect x="3" y="12" width="42" height="26" rx="3"/><rect x="8" y="17" width="18" height="12" rx="2"/><circle cx="14" cy="23" r="2.8"/><circle cx="20" cy="23" r="2.8"/><line x1="16.8" y1="23" x2="17.2" y2="23"/><path d="M10 20 h2 M22 20 h2"/><circle cx="33" cy="20" r="3.2"/><circle cx="40" cy="20" r="3.2"/><path d="M31.5 21 l1 -2 M38.5 21 l1 -2"/><rect x="30" y="26" width="12" height="3" rx="1"/><line x1="8" y1="33" x2="12" y2="33"/><line x1="14" y1="33" x2="18" y2="33"/><line x1="20" y1="33" x2="24" y2="33"/><circle cx="40" cy="33" r="1.4"/>',
    cassette: '<rect x="6" y="12" width="36" height="24" rx="3"/><rect x="14" y="18" width="20" height="9" rx="4.5"/><circle cx="19" cy="22.5" r="2.6"/><circle cx="29" cy="22.5" r="2.6"/><path d="M14 36 l3 -5 h14 l3 5"/>',
    video: '<rect x="3" y="13" width="42" height="22" rx="3"/><rect x="7" y="17" width="26" height="14" rx="2"/><circle cx="14" cy="24" r="4.4"/><circle cx="26" cy="24" r="4.4"/><circle cx="14" cy="24" r="1.4"/><circle cx="26" cy="24" r="1.4"/><path d="M14 19.6 v2 M14 26.4 v2 M11 24 h-2 M26 19.6 v2 M26 26.4 v2 M29 24 h2"/><line x1="17" y1="24" x2="23" y2="24"/><rect x="36" y="19" width="6" height="3" rx="1"/><line x1="36" y1="27" x2="42" y2="27"/><line x1="36" y1="30" x2="40" y2="30"/>',
    walkman: '<rect x="10" y="6" width="24" height="30" rx="4"/><rect x="14" y="11" width="16" height="10" rx="2"/><circle cx="18.5" cy="16" r="2.2"/><circle cx="25.5" cy="16" r="2.2"/><line x1="20.7" y1="16" x2="23.3" y2="16"/><line x1="14" y1="25" x2="30" y2="25"/><circle cx="17" cy="30" r="1.5"/><rect x="21" y="28.5" width="9" height="3" rx="1.5"/><path d="M12 40 a10 8 0 0 1 20 0"/><rect x="10" y="39" width="4" height="6" rx="2"/><rect x="30" y="39" width="4" height="6" rx="2"/>',
    turntable: '<rect x="3" y="9" width="42" height="28" rx="3"/><circle cx="20" cy="23" r="10.5"/><circle cx="20" cy="23" r="7"/><circle cx="20" cy="23" r="3.5"/><circle cx="20" cy="23" r="1.2"/><circle cx="38" cy="14" r="2.4"/><line x1="38" y1="16.4" x2="38" y2="25"/><path d="M38 25 l-6 6"/><path d="M32 31 l-1.6 1.6" stroke-width="3"/><circle cx="8" cy="33" r="1.4"/><rect x="34" y="32" width="7" height="2.6" rx="1.3"/><line x1="8" y1="37" x2="8" y2="40"/><line x1="40" y1="37" x2="40" y2="40"/>',
    cd: '<rect x="4" y="10" width="40" height="26" rx="3"/><rect x="9" y="15" width="20" height="16" rx="2"/><circle cx="19" cy="23" r="6.4"/><circle cx="19" cy="23" r="2"/><path d="M14.5 19.5 a6.4 6.4 0 0 1 3 -2.3"/><rect x="33" y="16" width="7" height="2.6" rx="1.3"/><line x1="33" y1="23" x2="40" y2="23"/><line x1="33" y1="27" x2="38" y2="27"/><line x1="9" y1="33" x2="17" y2="33"/>',
    minidisc: '<rect x="8" y="10" width="32" height="28" rx="3"/><circle cx="24" cy="26" r="8"/><circle cx="24" cy="26" r="2"/><line x1="12" y1="15" x2="24" y2="15"/>',
    reel: '<rect x="4" y="6" width="40" height="34" rx="3"/><circle cx="16" cy="17" r="8"/><circle cx="32" cy="17" r="8"/><circle cx="16" cy="17" r="2"/><circle cx="32" cy="17" r="2"/><path d="M16 9.4 v3 M16 21.6 v3 M9.4 17 h3 M19.6 17 h3 M32 9.4 v3 M32 21.6 v3 M25.4 17 h3 M35.6 17 h3"/><path d="M16 25 q8 5 16 0"/><circle cx="14" cy="33" r="1.5"/><circle cx="24" cy="33" r="1.5"/><rect x="30" y="31.5" width="10" height="3" rx="1.5"/>',
    radio: '<rect x="4" y="14" width="40" height="24" rx="3"/><circle cx="34" cy="26" r="6.5"/><circle cx="34" cy="26" r="2"/><line x1="34" y1="19.5" x2="34" y2="21.5"/><line x1="8" y1="20" x2="26" y2="20"/><line x1="11" y1="18.5" x2="11" y2="21.5" stroke-width="2.6"/><line x1="8" y1="26" x2="24" y2="26"/><line x1="8" y1="29" x2="24" y2="29"/><line x1="8" y1="32" x2="24" y2="32"/><line x1="10" y1="14" x2="20" y2="4"/><circle cx="20" cy="4" r="1.2"/>',
    amplifier: '<rect x="4" y="14" width="40" height="20" rx="3"/><circle cx="14" cy="24" r="4"/><circle cx="26" cy="24" r="4"/><line x1="34" y1="20" x2="40" y2="20"/><line x1="34" y1="25" x2="40" y2="25"/><line x1="34" y1="30" x2="38" y2="30"/>',
    speaker: '<rect x="12" y="6" width="24" height="36" rx="4"/><circle cx="24" cy="17" r="4"/><circle cx="24" cy="31" r="7"/><circle cx="24" cy="31" r="2"/>',
    belt: '<ellipse cx="20" cy="22" rx="14" ry="9" transform="rotate(-18 20 22)"/><ellipse cx="31" cy="30" rx="8" ry="5" transform="rotate(-18 31 30)"/>',
    roller: '<circle cx="24" cy="24" r="12"/><circle cx="24" cy="24" r="4"/><line x1="24" y1="6" x2="24" y2="12"/><line x1="24" y1="36" x2="24" y2="42"/>',
    tire: '<circle cx="24" cy="24" r="14"/><circle cx="24" cy="24" r="8"/>',
    gear: '<circle cx="24" cy="24" r="10"/><circle cx="24" cy="24" r="3.5"/><line x1="24" y1="9" x2="24" y2="14"/><line x1="24" y1="34" x2="24" y2="39"/><line x1="9" y1="24" x2="14" y2="24"/><line x1="34" y1="24" x2="39" y2="24"/><line x1="13.4" y1="13.4" x2="17" y2="17"/><line x1="31" y1="31" x2="34.6" y2="34.6"/><line x1="34.6" y1="13.4" x2="31" y2="17"/><line x1="17" y1="31" x2="13.4" y2="34.6"/>',
    laser: '<rect x="10" y="20" width="28" height="16" rx="3"/><circle cx="24" cy="28" r="5"/><circle cx="24" cy="28" r="1.6"/><path d="M20 14 l4 4 M28 14 l-4 4 M24 10 v8" stroke-dasharray="2 3"/>',
    stylus: '<path d="M8 14 l20 14 8 -2 4 6 -10 2 -24 -16 z"/><circle cx="38" cy="30" r="2"/>',
    component: '<rect x="5" y="16" width="11" height="16" rx="2"/><line x1="8" y1="16" x2="8" y2="11"/><line x1="13" y1="16" x2="13" y2="11"/><line x1="5" y1="21" x2="16" y2="21"/><path d="M20 34 h3 l2 -6 4 12 4 -12 4 12 2 -6 h3"/><circle cx="36" cy="15" r="6"/><line x1="33" y1="12" x2="33" y2="18"/><line x1="33" y1="14" x2="39" y2="10.5"/><line x1="33" y1="16" x2="39" y2="19.5"/><line x1="30" y1="15" x2="26" y2="15"/>',
    capacitor: '<rect x="16" y="10" width="16" height="24" rx="4"/><line x1="16" y1="16" x2="32" y2="16"/><line x1="21" y1="34" x2="21" y2="42"/><line x1="27" y1="34" x2="27" y2="42"/>',
    resistor: '<path d="M4 24 h6 l3 -7 5 14 5 -14 5 14 5 -14 3 7 h8"/>',
    transistor: '<circle cx="24" cy="22" r="10"/><line x1="19" y1="17" x2="19" y2="27"/><line x1="19" y1="21" x2="28" y2="15"/><line x1="19" y1="24" x2="28" y2="29"/><line x1="14" y1="22" x2="8" y2="22"/><line x1="28" y1="15" x2="28" y2="8"/><line x1="28" y1="29" x2="28" y2="40"/>',
    diode: '<line x1="6" y1="24" x2="18" y2="24"/><path d="M18 16 v16 l12 -8 z"/><line x1="30" y1="16" x2="30" y2="32"/><line x1="30" y1="24" x2="42" y2="24"/>',
    ic: '<rect x="14" y="14" width="20" height="20" rx="2"/><line x1="14" y1="18" x2="9" y2="18"/><line x1="14" y1="24" x2="9" y2="24"/><line x1="14" y1="30" x2="9" y2="30"/><line x1="34" y1="18" x2="39" y2="18"/><line x1="34" y1="24" x2="39" y2="24"/><line x1="34" y1="30" x2="39" y2="30"/><circle cx="19" cy="19" r="1.2"/>',
    fuse: '<rect x="10" y="18" width="28" height="12" rx="6"/><line x1="10" y1="24" x2="4" y2="24"/><line x1="38" y1="24" x2="44" y2="24"/><path d="M16 24 q4 -4 8 0 t8 0"/>',
    bulb: '<circle cx="24" cy="20" r="10"/><path d="M20 29 h8 v5 a4 4 0 0 1 -8 0 z"/><path d="M21 20 l3 -4 3 4"/>',
    connector: '<rect x="8" y="16" width="18" height="16" rx="3"/><line x1="26" y1="20" x2="34" y2="20"/><line x1="26" y1="24" x2="36" y2="24"/><line x1="26" y1="28" x2="34" y2="28"/><line x1="36" y1="18" x2="36" y2="30"/><line x1="36" y1="24" x2="42" y2="24"/>',
    antenna: '<line x1="24" y1="42" x2="24" y2="14"/><line x1="24" y1="20" x2="36" y2="6"/><path d="M14 14 a14 14 0 0 1 6 -6 M10 10 a20 20 0 0 1 8 -8" stroke-dasharray="2 3"/><path d="M18 42 h12"/>',
    screw: '<circle cx="24" cy="12" r="6"/><line x1="20" y1="12" x2="28" y2="12"/><path d="M21 18 v16 l3 6 3 -6 v-16"/><line x1="21" y1="24" x2="27" y2="22"/><line x1="21" y1="29" x2="27" y2="27"/><line x1="21" y1="34" x2="27" y2="32"/>',
    spring: '<path d="M18 6 h12 M18 42 h12 M24 6 c-8 3 8 6 0 9 c-8 3 8 6 0 9 c-8 3 8 6 0 9 c-8 3 8 6 0 9"/>',
    switch: '<rect x="8" y="18" width="32" height="12" rx="6"/><circle cx="16" cy="24" r="4"/><line x1="26" y1="24" x2="34" y2="24"/>',
    motor: '<rect x="10" y="16" width="22" height="16" rx="4"/><line x1="32" y1="24" x2="42" y2="24"/><line x1="14" y1="16" x2="14" y2="12"/><line x1="28" y1="16" x2="28" y2="12"/><line x1="14" y1="32" x2="14" y2="36"/><line x1="28" y1="32" x2="28" y2="36"/>',
    cable: '<circle cx="10" cy="14" r="4"/><circle cx="38" cy="34" r="4"/><path d="M13 17 q14 2 10 10 t12 4"/>',
    battery: '<rect x="8" y="16" width="30" height="16" rx="3"/><line x1="38" y1="21" x2="42" y2="21"/><line x1="38" y1="27" x2="42" y2="27"/><line x1="15" y1="21" x2="15" y2="27"/><line x1="12" y1="24" x2="18" y2="24"/><line x1="26" y1="24" x2="32" y2="24"/>',
    buzzer: '<circle cx="24" cy="22" r="12"/><circle cx="24" cy="22" r="2"/><line x1="19" y1="36" x2="19" y2="42"/><line x1="29" y1="36" x2="29" y2="42"/>',
    crystal: '<rect x="12" y="14" width="24" height="14" rx="7"/><line x1="18" y1="28" x2="18" y2="38"/><line x1="30" y1="28" x2="30" y2="38"/>',
    potentiometer: '<circle cx="24" cy="20" r="10"/><line x1="24" y1="20" x2="29" y2="13"/><line x1="16" y1="34" x2="16" y2="40"/><line x1="24" y1="34" x2="24" y2="40"/><line x1="32" y1="34" x2="32" y2="40"/>',
    cleaning: '<path d="M18 6 h12 l-2 10 h-8 z"/><rect x="14" y="16" width="20" height="10" rx="2"/><path d="M16 26 l-2 14 M24 26 v14 M32 26 l2 14"/>',
    wrench: '<path d="M30 8 a8 8 0 1 0 6 12 l6 6 -4 4 -6 -6 a8 8 0 0 1 -10 -10 l5 5 4 -4 z"/>',
    box: '<rect x="8" y="14" width="32" height="24" rx="3"/><path d="M8 20 h32 M24 14 v6"/>'
  };
  var LINEART_MATCH = [
    [/pinch\s*roller|roller/i, 'roller'],
    [/idler|tyre|tire/i, 'tire'],
    [/belt/i, 'belt'],
    [/gear|pulley/i, 'gear'],
    [/laser|pickup|optical/i, 'laser'],
    [/stylus|needle|cartridge/i, 'stylus'],
    [/walkman|portable/i, 'walkman'],
    [/video|vhs|vcr/i, 'video'],
    [/cassette deck|tape deck|deck/i, 'deck'],
    [/cassette|tape/i, 'cassette'],
    [/turntable|record player|vinyl/i, 'turntable'],
    [/minidisc|md\b/i, 'minidisc'],
    [/cd|dvd|disc/i, 'cd'],
    [/reel/i, 'reel'],
    [/radio|tuner|receiver/i, 'radio'],
    [/amplifier|amp\b/i, 'amplifier'],
    [/speaker/i, 'speaker'],
    [/capacitor/i, 'capacitor'],
    [/resistor/i, 'resistor'],
    [/transistor/i, 'transistor'],
    [/diode/i, 'diode'],
    [/integrated|circuit\b|ic\b/i, 'ic'],
    [/fuse/i, 'fuse'],
    [/bulb|light|lamp|neon/i, 'bulb'],
    [/connector|plug|jack|adapter/i, 'connector'],
    [/antenna|aerial/i, 'antenna'],
    [/screw|bolt|washer/i, 'screw'],
    [/spring/i, 'spring'],
    [/switch|lever/i, 'switch'],
    [/motor/i, 'motor'],
    [/cable|wire|cord/i, 'cable'],
    [/batter/i, 'battery'],
    [/buzzer/i, 'buzzer'],
    [/crystal|resonator/i, 'crystal'],
    [/potentiometer|trimmer/i, 'potentiometer'],
    [/clean|maintenance|grease|oil|lubric/i, 'cleaning'],
    [/custom|workshop|service/i, 'wrench'],
    [/electronic|component/i, 'component'],
    [/audio|part/i, 'deck']
  ];
  function lineArtIcon(title) {
    var key = 'box';
    for (var i = 0; i < LINEART_MATCH.length; i++) {
      if (LINEART_MATCH[i][0].test(String(title || ''))) { key = LINEART_MATCH[i][1]; break; }
    }
    return LINEART_HEAD + LINEART[key] + '</svg>';
  }
  window.WSPLineArt = lineArtIcon;
  function fillLineArt(root) {
    (root || document).querySelectorAll('[data-lineart]').forEach(function (el) {
      if (!el.firstChild) el.innerHTML = lineArtIcon(el.getAttribute('data-lineart') || el.textContent);
    });
  }

  /* ============ shared collections index (for strip + subcategory grids) ============ */
  var COLS_CACHE_KEY = 'wsp_cols_v2';
  function colsCacheRead() {
    try {
      var c = JSON.parse(localStorage.getItem(COLS_CACHE_KEY) || 'null');
      if (c && c.t && Date.now() - c.t < 86400000 && c.all && c.all.length) return c.all;
    } catch (e) {}
    return null;
  }
  function colsCacheWrite(all) {
    try { localStorage.setItem(COLS_CACHE_KEY, JSON.stringify({ t: Date.now(), all: all })); } catch (e) {}
  }
  function readColPage(doc) {
    var out = [];
    doc.querySelectorAll('[data-colpage]').forEach(function (el) {
      try { JSON.parse(el.textContent).forEach(function (c) { out.push(c); }); } catch (e) {}
    });
    return out;
  }
  function loadCollectionsIndex() {
    /* 24h localStorage cache -> instant after the first visit */
    var cached = colsCacheRead();
    if (cached) return Promise.resolve(cached);
    return fetch(lurl('/collections'), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var all = readColPage(doc);
        var pagEl = doc.querySelector('[data-col-pagination]');
        var pages = pagEl ? parseInt(pagEl.getAttribute('data-pages'), 10) || 1 : 1;
        /* Section Rendering API: fetch ONLY our section for pages 2..N
           (a fraction of a full page) */
        var sid = '';
        var root = doc.querySelector('[data-collections-root]');
        var wrap = root && root.closest ? root.closest('[id^="shopify-section-"]') : null;
        if (wrap) sid = wrap.id.replace('shopify-section-', '');
        var reqs = [];
        for (var p = 2; p <= Math.min(pages, 20); p++) {
          reqs.push(fetch(lurl('/collections?page=' + p + (sid ? '&section_id=' + encodeURIComponent(sid) : '')), { credentials: 'same-origin' })
            .then(function (r) { return r.text(); })
            .then(function (h) { return readColPage(new DOMParser().parseFromString(h, 'text/html')); })
            .catch(function () { return []; }));
        }
        return Promise.all(reqs).then(function (batches) {
          batches.forEach(function (b) { b.forEach(function (c) { all.push(c); }); });
          var seen = {};
          all = all.filter(function (c) { if (seen[c.h]) return false; seen[c.h] = true; return true; });
          all.sort(function (a, b) { return a.t.localeCompare(b.t); });
          colsCacheWrite(all);
          return all;
        });
      })
      .catch(function () { return []; });
  }
  function collectionsToGroups(all) {
    var groups = [], current = null;
    all.forEach(function (c) {
      if (/specialist/i.test(c.t)) return;
      if (current && c.t.indexOf(current.t + ' ') === 0) { current.children.push(c); return; }
      current = { t: c.t, u: c.u, h: c.h, c: c.c, children: [] };
      groups.push(current);
    });
    return groups;
  }

  /* device-type strip under the header on browse pages */
  function initCategoryStrip() {
    var strip = document.querySelector('[data-catstrip]');
    if (!strip) return;
    var row = strip.querySelector('[data-catstrip-row]');
    loadCollectionsIndex().then(function (all) {
      if (!all.length) return;
      var groups = collectionsToGroups(all);
      var DEVICE_RE = /(cassette|deck|turntable|cd|walkman|reel|radio|video|minidisc|boombox|amplifier|receiver|tuner)/i;
      var tiles = groups.filter(function (g) {
        return g.children.length >= 2 && DEVICE_RE.test(g.t);
      });
      groups.forEach(function (g) {
        if (/by size/i.test(g.t) || g.h === 'custom-made-parts-workshop-services') tiles.push(g);
      });
      if (!tiles.length) return;
      row.innerHTML = tiles.slice(0, 12).map(function (g) {
        return '<a class="catstrip__tile" href="' + esc(g.u) + '">' +
          '<span class="catstrip__icon">' + lineArtIcon(g.t) + '</span>' +
          '<span class="catstrip__name">' + esc(g.t) + '</span>' +
        '</a>';
      }).join('');
      strip.hidden = false;
    });
  }

  /* "Shop by category" subcategory grid on collection pages */
  function initSubcatGrid() {
    var grid = document.querySelector('[data-subcat-grid]');
    if (!grid) return;
    var parentTitle = grid.getAttribute('data-parent-title') || '';
    var wrap = grid.querySelector('[data-subcat-items]');
    if (!parentTitle || !wrap) return;
    loadCollectionsIndex().then(function (all) {
      var prefix = parentTitle + ' ';
      var kids = all.filter(function (c) {
        return c.t.indexOf(prefix) === 0 && !/specialist/i.test(c.t);
      });
      if (!kids.length) return;
      function tileHtml(c) {
        return '<a class="subcat__tile" href="' + esc(c.u) + '">' +
          '<span class="subcat__icon">' + lineArtIcon(c.t.slice(prefix.length)) + '</span>' +
          '<span class="subcat__name">' + esc(c.t.slice(prefix.length)) + '</span>' +
          '<span class="subcat__count mono">' + c.c + '</span>' +
        '</a>';
      }
      if (kids.length <= 20) {
        wrap.innerHTML = kids.map(tileHtml).join('');
      } else {
        /* huge families (Electronic Components: 78 subcategories) get
           labeled, collapsible groups instead of a tile wall */
        var BUCKETS = [
          ['Passives', /capacitor|resistor|potentiometer|inductor|coil|crystal|resonator/i],
          ['Semiconductors', /transistor|diode|integrated|thyristor|photo/i],
          ['Connectors & plugs', /connector|plug|jack|adapter/i],
          ['Fuses', /fuse/i],
          ['Lighting', /light|bulb|lamp|neon/i],
          ['Batteries', /batter/i]
        ];
        var groups = {}, order = [];
        kids.forEach(function (c) {
          var short = c.t.slice(prefix.length);
          var label = 'Other';
          for (var i = 0; i < BUCKETS.length; i++) {
            if (BUCKETS[i][1].test(short)) { label = BUCKETS[i][0]; break; }
          }
          if (!groups[label]) { groups[label] = []; order.push(label); }
          groups[label].push(c);
        });
        order.sort(function (a, b) {
          var ia = BUCKETS.map(function (x) { return x[0]; }).indexOf(a);
          var ib = BUCKETS.map(function (x) { return x[0]; }).indexOf(b);
          return (ia === -1 ? 99 : ia) - (ib === -1 ? 99 : ib);
        });
        wrap.innerHTML = order.map(function (label, i) {
          var g = groups[label];
          return '<details class="subcatbucket"' + (i === 0 ? ' open' : '') + '>' +
            '<summary><span>' + esc(label) + '</span><span class="subcatbucket__n mono">' + g.length + ' groups &middot; ' +
              g.reduce(function (a, c) { return a + (c.c || 0); }, 0) + ' products</span></summary>' +
            '<div class="subcat__items subcat__items--inbucket">' + g.map(tileHtml).join('') + '</div>' +
          '</details>';
        }).join('');
        wrap.classList.add('subcat__items--bucketed');
      }
      grid.hidden = false;
    });
  }

  /* Trustpilot-style star strip */

  /* JSON data islands may be base64-encoded (data-enc="b64") so product
     tags never sit in plain page source */
  function readIsland(el) {
    if (!el) return null;
    var t = (el.textContent || '').trim();
    if (el.getAttribute('data-enc') === 'b64') {
      try { t = atob(t); } catch (e) { return null; }
    }
    try { return JSON.parse(t); } catch (e) { return null; }
  }
  function stripEmoji(t) {
    return String(t || '').replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]|[\u2190-\u21FF\u2600-\u27BF\uFE0F\u2764]/g, '').replace(/\s{2,}/g, ' ').trim();
  }
  function tpStarsHtml(size) {
    var i, out = '<span class="tpstars tpstars--' + (size || 'md') + '" aria-label="' + T('Rated 5 out of 5 on Trustpilot') + '">';
    for (i = 0; i < 5; i++) out += '<i>&#9733;</i>';
    return out + '</span>';
  }

  function toast(text) {
    var t = document.getElementById('wsp-toast');
    if (!t) return;
    var body = t.querySelector('.wsp-toast__text');
    if (body) body.textContent = text;
    t.hidden = false;
    clearTimeout(t.__timer);
    t.__timer = setTimeout(function () { t.hidden = true; }, 5000);
  }
  /* Inline "added" confirmation anchored directly under the product card
     the customer just added - no floating panels centre or right. Shows
     "Added", a prominent Checkout button, and a View cart link. One card
     at a time: any previous inline confirm is removed first. */
  function showRowConfirm(row) {
    if (!row) return;
    document.querySelectorAll('.crowconfirm').forEach(function (n) { n.remove(); });
    var box = document.createElement('div');
    box.className = 'crowconfirm';
    box.innerHTML =
      '<p class="crowconfirm__added">&#10003; ' + T('Added to cart') + '</p>' +
      '<a class="btn btn--primary btn--block crowconfirm__checkout" href="' + lurl('/cart') + '">' + T('Review cart &amp; checkout') + ' &rarr;</a>' +
      '<a class="crowconfirm__cart" href="/collections">' + T('Keep shopping') + '</a>' +
      '<button class="crowconfirm__close" type="button" aria-label="' + T('Close') + '">&#10005;</button>';
    box.querySelector('.crowconfirm__close').addEventListener('click', function () { box.remove(); });
    /* place it right after the card body, inside the same card */
    row.appendChild(box);
    requestAnimationFrame(function () { box.classList.add('is-in'); });
    clearTimeout(showRowConfirm._t);
    showRowConfirm._t = setTimeout(function () {
      box.classList.remove('is-in');
      setTimeout(function () { box.remove(); }, 220);
    }, 12000);
  }
  function bumpCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = !count;
    });
  }

  /* ------------------------------------------------- database (getAll) */
  var db = { brands: [], modelsByBrand: {} };
  var searchIndex = [];
  var dbReady = false;
  var dbFailed = false;
  var dbCallbacks = [];

  function buildIndex() {
    searchIndex = [];
    db.brands.forEach(function (brand) {
      searchIndex.push({ type: 'brand', brand: brand, label: brand });
      (db.modelsByBrand[brand] || []).forEach(function (model) {
        searchIndex.push({ type: 'model', brand: brand, model: model, label: brand + ' ' + model });
      });
    });
    searchIndex.forEach(prepareSearchEntry);
  }
  function onDbReady(cb) {
    if (dbReady) cb(true);
    else if (dbFailed) cb(false);
    else dbCallbacks.push(cb);
  }
  var dbLoading = false;
  /* v4.45: brands index cache. sessionStorage died with the tab, so every
     new visit paid the full getAll + Apps Script cold start. localStorage
     with stale-while-revalidate: serve instantly up to 7 days, refresh in
     the background after 6h. */
  var DB_LS_KEY = 'wsp:db:v1';
  var DB_FRESH_MS = 21600000;      /* 6h  - serve without refreshing */
  var DB_MAX_MS   = 604800000;     /* 7d  - beyond this, refetch first */
  function loadDb() {
    if (dbLoading || dbReady) return; /* one chain only - protects the rate-limited backend */
    dbLoading = true;
    dbFailed = false;
    if (!BACKEND) { dbLoading = false; dbFailed = true; flushDb(false); return; }
    if (botLikely()) { dbLoading = false; dbFailed = true; flushDb(false); return; }
    try {
      var cached = null;
      try { cached = JSON.parse(localStorage.getItem(DB_LS_KEY) || 'null'); } catch (e0) {}
      if (!cached) {
        /* migrate old sessionStorage cache once */
        try {
          var legacy = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
          if (legacy && legacy.brands) cached = { t: 0, brands: legacy.brands, modelsByBrand: legacy.modelsByBrand || {} };
        } catch (e1) {}
      }
      if (validFinderIndex(cached) && cached.brands.length) {
        var age = Date.now() - (cached.t || 0);
        if (age < DB_MAX_MS) {
          db.brands = cached.brands;
          db.modelsByBrand = cached.modelsByBrand || {};
          buildIndex();
          dbReady = true;
          dbLoading = false;
          flushDb(true);
          dbRecovered.splice(0).forEach(function (cb) { try { cb(); } catch (e) {} });
          if (age > DB_FRESH_MS) fetchDbAttempt(0, true); /* silent background refresh */
          return;
        }
      }
    } catch (e) {}
    fetchDbAttempt(0);
  }
  function validFinderIndex(data) {
    return !!(data && Array.isArray(data.brands) && data.modelsByBrand &&
      typeof data.modelsByBrand === 'object' && !Array.isArray(data.modelsByBrand) &&
      data.brands.every(function (brand) {
        return typeof brand === 'string' && Array.isArray(data.modelsByBrand[brand]) &&
          data.modelsByBrand[brand].every(function (model) { return typeof model === 'string'; });
      }));
  }
  function fetchDbAttempt(attempt, silent) {
    dbLoading = true;
    return finderFetch(beUrl('action=getAll'), { cache: 'no-store', credentials: 'omit' })
      .then(finderReadJson)
      .then(function (data) {
        if (data && data.error) throw new Error(data.error);
        if (!validFinderIndex(data)) throw new Error('finder_invalid_response');
        db.brands = data.brands;
        db.modelsByBrand = data.modelsByBrand;
        try { localStorage.setItem(DB_LS_KEY, JSON.stringify({ t: Date.now(), brands: db.brands, modelsByBrand: db.modelsByBrand })); } catch (e) {}
        buildIndex();
        dbReady = true;
        dbFailed = false;
        dbLoading = false;
        flushDb(true);
        dbRecovered.splice(0).forEach(function (cb) { try { cb(); } catch (e) {} });
      })
      .catch(function () {
        dbLoading = false;
        if (silent) return; /* cache still serving - fail quietly */
        dbFailed = true;
        flushDb(false);
      });
  }
  var dbRecovered = [];
  function onDbRecovered(cb) { if (dbReady) cb(); else dbRecovered.push(cb); }
  function flushDb(ok) {
    dbCallbacks.splice(0).forEach(function (cb) { cb(ok); });
  }

  /* --------------------------------------------------- fuzzy scoring */
  function prepareSearchEntry(entry) {
    if (entry._searchLabel !== entry.label) {
      entry._searchLabel = entry.label;
      entry._searchNorm = norm(entry.label);
      entry._searchHay = String(entry.label || '').toLowerCase();
    }
    return entry;
  }
  function prepareSearchQuery(q) {
    var raw = String(q || '');
    return { normalized: norm(raw), words: raw.toLowerCase().match(/[a-z0-9]+/g) || [] };
  }
  function scoreEntry(label, q, boost, entry) {
    var query = typeof q === 'object' && q ? q : prepareSearchQuery(q);
    var candidate = entry || prepareSearchEntry({ label: label });
    var ni = candidate._searchNorm, nq = query.normalized;
    var words = query.words;
    var hay = candidate._searchHay;
    if (!nq) return 1 + (boost || 0);
    if (ni === nq) return 2000 + (boost || 0);
    if (ni.indexOf(nq) === 0) return 1700 - ni.length + (boost || 0);
    if (ni.indexOf(nq) !== -1) return 1400 - ni.length + (boost || 0);
    if (words.length > 1 && words.every(function (p) { return hay.indexOf(p) !== -1 || ni.indexOf(p) !== -1; })) {
      return 1500 - ni.length + (boost || 0);
    }
    if (words.length > 1) {
      var hits = words.filter(function (p) { return hay.indexOf(p) !== -1; }).length;
      if (hits >= Math.max(2, words.length - 1)) return 1000 + (hits * 30) + (boost || 0);
    }
    if (nq.length < 3) return null;
    var limit = Math.floor(nq.length / 4) + 1;
    var d = lev(nq, ni.slice(0, Math.min(ni.length, nq.length + 4)), limit);
    if (d <= limit) return 800 - (d * 80) + (boost || 0);
    return null;
  }
  function searchDb(q, selBrand, resultLimit, entryType) {
    var scored = [];
    var query = prepareSearchQuery(q);
    var limit = resultLimit || 40;
    for (var i = 0; i < searchIndex.length; i++) {
      var e = searchIndex[i];
      if (entryType && e.type !== entryType) continue;
      prepareSearchEntry(e);
      var boost = e.type === 'model' ? 200 : 0;
      if (selBrand && e.brand === selBrand && e.type === 'model') boost += 400;
      var s = scoreEntry(e.label, query, boost, e);
      if (s === null || (scored.length === limit && s < scored[limit - 1].s)) continue;
      var low = 0, high = scored.length;
      while (low < high) {
        var mid = (low + high) >>> 1;
        var order = scored[mid].s - s || e.label.localeCompare(scored[mid].e.label);
        if (order < 0) high = mid;
        else low = mid + 1;
      }
      if (low >= limit) continue;
      scored.splice(low, 0, { e: e, s: s });
      if (scored.length > limit) scored.pop();
    }
    return scored;
  }
  function findUniqueModelMatch(rawInput) {
    var nq = norm(rawInput);
    if (!nq || nq.length < 3) return null;
    var matches = [];
    (db.brands || []).forEach(function (brand) {
      var brandNorm = norm(brand);
      (db.modelsByBrand[brand] || []).forEach(function (model) {
        var modelNorm = norm(model);
        var fullNorm = brandNorm + modelNorm;
        if (modelNorm === nq || fullNorm === nq || modelNorm.indexOf(nq) === 0 || fullNorm.indexOf(nq) === 0) {
          matches.push({ brand: brand, model: model });
        }
      });
    });
    return matches.length === 1 ? matches[0] : null;
  }
  function exactModelExists(brand, model) {
    var models = db.modelsByBrand[brand] || [];
    for (var i = 0; i < models.length; i++) {
      if (norm(models[i]) === norm(model)) return models[i];
    }
    return '';
  }
  function highlight(text, q) {
    var raw = String(text || '');
    if (!q) return esc(raw);
    var parts = String(q).replace(/[^a-zA-Z0-9]+/g, ' ').trim().split(/\s+/).filter(Boolean).slice(0, 4);
    if (!parts.length) return esc(raw);
    /* Flag matched ranges on the PLAIN string first. The old version
       ran sequential replaces over its own generated HTML, so short
       tokens like "m" matched inside "<mark>" and shredded the tags
       (rendered literally as "<mark>CDPmark>-M7"). */
    var low = raw.toLowerCase();
    var flags = new Array(raw.length);
    parts.forEach(function (p) {
      p = p.toLowerCase();
      var idx = 0;
      while ((idx = low.indexOf(p, idx)) !== -1) {
        for (var i = idx; i < idx + p.length; i++) flags[i] = true;
        idx += p.length;
      }
    });
    /* Build output in one pass: contiguous flagged runs share one <mark>. */
    var out = '', buf = '', marking = false;
    function flush() {
      if (!buf) return;
      out += marking ? '<mark>' + esc(buf) + '</mark>' : esc(buf);
      buf = '';
    }
    for (var i = 0; i < raw.length; i++) {
      var f = !!flags[i];
      if (f !== marking) { flush(); marking = f; }
      buf += raw.charAt(i);
    }
    flush();
    return out;
  }

  /* ------------------------------------------------- recent searches */
  function rLoad() {
    try {
      var raw = JSON.parse(localStorage.getItem(RECENT_KEY)) || [];
      return raw.filter(function (r) { return r && r.brand && r.model; }).slice(0, 5);
    } catch (e) { return []; }
  }
  function rSave(brand, model) {
    if (!brand || !model) return;
    var list = rLoad().filter(function (r) { return norm(r.brand + r.model) !== norm(brand + model); });
    list.unshift({ brand: brand, model: model, ts: Date.now() });
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 5))); } catch (e) {}
  }

  /* --------------------------------------------------- model memory */
  function memorySave(brand, model) {
    try { localStorage.setItem(MEMORY_KEY, JSON.stringify({ brand: brand, model: model, ts: Date.now() })); } catch (e) {}
  }
  function memoryLoad() {
    try {
      var m = JSON.parse(localStorage.getItem(MEMORY_KEY));
      if (m && m.brand && m.model && !m.dismissed) return m;
    } catch (e) {}
    return null;
  }

  /* ---------------------------------------- backend proof machinery */
  function cleanSearchTerm(term) {
    var t = String(term || '');
    t = t.replace(/\b(?:tag|tags|sku|variants\.sku|product_type|title)\s*:/ig, ' ');
    t = t.replace(/[()"]/g, ' ');
    t = t.replace(/\s*-\s*/g, '-');
    t = t.replace(/\s+/g, ' ').trim();
    return t;
  }
  function normalizeShopifySearchTerm(term) {
    return String(term || '').replace(/\s*-\s*/g, '-').replace(/\s+/g, ' ').trim();
  }
  function normalizeShopifySearchQuery(query) {
    return String(query || '').split(/\s+OR\s+/i).map(normalizeShopifySearchTerm).filter(Boolean).join(' OR ');
  }
  function isSharedCompatibilityTag(tag) {
    return /^(?:CK|DK)\d{3,}$/i.test(String(tag || '').trim());
  }
  function extractMechanismTagsFromText(text) {
    var out = [], seen = {};
    String(text || '').replace(/\b(?:CK|DK)\d{3,}\b/ig, function (m) {
      var tag = m.toUpperCase();
      if (!seen[tag]) { seen[tag] = true; out.push(tag); }
      return m;
    });
    return out;
  }
  function extractSearchTerms(searchQuery) {
    return String(searchQuery || '').split(/\s+OR\s+/i).map(cleanSearchTerm).filter(function (t) {
      return norm(t).length >= 4;
    });
  }
  function exactTagMatch(tags, terms) {
    for (var i = 0; i < (tags || []).length; i++) {
      var tagNorm = norm(tags[i]);
      if (!tagNorm) continue;
      for (var j = 0; j < (terms || []).length; j++) {
        if (tagNorm === norm(terms[j])) return { matched: true, tag: tags[i], term: terms[j] };
      }
    }
    return { matched: false, tag: '', term: '' };
  }
  function extractTypeCodesFromText(text, allowBare) {
    var out = [], seen = {};
    var s = String(text || '');
    function add(code) {
      code = String(code || '').toLowerCase();
      if (!/^\d{4}$/.test(code) && !/^\d{2}xx$/.test(code)) return;
      if (!seen[code]) { seen[code] = true; out.push(code); }
    }
    s.replace(/\bType\s*[:#-]?\s*(\d{4}|\d{2}xx)\b/ig, function (_, code) { add(code); return _; });
    if (allowBare) {
      s.split(/[^A-Za-z0-9]+/).forEach(function (part) {
        if (/^\d{4}$/.test(part) || /^\d{2}xx$/i.test(part)) add(part);
      });
    }
    return out;
  }
  function buildCompatibilityContext(selBrand, selModel, data) {
    var searchQuery = normalizeShopifySearchQuery((data && data.searchQuery) || '');
    var selectedText = [selBrand, selModel, searchQuery].join(' ');
    var exactTags = extractSearchTerms(searchQuery);
    var typeCodes = extractTypeCodesFromText(selectedText, false);
    var bareFamily = String(selectedText || '').match(/\b\d{2}xx\b/i);
    var selectedType = typeCodes.length ? typeCodes[0] : (bareFamily ? bareFamily[0].toLowerCase() : '');
    var familyPrefix = /^\d{2}xx$/i.test(selectedType) ? selectedType.slice(0, 2) : '';
    var brandNorm = norm(selBrand);
    var selectedNorm = norm(selBrand + ' ' + selModel);
    var baseModel = String(selModel || '')
      .replace(/\bType\s*[:#-]?\s*(\d{4}|\d{2}xx)\b/ig, ' ')
      .replace(/\([^)]*\)/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    var proofTerms = extractSearchTerms(searchQuery).filter(function (term) {
      var nt = norm(term);
      if (!nt || nt === brandNorm) return false;
      if (brandNorm && nt.replace(brandNorm, '') === '') return false;
      return nt.length >= 4 || nt === selectedNorm;
    });
    if (selectedNorm && proofTerms.indexOf(selBrand + ' ' + selModel) === -1) proofTerms.push(selBrand + ' ' + selModel);
    if (baseModel) {
      proofTerms.push(baseModel);
      if (selBrand) proofTerms.push(selBrand + ' ' + baseModel);
    }
    return {
      brand: selBrand,
      model: selModel,
      searchQuery: searchQuery,
      exactTags: exactTags,
      proofTerms: proofTerms,
      selectedType: selectedType,
      familyPrefix: familyPrefix,
      mechanismTags: extractMechanismTagsFromText(searchQuery)
    };
  }
  function pData(p) { return (p && p._d) || null; }
  function rawProductTags(p) {
    var d = pData(p) || {};
    var out = [], seen = {};
    function addOne(tag) {
      tag = String(tag || '').trim();
      var key = norm(tag);
      if (!tag || seen[key]) return;
      seen[key] = true;
      out.push(tag);
    }
    function addMany(tags) {
      if (Array.isArray(tags)) tags.forEach(addOne);
      else String(tags || '').split(',').forEach(addOne);
    }
    addMany(p && p.tags);
    addMany(d.tags);
    return out;
  }
  function hasFreeSampleTag(p) {
    var tags = rawProductTags(p) || [];
    for (var i = 0; i < tags.length; i++) {
      if (String(tags[i]).toLowerCase().replace(/[\s_]+/g, '-') === 'free-sample') return true;
    }
    return false;
  }
  function rawProductSkus(p) {
    var d = pData(p) || {};
    return ((d.variants || []).map(function (v) { return v && v.sku ? String(v.sku) : ''; })).filter(Boolean);
  }
  function fieldMatchesTerm(field, term) {
    var nf = norm(field), nt = norm(term);
    if (!nf || !nt || nt.length < 4) return false;
    if (nf === nt) return true;
    var parts = String(field || '').split(/[^A-Za-z0-9]+/).map(norm).filter(Boolean);
    if (parts.indexOf(nt) !== -1) return true;
    return nt.length >= 6 && nf.indexOf(nt) !== -1;
  }
  function fieldMatchesAnyTerm(fields, terms, source) {
    for (var i = 0; i < (fields || []).length; i++) {
      for (var j = 0; j < (terms || []).length; j++) {
        if (fieldMatchesTerm(fields[i], terms[j])) return { matched: true, source: source, term: terms[j], field: fields[i] };
      }
    }
    return { matched: false, source: '', term: '', field: '' };
  }
  function sourceTypeCodes(fields) {
    var exact = [], seen = {};
    function add(code, source) {
      code = String(code || '').toLowerCase();
      if (!/^\d{4}$/.test(code) && !/^\d{2}xx$/.test(code)) return;
      if (!seen[code]) { seen[code] = true; exact.push({ code: code, source: source }); }
    }
    (fields.skus || []).forEach(function (s) { extractTypeCodesFromText(s, false).forEach(function (code) { add(code, 'sku'); }); });
    (fields.tags || []).forEach(function (t) { extractTypeCodesFromText(t, false).forEach(function (code) { add(code, 'tag'); }); });
    return exact;
  }
  function productCompatibilityProof(p, ctx) {
    ctx = ctx || {};
    var fields = { skus: rawProductSkus(p), tags: rawProductTags(p) };
    var codes = sourceTypeCodes(fields);
    var proof = { accepted: false, source: '', variantLabel: '', family: false, rank: 9 };
    var shared = exactTagMatch(fields.tags, ctx.mechanismTags || []);
    var direct = exactTagMatch(fields.tags, (ctx.exactTags || []).filter(function (t) { return !isSharedCompatibilityTag(t); }));

    if (ctx.selectedType) {
      for (var i = 0; i < codes.length; i++) {
        var code = codes[i].code;
        if (ctx.familyPrefix) {
          if (code === ctx.selectedType || (/^\d{4}$/.test(code) && code.slice(0, 2) === ctx.familyPrefix)) {
            proof.accepted = true;
            proof.source = codes[i].source;
            proof.variantLabel = 'Type ' + (/^\d{4}$/.test(code) ? code : ctx.selectedType);
            proof.family = code === ctx.selectedType;
            proof.rank = 1;
            return proof;
          }
        } else if (code === ctx.selectedType) {
          proof.accepted = true;
          proof.source = codes[i].source;
          proof.variantLabel = 'Type ' + code;
          proof.rank = 1;
          return proof;
        }
      }
      if (ctx.familyPrefix) {
        var skuMatch = fieldMatchesAnyTerm(fields.skus, ctx.proofTerms, 'sku');
        var tagMatch = skuMatch.matched ? skuMatch : fieldMatchesAnyTerm(fields.tags, ctx.proofTerms, 'tag');
        if (tagMatch.matched) {
          var matchedCodes = extractTypeCodesFromText(tagMatch.term + ' ' + tagMatch.field, true).filter(function (code) {
            return /^\d{4}$/.test(code) && code.slice(0, 2) === ctx.familyPrefix;
          });
          proof.accepted = true;
          proof.source = tagMatch.source;
          proof.variantLabel = 'Type ' + (matchedCodes[0] || ctx.selectedType);
          proof.family = true;
          proof.rank = tagMatch.source === 'sku' ? 1 : 2;
          return proof;
        }
      }
      if (shared.matched) {
        proof.accepted = true;
        proof.source = 'tag';
        proof.variantLabel = ctx.selectedType ? 'Type ' + ctx.selectedType : '';
        proof.family = !!ctx.familyPrefix;
        proof.rank = 2;
        return proof;
      }
      if (direct.matched) {
        proof.accepted = true;
        proof.source = 'tag';
        proof.variantLabel = ctx.selectedType ? 'Type ' + ctx.selectedType : '';
        proof.rank = 1;
        return proof;
      }
      return proof;
    }

    var skuProof = fieldMatchesAnyTerm(fields.skus, ctx.proofTerms, 'sku');
    if (skuProof.matched) { proof.accepted = true; proof.source = 'sku'; proof.rank = 1; return proof; }
    if (direct.matched) { proof.accepted = true; proof.source = 'tag'; proof.rank = 1; return proof; }
    if (shared.matched) { proof.accepted = true; proof.source = 'tag'; proof.rank = 2; return proof; }
    return proof;
  }

  /* -------------------------------------------- Shopify product fetch */
  /* Read-only finder requests. The deadline includes queueing and body reads,
     even if the browser/network ignores AbortController. Never used for POST. */
  var finderReadQueue = [], finderReadsActive = 0, finderReadsDraining = false;
  function finderDrainReads() {
    if (finderReadsDraining) return;
    finderReadsDraining = true;
    try {
      while (finderReadsActive < 6 && finderReadQueue.length) finderReadQueue.shift()();
    } finally { finderReadsDraining = false; }
  }
  function finderFetch(url, options) {
    options = options || {};
    var configured = Number(WSP.finderRequestTimeoutMs);
    var timeout = configured > 0 && configured <= 12000 ? configured : 12000;
    return new Promise(function (resolve, reject) {
      var expires = Date.now() + timeout;
      var done = false, started = false;
      var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var timer = setTimeout(function () { finish(new Error('finder_timeout')); }, timeout);
      function finish(error, value) {
        if (done) return;
        done = true;
        clearTimeout(timer);
        if (error && ctrl) ctrl.abort();
        if (started) finderReadsActive--;
        else {
          var at = finderReadQueue.indexOf(start);
          if (at !== -1) finderReadQueue.splice(at, 1);
        }
        if (error) reject(error); else resolve(value);
        finderDrainReads();
      }
      function start() {
        if (done) return;
        if (Date.now() >= expires) { finish(new Error('finder_timeout')); return; }
        started = true;
        finderReadsActive++;
        var init = Object.assign({}, options);
        if (ctrl) init.signal = ctrl.signal;
        Promise.resolve().then(function () { return fetch(url, init); })
          .then(function (response) {
            return response.text().then(function (body) {
              finish(null, {
                ok: response.ok, status: response.status,
                text: function () { return Promise.resolve(body); },
                json: function () { return Promise.resolve().then(function () { return JSON.parse(body); }); }
              });
            });
          }).catch(function (err) { finish(err); });
      }
      finderReadQueue.push(start);
      finderDrainReads();
    });
  }
  function finderWithin(work, timeout) {
    return new Promise(function (resolve, reject) {
      var timer = setTimeout(function () { reject(new Error('finder_timeout')); }, timeout || 25000);
      work.then(function (value) { clearTimeout(timer); resolve(value); }, function (err) { clearTimeout(timer); reject(err); });
    });
  }
  function finderReadJson(response) {
    if (!response.ok) throw new Error('HTTP ' + response.status);
    return response.json();
  }
  function finderReadHtml(response) {
    if (response.status === 404) return '';
    if (!response.ok) throw new Error('HTTP ' + response.status);
    return response.text();
  }
  var productJsonCache = {};
  function jsUrlFromUrl(url) {
    var r = String(url || '').replace(/^https?:\/\/[^/]+/, '').split('?')[0];
    if (r && r.charAt(0) !== '/') r = '/' + r.replace(/^\/+/, '');
    if (/\.js$/i.test(r)) return r;
    return r ? r + '.js' : '';
  }
  function productHandleFromUrl(url) {
    var m = String(url || '').replace(/^https?:\/\/[^/]+/i, '').match(/\/products\/([^/?#]+)/i);
    return m ? m[1].toLowerCase() : '';
  }
  function productMergeKey(p) {
    var skus = rawProductSkus(p);
    if (skus.length) return 'sku:' + norm(skus[0]);
    var handle = productHandleFromUrl((p && p.url) || '');
    if (handle) return 'handle:' + handle;
    return 'id:' + String((p && p.id) || (p && p.title) || '');
  }
  function hydrateProduct(p) {
    var ju = jsUrlFromUrl(p.url || '');
    if (!ju) return Promise.resolve(p);
    var work = productJsonCache[ju];
    if (!work) {
      work = finderFetch(ju, { credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) {
          if (r.status === 404) return null;
          return finderReadJson(r).then(function (d) {
            if (!d || typeof d !== 'object' || !Array.isArray(d.variants)) throw new Error('finder_invalid_product');
            return d;
          });
        })
        .catch(function (err) { delete productJsonCache[ju]; throw err; });
      productJsonCache[ju] = work; /* share in-flight work, not only finished JSON */
    }
    return work.then(function (d) {
      if (d) {
        p._d = d;
        if (d.images && d.images.length > 1 && d.images[1]) p._img2 = String(d.images[1]);
        var pt = d.product_type || d.type || '';
        if (pt) p.product_type = pt;
        if (pt && !p.type) p.type = pt;
        if (d.available !== undefined) p.available = d.available;
        if (d.price !== undefined) { p.price = d.price; p._priceFromProductJson = true; }
        else if (d.variants && d.variants[0] && d.variants[0].price !== undefined) {
          p.price = d.variants[0].price;
          p._priceFromProductJson = true;
        }
        if (d.featured_image && !p.image) p.image = d.featured_image;
      }
      return p;
    });
  }
  function fetchProductJsonByUrl(url) {
    var ju = jsUrlFromUrl(url || '');
    if (!ju) return Promise.resolve(null);
    var pre = { url: url };
    return hydrateProduct(pre).then(function (p) {
      var d = p._d;
      if (!d) return null;
      return {
        id: d.id,
        title: d.title || '',
        url: d.handle ? lurl('/products/' + d.handle) : url,
        image: d.featured_image || '',
        price: d.price || (d.variants && d.variants[0] && d.variants[0].price) || '',
        _priceFromProductJson: true,
        available: d.available,
        product_type: d.product_type || d.type || '',
        type: d.product_type || d.type || '',
        tags: d.tags || [],
        _d: d
      };
    });
  }
  function searchPageProductUrls(html) {
    var urls = [], seen = {};
    String(html || '').replace(/href=["']([^"']*\/products\/[^"'?#]+)[^"']*["']/ig, function (_, href) {
      var m = href.replace(/^https?:\/\/[^/]+/i, '').match(/\/products\/[^/?#"']+/i);
      if (!m) return _;
      var path = m[0];
      if (path.charAt(0) !== '/') path = '/' + path.replace(/^\/+/, '');
      if (!seen[path]) { seen[path] = true; urls.push(path); }
      return _;
    });
    return urls;
  }
  function suggestAllForTerm(q) {
    q = String(q || '').trim();
    if (!q) return Promise.resolve([]);
    var SUGGEST = lurl('/search/suggest.json?q=' + encodeURIComponent(q)) +
      '&resources[type]=product&resources[limit]=10' +
      '&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor,tag';
    return finderFetch(SUGGEST, { credentials: 'same-origin', cache: 'no-store' })
      .then(finderReadJson)
      .then(function (res) {
        var prods = res && res.resources && res.resources.results && res.resources.results.products;
        if (!Array.isArray(prods)) throw new Error('finder_invalid_response');
        /* fewer than 10 => suggest returned everything for this term */
        if (prods.length < 10) return prods;
        /* 10 back => likely truncated. Page the full-text /search view to
           collect every product url for this term, then hydrate. */
        return fetchAllSearchUrls(q).then(function (urls) {
          var have = {};
          prods.forEach(function (p) { if (p && p.url) have[p.url.split('?')[0]] = true; });
          var missing = urls.filter(function (u) { return !have[u.split('?')[0]]; });
          if (!missing.length) return prods;
          return Promise.all(missing.map(fetchProductJsonByUrl)).then(function (extra) {
            return prods.concat(extra.filter(Boolean));
          });
        });
      });
  }
  /* walk /search result pages until no more products are found (cap the
     page count so a runaway term can't loop forever) */
  function fetchAllSearchUrls(q) {
    var all = [], seen = {};
    function page(n) {
      if (n > 8) return Promise.resolve();  /* up to ~8 pages */
      return finderFetch(lurl('/search?q=' + encodeURIComponent(q) + '&type=product&page=' + n), { credentials: 'same-origin' })
        .then(finderReadHtml)
        .then(function (html) {
          var urls = searchPageProductUrls(html);
          var fresh = 0;
          urls.forEach(function (u) { if (!seen[u]) { seen[u] = true; all.push(u); fresh++; } });
          if (fresh > 0 && urls.length >= 1) return page(n + 1);
        });
    }
    return page(1).then(function () { return all; });
  }
  function fetchMechanismProducts(ctx) {
    var tags = (ctx && ctx.mechanismTags) || [];
    if (!tags.length) return Promise.resolve([]);
    return Promise.all(tags.map(function (tag) {
      var collReq = finderFetch(lurl('/collections/all/' + encodeURIComponent(tag)), { credentials: 'same-origin' })
        .then(finderReadHtml).then(searchPageProductUrls);
      var searchReq = finderFetch(lurl('/search?q=' + encodeURIComponent('tag:' + tag) + '&type=product'), { credentials: 'same-origin' })
        .then(finderReadHtml).then(searchPageProductUrls);
      return Promise.all([collReq, searchReq]).then(function (lists) {
        var merged = [], seen = {};
        lists.forEach(function (list) {
          (list || []).forEach(function (u) { if (!seen[u]) { seen[u] = true; merged.push(u); } });
        });
        return Promise.all(merged.map(fetchProductJsonByUrl)).then(function (items) { return items.filter(Boolean); });
      });
    })).then(function (groups) {
      return groups.reduce(function (acc, g) { return acc.concat(g); }, []);
    });
  }

  /* --------------------------------------------- category & sorting */
  var TOP_TIER = ['Belt Kit', 'Flat Belt', 'Square Belt', 'Round Belt', 'Pinch Roller'];
  var MAINT_RX = /\b(cleaning|maintenance|grease|oil|lubricant|lubrication|cleaner|adhesive|silicone)\b/;
  /* When a product has NO product_type set in Shopify, we don't want it
     dumped into "Other". Infer a fitting category from its title, tags
     and SKU so it lands in the right group (Belts, Gears, Pinch Rollers,
     Lasers, Cleaning...). If nothing matches we still return a readable
     bucket. The inferred type is cached on the product. */
  function inferType(p) {
    var d = pData(p) || {};
    var hay = foldDiacritics([p && p.title, d.title, (rawProductTags(p) || []).join(' '), (rawProductSkus(p) || []).join(' ')]
      .filter(Boolean).join(' ')).toLowerCase();
    if (!hay) return '';
    /* order matters: most specific first */
    if (/\bbelt\b|square belt|flat belt|round belt|drive belt|counter belt|courroi|riemen|gurtel|cinghi|cintur|curea|curele|remsats|remmar|drivrem|balte|rem\b/.test(hay)) return 'Belts';
    if (/pinch ?roller|idler|tire|tyre|\broller\b|galet\s*presseur|andruckroll|zwischenrad|rull[oi]\s*(?:di\s*)?press|pressore|gomma\s*(?:idler|della\s*ruota\s*folle)|presoare|anvelop|tryckrull|mellanhjul/.test(hay)) return 'Pinch Rollers & Tires';
    if (/laser|pickup|optical|kss-|optima|lens assembly|cap laser/.test(hay)) return 'Laser Pickups';
    if (/\bgear\b|pulley|cog|sprocket|angrenaj/.test(hay)) return 'Gears';
    if (/\bhead\b|azimuth|erase head|record head|play head/.test(hay)) return 'Heads';
    if (/\bmotor\b|spindle motor|capstan motor/.test(hay)) return 'Motors';
    if (/\bscrew\b|washer|\bspring\b|clip|bracket|lever|bushing|mechanism|chassis|mecanic/.test(hay)) return 'Mechanical Parts';
    if (/clean|grease|oil|lubric|adhesive|silicone|solvent|nettoy|entretien|reinigung|wartung|pulizia|manutenzione|reng\u00f6ring|underh\u00e5ll|cur[a\u0103][t\u021b]|vaselin|ulei/.test(hay)) return 'Cleaning & Maintenance';
    return '';
  }
  /* On localized storefronts (ro-ro, de-de...) Shopify serves the
     product_type TRANSLATED ("Seturi curele", "Curea"), which silently
     breaks every /belt/, /mechanical/ test and the whole ranking. So the
     FIRST thing we do with any incoming type is map it back to canonical
     English: exact reverse-lookup of our I18N dictionaries, then a
     multilingual regex fallback for store-side translations we don't
     know verbatim. */
  /* Language-independent type mapping, three tiers built automatically
     from the I18N dictionaries. Adding a NEW market language therefore
     needs ONLY its dictionary (which the UI needs anyway): exact match,
     diacritic-stripped match, and word-stem match (catches
     singular/plural and small inflections in any language, e.g. Shopify
     "Cinghia" vs dictionary "Cinghie", "Courroie" vs "Courroies").
     The per-language regex blocks below remain only as a last net for
     store-side wordings that differ from the dictionary entirely. */
  function foldDiacritics(s) {
    s = String(s);
    try { s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); } catch (e) {}
    return s;
  }
  function stemSig(s) {
    var words = foldDiacritics(s).toLowerCase().split(/[^a-z0-9&]+/).filter(Boolean);
    return words.map(function (w) {
      if (w.length > 5) return w.slice(0, w.length - 2);
      if (w.length > 3) return w.slice(0, w.length - 1);
      return w;
    }).join(' ');
  }
  /* prefSig: each word cut to its first 5 letters. Catches inflection
     (Courroie/Courroies -> "courr") in any language. Only trusted when
     the signature maps to a SINGLE canonical type: compound-word
     collisions (Riemen vs Riemensatz -> both "rieme") are marked
     ambiguous and never matched, falling through to the safer tiers. */
  function prefSig(s) {
    var words = foldDiacritics(s).toLowerCase().split(/[^a-z0-9&]+/).filter(Boolean);
    return words.map(function (w) { return w.length > 5 ? w.slice(0, 5) : w; }).join(' ');
  }
  /* Shopify Translate & Adapt sometimes spells conjunctions out while the
     theme dictionary uses an ampersand (French "et" vs "&", German "und",
     Swedish "och", etc.). Remove conjunction-only tokens for one additional
     exact signature so wording/punctuation changes cannot turn a translated
     product type into an unknown category. */
  function semanticSig(s) {
    var stop = { '&': true, 'and': true, 'und': true, 'et': true, 'e': true, 'si': true, 'och': true };
    return foldDiacritics(s).toLowerCase().split(/[^a-z0-9&]+/)
      .filter(function (w) { return w && !stop[w]; }).join(' ');
  }
  var REVERSE_I18N = {};
  var REVERSE_FOLD = {};
  var REVERSE_STEM = {};
  var REVERSE_PREF = {};
  var REVERSE_SEMANTIC = {};
  (function () {
    function addPref(v, en) {
      var sig = prefSig(v);
      if (!(sig in REVERSE_PREF)) REVERSE_PREF[sig] = en;
      else if (REVERSE_PREF[sig] !== en) REVERSE_PREF[sig] = null; /* ambiguous */
    }
    function addSemantic(v, en) {
      var sig = semanticSig(v);
      if (!(sig in REVERSE_SEMANTIC)) REVERSE_SEMANTIC[sig] = en;
      else if (REVERSE_SEMANTIC[sig] !== en) REVERSE_SEMANTIC[sig] = null;
    }
    Object.keys(I18N).forEach(function (loc) {
      var d = I18N[loc];
      Object.keys(d).forEach(function (en) {
        var v = String(d[en]);
        REVERSE_I18N[v.toLowerCase()] = en;
        REVERSE_FOLD[foldDiacritics(v).toLowerCase()] = en;
        REVERSE_STEM[stemSig(v)] = en;
        addPref(v, en);
        addSemantic(v, en);
      });
      /* the English keys themselves are also valid inputs */
      Object.keys(d).forEach(function (en) {
        REVERSE_STEM[stemSig(en)] = REVERSE_STEM[stemSig(en)] || en;
        addPref(en, en);
        addSemantic(en, en);
      });
    });
  })();
  /* WHEN ADDING A NEW MARKET LANGUAGE: add its I18N dictionary and the
     three-tier reverse lookup (exact / diacritic-folded / word-stem)
     covers Shopify's type translations automatically, including
     singular/plural variants. Only add a regex block below if the
     store-side wording differs from the dictionary ENTIRELY (different
     vocabulary, not just inflection); otherwise nothing else is needed. */
  function canonType(t) {
    var s = String(t || '').trim();
    if (!s) return s;
    var hit = REVERSE_I18N[s.toLowerCase()] ||
              REVERSE_FOLD[foldDiacritics(s).toLowerCase()] ||
              REVERSE_SEMANTIC[semanticSig(s)] ||
              REVERSE_STEM[stemSig(s)] ||
              REVERSE_PREF[prefSig(s)];
    if (hit) return hit;
    var low = foldDiacritics(s).toLowerCase();
    /* store-side translations. Accepts the validated RO glossary terms AND
       older/alternative wordings, so a change of vocabulary in Shopify can
       never silently break belt detection or ranking again. */
    if (/curea|curele/.test(low)) return /set|kit/.test(low) ? 'Belt Kit' : 'Belts';
    /* pinch roller: glossary "rolă presiune" + older "rolă presoare" */
    if (/rol[ea\u0103]\s*(de\s*)?presi|presoare|pinch/.test(low)) return 'Pinch Rollers & Tires';
    /* idler tire: glossary "pneu roată intermediară" + older "anvelopă idler" */
    if (/pneu|anvelop|roat[a\u0103]\s*intermediar|ro[t\u021b\u0163]i\s*intermediare|idler/.test(low)) return 'Pinch Rollers & Tires';
    /* gears: glossary "roți dințate" + older "angrenaj" */
    if (/roat[a\u0103]\s*din[t\u021b\u0163]at|ro[t\u021b\u0163]i\s*din[t\u021b\u0163]ate|angrenaj/.test(low)) {
      return /mecanic/.test(low) ? 'Gears & Mechanical Parts' : 'Gears';
    }
    if (/mecanic/.test(low)) return 'Mechanical Parts';
    /* laser: glossary "cap de citire laser" + older "cap laser" */
    if (/cap\s*(de\s*citire\s*)?laser|cap(ete)?\s*laser|pick-?up\s*optic|laser/.test(low)) return 'Laser Pickups';
    if (/cur[a\u0103][t\u021b\u0163]are|\u00eentre[t\u021b\u0163]inere/.test(low)) return 'Cleaning & Maintenance';
    if (/baterii/.test(low)) return 'Batteries';
    if (/motoare/.test(low)) return 'Motors';
    if (/antene/.test(low)) return 'Antennas';
    if (/cablu|cabluri/.test(low)) return 'Connecting Cables';
    if (/siguran[\u021b\u0163][e\u0103]/.test(low)) return 'Fuses';
    if (/l\u0103mpi|becuri/.test(low)) return 'Lamps';
    if (/\u00eentrerup\u0103t|comutat|microcomutat/.test(low)) return 'Switches';
    if (/covora[\u0219\u015f]|slipmat/.test(low)) return 'Mats';
    if (/contragreut|greut\u0103[\u021b\u0163]/.test(low)) return 'Weights';
    if (/kit(uri)? de repara/.test(low)) return 'Repair Kits';
    if (/unelte|scule|calibrare/.test(low)) return 'Tools & Calibration';
    if (/conector|mufe/.test(low)) return 'Connectors';
    if (/\bdoze\b|doz\u0103/.test(low)) return 'Cartridges';
    if (/picioru[\u0219\u015f]e|picioare/.test(low)) return 'Feet';
    /* ---- French store translations (including "et" vs dictionary "&") ---- */
    if (/courroi/.test(low)) {
      if (/plat/.test(low)) return 'Flat Belt';
      if (/carr/.test(low)) return 'Square Belt';
      if (/rond/.test(low)) return 'Round Belt';
      if (/courroi.*(?:\bet\b|&).*kit|kit.*(?:\bet\b|&).*courroi/.test(low)) return 'Belts & Belt Kits';
      return /kit|jeu|lot/.test(low) ? 'Belt Kit' : 'Belts';
    }
    if (/galet\s*presseur|pneu\s*(?:de\s*)?galet|roue\s*folle/.test(low)) return 'Pinch Rollers & Tires';
    if (/engrenage/.test(low)) return /mecani/.test(low) ? 'Gears & Mechanical Parts' : 'Gears';
    if (/piece[s]?\s*mecani|mecanique/.test(low)) return 'Mechanical Parts';
    if (/bloc\s*optique|tete\s*laser|capteur\s*laser|laser/.test(low)) return 'Laser Pickups';
    if (/nettoy|entretien/.test(low)) return 'Cleaning & Maintenance';
    if (/batterie|pile/.test(low)) return 'Batteries';
    if (/moteur/.test(low)) return 'Motors';
    if (/antenne/.test(low)) return 'Antennas';
    if (/cable/.test(low)) return 'Connecting Cables';
    if (/fusible/.test(low)) return 'Fuses';
    if (/lampe|ampoule/.test(low)) return 'Lamps';
    if (/interrupteur|commutateur/.test(low)) return 'Switches';
    if (/tapis/.test(low)) return 'Mats';
    if (/contrepoids|poids/.test(low)) return 'Weights';
    if (/kit\s*de\s*reparation/.test(low)) return 'Repair Kits';
    if (/outil|calibrage|etalonnage/.test(low)) return 'Tools & Calibration';
    if (/connecteur|fiche/.test(low)) return 'Connectors';
    if (/cellule|phonocapteur/.test(low)) return 'Cartridges';
    if (/tete\s*(?:de\s*)?(?:lecture|enregistrement|magnetique)/.test(low)) return 'Heads';
    if (/pied[s]?\s*(?:en\s*)?caoutchouc/.test(low)) return 'Rubber Feet';
    /* ---- Swedish store translations (glossary-compliant + variants) ---- */
    if (/remsats|remsatser/.test(low)) return 'Belt Kit';
    if (/\brem\b|remmar|drivrem|drivremmar/.test(low)) return /sats/.test(low) ? 'Belt Kit' : 'Belts';
    if (/tryckhjul|tryckrull/.test(low)) return 'Pinch Rollers & Tires';
    if (/utbytesgummi|mellanhjul/.test(low)) return 'Pinch Rollers & Tires';
    if (/kugghjul/.test(low)) return /mekanisk/.test(low) ? 'Gears & Mechanical Parts' : 'Gears';
    if (/mekaniska delar|mekanisk/.test(low)) return 'Mechanical Parts';
    if (/laserspickup|laserpickup|laserenhet/.test(low)) return 'Laser Pickups';
    if (/reng\u00f6ring|underh\u00e5ll/.test(low)) return 'Cleaning & Maintenance';
    if (/batterier/.test(low)) return 'Batteries';
    if (/motorer/.test(low)) return 'Motors';
    if (/antenner/.test(low)) return 'Antennas';
    if (/anslutningskablar/.test(low)) return 'Connecting Cables';
    if (/gummif\u00f6tter/.test(low)) return 'Rubber Feet';
    if (/s\u00e4kringar|s\u00e4kring/.test(low)) return 'Fuses';
    if (/lampor|gl\u00f6dlampor/.test(low)) return 'Lamps';
    if (/brytare|omkopplare|mikrobrytare|str\u00f6mbrytare/.test(low)) return 'Switches';
    if (/mattor|slipmatt/.test(low)) return 'Mats';
    if (/vikter|motvikt/.test(low)) return 'Weights';
    if (/reparationssats/.test(low)) return 'Repair Kits';
    if (/verktyg|kalibrering/.test(low)) return 'Tools & Calibration';
    if (/kontakter|stickkontakt|anslutningsplugg/.test(low)) return 'Connectors';
    if (/f\u00f6tter/.test(low)) return 'Feet';
    /* ---- Italian store translations (Translate & Adapt wordings) ---- */
    if (/cinghi[ae]/.test(low)) return /set|kit/.test(low) ? 'Belt Kit' : 'Belts';
    if (/rull[oi]\s*(di\s*)?press|pressore/.test(low)) return 'Pinch Rollers & Tires';
    if (/gomma|gommino|ruota\s*folle|puleggia\s*folle/.test(low)) return 'Pinch Rollers & Tires';
    if (/ingranagg/.test(low)) return /meccanic/.test(low) ? 'Gears & Mechanical Parts' : 'Gears';
    if (/meccanic/.test(low)) return 'Mechanical Parts';
    if (/cintur/.test(low)) return /kit|set/.test(low) ? 'Belt Kit' : 'Belts'; /* T&A mistranslation net */
    if (/pulizia|manutenzione/.test(low)) return 'Cleaning & Maintenance';
    if (/batterie/.test(low)) return 'Batteries';
    if (/motor[ei]/.test(low)) return 'Motors';
    if (/antenne/.test(low)) return 'Antennas';
    if (/cav[oi]\b/.test(low)) return 'Connecting Cables';
    if (/piedini/.test(low)) return 'Rubber Feet';
    if (/fonorivelator|testin[ae]/.test(low)) return 'Cartridges';
    /* ---- German (glossary wordings; dict tiers cover the rest) ---- */
    if (/riemens[a\u00e4]tz/.test(low)) return 'Belt Kit';
    if (/g[u\u00fc]rtel/.test(low)) { /* T&A mistranslation net */
      if (/(?:\bund\b|&).*(?:satz|set|kit)|(?:satz|set|kit).*(?:\bund\b|&)/.test(low)) return 'Belts & Belt Kits';
      return /satz|set|kit/.test(low) ? 'Belt Kit' : 'Belts';
    }
    if (/riemen/.test(low)) return /satz|kit/.test(low) ? 'Belt Kit' : 'Belts';
    if (/andruckroll|zwischenrad/.test(low)) return 'Pinch Rollers & Tires';
    if (/zahnr[a\u00e4]d/.test(low)) return /mechanis|mechanik/.test(low) ? 'Gears & Mechanical Parts' : 'Gears';
    if (/mechanische|mechanik-?teile/.test(low)) return 'Mechanical Parts';
    if (/laserabtast|abtasteinheit/.test(low)) return 'Laser Pickups';
    if (/reinigung|wartung/.test(low)) return 'Cleaning & Maintenance';
    if (/sicherung/.test(low)) return 'Fuses';
    if (/verbindungskabel/.test(low)) return 'Connecting Cables';
    if (/gummif[u\u00fc]sse|gummif\u00fc\u00dfe/.test(low)) return 'Rubber Feet';
    if (/tonabnehmer/.test(low)) return 'Cartridges';
    if (/tonk[o\u00f6]pfe|tonkopf/.test(low)) return 'Heads';
    if (/mikroschalter|schalter/.test(low)) return 'Switches';
    if (/motoren/.test(low)) return 'Motors';
    if (/batterien/.test(low)) return 'Batteries';
    if (/antennen/.test(low)) return 'Antennas';
    if (/fusibil/.test(low)) return 'Fuses';
    if (/lampad/.test(low)) return 'Lamps';
    if (/interruttor|microinterruttor|commutator/.test(low)) return 'Switches';
    if (/tappetin/.test(low)) return 'Mats';
    if (/contrappes/.test(low)) return 'Weights';
    if (/kit di riparazion/.test(low)) return 'Repair Kits';
    if (/attrezzi|strumenti|calibrazion/.test(low)) return 'Tools & Calibration';
    if (/connettor|spinott/.test(low)) return 'Connectors';
    if (/rinvio/.test(low)) return 'Pinch Rollers & Tires';
    /* ---- Swedish (compounds + T&A wordings) ---- */
    if (/fyrkant\w*rem|rem\w*fyrkant/.test(low)) return 'Square Belt';
    if (/platt\w*rem|rem\w*platt/.test(low)) return 'Flat Belt';
    if (/rund\w*rem|rem\w*rund/.test(low)) return 'Round Belt';
    if (/remsats/.test(low)) return 'Belt Kit';
    if (/b[a\u00e4]lte|drivrem|remmar|rem\b/.test(low)) return /sats|set|kit/.test(low) ? 'Belt Kit' : 'Belts';
    if (/tryckrull|mellanhjul/.test(low)) return 'Pinch Rollers & Tires';
    if (/mekanisk/.test(low)) return 'Mechanical Parts';
    if (/reng[o\u00f6]ring|underh[a\u00e5]ll/.test(low)) return 'Cleaning & Maintenance';
    return s;
  }

  function getType(p) {
    if (p && p._wspType) return p._wspType;           /* cached */
    var d = pData(p) || {};
    var raw = (p && (p.product_type || p.type)) || d.product_type || d.type || '';
    var clean = canonType(String(raw || '').trim());
    if (!clean) {
      clean = inferType(p);                            /* auto-allocate */
      if (clean) console.info('[WSP] auto-typed "' + ((p && p.title) || '?') + '" -> ' + clean);
    }
    var out = clean || 'Other compatible parts'; /* canonical; catLabelI18n translates at render */
    if (p) p._wspType = out;
    return out;
  }
  function typeLexemes(t) {
    return foldDiacritics(String(t || '')).toLowerCase();
  }
  function isBeltType(t) {
    var s = typeLexemes(canonType(t) || t);
    return /\bbelt\b|\bbelts\b|courroi|riemen|g[u]?[u\u00fc]rtel|cinghi|cintur|curea|curele|remsats|remmar|drivrem|rem\b|b[a\u00e4]lte/.test(s);
  }
  function isMechanicalType(t) {
    var s = typeLexemes(canonType(t) || t);
    return /mechanical|mechanik|mecani|meccanic|mecanic|mekanisk/.test(s);
  }
  function isMaintenanceType(t) {
    var s = typeLexemes(canonType(t) || t);
    return MAINT_RX.test(s) || /nettoy|entretien|reinigung|wartung|pulizia|manutenzione|rengoring|underhall|curat|intretinere|vaselin|ulei/.test(s);
  }
  /* CANONICAL label - English, used for grouping, ranking and every
     /belt/, /mechanical/ test. NEVER translated, or the logic breaks in
     other locales (e.g. "Belt Kit" -> "Seturi curele" stops matching /belt/). */
  function displayCategoryLabel(t) { return (t === 'Uncategorized' || t === 'Other') ? 'Other compatible parts' : t; }
  /* TRANSLATED label - only for showing to the user, applied at render time. */
  function catLabelI18n(t) { return T(displayCategoryLabel(t)); }
  function categoryPriority(type) {
    var t = displayCategoryLabel(type);
    return categoryRankFromType(t);
  }
  /* Business priority by PRODUCT TYPE ONLY (titles are never used to
     categorize - a grease tin mentioning "gears" stays in Cleaning):
     belts -> gears -> pinch rollers -> lasers -> cleaning -> the rest. */
  function categoryRankFromType(type) {
    var t = String(type || '').toLowerCase();
    /* ORDER MATTERS: store labels can be combined ("Gears & Mechanical
       Parts"), and mechanical must win over gear or the big mechanical
       block ranks as Gears (1) and buries everything after it. */
    if (isMechanicalType(t)) return 85;  /* always the last real category */
    if (isBeltType(t)) return 0;
    if (/gear/.test(t)) return 1;
    if (/pinch|idler|tire|tyre|roller/.test(t)) return 2;
    if (/laser|pickup|optical/.test(t)) return 3;
    if (isMaintenanceType(t)) return 50;
    if (/other compatible/.test(t)) return 90;
    return 60;
  }
  function productCategoryRank(p) {
    return categoryRankFromType(getType(p));
  }
  function productCategoryGroup(p) {
    /* group heading is the real product type label from the store */
    return displayCategoryLabel(getType(p));
  }
  function isMaintenanceProduct(p) {
    return isMaintenanceType(getType(p));
  }
  /* "Handy for any repair" / "suits any machine" must only ever offer
     consumables that genuinely fit every deck type: greases, oils and
     lubricants. Machine-specific cleaning products - vinyl record
     cleaning fluids/kits, tape & DAT head cleaners, stylus tools - fit
     ONE format only, so they must never surface in the cross-model
     upsell (a CD buyer was being shown record-cleaning fluid). Per-model
     results still show their own cleaning items via the side rail; this
     guard only governs the universal cache. */
  function maintText(p) {
    var d = pData(p);
    var vt = (d && d.variants ? d.variants : []).map(function (v) { return v && v.title ? v.title : ''; }).join(' ');
    return (String((p && p.handle) || '') + ' ' + String((p && p.title) || '') + ' ' + String(getType(p) || '') + ' ' + vt).toLowerCase();
  }
  function isUniversalMaint(p) {
    var s = maintText(p);
    /* keyword net = candidate finder only; the gates below decide */
    var lube = /grease|molybdenum|\bmos\b|lubric|silicone[\s-]?oil|synthetic|adhesive|\boil\b/.test(s);
    if (!lube) return false;
    var specific = /record|vinyl|turntable|stylus|head[\s-]?clean|tape[\s-]?head|clean(?:ing)?[\s-]*(?:kit|fluid|solution|set|liquid|swab|stick)|\bbrush\b/.test(s);
    if (specific) return false;
    /* GATE 1 - mechanical part references. Spare parts carry service-manual
       positions ("Pos.207") and ref codes ("AZB1091"); consumables never do.
       "Pos.207 - AZB1091 Oil Cut" is a PART with "oil" in the name, not oil. */
    if (/\bpos\.?\s*\d+|\b[a-z]{2,4}-?\d{3,}\b/.test(s)) return false;
    /* GATE 2 - second-hand / original-OEM stock is never a consumable. */
    if (/\bused\b|second[\s-]?hand|refurb|\bnos\b|new old stock|original[\s-]?oem|oem[\s-]?original|condition[:\s-]+used/.test(s)) return false;
    /* GATE 3 - once hydrated, the product's real TYPE decides (type before
       title - house rule). A typed product that isn't Cleaning & Maintenance
       is a spare part, whatever its name says. */
    var d = pData(p);
    if (d) {
      var rawTy = d.product_type || d.type || '';
      if (rawTy && !isMaintenanceType(rawTy)) return false;
    }
    return true;
  }
  function primaryVariant(p) {
    var d = pData(p);
    var v = d && d.variants ? d.variants : [];
    if (!v.length) return null;
    return v.find(function (x) { return x.available; }) || v[0];
  }
  function stockN(v) {
    if (!v) return null;
    var ks = ['inventory_quantity', 'quantity', 'inventory'];
    for (var i = 0; i < ks.length; i++) if (typeof v[ks[i]] === 'number') return v[ks[i]];
    return null;
  }
  function isAvailable(p) {
    var avail = p && p.available !== false;
    var v = primaryVariant(p);
    if (v && v.available === false) avail = false;
    return avail;
  }
  function outRank(p) { return isAvailable(p) ? 0 : 1; }
  function priceValue(p) {
    if (p && p.price !== undefined && p.price !== '') {
      var raw = String(p.price).replace(/[^0-9.]/g, '');
      var n = parseFloat(raw);
      if (isNaN(n)) return Infinity;
      if (p._priceFromProductJson && String(p.price).indexOf('.') === -1) n = n / 100;
      else if (n > 500 && String(p.price).indexOf('.') === -1) n = n / 100;
      return n;
    }
    return Infinity;
  }
  function sortProductsForDisplay(a, b) {
    /* absolute rule: any product whose TYPE contains "belt" outranks
       everything else, stock status included - belts are the business */
    var abelt = isBeltType(getType(a)) ? 0 : 1;
    var bbelt = isBeltType(getType(b)) ? 0 : 1;
    if (abelt !== bbelt) return abelt - bbelt;
    var ao = outRank(a), bo = outRank(b);
    if (ao !== bo) return ao - bo;
    var at = productCategoryRank(a), bt = productCategoryRank(b);
    if (at !== bt) return at - bt;
    var ar = (a._wspCompat && a._wspCompat.rank) || 9;
    var br = (b._wspCompat && b._wspCompat.rank) || 9;
    if (ar !== br) return ar - br;
    return String(a.title || '').localeCompare(String(b.title || ''), undefined, { numeric: true, sensitivity: 'base' });
  }
  function sortComparator(mode) {
    if (mode === 'price-asc') return function (a, b) { return priceValue(a) - priceValue(b); };
    if (mode === 'price-desc') return function (a, b) { return priceValue(b) - priceValue(a); };
    if (mode === 'stock') return function (a, b) {
      var ao = outRank(a), bo = outRank(b);
      if (ao !== bo) return ao - bo;
      return sortProductsForDisplay(a, b);
    };
    return sortProductsForDisplay;
  }

  /* -------------------------------------------- title / display utils */
  function stripLeadingProductCode(title) {
    var t = String(title || '').replace(/\s+/g, ' ').trim();
    if (!t) return '';
    var m = t.match(/^([A-Za-z]{1,4}\d{2,}(?:[.-]\d+)?)(?:\s*[-:\u2013\u2014]\s*|\s+)(.+)$/);
    if (m && /\d/.test(m[1])) return m[2].replace(/^[\s\-:\u2013\u2014]+/, '').trim();
    return t;
  }
  function extractLeadingCode(title) {
    var t = String(title || '').replace(/\s+/g, ' ').trim();
    var m = t.match(/^([A-Za-z]{1,4}\d{2,}(?:[.-]\d+)?)(?:\s*[-:\u2013\u2014]\s*|\s+)(.+)$/);
    if (m && /\d/.test(m[1])) return m[1];
    return '';
  }
  function primarySku(p) {
    var skus = rawProductSkus(p);
    if (skus.length) return skus[0];
    return extractLeadingCode((p && p.title) || '');
  }
  function extractMaintenancePackSize(title) {
    var m = stripLeadingProductCode(title).match(/\b\d+(?:[.,]\d+)?\s*(?:ml|mL|l|g|gr|gram|grams)\b\.?/i);
    return m ? m[0].replace(/\s+/g, ' ').replace(/\bgrams?\b/i, 'g').trim() : '';
  }
  function maintenanceBaseTitle(title) {
    return stripLeadingProductCode(title)
      .replace(/\b\d+(?:[.,]\d+)?\s*(?:ml|mL|l|g|gr|gram|grams)\b\.?/ig, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }
  function groupMaintenanceRows(products) {
    var out = [], map = {};
    (products || []).forEach(function (p) {
      if (!isMaintenanceProduct(p)) { out.push(p); return; }
      var key = norm(maintenanceBaseTitle((p && p.title) || ''));
      if (!key) { out.push(p); return; }
      if (!map[key]) {
        map[key] = p;
        p._wspGroupItems = [p];
        p._wspGroupTitle = maintenanceBaseTitle(p.title);
        out.push(p);
      } else {
        map[key]._wspGroupItems.push(p);
      }
    });
    out.forEach(function (p) {
      if (p && p._wspGroupItems && p._wspGroupItems.length < 2) {
        p._wspGroupItems = null;
        p._wspGroupTitle = '';
      }
    });
    return out;
  }

  /* ------------------------------------------------------ cart utils */
  var cartVar = {};
  function loadCart() {
    return finderFetch(lurl('/cart.js'), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cartVar = {};
        ((cart && cart.items) || []).forEach(function (it) {
          var v = String(it.variant_id || it.id || '');
          if (v) cartVar[v] = (cartVar[v] || 0) + Number(it.quantity || 0);
        });
        return cart;
      });
  }
  function addVariantToCart(variantId, quantity) {
    return fetch(lurl('/cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: Number(variantId), quantity: quantity || 1 })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error((j && j.description) || 'add_fail'); });
      return r.json();
    });
  }
  function addProductToCart(p) {
    /* Adds the exact first available variant of this specific product. */
    var work = p._d ? Promise.resolve(p._d) : hydrateProduct(p).then(function () { return p._d; });
    return work.then(function (d) {
      if (!d || !(d.variants || []).length) throw new Error('no_var');
      var v = d.variants.find(function (x) { return x.available; }) || d.variants[0];
      if (!v || !v.id) throw new Error('no_var');
      var sq = stockN(v);
      var cq = cartVar[String(v.id)] || 0;
      if (sq !== null && cq > 0 && cq >= sq) throw new Error('cart_limit');
      return addVariantToCart(v.id, 1);
    });
  }

  /* ================================================================
     FINDER widget ([data-finder]) - dropdown, recent, go button
     ================================================================ */
  function initFinder(root, onSearch) {
    var input = root.querySelector('[data-finder-input]');
    var box = root.querySelector('[data-finder-box]');
    var clear = root.querySelector('[data-finder-clear]');
    var go = root.querySelector('[data-finder-go]');
    var goText = root.querySelector('[data-finder-go-text]');
    var dropdown = root.querySelector('[data-finder-dropdown]');
    var status = root.querySelector('[data-finder-status]');
    var progress = root.querySelector('[data-finder-progress]');
    var recentWrap = root.querySelector('[data-finder-recent]');
    var recentChips = root.querySelector('[data-finder-recent-chips]');
    if (!input || !go || !dropdown) return null;

    var selBrand = '', selModel = '', dropIdx = -1, busy = false;
    if (progress && !dbReady && !dbFailed) progressStart(progress); /* DB loading phase */

    /* While the database is loading, typing would only produce a false
       "no model found" - so lock the input and say what's happening.
       Unlocks (and restores the placeholder) the moment the DB arrives,
       or on failure (the fallback search path still works then). */
    if (!dbReady && !dbFailed) {
      var origPlaceholder = input.getAttribute('placeholder') || '';
      input.disabled = true;
      go.disabled = true;
      root.classList.add('finder--dbloading');
      input.setAttribute('placeholder', T('Database loading, please wait…'));
      onDbReady(function () {
        input.disabled = false;
        go.disabled = false;
        root.classList.remove('finder--dbloading');
        input.setAttribute('placeholder', origPlaceholder);
      });
    }

    /* Typewriter placeholder on the hero finder: shows real examples so
       visitors instantly understand what to type. Stops on first focus. */
    var demoTimer = null, demoStopped = false;
    function startPlaceholderDemo() {
      if (!root.closest('.hero') || demoStopped || demoTimer) return;
      var samples = ['Sony CDP-M301', 'Technics SL-1210', 'Aiwa AD-F770', 'Pioneer CT-F850', 'Bang & Olufsen Beogram 4002'];
      var si = 0, ci = 0, deleting = false;
      demoTimer = setInterval(function () {
        if (demoStopped || document.activeElement === input || input.value) return;
        var word = samples[si % samples.length];
        if (!deleting) {
          ci++;
          if (ci >= word.length + 14) deleting = true; /* hold, then delete */
        } else {
          ci--;
          if (ci <= 0) { deleting = false; si++; }
        }
        input.placeholder = word.slice(0, Math.max(0, Math.min(ci, word.length))) || T('Enter brand and model…');
      }, 95);
      input.addEventListener('focus', stopDemo, { once: false });
      input.addEventListener('input', stopDemo, { once: false });
    }
    function stopDemo() {
      demoStopped = true;
      if (demoTimer) { clearInterval(demoTimer); demoTimer = null; }
      input.placeholder = T('Enter brand and model, e.g. Sony CDP-M301');
    }
    var autoTimer = null, lastAutoKey = '';

    function setStatus(html, type) {
      if (!status) return;
      status.innerHTML = html || '';
      status.className = 'finder__status' + (type ? ' finder__status--' + type : '');
    }
    function updateGo() {
      /* the primary CTA never renders dead - only while actually working */
      go.disabled = busy;
    }
    function setProgress(on) {
      if (!progress) return;
      if (on) progressStart(progress); else progressFinish(progress);
    }
    function setBusy(b, label) {
      busy = b;
      if (label && goText) goText.textContent = label;
      setProgress(b);
      updateGo();
    }
    function closeDropdown() {
      dropdown.classList.remove('is-open');
      input.setAttribute('aria-expanded', 'false');
      dropIdx = -1;
    }
    function renderRecent() {
      if (!recentWrap || !recentChips) return;
      var list = rLoad();
      if (!list.length) { recentWrap.hidden = true; return; }
      recentWrap.hidden = false;
      recentChips.innerHTML = '';
      list.slice(0, 3).forEach(function (r) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'chip';
        b.textContent = r.brand + ' ' + r.model;
        b.addEventListener('click', function () {
          selBrand = r.brand;
          selModel = r.model;
          input.value = r.brand + ' ' + r.model;
          updateGo();
          trigger();
        });
        recentChips.appendChild(b);
      });
    }
    function renderDropdown(q) {
      var rawQuery = String(q || '').trim();
      dropdown.innerHTML = '';
      dropIdx = -1;
      if (!rawQuery) { closeDropdown(); return; }
      var results = searchDb(rawQuery, selBrand);
      if (!results.length) {
        dropdown.innerHTML = '<div class="fd__empty">' + T('No matches for that spelling. Model not in the database yet? We\'ll identify the right belt for you. <strong>Free, you only pay shipping</strong>.') +
          '<a class="finder__offerbtn fd__offerbtn" href="/pages/technical-support?model=' + encodeURIComponent((input.value || '').trim().slice(0, 80)) + '&offer=identify">' + T('Get your free belt →') + '</a></div>';
        dropdown.classList.add('is-open');
        input.setAttribute('aria-expanded', 'true');
        return;
      }
      var head = document.createElement('div');
      head.className = 'fd__group';
      head.textContent = T('Best matches');
      dropdown.appendChild(head);
      results.slice(0, 9).forEach(function (r) {
        var e = r.e;
        var item = document.createElement('button');
        item.type = 'button';
        item.className = 'fd__item';
        item.setAttribute('role', 'option');
        if (e.type === 'brand') {
          item.innerHTML = '<span class="fd__brand">' + highlight(e.brand, rawQuery) + '</span><span class="fd__hint">' + T('Brand, keep typing the model') + '</span>';
        } else {
          item.innerHTML = '<span class="fd__brand">' + esc(e.brand) + '</span><span class="fd__model">' + highlight(e.model, rawQuery) + '</span>';
        }
        item.addEventListener('mousedown', function (ev) {
          ev.preventDefault();
          pickEntry(e);
        });
        dropdown.appendChild(item);
      });
      var offer = document.createElement('div');
      offer.className = 'fd__offer';
      offer.innerHTML = T('None of these? We will identify the right belt for you. Free, you only pay shipping.') + ' ' +
        '<a class="finder__offerbtn fd__offerbtn" href="/pages/technical-support?model=' + encodeURIComponent(rawQuery.slice(0, 80)) + '&offer=identify">' + T('Get your free belt →') + '</a>';
      offer.addEventListener('mousedown', function (ev) { ev.stopPropagation(); });
      dropdown.appendChild(offer);
      dropdown.classList.add('is-open');
      input.setAttribute('aria-expanded', 'true');
    }
    function pickEntry(e) {
      if (e.type === 'brand') {
        selBrand = e.brand;
        selModel = '';
        input.value = e.brand + ' ';
        setStatus(T('<strong>{b}</strong>. Now type the model number, or pick it from the list.').replace('{b}', esc(e.brand)), 'ok');
        renderDropdown(input.value);
        input.focus();
        updateGo();
      } else {
        selBrand = e.brand;
        selModel = e.model;
        input.value = e.brand + ' ' + e.model;
        closeDropdown();
        updateGo();
        trigger();
      }
    }
    function resolveSelectionFromInput(raw) {
      selBrand = '';
      selModel = '';
      db.brands.some(function (b) {
        if (raw.toLowerCase().indexOf(b.toLowerCase() + ' ') === 0 || norm(raw) === norm(b)) {
          selBrand = b;
          var rest = raw.slice(b.length).trim();
          var m = (db.modelsByBrand[b] || []).find(function (model) { return norm(model) === norm(rest); });
          if (m) { selModel = m; return true; }
        }
        return false;
      });
    }
    function tryAutoSearch(raw) {
      if (autoTimer) { clearTimeout(autoTimer); autoTimer = null; }
      if (busy) return;
      var match = findUniqueModelMatch(raw);
      if (!match) return;
      var key = match.brand + '|' + match.model;
      if (lastAutoKey === key) return;
      autoTimer = setTimeout(function () {
        var nowMatch = findUniqueModelMatch(input.value.trim());
        if (!nowMatch) return;
        var nowKey = nowMatch.brand + '|' + nowMatch.model;
        if (nowKey !== key || lastAutoKey === nowKey) return;
        lastAutoKey = nowKey;
        selBrand = nowMatch.brand;
        selModel = nowMatch.model;
        input.value = nowMatch.brand + ' ' + nowMatch.model;
        closeDropdown();
        updateGo();
        trigger();
      }, 450);
    }
    var queuedSearch = false;
    function trigger() {
      if (busy) return;
      if (!dbReady) {
        queuedSearch = true;
        setStatus(T('Connecting to the database. Your search will run automatically in a moment…'), 'hint');
        return;
      }
      if (!selBrand || !selModel) {
        input.focus();
        var typed = (input.value || '').trim().slice(0, 80);
        if (typed.length >= 3) {
          /* unresolvable text: the dropdown itself carries the free-belt
             offer (empty state or the row under the suggestions) */
          renderDropdown(typed);
          setStatus(T('Pick your model from the list, or use the free identification below it.'), 'hint');
        } else {
          setStatus(T('Type the brand and model printed on your unit, e.g. <strong>Sony CDP-M301</strong>, then pick it from the list.'), 'hint');
        }
        if (box) { box.classList.remove('finder__box--nudge'); void box.offsetWidth; box.classList.add('finder__box--nudge'); }
        return;
      }
      rSave(selBrand, selModel);
      renderRecent();
      onSearch(selBrand, selModel, api);
    }

    input.addEventListener('input', function () {
      var raw = this.value.trim();
      if (clear) clear.hidden = !raw;
      resolveSelectionFromInput(raw);
      updateGo();
      renderDropdown(raw);
      tryAutoSearch(raw);
    });
    input.addEventListener('focus', function () {
      if (this.value.trim()) renderDropdown(this.value.trim());
    });
    input.addEventListener('keydown', function (e) {
      var opts = dropdown.querySelectorAll('.fd__item');
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        dropIdx = Math.min(dropIdx + 1, opts.length - 1);
        opts.forEach(function (o, i) { o.classList.toggle('is-focused', i === dropIdx); });
        if (opts[dropIdx]) opts[dropIdx].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        dropIdx = Math.max(dropIdx - 1, 0);
        opts.forEach(function (o, i) { o.classList.toggle('is-focused', i === dropIdx); });
        if (opts[dropIdx]) opts[dropIdx].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter') {
        e.preventDefault();
        if (dropIdx >= 0 && opts[dropIdx]) opts[dropIdx].dispatchEvent(new MouseEvent('mousedown'));
        else if (opts.length === 1) opts[0].dispatchEvent(new MouseEvent('mousedown'));
        else if (selBrand && selModel) trigger();
      } else if (e.key === 'Escape') {
        closeDropdown();
      }
    });
    if (clear) {
      clear.addEventListener('click', function () {
        input.value = '';
        clear.hidden = true;
        selBrand = '';
        selModel = '';
        lastAutoKey = '';
        closeDropdown();
        updateGo();
        setStatus('', '');
        input.focus();
      });
    }
    go.addEventListener('click', trigger);
    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) closeDropdown();
    });

    var api = {
      setBusy: setBusy,
      setStatus: setStatus,
      setSelection: function (brand, model) {
        selBrand = brand;
        selModel = model;
        input.value = brand + ' ' + model;
        if (clear) clear.hidden = false;
        updateGo();
      },
      clearSelection: function () {
        selBrand = '';
        selModel = '';
        lastAutoKey = '';
        input.value = '';
        if (clear) clear.hidden = true;
        updateGo();
      },
      focus: function () { input.focus(); },
      prefill: function (raw) {
        input.value = raw;
        if (clear) clear.hidden = !raw;
        var run = function () {
          resolveSelectionFromInput(raw);
          renderDropdown(raw);
          if (selBrand && selModel) trigger(); else input.focus();
        };
        if (dbReady) run(); else dbCallbacks.push(function (ok) { if (ok) run(); });
      },
      ready: function () {
        progressFinish(progress);
        input.disabled = false;
        startPlaceholderDemo();
        setBusy(false, T('Find compatible parts'));
        var raw = input.value.trim();
        if (raw) {
          /* they typed while the db was loading - honour it now */
          resolveSelectionFromInput(raw);
          renderDropdown(raw);
          if (queuedSearch && selBrand && selModel) { queuedSearch = false; trigger(); return; }
        }
        queuedSearch = false;
        /* standing rule: the idle state stays silent. The "{n} brands loaded"
           prompt only appears when the person is already engaging with the
           input; on a fresh page it would be noise. */
        if (raw || document.activeElement === input) {
          setStatus(T('<strong>{n} brands</strong> loaded. Try Sony TC-K611S, Pioneer CT-F850…').replace('{n}', db.brands.length), 'ok');
        } else {
          setStatus('', '');
        }
        renderRecent();
      },
      fail: function () {
        progressFail(progress);
        input.disabled = false; /* the tool never renders dead */
        setBusy(false, T('Find compatible parts'));
        setStatus(ERROR_MSG_T() + ' <button class="btn btn--outline btn--sm" type="button" data-finder-db-retry>' + T('Try again') + '</button> ' + T('or <a href="{u}">contact technical support</a>.').replace('{u}', esc(lurl(CONTACT_URL))), 'warn');
        var retry = root.querySelector('[data-finder-db-retry]');
        if (retry) retry.addEventListener('click', function () {
          setBusy(true, T('Checking database…'));
          setStatus(T('Checking database…'), 'searching');
          loadDb();
          onDbReady(function (ok) { if (!ok) api.fail(); });
        });
        if (!api._awaitingRecovery) {
          api._awaitingRecovery = true;
          onDbRecovered(function () { api._awaitingRecovery = false; api.ready(); });
        }
      }
    };
    return api;
  }

  /* ================================================================
     COMPATIBILITY PAGE - search + results dashboard on one URL
     ================================================================ */
  function initCompatPage(finderRoot) {
    var page = document.querySelector('[data-compat-page]');
    if (!page) return;
    var els = {
      results: page.querySelector('[data-compat-results]'),
      about: page.querySelector('[data-compat-about]'),
      viewToggle: page.querySelector('[data-view-toggle]'),
      landing: page.querySelectorAll('[data-compat-landing]'),
      recordRef: page.querySelector('[data-record-ref]'),
      recordModel: page.querySelector('[data-record-model]'),
      recordSummary: page.querySelector('[data-record-summary]'),
      newSearch: page.querySelector('[data-compat-new]'),
      repairset: page.querySelector('[data-repairset]'),
      repairItems: page.querySelector('[data-repairset-items]'),
      repairCount: page.querySelector('[data-repairset-count]'),
      repairAdd: page.querySelector('[data-repairset-add]'),
      pills: page.querySelector('[data-compat-pills]'),
      listTitle: page.querySelector('[data-compat-list-title]'),
      listCount: page.querySelector('[data-compat-list-count]'),
      sort: page.querySelector('[data-compat-sort]'),
      list: page.querySelector('[data-compat-list]'),
      pagination: page.querySelector('[data-compat-pagination]'),
      showing: page.querySelector('[data-compat-showing]'),
      more: page.querySelector('[data-compat-more]')
    };

    var state = {
      brand: '',
      model: '',
      products: [],
      ctx: null,
      activeCat: 'all',
      sort: 'recommended',
      shown: 0,
      pageSize: 20,
      rows: []
    };
    var finderApi = null;
    var searchToken = 0;

    /* --- URL contract: ?brand=X&model=Y on this same page --- */
    function readUrlParams() {
      try {
        var sp = new URLSearchParams(location.search);
        var brand = (sp.get('brand') || '').trim();
        var model = (sp.get('model') || '').trim();
        if (brand && model) return { brand: brand, model: model };
        var legacy = (sp.get('wsp') || sp.get('q') || '').trim();
        if (legacy) return { legacy: legacy };
      } catch (e) {}
      return null;
    }
    function writeUrlParams(brand, model, replace) {
      try {
        var url = location.pathname + '?brand=' + encodeURIComponent(brand) + '&model=' + encodeURIComponent(model);
        if (replace) history.replaceState({ wsp: true, brand: brand, model: model }, '', url);
        else history.pushState({ wsp: true, brand: brand, model: model }, '', url);
      } catch (e) {}
    }
    function clearUrlParams() {
      try { history.pushState({ wsp: true }, '', location.pathname); } catch (e) {}
    }
    window.addEventListener('popstate', function () {
      var params = readUrlParams();
      if (params && params.brand && params.model) startSearch(params.brand, params.model, { skipUrl: true });
      else showSearchState();
    });

    /* --- state transitions --- */
    function showSearchState() {
      searchToken++;
      if (els.results) els.results.hidden = true;
      if (els.about) els.about.hidden = false;
      if (els.landing) els.landing.forEach(function (n) { n.hidden = false; });
      state.products = [];
      if (finderApi) {
        finderApi.clearSelection();
        finderApi.setStatus('', '');
      }
    }
    if (els.newSearch) {
      els.newSearch.addEventListener('click', function () {
        clearUrlParams();
        showSearchState();
        if (finderApi) finderApi.focus();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    /* --- run a search --- */
    function startSearch(brand, model, opts) {
      opts = opts || {};
      var token = ++searchToken;
      state.brand = brand;
      state.model = model;
      memorySave(brand, model);
      if (!opts.skipUrl) writeUrlParams(brand, model, !!opts.replaceUrl);
      if (finderApi) {
        finderApi.setSelection(brand, model);
        finderApi.setBusy(true, T('Checking database…'));
        finderApi.setStatus(T('Checking the compatibility database for <strong>{m}</strong>…').replace('{m}', esc(brand + ' ' + model)), 'searching');
      }
      if (els.results) els.results.hidden = true;
      if (els.about) els.about.hidden = false;
      if (els.landing) els.landing.forEach(function (n) { n.hidden = false; });

      var work = fetchWithRetry(beUrl('action=getSearch&brand=' + encodeURIComponent(brand) + '&model=' + encodeURIComponent(model)), 1)
        .then(function (data) {
          if (token !== searchToken) throw new Error('stale');
          if (!data || !data.searchQuery) throw new Error('no_query');
          var ctx = buildCompatibilityContext(brand, model, data);
          var terms = ctx.searchQuery.split(/\s+OR\s+/i);
          return Promise.all(terms.map(function (q) {
            return suggestAllForTerm(q.trim());
          })).then(function (groups) { return { groups: groups, ctx: ctx }; });
        })
        .then(function (payload) {
          if (token !== searchToken) throw new Error('stale');
          var seen = {}, products = [];
          payload.groups.forEach(function (g) {
            g.forEach(function (p) {
              var k = productMergeKey(p);
              if (!seen[k]) { seen[k] = true; products.push(p); }
            });
          });
          return fetchMechanismProducts(payload.ctx).then(function (mech) {
            mech.forEach(function (p) {
              var k = productMergeKey(p);
              if (!seen[k]) { seen[k] = true; products.push(p); }
            });
            return Promise.all(products.map(hydrateProduct)).then(function (hydrated) {
              var merged = [], seen2 = {};
              hydrated.forEach(function (p) {
                var k = productMergeKey(p);
                if (!seen2[k]) { seen2[k] = true; merged.push(p); }
              });
              return { products: merged, ctx: payload.ctx };
            });
          });
        })
        .then(function (payload) { return finderWithin(loadCart(), 2000).catch(function () {}).then(function () { return payload; }); });
      finderWithin(work, 25000)
        .then(function (payload) {
          if (token !== searchToken) return;
          var allProducts = payload.products || [];
          /* FREE-SAMPLE is checked on ALL returned products, BEFORE the
             compatibility filter: an un-linked model's belt won't pass
             proof, so checking only `proven` would miss it. */
          var freeSampleCount = allProducts.filter(hasFreeSampleTag).length;
          var proven = allProducts.filter(function (p) {
            var proof = productCompatibilityProof(p, payload.ctx);
            p._wspCompat = proof;
            return proof.accepted;
          }).sort(sortProductsForDisplay);
          state.products = proven;
          state.ctx = payload.ctx;
          rememberMaintenance(proven);
          if (finderApi) finderApi.setBusy(false, T('Find compatible parts'));
          var rescueEl = document.querySelector('[data-compat-rescue]');
          if (rescueEl) rescueEl.hidden = true;
          /* FREE-SAMPLE: an un-linked model whose belt we DO stock. If any
             returned product carries the tag, replace the whole results
             view with a help-us-identify contact panel. */
          var freeSample = freeSampleCount > 0;
          if (freeSample) {
            renderFreeSample(brand, model);
          } else if (!proven.length) {
            renderEmpty(brand, model);
          } else {
            if (finderApi) finderApi.setStatus('', '');
            renderResults();
          }
        })
        .catch(function (err) {
          if (token !== searchToken || (err && err.message === 'stale')) return;
          if (!finderApi) return;
          if (err && err.message === 'no_query') {
            finderApi.setBusy(false, T('Find compatible parts'));
            finderApi.setStatus(lhtml(T('<strong>{m}</strong> has no confirmed record yet. <strong>Send it to the workshop and we\'ll identify the right belt for you. Free, you only pay shipping.</strong>').replace('{m}', esc(brand + ' ' + model)) + ' <a class="finder__offerbtn" href="/pages/technical-support?model=' + encodeURIComponent(brand + ' ' + model) + '&offer=identify">' + T('Claim the free belt →') + '</a> ' + T('Or <a href="/collections">browse parts by category</a> / <a href="/collections/belts-by-size">match a belt by its measurements</a>.')), 'warn');
            return;
          }
          searchToken++; /* do not allow late work to replace this error */
          finderApi.setBusy(false, T('Find compatible parts'));
          finderApi.setStatus(ERROR_MSG_T() + ' <button class="btn btn--outline btn--sm" type="button" data-compat-retry>' + T('Try again') + '</button> ' + T('or <a href="{u}">contact technical support</a>.').replace('{u}', esc(lurl(CONTACT_URL))), 'err');
          var retryBtn = document.querySelector('[data-compat-retry]');
          if (retryBtn) retryBtn.addEventListener('click', function () {
            startSearch(brand, model, { skipUrl: true });
          });
        });
    }

    function buildFreeBeltOffer(brand, model) {
      var mm = (String(brand || '') + ' ' + String(model || '')).trim();
      var uploadEp = (window.WSP && window.WSP.supportBackend) || '';
      var el = document.createElement('section');
      el.className = 'nobelt';
      el.innerHTML =
        '<div class="nobelt__head">' +
          '<div class="freesample__badge mono">' + T('FREE BELT · YOU ONLY PAY SHIPPING') + '</div>' +
          '<h3 class="nobelt__title">' + T('No belt listed for the') + ' <span class="mono">' + esc(mm) + '</span> ' + T('yet. We probably stock it.') + '</h3>' +
          '<p class="nobelt__text">' + T('This model is in our database, but its belt has not been identified yet. Send a photo of the mechanism and tell us about the old belt. Once we confirm the match,') + ' <strong>' + T('the belt is free, you only cover shipping') + '</strong>.</p>' +
        '</div>' +
        '<form class="nobelt__form" data-freesample-form>' +
          '<input type="hidden" data-wsp-form value="free-sample">' +
          '<input type="hidden" name="contact[model]" value="' + esc(mm) + '">' +
          '<input type="hidden" name="contact[subject]" value="FREE-SAMPLE identification: ' + esc(mm) + '">' +
          '<div class="nobelt__row">' +
            '<input class="nomodel__input" type="text" name="contact[name]" placeholder="' + T('Your name') + '" aria-label="' + T('Your name') + '" required>' +
            '<input class="nomodel__input" type="email" name="contact[email]" placeholder="' + T('Your email') + '" aria-label="' + T('Your email') + '" required>' +
          '</div>' +
          '<div class="freesample__q">' +
            '<span class="freesample__qlabel">' + T('Do you still have the original belt?') + '</span>' +
            '<div class="freesample__opts">' +
              '<label class="freesample__opt"><input type="radio" name="contact[has_original_belt]" value="Yes, I have it"> ' + T('Yes, I have it') + '</label>' +
              '<label class="freesample__opt"><input type="radio" name="contact[has_original_belt]" value="It snapped / in pieces"> ' + T('It snapped / in pieces') + '</label>' +
              '<label class="freesample__opt"><input type="radio" name="contact[has_original_belt]" value="No, it\'s gone"> ' + T("No, it\'s gone") + '</label>' +
            '</div>' +
          '</div>' +
          '<textarea class="nomodel__input" name="contact[body]" rows="2" placeholder="' + T('Markings on the unit, the old belt size if you measured it, what the machine is doing…') + '" aria-label="' + T('Details') + '" required></textarea>' +
          '<div class="photoattach" data-photo-attach data-endpoint="' + esc(uploadEp) + '">' +
            '<input class="photoattach__input visually-hidden" type="file" accept="image/*" multiple data-photo-input>' +
            '<button type="button" class="btn btn--dark btn--sm photoattach__pick" data-photo-pick>&#128247; ' + T('Add photos of the mechanism') + '</button>' +
            '<div class="photoattach__list" data-photo-list></div>' +
            '<p class="photoattach__status mono" data-photo-status>' + T('A photo of the belt path / mechanism tells us everything.') + '</p>' +
            '<input type="hidden" name="contact[photo_links]" data-photo-links>' +
          '</div>' +
          '<button type="submit" class="btn btn--primary">' + T('Claim my free belt \u2192') + '</button>' +
        '</form>';
      setTimeout(function () {
        try {
          if (window.WSP && window.WSP.bindSupportForm) window.WSP.bindSupportForm(el.querySelector('[data-freesample-form]'));
          if (window.WSP && window.WSP.initPhotoAttach) window.WSP.initPhotoAttach(el.querySelector('[data-photo-attach]'));
        } catch (e) {}
      }, 0);
      return el;
    }

    function renderFreeSample(brand, model) {
      if (els.results) els.results.hidden = true;
      if (els.intro) els.intro.hidden = true;
      if (els.about) els.about.hidden = true;
      if (els.landing) els.landing.forEach(function (n) { n.hidden = true; });
      var host = els.results && els.results.parentNode ? els.results.parentNode : (els.results || document.body);
      var panel = document.querySelector('[data-freesample-panel]');
      if (panel) panel.remove();
      panel = document.createElement('div');
      panel.className = 'freesample';
      panel.setAttribute('data-freesample-panel', '');
      var mm = brand + ' ' + model;
      var uploadEp = (window.WSP && window.WSP.supportBackend) || '';
      panel.innerHTML =
        '<div class="freesample__badge mono">' + T('FREE BELT · YOU ONLY PAY SHIPPING') + '</div>' +
        '<h2 class="freesample__title">' + T('We have the belt for your') + ' <span class="mono">' + esc(mm) + '</span>. ' + T('Help us confirm it.') + '</h2>' +
        '<p class="freesample__text">' + T('This model is in our database, but its belt has not been identified yet. Send a photo of the mechanism and tell us about the old belt. Once we confirm the match,') + ' <strong>' + T('the belt is free, you only cover shipping') + '</strong>.</p>' +
        '<form class="freesample__form" data-freesample-form>' +
          '<input type="hidden" data-wsp-form value="free-sample">' +
          '<input type="hidden" name="contact[model]" value="' + esc(mm) + '">' +
          '<input type="hidden" name="contact[subject]" value="FREE-SAMPLE identification: ' + esc(mm) + '">' +
          '<div class="freesample__row">' +
            '<input class="freesample__input" type="text" name="contact[name]" placeholder="' + T('Your name') + '" aria-label="' + T('Your name') + '" required>' +
            '<input class="freesample__input" type="email" name="contact[email]" placeholder="' + T('Your email') + '" aria-label="' + T('Your email') + '" required>' +
          '</div>' +
          '<div class="freesample__q">' +
            '<span class="freesample__qlabel">' + T('Do you still have the original belt?') + '</span>' +
            '<div class="freesample__opts">' +
              '<label class="freesample__opt"><input type="radio" name="contact[has_original_belt]" value="Yes, I have it"> ' + T('Yes, I have it') + '</label>' +
              '<label class="freesample__opt"><input type="radio" name="contact[has_original_belt]" value="It snapped / in pieces"> ' + T('It snapped / in pieces') + '</label>' +
              '<label class="freesample__opt"><input type="radio" name="contact[has_original_belt]" value="No, it\'s gone"> ' + T("No, it\'s gone") + '</label>' +
            '</div>' +
          '</div>' +
          '<textarea class="freesample__input" name="contact[body]" rows="3" placeholder="' + T("Tell us anything that helps identify it: markings on the unit, the old belt\'s size if you measured it, what the machine is doing\u2026") + '" required></textarea>' +
          '<div class="freesample__photolabel">' + T('Photos of the mechanism &amp; the old belt') + ' <span>' + T('(this is what confirms the match)') + '</span></div>' +
          '<div class="freesample__photos">' +
            '<div class="photoattach" data-photo-attach data-endpoint="' + esc(uploadEp) + '">' +
              '<input class="photoattach__input visually-hidden" type="file" accept="image/*" multiple data-photo-input>' +
              '<button type="button" class="btn btn--dark btn--sm photoattach__pick" data-photo-pick>&#128247; ' + T('Add photos of the mechanism') + '</button>' +
              '<div class="photoattach__list" data-photo-list></div>' +
              '<p class="photoattach__status mono" data-photo-status>' + T('Open the machine and photograph the belt path / mechanism. JPG or PNG, we resize them for you.') + '</p>' +
              '<input type="hidden" name="contact[photo_links]" data-photo-links>' +
            '</div>' +
          '</div>' +
          '<button type="submit" class="btn btn--primary btn--lg">' + T('Claim my free belt \u2192') + '</button>' +
          '<p class="freesample__reassure mono">' + T('A member of our team replies \u00B7 Mon\u2013Fri') + '</p>' +
        '</form>';
      host.insertBefore(panel, els.results);
      if (finderApi) finderApi.setStatus('', '');
      try {
        if (window.WSP && typeof window.WSP.bindSupportForm === 'function') {
          window.WSP.bindSupportForm(panel.querySelector('[data-freesample-form]'));
        }
        if (window.WSP && typeof window.WSP.initPhotoAttach === 'function') {
          window.WSP.initPhotoAttach(panel.querySelector('[data-photo-attach]'));
        }
      } catch (e) {}
      panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    function beltGuideHTML() {
      /* three belt shapes measured against a ruler, line-art in brand
         colours - flat/folded, square-section, round-section */
      var W = '#4A342B', C = '#C96F2E';
      function ruler(x, y, w) {
        var t = '';
        for (var i = 0; i <= w; i += 12) {
          var big = (i % 36 === 0);
          t += '<line x1="' + (x + i) + '" y1="' + y + '" x2="' + (x + i) + '" y2="' + (y + (big ? 9 : 5)) + '" stroke="' + W + '" stroke-width="1"/>';
        }
        return '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="16" rx="2" fill="none" stroke="' + W + '" stroke-width="1.4"/>' + t;
      }
      return '<div class="beltguide">' +
        '<h3 class="beltguide__title">' + T('How to measure your old belt') + '</h3>' +
        '<p class="beltguide__lead">' + T('Lay the old belt flat and relaxed next to a ruler. Don’t stretch it. Tell us the <strong>length</strong> and whether the cross-section is <strong>flat, square or round</strong>. A photo like these is perfect.') + '</p>' +

        '<div class="beltguide__item">' +
          '<svg viewBox="0 0 220 96" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
            '<path d="M30 34 h150 a10 10 0 0 1 0 20 h-150 a10 10 0 0 1 0 -20 Z" fill="none" stroke="' + C + '" stroke-width="3"/>' +
            '<path d="M30 34 v20 M180 34 v20" stroke="' + C + '" stroke-width="1" opacity=".5"/>' +
            ruler(24, 66, 168) +
            '<text x="108" y="24" text-anchor="middle" font-family="ui-monospace,monospace" font-size="10" fill="' + W + '">' + T('flat / folded loop, measure the length') + '</text>' +
          '</svg>' +
          '<span class="beltguide__cap"><strong>' + T('Flat belt') + '</strong> &middot; ' + T('measure total length laid flat') + '</span>' +
        '</div>' +

        '<div class="beltguide__item">' +
          '<svg viewBox="0 0 220 96" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
            '<rect x="70" y="26" width="80" height="36" rx="3" fill="none" stroke="' + C + '" stroke-width="3"/>' +
            '<rect x="82" y="38" width="56" height="12" rx="2" fill="none" stroke="' + C + '" stroke-width="1" opacity=".5"/>' +
            '<path d="M70 26 l-6 -6 M150 26 l6 -6" stroke="' + W + '" stroke-width="1"/>' +
            ruler(24, 70, 168) +
            '<text x="110" y="16" text-anchor="middle" font-family="ui-monospace,monospace" font-size="10" fill="' + W + '">' + T('Square belt') + '</text>' +
          '</svg>' +
          '<span class="beltguide__cap"><strong>' + T('Square belt') + '</strong> &middot; ' + T('flat-sided cross-section') + '</span>' +
        '</div>' +

        '<div class="beltguide__item">' +
          '<svg viewBox="0 0 220 96" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
            '<ellipse cx="110" cy="44" rx="42" ry="20" fill="none" stroke="' + C + '" stroke-width="3"/>' +
            '<ellipse cx="110" cy="44" rx="30" ry="11" fill="none" stroke="' + C + '" stroke-width="1" opacity=".5"/>' +
            ruler(24, 70, 168) +
            '<text x="110" y="16" text-anchor="middle" font-family="ui-monospace,monospace" font-size="10" fill="' + W + '">' + T('Round belt') + '</text>' +
          '</svg>' +
          '<span class="beltguide__cap"><strong>' + T('Round belt') + '</strong> &middot; ' + T('circular cross-section') + '</span>' +
        '</div>' +

        '<p class="beltguide__tip mono">&#128247; ' + T('A photo of the belt next to the ruler, and one of the mechanism, tells us everything.') + '</p>' +
      '</div>';
    }

    function renderNoModelParts(brand, model) {
      var mm = brand + ' ' + model;
      /* hide everything that implies "here are your results": the record
         card, the filter pills, the sort toolbar, pagination. This screen
         is a single clear call to action, not a parts list. */
      if (els.intro) els.intro.hidden = true;
      if (els.about) els.about.hidden = true;
      if (els.landing) els.landing.forEach(function (n) { n.hidden = true; });
      if (els.pagination) els.pagination.hidden = true;
      if (els.viewToggle) els.viewToggle.hidden = true;
      if (els.showing) els.showing.hidden = true;
      if (els.more) els.more.hidden = true;
      var page = document.querySelector('[data-compat-page]');
      if (page) {
        var record = page.querySelector('[data-record]');
        if (record) record.hidden = true;
        var toolbar = page.querySelector('.compat__toolbar');
        if (toolbar) toolbar.style.display = 'none';
        var pillsWrap = page.querySelector('.compat__pills');
        if (pillsWrap) pillsWrap.style.display = 'none';
        var filterRow = page.querySelector('.compat__filters, [data-compat-filters]');
        if (filterRow) filterRow.style.display = 'none';
      }
      if (els.results) els.results.hidden = false;
      els.list.className = 'compat__list nomodel-host';
      var uploadEp = (window.WSP && window.WSP.supportBackend) || (window.WSP && window.WSP.uploadBackend) || '';
      els.list.innerHTML =
        '<section class="nomodel" role="region" aria-label="' + esc(T('Free belt identification')) + '">' +
          '<div class="nomodel__left">' +
            '<div class="nomodel__badge mono">' + T('FREE BELT · YOU ONLY PAY SHIPPING') + '</div>' +
            '<h2 class="nomodel__title">' + T('We stock the belt for the') + ' <span class="nomodel__model mono">' + esc(mm) + '</span>. ' + T('Help us confirm it.') + '</h2>' +
            '<p class="nomodel__text">' + T('We check every model by hand, and this one is not linked yet. There is a strong chance we already have the exact belt on the shelf. Confirm it with us and it is yours') + ' <strong>' + T('free, you only pay shipping') + '</strong>.</p>' +
            '<form class="nomodel__form" data-freesample-form>' +
              '<input type="hidden" data-wsp-form value="free-sample">' +
              '<input type="hidden" name="contact[model]" value="' + esc(mm) + '">' +
              '<input type="hidden" name="contact[subject]" value="Model identification: ' + esc(mm) + '">' +
              '<h3 class="nomodel__form-title">' + T('Claim your free belt') + '</h3>' +
              '<p class="nomodel__form-sub">' + T('Send your details and a photo or two. We reply Mon-Fri.') + '</p>' +
              '<label class="nomodel__label">' + T('Your name') + '<input class="nomodel__input" type="text" name="contact[name]" required></label>' +
              '<label class="nomodel__label">' + T('Your email') + '<input class="nomodel__input" type="email" name="contact[email]" required></label>' +
              '<label class="nomodel__label">' + T('What’s the machine doing?') + '<textarea class="nomodel__input" name="contact[body]" rows="3" placeholder="' + T('Belt loose or snapped, tape won’t move, markings on the unit…') + '" required></textarea></label>' +
              '<div class="nomodel__photos">' +
                '<div class="photoattach" data-photo-attach data-endpoint="' + esc(uploadEp) + '">' +
                  '<input class="photoattach__input visually-hidden" type="file" accept="image/*" multiple data-photo-input>' +
                  '<button type="button" class="btn btn--dark btn--sm photoattach__pick" data-photo-pick>&#128247; ' + T('Photos of the mechanism &amp; the old belt') + '</button>' +
                  '<div class="photoattach__list" data-photo-list></div>' +
                  '<p class="photoattach__status mono" data-photo-status>' + T('A photo of the belt next to the ruler, and one of the mechanism, tells us everything.') + '</p>' +
                  '<input type="hidden" name="contact[photo_links]" data-photo-links>' +
                '</div>' +
              '</div>' +
              '<button type="submit" class="btn btn--primary btn--lg nomodel__submit">' + T('Claim my free belt \u2192') + '</button>' +
              '<p class="nomodel__reassure mono">' + T('A member of our team replies \u00B7 Mon\u2013Fri') + '</p>' +
            '</form>' +
          '</div>' +
          '<div class="nomodel__right">' +
            beltGuideHTML() +
          '</div>' +
        '</section>';
      try {
        if (window.WSP && typeof window.WSP.bindSupportForm === 'function') {
          window.WSP.bindSupportForm(els.list.querySelector('[data-freesample-form]'));
        }
        if (window.WSP && typeof window.WSP.initPhotoAttach === 'function') {
          window.WSP.initPhotoAttach(els.list.querySelector('[data-photo-attach]'));
        }
      } catch (e) {}
      els.list.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function renderEmpty(brand, model) {
      if (els.results) els.results.hidden = true;
      if (els.intro) els.intro.hidden = true;
      var rescue = document.querySelector('[data-compat-rescue]');
      if (rescue) {
        var rm = rescue.querySelector('[data-compat-rescue-model]');
        if (rm) rm.textContent = brand + ' ' + model;
        rescue.hidden = false;
      }
      if (finderApi) finderApi.setStatus(lhtml('<strong>' + esc(brand + ' ' + model) + '</strong> has no confirmed record yet. <strong>We\'ll identify the right belt for you. Free, you only pay shipping.</strong> <a class="finder__offerbtn" href="/pages/technical-support?model=' + encodeURIComponent(brand + ' ' + model) + '&offer=identify">Claim the free belt &rarr;</a> Or <a href="/collections">browse parts by category</a>.'), 'warn');
    }

    /* --- render results dashboard --- */
    function renderResults() {
      if (!els.results) return;
      els.results.hidden = false;
      if (els.about) els.about.hidden = true;
      if (els.landing) els.landing.forEach(function (n) { n.hidden = true; });
      state.activeCat = 'all';
      state.sort = 'recommended';
      if (els.sort) els.sort.value = 'recommended';

      var label = state.brand + ' ' + state.model;
      if (els.recordModel) els.recordModel.textContent = label;
      if (els.recordRef) els.recordRef.textContent = 'REF ' + norm(label).toUpperCase().slice(0, 18);


      renderRepairSet();
      renderPills();
      renderList();

      setTimeout(function () {
        var target = els.results;
        if (target) {
          var y = target.getBoundingClientRect().top + window.pageYOffset - 12;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      }, 60);
    }

    /* --- repair set: top item per key category, exact variants only --- */
    var REPAIR_CATEGORIES = ['Belt Kit', 'Flat Belt', 'Square Belt', 'Round Belt', 'Pinch Roller', 'Idler Tire'];
    function renderRepairSet() {
      if (!els.repairset || !els.repairItems) return;
      var picks = [];
      var used = {};
      REPAIR_CATEGORIES.forEach(function (cat) {
        if (used[cat === 'Flat Belt' || cat === 'Square Belt' || cat === 'Round Belt' ? 'belt' : cat]) return;
        var best = null;
        state.products.forEach(function (p) {
          if (displayCategoryLabel(getType(p)) !== cat) return;
          if (!best || sortProductsForDisplay(p, best) < 0) best = p;
        });
        if (best && isAvailable(best)) {
          picks.push(best);
          used[cat === 'Flat Belt' || cat === 'Square Belt' || cat === 'Round Belt' ? 'belt' : cat] = true;
        }
      });
      if (picks.length < 2) { els.repairset.hidden = true; return; }
      els.repairset.hidden = false;
      els.repairItems.innerHTML = '';
      picks.forEach(function (p, i) {
        var lab = document.createElement('label');
        lab.className = 'rsitem';
        var price = fmtPrice(p.price, p._priceFromProductJson);
        lab.innerHTML =
          '<input type="checkbox" data-rs-index="' + i + '">' +
          '<span class="rsitem__type">' + esc(catLabelI18n(getType(p))) + '</span>' +
          '<span class="rsitem__title">' + esc(stripLeadingProductCode(p.title)) + '</span>' +
          '<span class="rsitem__price mono">' + esc(price) + '</span>';
        lab.__p = p;
        els.repairItems.appendChild(lab);
        hydratePriceInto(p, lab.querySelector('.rsitem__price'));
      });
      updateRepairBar();
      els.repairItems.addEventListener('change', updateRepairBar);
      if (els.repairAdd && !els.repairAdd.__wired) {
        els.repairAdd.__wired = true;
        els.repairAdd.addEventListener('click', addRepairSelection);
      }
    }
    function selectedRepairItems() {
      var out = [];
      if (!els.repairItems) return out;
      els.repairItems.querySelectorAll('input[type="checkbox"]:checked').forEach(function (cb) {
        var lab = cb.closest('.rsitem');
        if (lab && lab.__p) out.push(lab.__p);
      });
      return out;
    }
    function updateRepairBar() {
      var n = selectedRepairItems().length;
      if (els.repairCount) els.repairCount.textContent = n ? T(n === 1 ? '{n} part selected' : '{n} parts selected').replace('{n}', n) : T('No parts selected');
      if (els.repairAdd) els.repairAdd.disabled = !n;
    }
    function addRepairSelection() {
      var items = selectedRepairItems();
      if (!items.length) return;
      var btn = els.repairAdd;
      btn.disabled = true;
      btn.textContent = T('Adding…');
      var chain = loadCart().catch(function () {});
      var added = 0;
      items.forEach(function (p) {
        chain = chain.then(function () {
          return addProductToCart(p).then(function () { added++; }).catch(function () {});
        });
      });
      chain.then(function () { return loadCart().catch(function () { return null; }); }).then(function (cart) {
        btn.textContent = T('Add selected parts to cart');
        updateRepairBar();
        if (cart) bumpCartCount(cart.item_count);
        if (added) toast((added !== 1 ? T('{n} parts added to your cart') : T('{n} part added to your cart')).replace('{n}', added));
        else toast(T('Could not add the selected parts. Please try again.'));
      });
    }

    /* --- part-type pills --- */
    function groupByType(prods) {
      var map = {};
      prods.forEach(function (p) {
        var t = displayCategoryLabel(getType(p));
        if (!map[t]) map[t] = [];
        map[t].push(p);
      });
      return Object.keys(map).sort(function (a, b) {
        var ap = categoryPriority(a), bp = categoryPriority(b);
        if (ap !== bp) return ap - bp;
        return a.localeCompare(b);
      }).map(function (k) { return { type: k, items: map[k] }; });
    }
    function renderPills() {
      if (!els.pills) return;
      els.pills.innerHTML = '';
      var groups = groupByType(state.products);
      function pill(labelText, count, cat) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'cpill' + (cat === state.activeCat ? ' is-active' : '');
        b.setAttribute('role', 'tab');
        b.innerHTML = '<span>' + esc(labelText) + '</span><span class="cpill__count">' + count + '</span>';
        b.addEventListener('click', function () {
          state.activeCat = cat;
      state.subFilter = 'All';
          els.pills.querySelectorAll('.cpill').forEach(function (x) { x.classList.remove('is-active'); });
          b.classList.add('is-active');
          renderList();
        });
        els.pills.appendChild(b);
      }
      pill(T('All parts'), state.products.length, 'all');
      groups.forEach(function (g) { pill(catLabelI18n(g.type), g.items.length, g.type); });
    }

    /* --- results list --- */
    function getFiltered() {
      var prods = state.products.slice();
      if (state.activeCat !== 'all') {
        prods = prods.filter(function (p) { return displayCategoryLabel(getType(p)) === state.activeCat; });
      }
      return prods.sort(sortComparator(state.sort));
    }
    function compatBadge(p) {
      if (isMaintenanceProduct(p)) return '<span class="badge badge--maint">' + T('Universal fit, suits all models') + '</span>';
      /* gears & mechanical parts don't show the green "Confirmed fit"
         pill - the fit is implied by the category and it cluttered the
         card. The "Fits <model>" line under stock still conveys it. */
      var t = String(getType(p) || '').toLowerCase();
      if (/gear|mechanical/.test(t)) return '';
      return '<span class="badge badge--ok badge--fit">&#10003; ' + T('Confirmed fit') + '</span>';
    }
    function stockChip(p) {
      var v = primaryVariant(p);
      var sq = stockN(v);
      if (!isAvailable(p)) return '<span class="stock stock--out">' + T('Out of stock') + '</span>';
      if (sq === 1) return '<span class="stock stock--last">' + T('Last unit left') + '</span>';
      if (sq !== null && sq > 1) return '<span class="stock stock--in">' + T('In stock, ') + sq + T(' units') + '</span>';
      return '<span class="stock stock--in">' + T('In stock') + '</span>';
    }
    function buildRow(p) {
      var row = document.createElement('article');
      var maint = isMaintenanceProduct(p);
      row.className = 'crow' + (maint ? ' crow--maint' : '');
      row.setAttribute('role', 'listitem');
      var img = productImage(p);
      if (img && String(img).indexOf('//') === 0) img = 'https:' + img;
      var displayTitle = p._wspGroupTitle || stripLeadingProductCode(p.title);
      var fullTitle = String(p.title || '');
      var ref = primarySku(p);
      var typeLabel = catLabelI18n(getType(p));
      var fitLabel = maint ? '' : T('Fits {m}').replace('{m}', state.brand + ' ' + state.model);
      var typeCodeLabel = (p._wspCompat && p._wspCompat.variantLabel) || '';
      var price = fmtPrice(p.price, p._priceFromProductJson);
      var url = p.url && p.url.indexOf('http') === 0 ? p.url : (p.url || '#');
      var groupItems = p._wspGroupItems && p._wspGroupItems.length > 1 ? p._wspGroupItems : null;

      var optsHtml = '';
      if (groupItems) {
        optsHtml = '<div class="crow__opts">' + groupItems.map(function (item, i) {
          var size = extractMaintenancePackSize(item.title) || (T('Option') + ' ' + (i + 1));
          var itemPrice = fmtPrice(item.price, item._priceFromProductJson);
          return '<button class="optpill" type="button" data-opt="' + i + '" title="' + esc(item.title) + '">' + esc(size) + (itemPrice ? ' <span class="mono">' + esc(itemPrice) + '</span>' : '') + '</button>';
        }).join('') + '</div>';
      }

      var actionHtml;
      if (!isAvailable(p)) actionHtml = '';
      else if (groupItems) actionHtml = '';
      else actionHtml = '<button class="btn btn--primary crow__add" type="button" data-row-add>' + T('Add to cart') + '</button>';

      row.innerHTML =
        '<div class="crow__mediawrap">' +
          '<a class="crow__media" href="' + esc(url) + '" tabindex="-1" aria-hidden="true" data-quick="' + esc(quickKey(p)) + '">' +
            (img ? '<img src="' + esc(img) + '" alt="' + esc(fullTitle || displayTitle || '') + '" loading="lazy">' : '<span class="crow__noimg">&#128230;</span>') +
          '</a>' +
          (img ? '<button type="button" class="crow__zoom" data-zoom-src="' + esc(sizedImg(img, 1400)) + '" aria-label="' + T('View full image') + '" title="' + T('View full image') + '">&#128269;</button>' : '') +
        '</div>' +
        '<div class="crow__body">' +
          ((compatBadge(p) || typeCodeLabel) ? ('<div class="crow__badges">' + compatBadge(p) +
            (typeCodeLabel ? '<span class="badge mono">' + esc(typeCodeLabel) + '</span>' : '') +
          '</div>') : '') +
          '<h4 class="crow__title"><a href="' + esc(url) + '" title="' + esc(fullTitle) + '">' + esc(displayTitle) + '</a></h4>' +
          '<div class="crow__meta">' +
            stockChip(p) +
            (fitLabel ? '<span class="crow__fits">' + esc(fitLabel) + '</span>' : '') +
          '</div>' +
          optsHtml +
        '</div>' +
        '<div class="crow__foot">' +
          '<div class="crow__pricerow">' +
            '<span class="crow__price">' + esc(price) + '</span>' +
            qtyChipHtml(p) +
          '</div>' +
          actionHtml +
          '<a class="crow__details" href="' + esc(url) + '" data-quick="' + esc(quickRegister(p, { price: price, img: img, url: url, badge: compatBadge(p) })) + '">' + T('View details') + '</a>' +
        '</div>';

      ensureHoverAlt(p, row);
      var addBtn = row.querySelector('[data-row-add]');
      if (addBtn) {
        addBtn.addEventListener('click', function () {
          addBtn.disabled = true;
          addBtn.textContent = T('Adding…');
          addProductToCart(p)
            .then(function () { return loadCart(); })
            .then(function (cart) {
              addBtn.textContent = T('Added OK');
              bumpCartCount(cart.item_count);
              var chip = row.querySelector('[data-inqty]');
              if (chip) {
                var q = qtyInCart(p);
                chip.innerHTML = T('In cart:') + ' <strong>' + q + '</strong>';
                chip.hidden = !q;
                chip.classList.toggle('inqty--zero', !q);
              }
              showRowConfirm(row);
              setTimeout(function () { addBtn.textContent = T('Add to cart'); addBtn.disabled = false; }, 1600);
            })
            .catch(function (err) {
              var lim = String(err && err.message || '').indexOf('cart_limit') !== -1;
              addBtn.textContent = lim ? T('All stock in cart') : T('Could not add');
              setTimeout(function () { addBtn.textContent = T('Add to cart'); addBtn.disabled = false; }, 2000);
            });
        });
      }
      if (groupItems) {
        row.querySelectorAll('.optpill').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var item = groupItems[Number(btn.dataset.opt)];
            if (!item) return;
            btn.disabled = true;
            addProductToCart(item)
              .then(function () { return loadCart(); })
              .then(function (cart) {
                bumpCartCount(cart.item_count);
                showRowConfirm(row);
                btn.disabled = false;
              })
              .catch(function () {
                toast(T('Could not add that option. It may be out of stock.'));
                btn.disabled = false;
              });
          });
        });
      }
      hydratePriceInto(p, row.querySelector('.crow__price'));
      if (groupItems && activeCurrency() !== SHOP_CURRENCY) {
        groupItems.forEach(function (item, gi) {
          if (!needsPriceHydration(item)) return;
          hydrateProduct(item).then(function () {
            if (!item._priceFromProductJson) return;
            var b = row.querySelector('[data-opt="' + gi + '"]');
            if (!b) return;
            var txt = fmtPrice(item.price, true);
            if (!txt) return;
            var sp = b.querySelector('.mono');
            if (!sp) { sp = document.createElement('span'); sp.className = 'mono'; b.appendChild(document.createTextNode(' ')); b.appendChild(sp); }
            sp.textContent = txt;
          }).catch(function () {}); /* optional displayed-variant price refresh */
        });
      }
      return row;
    }

    /* technician list view: part number | description | price | add */
    function buildListRow(p) {
      var row = document.createElement('div');
      row.className = 'lrow';
      var code = extractLeadingCode(p.title);
      var name = stripLeadingProductCode(p.title);
      var pos = (String(p.title).match(/Pos\.?\s*\(([^)]+)\)/i) || [])[1] || '';
      row.innerHTML =
        '<span class="lrow__code mono">' + esc(code || '-') + '</span>' +
        '<a class="lrow__name" href="' + esc(p.url || '#') + '">' + esc(name) + (pos ? ' <span class="lrow__pos mono">Pos. ' + esc(pos) + '</span>' : '') + '</a>' +
        '<span class="lrow__stock">' + stockChip(p) + '</span>' +
        '<span class="lrow__price mono">' + esc(fmtPrice(p.price, p._priceFromProductJson)) + '</span>' +
        '<span class="lrow__actions"></span>';
      var actions = row.querySelector('.lrow__actions');
      var add = document.createElement('button');
      add.type = 'button';
      add.className = 'btn btn--primary btn--sm lrow__add';
      add.textContent = T('Add');
      if (isAvailable(p)) {
        add.addEventListener('click', function () {
          add.disabled = true; add.textContent = '...';
          addProductToCart(p)
            .then(function () { return loadCart(); })
            .then(function (cart) {
              bumpCartCount(cart.item_count);
              add.textContent = '\u2713';
              toast(T('Added to cart'));
              setTimeout(function () { add.textContent = T('Add'); add.disabled = false; }, 1600);
            })
            .catch(function () { add.textContent = T('Add'); add.disabled = false; });
        });
      } else { add.disabled = true; add.textContent = '-'; }
      actions.appendChild(add);
      hydratePriceInto(p, row.querySelector('.lrow__price'));
      return row;
    }
    function renderList() {
      if (!els.list) return;
      els.list.classList.toggle('compat__list--grid', state.activeCat !== 'all');
      /* stale layout classes from a previous 'all' render break the
         filtered grid (giant single-column cards) - always reset */
      els.list.classList.remove('compat__list--sections');
      els.list.classList.remove('compat__list--withside');
      els.list.classList.remove('compat__list--table');
      els.list.removeAttribute('data-seccount');
      state.pageSize = window.innerWidth <= 720 ? 10 : 20;
      var filtered = getFiltered();
      state.rows = groupMaintenanceRows(filtered);
      els.list.classList.toggle('compat__list--wide', state.activeCat !== 'all' && state.rows.length > 0 && state.rows.length <= 2);
      state.shown = 0;
      els.list.innerHTML = '';

      var titleLabel = state.activeCat === 'all'
        ? T('All compatible parts')
        : catLabelI18n(state.activeCat) + ' \u00B7 ' + state.brand + ' ' + state.model;
      if (els.listTitle) els.listTitle.textContent = titleLabel;
      if (els.listCount) {
        var totalP = state.products.length;
        var uniP = state.products.filter(function (p) { return isMaintenanceType(getType(p)); }).length;
        var realP = totalP - uniP;
        var allLabel;
        if (realP > 0 && uniP > 0) {
          allLabel = realP + ' ' + T(realP !== 1 ? 'model-specific parts' : 'model-specific part') + ' + ' + uniP + ' ' + T(uniP !== 1 ? 'universal service items' : 'universal service item');
        } else if (realP > 0) {
          allLabel = realP + ' ' + T(realP !== 1 ? 'confirmed parts' : 'confirmed part');
        } else {
          allLabel = uniP + ' ' + T(uniP !== 1 ? 'universal service items' : 'universal service item');
        }
        if (state.rows.length < totalP) allLabel += ' ' + T('(some sizes grouped)');
        els.listCount.textContent = state.activeCat === 'all'
          ? allLabel
          : T('Showing') + ' ' + state.rows.length + ' ' + T('of') + ' ' + totalP + ' ' + T('parts');
      }
      var fc = document.querySelector('[data-compat-found-count]');
      var fl = document.querySelector('[data-compat-found-label]');
      var fm = document.querySelector('[data-compat-found-model]');
      /* Honest headline (audit): "1 confirmed part + 10 universal service
         items for MODEL" - the count never overstates model-confirmed
         parts, and universal add-ons are named for what they are. */
      if (fc && fl) {
        if (realP > 0) {
          fc.textContent = realP;
          fl.textContent = T(realP !== 1 ? 'confirmed parts' : 'confirmed part') +
            (uniP > 0 ? ' + ' + uniP + ' ' + T(uniP !== 1 ? 'universal service items' : 'universal service item') : '');
        } else {
          fc.textContent = uniP;
          fl.textContent = T(uniP !== 1 ? 'universal service items' : 'universal service item');
        }
      } else if (fc) { fc.textContent = state.products.length; }
      if (fm) fm.textContent = state.brand + ' ' + state.model;
      renderReviews(state.brand, state.model);

      if (!state.rows.length) {
        els.list.innerHTML = state.activeCat !== 'all'
          ? '<div class="compat__empty"><h3>' + T('No parts in this category') + '</h3><p>' + T('Try another part type, or send us your model number. We check the database manually and add new references weekly.') + '</p><a class="btn btn--outline" href="' + esc(CONTACT_URL) + '">' + T('Contact technical support') + '</a></div>'
          : '<div class="compat__rescue"><h3>' + T('We will find it for you') + '</h3><p>' + T('Send us the model number printed on your unit, or just a photo of the label or mechanism. We confirm the exact part within one working day,') + ' <strong>' + T('before you pay') + '</strong>.</p><a class="btn btn--primary" href="' + esc(CONTACT_URL) + '">' + T('Send your model or a photo') + '</a><p class="compat__rescue-sub">' + T('Free specialist support, answered by vintage audio repairers') + '</p></div>';
        if (els.pagination) els.pagination.hidden = true;
        return;
      }

      if (state.activeCat === 'all') {
        if (els.viewToggle) els.viewToggle.hidden = true;
        /* Sectioned by category, repair parts first; universal cleaning /
           maintenance items move to a compact SIDE column so they never
           push model-specific results down the page. */
        var groups = groupByType(state.rows);
        var realGroups = groups.filter(function (g) { return !isMaintenanceType(g.type); });
        var uniGroups = groups.filter(function (g) { return isMaintenanceType(g.type); });
        /* No model-specific parts, only universal cleaning/maintenance:
           showing those alone looks poor and helps no one. Replace the
           whole results view with the identification offer instead. */
        if (!realGroups.length && uniGroups.length) {
          renderNoModelParts(state.brand, state.model);
          return;
        }
        els.list.classList.add('compat__list--sections');
        els.list.setAttribute('data-seccount', Math.min(groups.length, 4));
        els.list.classList.toggle('compat__list--withside', realGroups.length > 0 && uniGroups.length > 0);

        var mainCol = els.list, sideCol = null;
        if (realGroups.length && uniGroups.length) {
          mainCol = document.createElement('div');
          mainCol.className = 'ccols__main';
          sideCol = document.createElement('aside');
          sideCol.className = 'ccols__side';
          sideCol.setAttribute('aria-label', T('Universal service items'));
          els.list.appendChild(mainCol);
          els.list.appendChild(sideCol);
        }
        if (!realGroups.length && groups.length) {
          var note = document.createElement('p');
          note.className = 'compat__universal-note';
          note.innerHTML = T('No model-specific wear parts are listed for this model yet. Below are <strong>universal service items</strong> that suit any machine.') + ' <a href="' + esc(CONTACT_URL) + '">' + T('Ask us about specific parts') + '</a>. ' + T('We check models manually.');
          els.list.appendChild(note);
        }
        function buildSection(g, isUniversal) {
          var sec = document.createElement('div');
          sec.className = 'csec' + (isUniversal ? ' csec--universal' : '');
          var title = document.createElement('button');
          title.type = 'button';
          title.className = 'csec__title csec__title--btn';
          title.innerHTML = (isUniversal
            ? esc(catLabelI18n(g.type)) + ' <span class="csec__count mono">' + g.items.length + '</span><span class="csec__sub">' + T('Universal add-ons, suit any machine') + '</span>'
            : esc(catLabelI18n(g.type)) + ' <span class="csec__count mono">' + g.items.length + '</span><span class="csec__sub csec__sub--confirmed">&#10003; ' + T('Confirmed for your model') + '</span>');
          title.title = T('Show only') + ' ' + catLabelI18n(g.type);
          title.addEventListener('click', function () {
            var pills = els.pills ? els.pills.querySelectorAll('.cpill') : [];
            for (var i = 0; i < pills.length; i++) {
              var lbl = pills[i].querySelector('span');
              if (lbl && lbl.textContent.trim() === catLabelI18n(g.type)) { pills[i].click(); return; }
            }
          });
          sec.appendChild(title);
          var items = document.createElement('div');
          items.className = 'csec__items';
          g.items.forEach(function (p) { items.appendChild(buildRow(p)); });
          sec.appendChild(items);
          return sec;
        }
        /* Order every real category strictly by business rank so small
           but relevant groups (a single confirmed Pinch Roller) sit right
           after the belts, and Mechanical Parts (rank 85) always lands
           last. No singleton-strip reshuffling - it caused idlers/rollers
           to be buried under the big mechanical block. */
        var orderedGroups = realGroups.slice().sort(function (a, b) {
          var ra = categoryRankFromType(a.type), rb = categoryRankFromType(b.type);
          if (ra !== rb) return ra - rb;
          return a.type.localeCompare(b.type);
        });
        /* Split real groups:
             - single-item groups (except mechanical) -> ONE horizontal
               strip at the very top, side by side (BELT | GEAR | ROLLER),
               ordered by business rank
             - multi-item groups (except mechanical) -> their own full
               sections, rank-ordered, below the strip
             - Mechanical Parts -> always the last section
           A group with 3 belts stays a full Belts section; a lone belt
           joins the top strip. */
        var byRank = function (a, b) {
          var ra = categoryRankFromType(a.type), rb = categoryRankFromType(b.type);
          if (ra !== rb) return ra - rb;
          return a.type.localeCompare(b.type);
        };
        var mechGroups = realGroups.filter(function (g) { return isMechanicalType(g.type); }).sort(byRank);
        var nonMech = realGroups.filter(function (g) { return !isMechanicalType(g.type); });
        /* Belts always lead. But a LONE belt (1 item) should sit side by
           side with other single-item categories in the top strip, belt
           first - e.g. BELT | LASER PICKUP. A multi-item belt group keeps
           its own full section above everything. A lone belt with no other
           singles stays in its own section. */
        var allBelts = nonMech.filter(function (g) { return isBeltType(g.type); }).sort(byRank);
        var nonBelt  = nonMech.filter(function (g) { return !isBeltType(g.type); });
        var beltMulti  = allBelts.filter(function (g) { return g.items.length > 1; });
        var beltSingle = allBelts.filter(function (g) { return g.items.length === 1; });
        var otherSingles = nonBelt.filter(function (g) { return g.items.length === 1; }).sort(byRank);
        var multis = nonBelt.filter(function (g) { return g.items.length > 1; }).sort(byRank);

        /* the strip: lone belt(s) first (rank keeps belt at 0), then other
           singles. Only form a strip if it would hold 2+ cells; a truly
           lone single belt with nothing beside it stays a full section. */
        var stripGroups;
        var beltSectionGroups; /* belts that get their OWN full section */
        if (beltSingle.length && otherSingles.length) {
          /* single belt + other singles -> all go in the strip, belt first */
          stripGroups = beltSingle.concat(otherSingles).sort(byRank);
          beltSectionGroups = beltMulti;
        } else {
          /* no companion singles for the belt -> belt keeps its own section */
          stripGroups = otherSingles;
          beltSectionGroups = beltMulti.concat(beltSingle).sort(byRank);
        }

        var renderQueue = [];

        /* 0) belt sections first, always (multi-belt, or lone belt with no companions) */
        beltSectionGroups.forEach(function (g) {
          renderQueue.push({ el: buildSection(g, false), count: g.items.length, label: g.type });
        });
        /* 0b) no belt confirmed for this model? It's real (battery/antenna
           prove it) - the belt just isn't identified yet. Offer the
           free-sample identification panel at the very top. */
        if (!allBelts.length) {
          renderQueue.push({ el: buildFreeBeltOffer(state.brand, state.model), count: 1, label: T('Free belt identification') });
        }

        /* 1) horizontal strip of single-item categories (belt leads), rank-ordered */
        if (stripGroups.length) {
          var strip = document.createElement('div');
          strip.className = 'csecstrip';
          stripGroups.forEach(function (g) {
            var cell = document.createElement('div');
            cell.className = 'csecstrip__cell';
            var head = document.createElement('button');
            head.type = 'button';
            head.className = 'csecstrip__head';
            head.innerHTML = esc(catLabelI18n(g.type)) +
              '<span class="csecstrip__sub csec__sub--confirmed">&#10003; ' + T('Confirmed') + '</span>';
            head.title = T('Show only') + ' ' + catLabelI18n(g.type);
            (function (label) {
              head.addEventListener('click', function () {
                var pills = els.pills ? els.pills.querySelectorAll('.cpill') : [];
                for (var i = 0; i < pills.length; i++) {
                  var lbl = pills[i].querySelector('span');
                  if (lbl && lbl.textContent.trim() === label) { pills[i].click(); return; }
                }
              });
            })(catLabelI18n(g.type)); /* pill text is translated, compare like-for-like */
            cell.appendChild(head);
            cell.appendChild(buildRow(g.items[0]));
            strip.appendChild(cell);
          });
          renderQueue.push({ el: strip, count: stripGroups.length, label: T('Confirmed parts') });
        }

        /* 2) multi-item real categories, rank-ordered */
        multis.forEach(function (g) {
          renderQueue.push({ el: buildSection(g, false), count: g.items.length, label: g.type });
        });

        /* 3) mechanical parts, always last */
        mechGroups.forEach(function (g) {
          renderQueue.push({ el: buildSection(g, false), count: g.items.length, label: g.type });
        });

        renderQueue.forEach(function (entry, qi) {
          mainCol.appendChild(entry.el);
          if (qi < renderQueue.length - 1) {
            var nxt = renderQueue[qi + 1];
            var cue = document.createElement('div');
            cue.className = 'seccue';
            cue.innerHTML = '&darr; ' + T('{n} more below in <strong>{c}</strong>').replace('{n}', nxt.count).replace('{c}', esc(nxt.label || T('more categories')));
            mainCol.appendChild(cue);
          }
        });
        uniGroups.forEach(function (g) {
          (sideCol || els.list).appendChild(buildSection(g, true));
        });
        if (els.pagination) els.pagination.hidden = true;
      } else {
        /* list/grid toggle (technician table view) */
        if (els.viewToggle && !els.viewToggle.dataset.bound) {
          els.viewToggle.dataset.bound = '1';
          els.viewToggle.querySelectorAll('[data-view]').forEach(function (b) {
            b.addEventListener('click', function () {
              state.viewMode = b.getAttribute('data-view');
              try { sessionStorage.setItem('wsp_view_mode', state.viewMode); } catch (e) {}
              renderList();
            });
          });
        }
        if (!state.viewMode) {
          try { state.viewMode = sessionStorage.getItem('wsp_view_mode') || 'grid'; } catch (e) { state.viewMode = 'grid'; }
        }
        if (els.viewToggle) {
          els.viewToggle.hidden = false;
          els.viewToggle.querySelectorAll('[data-view]').forEach(function (b) {
            b.classList.toggle('is-active', b.getAttribute('data-view') === state.viewMode);
          });
        }
        /* Mechanical Parts: secondary sub-filter pills (client-side) */
        if (isMechanicalType(state.activeCat)) {
          var SUBS = [
            ['All', null],
            ['Screws', /screw|bolt|washer/i],
            ['Gears', /gear|pulley/i],
            ['Insulators', /insulator|damper|cushion|grommet/i],
            ['Switches', /switch|lever|button/i],
            ['Springs', /spring/i],
            ['Motors', /motor/i]
          ].filter(function (sf) { return !sf[1] || state.rows.some(function (r) { return sf[1].test(r.title || ''); }); });
          if (SUBS.length > 2) {
            var srow = document.createElement('div');
            srow.className = 'subpills';
            SUBS.forEach(function (sf) {
              var b = document.createElement('button');
              b.type = 'button';
              b.className = 'subpill' + ((state.subFilter || 'All') === sf[0] ? ' is-active' : '');
              b.textContent = sf[0];
              b.addEventListener('click', function () { state.subFilter = sf[0]; renderList(); });
              srow.appendChild(b);
            });
            els.list.appendChild(srow);
          }
          var sub = SUBS.filter(function (sf) { return sf[0] === (state.subFilter || 'All'); })[0];
          if (sub && sub[1]) state.rows = state.rows.filter(function (r) { return sub[1].test(r.title || ''); });
        }
        els.list.classList.toggle('compat__list--table', state.viewMode === 'list');
        var rowBuilder = (state.viewMode === 'list') ? buildListRow : buildRow;
        if (state.viewMode === 'list') {
          var lh = document.createElement('div');
          lh.className = 'lrow lrow--head';
          lh.innerHTML = '<span class="lrow__code mono">' + T('Part no.') + '</span><span class="lrow__name">' + T('Description') + '</span><span class="lrow__stock">' + T('Stock') + '</span><span class="lrow__price">' + T('Price') + '</span><span class="lrow__actions"></span>';
          els.list.appendChild(lh);
        }
        /* show every result at once - no "Load more" step */
        state.rows.forEach(function (p) { els.list.appendChild(rowBuilder(p)); });
        state.shown = state.rows.length;
        updatePagination();
      }
    }
    function updatePagination() {
      if (!els.pagination) return;
      /* everything is rendered up front now - the bar stays hidden, but
         we still show a quiet total count for orientation */
      els.pagination.hidden = true;
      if (els.showing) els.showing.textContent = state.rows.length + ' part' + (state.rows.length === 1 ? '' : 's') + ' shown';
    }
    if (els.more) {
      els.more.addEventListener('click', function () {
        var rb = (state.viewMode === 'list' && state.activeCat !== 'all') ? buildListRow : buildRow;
        state.rows.slice(state.shown, state.shown + state.pageSize).forEach(function (p) { els.list.appendChild(rb(p)); });
        state.shown = Math.min(state.shown + state.pageSize, state.rows.length);
        updatePagination();
      });
    }
    if (els.sort) {
      els.sort.addEventListener('change', function () {
        state.sort = this.value;
        renderList();
      });
    }

    /* --- wire finder in inline mode --- */
    if (finderRoot) {
      finderApi = initFinder(finderRoot, function (brand, model) {
        startSearch(brand, model);
      });
    }
    onDbReady(function (ok) {
      if (!finderApi) return;
      if (!ok) { finderApi.fail(); return; }
      finderApi.ready();
      var params = readUrlParams();
      if (params && params.brand && params.model) {
        /* Honour the exact record if it exists; otherwise resolve leniently. */
        var brand = params.brand, model = params.model;
        var exact = exactModelExists(brand, model);
        if (exact) {
          startSearch(brand, exact, { skipUrl: true });
        } else {
          var match = findUniqueModelMatch(brand + ' ' + model);
          if (match) startSearch(match.brand, match.model, { replaceUrl: true });
          else finderApi.setStatus(T('We could not find <strong>{m}</strong> in the database. Check the spelling, or <a href="{u}">ask technical support</a>.').replace('{m}', esc(brand + ' ' + model)).replace('{u}', esc(lurl(CONTACT_URL))), 'warn');
        }
      } else if (params && params.legacy) {
        var m2 = findUniqueModelMatch(params.legacy);
        if (m2) startSearch(m2.brand, m2.model, { replaceUrl: true });
        else if (finderApi && finderApi.prefill) finderApi.prefill(params.legacy);
      }
    });
  }

  /* ================================================================
     HEADER model finder - live autocomplete, same engine as the hero
     ================================================================ */
  function initHeaderFinder() {
    document.querySelectorAll('.header__modelfinder, .header__search-form').forEach(function (form, index) {
      if (form.dataset.modelFinderBound === '1') return;
      var input = form.querySelector('input[type="search"]');
      if (!input) return;
      form.dataset.modelFinderBound = '1';
      var drop = document.createElement('div');
      drop.className = 'hdrfinder__dropdown';
      drop.id = 'header-model-suggestions-' + index;
      form.appendChild(drop);
      input.setAttribute('aria-controls', drop.id);
      input.setAttribute('aria-expanded', 'false');
      var renderTimer = null;
      function close() {
        clearTimeout(renderTimer);
        renderTimer = null;
        drop.classList.remove('is-open');
        input.setAttribute('aria-expanded', 'false');
      }
      function queryValue() { return input.value.slice(0, 96).trim(); }
      function render(q) {
        if (form.closest('[hidden]')) { close(); return; }
        if (!dbReady || !q || q.length < 2) { close(); return; }
        var hits = searchDb(q, null, 6, 'model');
        if (!hits.length) { close(); return; }
        drop.innerHTML = '';
        hits.forEach(function (r) {
          var a = document.createElement('a');
          a.className = 'hdrfinder__item';
          a.href = COMPAT_URL + '?brand=' + encodeURIComponent(r.e.brand) + '&model=' + encodeURIComponent(r.e.model);
          a.innerHTML = '<span class="hdrfinder__brand">' + esc(r.e.brand) + '</span> <span class="mono">' + esc(r.e.model) + '</span>';
          drop.appendChild(a);
        });
        drop.classList.add('is-open');
        input.setAttribute('aria-expanded', 'true');
      }
      input.addEventListener('focus', function () {
        loadDb(); /* lazy: only pages where the person touches the header finder */
        onDbReady(function (ok) {
          if (ok && document.activeElement === input && queryValue()) render(queryValue());
        });
        if (queryValue()) render(queryValue());
      });
      input.addEventListener('input', function () {
        close();
        renderTimer = setTimeout(function () { renderTimer = null; render(queryValue()); }, 120);
      });
      form.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowDown' && e.target === input && drop.classList.contains('is-open')) {
          var first = drop.querySelector('a');
          if (first) { e.preventDefault(); first.focus(); }
        }
      });
      form.addEventListener('submit', close);
      document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
    });
  }

  /* ================================================================
     NAVIGATE-MODE finders (homepage hero, etc.)
     ================================================================ */
  function initNavigateFinder(root) {
    var api = initFinder(root, function (brand, model) {
      memorySave(brand, model);
      location.href = lurl(COMPAT_URL) + '?brand=' + encodeURIComponent(brand) + '&model=' + encodeURIComponent(model);
    });
    onDbReady(function (ok) {
      if (!api) return;
      if (ok) api.ready();
      else api.fail();
    });
  }

  /* ================================================================
     PRODUCT PAGE - "Does this fit your device?" checker
     ================================================================ */

  function initDescToggle() {
    var wrap = document.querySelector('[data-desc]');
    if (!wrap) return;
    var body = wrap.querySelector('[data-desc-body]');
    var btn = wrap.querySelector('[data-desc-toggle]');
    if (!body || !btn) return;
    /* Shopify RTE descriptions often end in empty paragraphs
       (<p>&nbsp;</p>, <p><br></p>) that inflate scrollHeight and made
       two-line descriptions clamp + fade. Strip them before measuring. */
    (function pruneTrailingEmpties() {
      var last = body.lastElementChild;
      while (last &&
             !String(last.textContent || '').replace(/\u00a0/g, ' ').trim() &&
             !last.querySelector('img,iframe,video,table,ul,ol,svg')) {
        body.removeChild(last);
        last = body.lastElementChild;
      }
    })();
    function measure() {
      if (wrap.classList.contains('is-open')) return;
      /* real overflow test: how much the clamp actually clips */
      var clipped = body.scrollHeight - body.clientHeight;
      if (clipped <= 32) {
        /* fits (or nearly): show everything, no fade, no button */
        wrap.classList.add('is-open');
        wrap.classList.remove('has-more');
        btn.hidden = true;
        return;
      }
      wrap.classList.add('has-more');
      btn.hidden = false;
      btn.textContent = T('Read full description');
    }
    measure();
    setTimeout(measure, 600); /* re-check after images/fonts settle */
  }
  /* delegated so it works regardless of init order or re-renders */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-desc-toggle]') : null;
    if (!btn) return;
    e.preventDefault();
    var wrap = btn.closest('[data-desc]');
    if (!wrap) return;
    wrap.classList.toggle('is-open');
    btn.textContent = wrap.classList.contains('is-open') ? T('Show less') : T('Read full description');
    if (!wrap.classList.contains('is-open')) {
      wrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  function initFitcheck() {
    var box = document.querySelector('[data-fitcheck]');
    if (!box) return;
    var input = box.querySelector('[data-fitcheck-input]');
    var go = box.querySelector('[data-fitcheck-go]');
    var dropdown = box.querySelector('[data-fitcheck-dropdown]');
    var result = box.querySelector('[data-fitcheck-result]');
    var dataEl = box.querySelector('[data-fitcheck-product]');
    if (!input || !go || !result || !dataEl) return;

    var product = readIsland(dataEl);
    if (!product) return;

    var sel = null, fitCheckToken = 0;
    function setResult(html, tone) {
      result.innerHTML = html || '';
      result.className = 'fitcheck__result' + (tone ? ' fitcheck__result--' + tone : '');
    }
    function closeDrop() { if (dropdown) dropdown.classList.remove('is-open'); }
    function renderDrop(q) {
      if (!dropdown) return;
      dropdown.innerHTML = '';
      var raw = String(q || '').trim();
      if (!raw || !dbReady) { closeDrop(); return; }
      var results = searchDb(raw, '').filter(function (r) { return r.e.type === 'model'; }).slice(0, 6);
      if (!results.length) { closeDrop(); return; }
      results.forEach(function (r) {
        var e = r.e;
        var item = document.createElement('button');
        item.type = 'button';
        item.className = 'fd__item';
        item.innerHTML = '<span class="fd__brand">' + esc(e.brand) + '</span><span class="fd__model">' + highlight(e.model, raw) + '</span>';
        item.addEventListener('mousedown', function (ev) {
          ev.preventDefault();
          fitCheckToken++;
          go.disabled = false;
          go.textContent = T('Check fit');
          setResult('', '');
          sel = e;
          input.value = e.brand + ' ' + e.model;
          closeDrop();
        });
        dropdown.appendChild(item);
      });
      dropdown.classList.add('is-open');
    }
    input.addEventListener('input', function () {
      fitCheckToken++;
      go.disabled = false;
      go.textContent = T('Check fit');
      sel = null;
      setResult('', '');
      renderDrop(this.value);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); check(); }
      if (e.key === 'Escape') closeDrop();
    });
    document.addEventListener('click', function (e) { if (!box.contains(e.target)) closeDrop(); });

    function check() {
      var raw = input.value.trim();
      if (!raw) return;
      if (!dbReady) {
        var waitingToken = ++fitCheckToken;
        go.disabled = true;
        go.textContent = T('Checking…');
        setResult(T('Checking the compatibility database…'), '');
        loadDb();
        onDbReady(function (ok) {
          if (waitingToken !== fitCheckToken) return;
          go.disabled = false;
          go.textContent = T('Check fit');
          if (ok) check(); else setResult(ERROR_MSG_T(), 'err');
        });
        return;
      }
      var entry = sel || findUniqueModelMatch(raw);
      if (!entry) {
        setResult(T('We could not find that exact model in the database. Check the spelling, or <a href="{u}">ask technical support</a> before ordering.').replace('{u}', esc(lurl(CONTACT_URL))), 'warn');
        return;
      }
      var token = ++fitCheckToken;
      go.disabled = true;
      go.textContent = T('Checking…');
      setResult(T('Checking the compatibility database…'), '');
      fetchWithRetry(beUrl('action=getSearch&brand=' + encodeURIComponent(entry.brand) + '&model=' + encodeURIComponent(entry.model)), 0)
        .then(function (data) {
          if (token !== fitCheckToken) return;
          go.disabled = false;
          go.textContent = T('Check fit');
          if (!data || !data.searchQuery) {
            setResult(T('We could not confirm this exact fit for <strong>{m}</strong>.').replace('{m}', esc(entry.brand + ' ' + entry.model)) + ' <a href="' + esc(CONTACT_URL) + '">' + T('Ask technical support before ordering') + '.</a>', 'warn');
            return;
          }
          var ctx = buildCompatibilityContext(entry.brand, entry.model, data);
          var pseudo = {
            title: product.title,
            tags: product.tags || [],
            _d: { tags: product.tags || [], variants: (product.skus || []).map(function (s) { return { sku: s }; }) }
          };
          var proof = productCompatibilityProof(pseudo, ctx);
          if (proof.accepted) {
            memorySave(entry.brand, entry.model);
            setResult('&#10003; ' + T('Confirmed fit for') + ' <strong>' + esc(entry.brand + ' ' + entry.model) + '</strong>' + (proof.variantLabel ? ' (' + esc(proof.variantLabel) + ')' : '') + '. <a href="' + esc(COMPAT_URL) + '?brand=' + encodeURIComponent(entry.brand) + '&model=' + encodeURIComponent(entry.model) + '">' + T('See all parts for this model') + '</a>.', 'ok');
          } else {
            setResult(T('We could not confirm this exact fit for <strong>{m}</strong>.').replace('{m}', esc(entry.brand + ' ' + entry.model)) + ' <a href="' + esc(CONTACT_URL) + '">' + T('Ask technical support before ordering') + '</a>, ' + T('or') + ' <a href="' + esc(COMPAT_URL) + '?brand=' + encodeURIComponent(entry.brand) + '&model=' + encodeURIComponent(entry.model) + '">see confirmed parts for your model</a>.', 'warn');
          }
        })
        .catch(function () {
          if (token !== fitCheckToken) return;
          go.disabled = false;
          go.textContent = T('Check fit');
          setResult(ERROR_MSG_T(), 'err');
        });
    }
    go.addEventListener('click', check);
    onDbReady(function () {});
  }

  /* ================================================================
     PRODUCT PAGE - "More parts for {model}" strip
     Detects the brand + model from the product title against the
     database index, then runs the exact same backend-proofed pipeline
     as the compatibility page. Never guesses: if the backend search or
     the proof filter yields nothing, the strip stays hidden.
     ================================================================ */
  function detectModelFromText(text) {
    var nt = norm(text);
    if (!nt) return null;
    var best = null;
    db.brands.forEach(function (brand) {
      var nb = norm(brand);
      if (!nb || nt.indexOf(nb) === -1) return;
      (db.modelsByBrand[brand] || []).forEach(function (model) {
        var nm = norm(model);
        if (nm.length < 3 || nt.indexOf(nm) === -1) return;
        if (!best || nm.length > norm(best.model).length) best = { brand: brand, model: model };
      });
    });
    return best;
  }

  /* Indeterminate loading animation: no artificial percentage while work runs. */
  /* Vintage gear train shown while the finder works: three meshing
     gears (like a cassette mechanism), speeds proportional to tooth
     counts so they visually mesh. Pure SVG + CSS animation. */
  function gearG(cx, cy, r, teeth, cls) {
    var t = [];
    for (var i = 0; i < teeth; i++) {
      var a = (Math.PI * 2 * i) / teeth;
      t.push('<line x1="' + (cx + Math.cos(a) * r).toFixed(1) + '" y1="' + (cy + Math.sin(a) * r).toFixed(1) +
             '" x2="' + (cx + Math.cos(a) * (r + 4)).toFixed(1) + '" y2="' + (cy + Math.sin(a) * (r + 4)).toFixed(1) + '"/>');
    }
    return '<g class="' + cls + '" style="transform-origin:' + cx + 'px ' + cy + 'px">' +
      '<circle cx="' + cx + '" cy="' + cy + '" r="' + r + '"/>' + t.join('') +
      '<circle cx="' + cx + '" cy="' + cy + '" r="' + (r * 0.35).toFixed(1) + '"/>' +
      '<circle cx="' + cx + '" cy="' + cy + '" r="1.6" fill="currentColor" stroke="none"/></g>';
  }
  /* Loading artwork: a random vintage machine fills the card and the
     real progress bar docks into that machine's own display. */
  function artDeck() {
    function well(x, tag) {
      return '<rect x="' + x + '" y="92" width="230" height="92" rx="8" stroke-width="1.6"/>' +
        '<rect x="' + (x + 16) + '" y="104" width="198" height="68" rx="7" stroke-width="1.4" opacity=".85"/>' +
        '<rect x="' + (x + 30) + '" y="112" width="170" height="14" rx="4" stroke-width="1" opacity=".5"/>' +
        '<circle cx="' + (x + 70) + '" cy="148" r="16" stroke-width="1" opacity=".4"/>' +
        '<circle cx="' + (x + 144) + '" cy="148" r="12" stroke-width="1" opacity=".4"/>' +
        '<path d="M' + (x + 70) + ' 164 Q' + (x + 107) + ' 170 ' + (x + 144) + ' 160" stroke-width="1" opacity=".4"/>' +
        gearG(x + 70, 148, 10, 9, tag) + gearG(x + 144, 148, 10, 9, tag) +
        '<text x="' + (x + 206) + '" y="168" font-family="ui-monospace,monospace" font-size="11" fill="currentColor" opacity=".6" stroke="none">' + (x < 200 ? 'A' : 'B') + '</text>';
    }
    function vu(x) {
      return '<rect x="' + x + '" y="38" width="50" height="30" rx="4" stroke-width="1.2" opacity=".75"/>' +
        '<g class="wspgears__vu" style="transform-origin:' + (x + 25) + 'px 62px"><line x1="' + (x + 25) + '" y1="62" x2="' + (x + 25) + '" y2="44" stroke="#C96F2E" stroke-width="1.6"/></g>' +
        '<path d="M' + (x + 8) + ' 50 Q' + (x + 25) + ' 42 ' + (x + 42) + ' 50" stroke-width="1" opacity=".45"/>';
    }
    function btns(x) {
      var o = '';
      for (var i = 0; i < 5; i++) o += '<rect x="' + (x + i * 26) + '" y="196" width="20" height="9" rx="2" stroke-width="1.1" opacity=".5"/>';
      return o;
    }
    return {
      svg: '<svg viewBox="0 0 560 224" preserveAspectRatio="xMidYMid meet" fill="none" stroke="currentColor" stroke-width="1.8">' +
        '<rect x="4" y="4" width="552" height="216" rx="11"/>' +
        '<rect x="24" y="38" width="406" height="30" rx="6" stroke="#C96F2E" stroke-width="1.6"/>' +
        vu(444) + well(34, 'wspgears__a') + well(296, 'wspgears__b') + btns(40) + btns(302) +
        '<circle cx="536" cy="200" r="9" stroke-width="1.4" opacity=".65"/><line x1="536" y1="194" x2="536" y2="200" stroke-width="1.4" opacity=".65"/></svg>',
      slot: 'left:4.6%;width:71%;top:17.4%;height:13%'
    };
  }
  function artTurntable() {
    var dots = '';
    for (var i = 0; i < 24; i++) {
      var a = Math.PI * 2 * i / 24;
      dots += '<circle cx="' + (200 + Math.cos(a) * 80).toFixed(1) + '" cy="' + (116 + Math.sin(a) * 80).toFixed(1) + '" r="1.3" fill="currentColor" stroke="none"/>';
    }
    return {
      svg: '<svg viewBox="0 0 560 234" preserveAspectRatio="xMidYMid meet" fill="none" stroke="currentColor" stroke-width="1.8">' +
        '<rect x="6" y="8" width="548" height="208" rx="12"/>' +
        '<g class="wspgears__tt" style="transform-origin:200px 116px">' +
        '<circle cx="200" cy="116" r="86" stroke-width="1.7"/>' + dots +
        '<circle cx="200" cy="116" r="68" stroke-width="1" opacity=".4"/>' +
        '<circle cx="200" cy="116" r="56" stroke-width="1" opacity=".4"/>' +
        '<circle cx="200" cy="116" r="44" stroke-width="1" opacity=".4"/>' +
        '<circle cx="200" cy="116" r="26" stroke-width="1.4" stroke="#C96F2E"/>' +
        '<line x1="200" y1="96" x2="200" y2="104" stroke="#C96F2E" stroke-width="1.4"/>' +
        '</g>' +
        '<circle cx="200" cy="116" r="3.4" fill="#C96F2E" stroke="none"/>' +
        '<circle cx="452" cy="56" r="12" stroke-width="1.5"/><circle cx="452" cy="56" r="4" stroke-width="1.2"/>' +
        '<rect x="470" y="44" width="26" height="14" rx="4" stroke-width="1.3" opacity=".7"/>' +
        '<line x1="443" y1="65" x2="328" y2="148" stroke-width="1.7"/>' +
        '<rect x="316" y="142" width="22" height="12" rx="3" transform="rotate(-36 327 148)" stroke-width="1.5"/>' +
        '<rect x="36" y="182" width="18" height="10" rx="2" stroke-width="1.1" opacity=".6"/>' +
        '<rect x="60" y="182" width="18" height="10" rx="2" stroke-width="1.1" opacity=".6"/>' +
        '<circle cx="46" cy="52" r="12" stroke-width="1.2" opacity=".55"/>' +
        '<circle cx="46" cy="52" r="4" stroke-width="1" opacity=".55"/>' +
        '<rect x="96" y="196" width="10" height="14" rx="2" stroke="#C96F2E" stroke-width="1.2" opacity=".8"/>' +
        '<rect x="330" y="180" width="204" height="26" rx="6" stroke="#C96F2E" stroke-width="1.6"/></svg>',
      slot: 'left:60%;width:34.3%;top:78%;height:9.5%'
    };
  }
  function artWalkman() {
    return {
      svg: '<svg viewBox="0 0 560 212" preserveAspectRatio="xMidYMid meet" fill="none" stroke="currentColor" stroke-width="1.8">' +
        '<rect x="60" y="22" width="320" height="168" rx="15"/>' +
        '<rect x="88" y="56" width="264" height="112" rx="10" stroke-width="1.5" opacity=".9"/>' +
        '<rect x="102" y="66" width="236" height="22" rx="5" stroke="#C96F2E" stroke-width="1.5"/>' +
        '<circle cx="160" cy="128" r="17" stroke-width="1" opacity=".4"/>' +
        '<circle cx="280" cy="128" r="13" stroke-width="1" opacity=".4"/>' +
        '<path d="M160 145 Q220 152 280 141" stroke-width="1" opacity=".4"/>' +
        gearG(160, 128, 10, 9, 'wspgears__a') + gearG(280, 128, 10, 9, 'wspgears__b') +
        '<rect x="396" y="52" width="14" height="34" rx="3" stroke-width="1.3" opacity=".7"/>' +
        '<rect x="396" y="96" width="14" height="22" rx="3" stroke-width="1.3" opacity=".7"/>' +
        '<path d="M410 160 C 460 168, 448 96, 492 78" stroke-width="1.4" opacity=".75"/>' +
        '<path d="M470 84 a 30 30 0 0 1 52 12" stroke-width="1.7"/>' +
        '<ellipse cx="472" cy="96" rx="9" ry="12" stroke-width="1.6"/>' +
        '<ellipse cx="520" cy="108" rx="9" ry="12" stroke-width="1.6"/></svg>',
      slot: 'left:18.6%;width:41.4%;top:31.6%;height:10.4%'
    };
  }
  function artCD() {
    return {
      svg: '<svg viewBox="0 0 560 190" preserveAspectRatio="xMidYMid meet" fill="none" stroke="currentColor" stroke-width="1.8">' +
        '<rect x="6" y="24" width="548" height="150" rx="8"/>' +
        '<line x1="6" y1="48" x2="554" y2="48" stroke-width="1" opacity=".35"/>' +
        '<rect x="26" y="58" width="180" height="82" rx="6" stroke-width="1.5" opacity=".9"/>' +
        '<g class="wspgears__cd" style="transform-origin:116px 99px">' +
        '<circle cx="116" cy="99" r="34" stroke-width="1.6"/>' +
        '<circle cx="116" cy="99" r="29" stroke-width="1" opacity=".4"/>' +
        '<path d="M96 84 a 25 25 0 0 1 14 -9" stroke-width="1" opacity=".55"/>' +
        '<path d="M136 114 a 25 25 0 0 1 -14 9" stroke-width="1" opacity=".55"/>' +
        '<circle cx="116" cy="99" r="9" stroke="#C96F2E" stroke-width="1.4"/>' +
        '<circle cx="116" cy="99" r="3.4" stroke-width="1.2"/>' +
        '</g>' +
        '<rect x="26" y="146" width="180" height="10" rx="3" stroke-width="1.1" opacity=".5"/>' +
        '<rect x="212" y="150" width="16" height="8" rx="2" stroke-width="1" opacity=".5"/>' +
        '<rect x="230" y="62" width="240" height="34" rx="5" stroke="#C96F2E" stroke-width="1.7"/>' +
        '<rect x="230" y="112" width="26" height="12" rx="2" stroke-width="1.1" opacity=".55"/>' +
        '<rect x="264" y="112" width="26" height="12" rx="2" stroke-width="1.1" opacity=".55"/>' +
        '<rect x="298" y="112" width="26" height="12" rx="2" stroke-width="1.1" opacity=".55"/>' +
        '<rect x="332" y="112" width="26" height="12" rx="2" stroke-width="1.1" opacity=".55"/>' +
        '<path d="M239 121 l6 -4 v8 Z" fill="currentColor" stroke="none" opacity=".55"/>' +
        '<path d="M273 117 l6 4 l-6 4 Z" fill="currentColor" stroke="none" opacity=".55"/>' +
        '<circle cx="500" cy="70" r="8" stroke-width="1.3" opacity=".7"/>' +
        '<line x1="500" y1="64" x2="500" y2="70" stroke-width="1.3" opacity=".7"/>' +
        '<circle cx="500" cy="126" r="14" stroke-width="1.5" opacity=".8"/>' +
        '<line x1="500" y1="114" x2="500" y2="120" stroke-width="1.4" opacity=".8"/>' +
        '<circle cx="466" cy="152" r="4" stroke-width="1.1" opacity=".5"/>' +
        '<rect x="60" y="174" width="26" height="6" rx="2" stroke-width="1" opacity=".4"/>' +
        '<rect x="474" y="174" width="26" height="6" rx="2" stroke-width="1" opacity=".4"/></svg>',
      slot: 'left:41.1%;width:42.9%;top:32.6%;height:17.9%'
    };
  }
  function artReel() {
    function reel(cx, cy, cls) {
      var sp = '';
      for (var i = 0; i < 3; i++) {
        var a = Math.PI * 2 * i / 3;
        sp += '<line x1="' + (cx + Math.cos(a) * 12).toFixed(1) + '" y1="' + (cy + Math.sin(a) * 12).toFixed(1) +
              '" x2="' + (cx + Math.cos(a) * 56).toFixed(1) + '" y2="' + (cy + Math.sin(a) * 56).toFixed(1) + '" stroke-width="4" opacity=".8"/>';
      }
      return '<g class="' + cls + '" style="transform-origin:' + cx + 'px ' + cy + 'px">' +
        '<circle cx="' + cx + '" cy="' + cy + '" r="62" stroke-width="1.8"/>' + sp +
        '<circle cx="' + cx + '" cy="' + cy + '" r="12" stroke-width="1.4"/>' +
        '<circle cx="' + cx + '" cy="' + cy + '" r="2.4" fill="#C96F2E" stroke="none"/></g>';
    }
    return {
      svg: '<svg viewBox="0 0 560 244" preserveAspectRatio="xMidYMid meet" fill="none" stroke="currentColor" stroke-width="1.8">' +
        '<rect x="6" y="6" width="548" height="232" rx="12"/>' +
        '<circle cx="150" cy="112" r="44" stroke-width="1" opacity=".35"/>' +
        '<circle cx="410" cy="112" r="30" stroke-width="1" opacity=".35"/>' +
        reel(150, 112, 'wspgears__rr') + reel(410, 112, 'wspgears__rr') +
        '<rect x="226" y="90" width="108" height="24" rx="5" stroke="#C96F2E" stroke-width="1.6"/>' +
        '<path d="M150 174 C 200 196, 240 184, 262 184" stroke-width="1.2" opacity=".6"/>' +
        '<path d="M298 184 C 330 184, 370 194, 410 174" stroke-width="1.2" opacity=".6"/>' +
        '<rect x="262" y="176" width="16" height="16" rx="3" stroke-width="1.4" opacity=".8"/>' +
        '<rect x="284" y="176" width="14" height="16" rx="3" stroke-width="1.4" opacity=".8"/>' +
        '<rect x="40" y="206" width="20" height="10" rx="2" stroke-width="1.1" opacity=".5"/>' +
        '<rect x="66" y="206" width="20" height="10" rx="2" stroke-width="1.1" opacity=".5"/>' +
        '<rect x="92" y="206" width="20" height="10" rx="2" stroke-width="1.1" opacity=".5"/>' +
        '<circle cx="482" cy="210" r="10" stroke-width="1.3" opacity=".6"/><line x1="482" y1="203" x2="482" y2="210" stroke-width="1.3" opacity=".6"/>' +
        '<circle cx="520" cy="210" r="10" stroke-width="1.3" opacity=".6"/><line x1="514" y1="205" x2="520" y2="210" stroke-width="1.3" opacity=".6"/></svg>',
      slot: 'left:40.4%;width:19.3%;top:36.9%;height:9.8%'
    };
  }
  function artBeo() {
    var dots = '';
    for (var i = 0; i < 18; i++) {
      var a = Math.PI * 2 * i / 18;
      dots += '<circle cx="' + (168 + Math.cos(a) * 55).toFixed(1) + '" cy="' + (96 + Math.sin(a) * 55).toFixed(1) + '" r="1.1" fill="currentColor" stroke="none"/>';
    }
    return {
      svg: '<svg viewBox="0 0 560 196" preserveAspectRatio="xMidYMid meet" fill="none" stroke="currentColor" stroke-width="1.6">' +
        '<rect x="10" y="26" width="540" height="140" rx="7"/>' +
        '<g class="wspgears__tt" style="transform-origin:168px 96px">' +
        '<circle cx="168" cy="96" r="60" stroke-width="1.5"/>' + dots +
        '<circle cx="168" cy="96" r="20" stroke="#C96F2E" stroke-width="1.2"/>' +
        '<line x1="168" y1="80" x2="168" y2="86" stroke="#C96F2E" stroke-width="1.2"/>' +
        '</g>' +
        '<circle cx="168" cy="96" r="2.6" fill="#C96F2E" stroke="none"/>' +
        '<line x1="258" y1="58" x2="532" y2="58" stroke-width="1.2" opacity=".7"/>' +
        '<rect x="292" y="50" width="30" height="16" rx="3" stroke-width="1.4"/>' +
        '<line x1="298" y1="66" x2="298" y2="96" stroke-width="1.5"/>' +
        '<rect x="292" y="96" width="14" height="8" rx="2" stroke-width="1.3"/>' +
        '<line x1="360" y1="150" x2="532" y2="150" stroke-width="1" opacity=".35"/>' +
        '<line x1="360" y1="156" x2="532" y2="156" stroke-width="1" opacity=".35"/>' +
        '<rect x="300" y="112" width="220" height="22" rx="4" stroke="#C96F2E" stroke-width="1.5"/></svg>',
      slot: 'left:54.6%;width:38.2%;top:58.2%;height:10.2%'
    };
  }
  function artBoombox() {
    function speaker(cx) {
      return '<circle cx="' + cx + '" cy="134" r="56" stroke-width="1.6"/>' +
        '<circle cx="' + cx + '" cy="134" r="40" stroke-width="1" opacity=".5"/>' +
        '<circle cx="' + cx + '" cy="134" r="24" stroke-width="1" opacity=".5"/>' +
        '<circle cx="' + cx + '" cy="134" r="7" stroke-width="1.3"/>';
    }
    return {
      svg: '<svg viewBox="0 0 560 248" preserveAspectRatio="xMidYMid meet" fill="none" stroke="currentColor" stroke-width="1.8">' +
        '<path d="M170 34 C 170 8, 390 8, 390 34" stroke-width="1.6" opacity=".8"/>' +
        '<rect x="8" y="34" width="544" height="200" rx="14"/>' +
        '<line x1="468" y1="34" x2="536" y2="4" stroke-width="1.5" opacity=".7"/>' +
        '<circle cx="536" cy="4" r="2" fill="currentColor" stroke="none"/>' +
        speaker(120) + speaker(440) +
        '<rect x="208" y="72" width="144" height="26" rx="5" stroke="#C96F2E" stroke-width="1.6"/>' +
        '<rect x="208" y="112" width="144" height="76" rx="8" stroke-width="1.5"/>' +
        '<rect x="220" y="122" width="120" height="56" rx="6" stroke-width="1.2" opacity=".8"/>' +
        '<circle cx="254" cy="150" r="12" stroke-width="1" opacity=".4"/>' +
        '<circle cx="306" cy="150" r="12" stroke-width="1" opacity=".4"/>' +
        gearG(254, 150, 8, 8, 'wspgears__a') + gearG(306, 150, 8, 8, 'wspgears__b') +
        '<rect x="216" y="200" width="18" height="9" rx="2" stroke-width="1.1" opacity=".5"/>' +
        '<rect x="240" y="200" width="18" height="9" rx="2" stroke-width="1.1" opacity=".5"/>' +
        '<rect x="264" y="200" width="18" height="9" rx="2" stroke-width="1.1" opacity=".5"/>' +
        '<rect x="288" y="200" width="18" height="9" rx="2" stroke-width="1.1" opacity=".5"/>' +
        '<rect x="312" y="200" width="18" height="9" rx="2" stroke-width="1.1" opacity=".5"/></svg>',
      slot: 'left:37.9%;width:24.3%;top:30.6%;height:9.7%'
    };
  }
  function gearsHTML() {
    var pool = [artDeck, artTurntable, artWalkman, artCD, artReel, artBeo, artBoombox];
    var a = pool[Math.floor(Math.random() * pool.length)]();
    return '<div class="wspgears" aria-hidden="true">' + a.svg +
      '<div class="wspgears__slot" data-gears-slot style="' + a.slot + '"></div></div>';
  }
  function gearsRemove(el) {
    if (!el || !el._wspGears) return;
    if (el._wspHome && el._wspHome.parentNode) {
      el._wspHome.parentNode.insertBefore(el, el._wspHome);
      el._wspHome.remove();
      el._wspHome = null;
    }
    if (el._wspGearsEl) { el._wspGearsEl.remove(); el._wspGearsEl = null; }
    else {
      var g = el.previousElementSibling;
      if (g && g.classList && g.classList.contains('wspgears')) g.remove();
    }
    el._wspGears = false;
  }

  function progressStart(el) {
    if (!el) return;
    el.classList.add('is-active');
    el.classList.remove('is-determinate');
    if (!el._wspGears) {
      el._wspGears = true;
      el.insertAdjacentHTML('beforebegin', gearsHTML());
      var gw = el.previousElementSibling;
      var slot = gw && gw.querySelector('[data-gears-slot]');
      if (slot) {
        el._wspHome = document.createComment('wsp-progress-home');
        el.parentNode.insertBefore(el._wspHome, el);
        el._wspGearsEl = gw;
        slot.appendChild(el);
      }
    }
    var bar = el.querySelector('span');
    var pct = el.querySelector('.finder__progress-pct');
    /* Existing CSS animates the shimmer; there is no measurable percent. */
    if (bar) bar.style.width = '100%';
    if (pct) pct.textContent = '';
  }
  function progressFinish(el) {
    gearsRemove(el);
    if (!el) return;
    var bar = el.querySelector('span');
    var pct = el.querySelector('.finder__progress-pct');
    el.classList.remove('is-active');
    if (bar) bar.style.width = '0%';
    if (pct) pct.textContent = '';
  }
  function progressFail(el) {
    gearsRemove(el);
    if (!el) return;
    el.classList.remove('is-active');
  }

  function fetchWithRetry(url, tries, delay) {
    delay = delay || 1400;
    return finderFetch(url, { cache: 'no-store', credentials: 'omit' }).then(finderReadJson).then(function (data) {
      if (data && data.error) throw new Error(String(data.error));
      if (!data || typeof data.searchQuery !== 'string') throw new Error('finder_invalid_response');
      return data;
    }).catch(function (err) {
      if (err && (err.message === 'no_query' || err.message === 'finder_timeout')) throw err;
      if (tries > 0) {
        return new Promise(function (res) { setTimeout(res, delay); })
          .then(function () { return fetchWithRetry(url, tries - 1, Math.min(delay * 1.8, 6000)); });
      }
      throw err;
    });
  }

  function runCompatSearch(brand, model) {
    var work = fetchWithRetry(beUrl('action=getSearch&brand=' + encodeURIComponent(brand) + '&model=' + encodeURIComponent(model)), 1)
      .then(function (data) {
        if (!data || !data.searchQuery) throw new Error('no_query');
        var ctx = buildCompatibilityContext(brand, model, data);
        var terms = ctx.searchQuery.split(/\s+OR\s+/i);
        return Promise.all(terms.map(function (q) {
          return suggestAllForTerm(q.trim());
        })).then(function (groups) {
          var seen = {}, products = [];
          groups.forEach(function (g) {
            g.forEach(function (p) {
              var k = productMergeKey(p);
              if (!seen[k]) { seen[k] = true; products.push(p); }
            });
          });
          return fetchMechanismProducts(ctx).then(function (mech) {
            mech.forEach(function (p) {
              var k = productMergeKey(p);
              if (!seen[k]) { seen[k] = true; products.push(p); }
            });
            return Promise.all(products.map(hydrateProduct));
          }).then(function (hydrated) {
            var merged = [], seen2 = {};
            hydrated.forEach(function (p) {
              var k = productMergeKey(p);
              if (!seen2[k]) { seen2[k] = true; merged.push(p); }
            });
            var proven = merged.filter(function (p) {
              var proof = productCompatibilityProof(p, ctx);
              p._wspCompat = proof;
              return proof.accepted;
            }).sort(sortProductsForDisplay);
            rememberMaintenance(proven);
            return { products: proven, ctx: ctx };
          });
        });
      });
    return finderWithin(work, 25000);
  }



  /* ======================= REVIEWS (Trustpilot excerpts) ======================= */
  function wspReviews() {
    var el = document.getElementById('wsp-reviews');
    if (!el) return [];
    try { return JSON.parse(el.textContent) || []; } catch (e) { return []; }
  }
  var CATEGORY_REVIEW_WORDS = {
    'belt': ['belt'], 'pinch': ['pinch roller', 'roller'], 'idler': ['idler', 'tire'],
    'laser': ['laser', 'pickup', 'cd player', 'cd-player'], 'gear': ['gear'],
    'clean': ['grease', 'oil', 'clean'], 'turntable': ['turntable'], 'cassette': ['cassette', 'deck', 'tape'],
    'walkman': ['walkman'], 'reel': ['reel']
  };
  function reviewCategoryWords(context) {
    var lc = (context || '').toLowerCase();
    var words = [];
    Object.keys(CATEGORY_REVIEW_WORDS).forEach(function (k) {
      if (lc.indexOf(k) !== -1) words = words.concat(CATEGORY_REVIEW_WORDS[k]);
    });
    return words;
  }
  function renderReviews(brand, model, context) {
    var boxes = document.querySelectorAll('[data-reviews]');
    if (!boxes.length) return;
    var all = wspReviews();
    var needle = ((brand || '') + ' ' + (model || '')).toLowerCase().trim();
    var brandLc = (brand || '').toLowerCase();
    var catWords = reviewCategoryWords(context);
    var matched = [], brandOnly = [], catMatched = [], generic = [];
    all.forEach(function (r) {
      var rm = (r.model || '').toLowerCase();
      var rq = (r.q || '').toLowerCase();
      var inCat = catWords.length && catWords.some(function (w) { return rq.indexOf(w) !== -1 || rm.indexOf(w) !== -1; });
      if (rm && needle && (rm.indexOf(needle) !== -1 || needle.indexOf(rm) !== -1)) matched.push(r);
      else if (rm && brandLc && rm.indexOf(brandLc) !== -1) brandOnly.push(r);
      else if (inCat) catMatched.push(r);
      else generic.push(r);
    });
    var pool = matched.concat(brandOnly).concat(shuffle(catMatched)).concat(shuffle(generic));
    function qHtml(r) {
      var loc = (window.WSP && window.WSP.locale ? String(window.WSP.locale) : 'en').toLowerCase().split('-')[0];
      var text = (loc !== 'en' && r['q_' + loc]) ? r['q_' + loc] : r.q;
      var isTranslated = (loc !== 'en' && r['q_' + loc]);
      return '<blockquote class="revbox__q">' +
        tpStarsHtml('sm') +
        '<p>&ldquo;' + esc(stripEmoji(text)) + '&rdquo;</p>' +
        '<cite>' + esc(r.author || T('Verified buyer')) + (r.model ? ' &middot; <span class="mono">' + esc(r.model) + '</span>' : '') + '</cite>' +
        (isTranslated ? '<span class="revbox__translated">' + T('Translated from the customer original language') + '</span>' : '') +
      '</blockquote>';
    }
    Array.prototype.forEach.call(boxes, function (box) {
      var wrap = box.querySelector('[data-reviews-quotes]');
      if (!wrap) return;
      var compact = box.hasAttribute('data-reviews-compact');
      var boxPool = pool;
      if (compact) {
        /* short quotes fit the buy box; keep model-matched ones even if long */
        var short = pool.filter(function (r, i) { return i < matched.length + brandOnly.length || (r.q || '').length <= 230; });
        if (short.length) boxPool = short;
      }
      if (!boxPool.length) { box.hidden = true; return; }
      var per = compact ? 1 : 2;
      /* model-matched reviews always lead; otherwise start somewhere random
         so repeat visitors don't keep seeing the same quotes */
      var idx = (matched.length || brandOnly.length) ? 0 : Math.floor(Math.random() * boxPool.length);
      function show() {
        var a = boxPool[idx % boxPool.length];
        var b = (!compact && boxPool.length > 1) ? boxPool[(idx + 1) % boxPool.length] : null;
        wrap.classList.remove('is-in');
        setTimeout(function () {
          wrap.innerHTML = qHtml(a) + (b ? qHtml(b) : '');
          wrap.classList.add('is-in');
        }, wrap.innerHTML ? 260 : 0);
      }
      show();
      if (box._wspRevTimer) clearInterval(box._wspRevTimer);
      if (boxPool.length > per) {
        box._wspRevTimer = setInterval(function () {
          if (box.matches(':hover')) return; /* let people finish reading */
          idx = (idx + per) % boxPool.length;
          show();
        }, compact ? 9000 : 12000);
      }
      box.hidden = false;
    });
  }
  function shuffle(a) {
    a = a.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1)), t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }
  /* generic reviews on load for product pages (model-matched once the strip detects) */
  document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('[data-reviews]')) renderReviews('', '', document.title);
  });

  /* ======================= QUICK VIEW MODAL ======================= */
  var quickReg = {};
  var quickViewGeneration = 0;
  function quickKey(p) { return (p.handle || (p.url || '').split('/').pop() || String(p.id)); }
  function quickRegister(p, extra) { quickReg[quickKey(p)] = { p: p, price: extra.price, img: extra.img, url: extra.url, badge: extra.badge || '' }; return quickKey(p); }

  function ensureQuickModal() {
    var m = document.getElementById('wsp-quick');
    if (m) return m;
    m = document.createElement('div');
    m.id = 'wsp-quick';
    m.hidden = true;
    m.innerHTML =
      '<div class="quick__backdrop" data-quick-close></div>' +
      '<div class="quick__panel" role="dialog" aria-modal="true" aria-label="Product details">' +
        '<button class="quick__close" type="button" data-quick-close aria-label="Close">&#10005;</button>' +
        '<div class="quick__inner" data-quick-inner></div>' +
      '</div>';
    document.body.appendChild(m);
    m.addEventListener('click', function (e) {
      if (e.target.closest('[data-quick-close]')) closeQuick();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeQuick();
    });
    return m;
  }
  function closeQuick() {
    var m = document.getElementById('wsp-quick');
    if (!m) return;
    var generation = ++quickViewGeneration;
    m.classList.remove('is-open');
    setTimeout(function () { if (generation === quickViewGeneration) m.hidden = true; }, 180);
    document.documentElement.classList.remove('wsp-noscroll');
  }
  function openQuickView(entry) {
    var generation = ++quickViewGeneration;
    var m = ensureQuickModal();
    var inner = m.querySelector('[data-quick-inner]');
    var p = entry.p;
    var d = pData(p) || {};
    var variants = (d.variants || []).filter(function (v) { return v && v.id; });
    var stock = isAvailable(p) ? '<span class="stock stock--in">' + T('In stock, ready to ship') + '</span>' : '<span class="stock stock--out">' + T('Out of stock') + '</span>';
    var optsHtml = '';
    if (variants.length > 1) {
      optsHtml = '<label class="quick__opt"><span>Option</span><select data-quick-variant>' +
        variants.map(function (v) {
          var vp = (typeof v.price === 'number') ? fmtPrice(v.price, true) : '';
          return '<option value="' + esc(String(v.id)) + '"' + (v.available === false ? ' disabled' : '') + '>' + esc(v.title || v.sku || T('Option')) + (vp ? ' - ' + vp : '') + (v.available === false ? ' (out of stock)' : '') + '</option>';
        }).join('') + '</select></label>';
    }
    inner.innerHTML =
      '<div class="quick__media">' +
        '<div class="quick__mainimg" data-quick-mainimg>' + (entry.img ? '<img src="' + esc(entry.img) + '" alt="">' : '<span class="crow__noimg">&#128230;</span>') + '</div>' +
        '<div class="quick__thumbs" data-quick-thumbs hidden></div>' +
      '</div>' +
      '<div class="quick__body">' +
        (entry.badge ? '<div class="crow__badges">' + entry.badge + '</div>' : '') +
        '<h3 class="quick__title">' + esc(p.title || '') + '</h3>' +
        '<div class="quick__meta">' + stock + '<span class="quick__price mono">' + esc(entry.price || '') + '</span></div>' +
        optsHtml +
        '<div class="quick__desc" data-quick-desc><p class="quick__descwait">' + esc(T('Loading description')) + '&hellip;</p></div>' +
        '<div class="quick__actions">' +
          (isAvailable(p) ? '<button class="btn btn--primary" type="button" data-quick-add>' + T('Add to cart') + '</button>' : '') +
          '<a class="btn btn--outline" href="' + esc(entry.url) + '">' + T('Open full page') + '</a>' +
        '</div>' +
      '</div>';
    m.hidden = false;
    requestAnimationFrame(function () { if (generation === quickViewGeneration) m.classList.add('is-open'); });
    document.documentElement.classList.add('wsp-noscroll');

    var _thumbsDone = false;
    function fillDesc() {
      if (generation !== quickViewGeneration) return;
      var dd = pData(p);
      var el = inner.querySelector('[data-quick-desc]');
      if (!el) return;
      var html = (dd && dd.description) ? dd.description : '';
      el.innerHTML = html || '<p class="quick__descwait">' + T('Full details on the product page.') + '</p>';
      if (!_thumbsDone) fillThumbs(dd);
    }
    function fillThumbs(dd) {
      if (generation !== quickViewGeneration) return;
      if (_thumbsDone) return;
      _thumbsDone = true;
      var wrap = inner.querySelector('[data-quick-thumbs]');
      var main = inner.querySelector('[data-quick-mainimg]');
      if (!wrap || !main || !dd) return;
      var pool = [];
      if (Array.isArray(dd.images)) pool = pool.concat(dd.images);
      if (Array.isArray(dd.media)) dd.media.forEach(function (m) {
        if (m && m.preview_image && m.preview_image.src) pool.push(m.preview_image.src);
        else if (m && m.src) pool.push(m.src);
      });
      (dd.variants || []).forEach(function (v) {
        if (v && v.featured_image && v.featured_image.src) pool.push(v.featured_image.src);
      });
      var seen = {};
      var srcs = pool.map(function (im) {
        var u = (typeof im === 'object' && im) ? (im.src || im.url || '') : String(im || '');
        if (u && u.indexOf('//') === 0) u = 'https:' + u;
        return u.split('?')[0] ? u : '';
      }).filter(function (u) {
        var k = u.split('?')[0];
        if (!k || seen[k]) return false;
        seen[k] = 1;
        return true;
      }).slice(0, 6);
      /* main image comes from the hydrated product, not entry.img
         (grid cards may not carry it yet) - set it as soon as we have
         at least one real image, so the panel never shows a blank box */
      if (srcs.length >= 1) {
        main.innerHTML = '<img src="' + esc(sizedCdn(srcs[0], 640)) + '" alt="" data-quick-full="' + esc(srcs[0]) + '" data-zoom-src="' + esc(sizedCdn(srcs[0], 1400)) + '" style="cursor:zoom-in">';
      }
      if (srcs.length < 2) { return; }  // one image: no thumbnail row needed
      wrap.innerHTML = srcs.map(function (u, i) {
        return '<button type="button" class="quick__thumb' + (i === 0 ? ' is-current' : '') + '" data-full="' + esc(u) + '">' +
          '<img src="' + esc(sizedCdn(u, 120)) + '" alt="" loading="lazy"></button>';
      }).join('');
      wrap.hidden = false;
      wrap.addEventListener('click', function (ev) {
        var b = ev.target.closest('[data-full]');
        if (!b) return;
        var full = b.getAttribute('data-full');
        main.innerHTML = '<img src="' + esc(sizedCdn(full, 640)) + '" alt="" data-quick-full="' + esc(full) + '">';
        wrap.querySelectorAll('.quick__thumb').forEach(function (x) { x.classList.remove('is-current'); });
        b.classList.add('is-current');
      });
    }
    function sizedCdn(u, w) {
      return /cdn\.shopify\.com/.test(u) ? u.replace(/(\.[a-z]{3,4})(\?|$)/i, '_' + w + 'x' + w + '$1$2') : u;
    }
    /* kick hydration immediately so images load fast; show the primary
       image the moment product data arrives, description follows */
    if (pData(p) && pData(p).images) { fillThumbs(pData(p)); fillDesc(); }
    else {
      hydrateProduct(p).then(function () { fillThumbs(pData(p)); fillDesc(); }).catch(fillDesc);
    }

    var addBtn = inner.querySelector('[data-quick-add]');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        addBtn.disabled = true;
        addBtn.textContent = T('Adding…');
        var sel = inner.querySelector('[data-quick-variant]');
        var doAdd;
        if (sel && sel.value) {
          doAdd = fetch((window.WSP && window.WSP.cartAddUrl) || '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: Number(sel.value), quantity: 1 })
          }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); });
        } else {
          doAdd = addProductToCart(p);
        }
        doAdd
          .then(function () { return loadCart(); })
          .then(function (cart) {
            addBtn.textContent = T('Added OK');
            if (cart && typeof cart.item_count === 'number') bumpCartCount(cart.item_count);
            toast(T('Added to cart'));
            setTimeout(function () { addBtn.disabled = false; addBtn.textContent = T('Add to cart'); }, 1400);
          })
          .catch(function () {
            addBtn.disabled = false;
            addBtn.textContent = T('Add to cart');
            toast(T('Could not add, try the product page'));
          });
      });
    }
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-quick]');
    if (!a) return;
    var entry = quickReg[a.getAttribute('data-quick')];
    if (!entry) return; /* fall through to normal navigation */
    e.preventDefault();
    openQuickView(entry);
  });

  function productImage(p) {
    var cands = [p.featured_image, p.image, p._d && p._d.featured_image, p._d && p._d.images && p._d.images[0]];
    for (var i = 0; i < cands.length; i++) {
      var c = cands[i];
      if (!c) continue;
      if (typeof c === 'string') return c;
      if (typeof c === 'object' && c.url) return c.url;
      if (typeof c === 'object' && c.src) return c.src;
    }
    return '';
  }

  function qtyInCart(p) {
    try {
      var v = primaryVariant(p);
      if (!v || !v.id) return 0;
      return Number((typeof cartVar !== 'undefined' && cartVar && cartVar[String(v.id)]) || 0);
    } catch (e) { return 0; }
  }
  function qtyChipHtml(p) {
    var q = qtyInCart(p);
    return '<span class="inqty' + (q ? '' : ' inqty--zero') + '" data-inqty' + (q ? '' : ' hidden') + '>' + T('In cart:') + ' <strong>' + q + '</strong></span>';
  }

  function productStockChip(p) {
    if (p.available === false) return '<span class="stock stock--out">' + T('Out of stock') + '</span>';
    return '<span class="stock stock--in">' + T('In stock') + '</span>';
  }

  function initProductCompat() {
    var box = document.querySelector('[data-product-compat]');
    if (!box) return;
    var srcEl = box.querySelector('[data-product-compat-source]');
    var list = box.querySelector('[data-product-compat-list]');
    var modelEl = box.querySelector('[data-product-compat-model]');
    var allLink = box.querySelector('[data-product-compat-all]');
    if (!srcEl || !list) return;
    var source = readIsland(srcEl);
    if (!source) return;

    function skeleton(n) {
      var html = '';
      for (var i = 0; i < n; i++) {
        html += '<div class="prodcompat__card prodcompat__card--skel"><span class="prodcompat__media skel"></span><div class="prodcompat__body"><span class="skel skel--line"></span><span class="skel skel--line skel--short"></span></div></div>';
      }
      return html;
    }

    function markConfirmedFit(brand, model) {
      var jwm = document.querySelector('[data-jumpwait-model]');
      if (jwm) jwm.textContent = T('parts for {m}').replace('{m}', brand + ' ' + model);
      var mini = document.querySelector('[data-fitcheck-mini]');
      if (mini) {
        mini.innerHTML = '<span class="fitmini__check" aria-hidden="true">&#10003;</span> ' + T('Confirmed fit, <strong class="mono">{m}</strong> · verified in our database').replace('{m}', esc(brand + ' ' + model));
        mini.hidden = false;
      }
      var fitBox = document.querySelector('[data-fitcheck]');
      if (!fitBox || fitBox.classList.contains('fitcheck--confirmed')) return;
      fitBox.hidden = false;
      fitBox.classList.add('fitcheck--confirmed');
      var banner = document.createElement('div');
      banner.className = 'fitcheck__confirmed';
      banner.innerHTML =
        '<span class="fitcheck__confirmed-badge">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M20 6L9 17l-5-5" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</span>' +
        '<span class="fitcheck__confirmed-text">' + T('Confirmed fit for') + ' <strong class="mono">' + esc(brand + ' ' + model) + '</strong> ' + T('in the compatibility database.') + '</span>' +
        '<button class="fitcheck__other" type="button" data-fitcheck-other>' + T('Repairing a different model?') + '</button>';
      fitBox.insertBefore(banner, fitBox.firstChild);
      var toggle = banner.querySelector('[data-fitcheck-other]');
      if (toggle) {
        toggle.addEventListener('click', function () {
          fitBox.classList.toggle('fitcheck--open');
          var inp = fitBox.querySelector('[data-fitcheck-input]');
          if (fitBox.classList.contains('fitcheck--open') && inp) { inp.value = ''; inp.focus(); }
        });
      }
    }

    function startStrip() {
      /* The lookup has a deadline; a failure remains visible and retryable. */
      var match = detectModelFromText(source.title || '');
      /* part-number titles ("Sony 4-951-940-01 INSULATOR ...") carry no
         model - fall back to the product's tags (e.g. Sony-TCK611S) */
      if (!match && source.tags && source.tags.length) {
        for (var ti = 0; ti < source.tags.length && !match; ti++) {
          match = detectModelFromText(String(source.tags[ti]).replace(/[-_]+/g, ' '));
        }
      }
      if (!match) { box.hidden = true; return; }

      /* Pre-fill the fit checker with the detected model for one-click confirm */
      var fit = document.querySelector('[data-fitcheck-input]');
      if (fit && !fit.value) fit.value = match.brand + ' ' + match.model;

      if (modelEl) modelEl.textContent = match.brand + ' ' + match.model;
      if (allLink) allLink.href = COMPAT_URL + '?brand=' + encodeURIComponent(match.brand) + '&model=' + encodeURIComponent(match.model);

      /* Show the strip immediately in loading state so the visitor knows
         model-specific results are on the way. */
      function showLoading(note) {
        box.classList.add('is-loading');
        list.innerHTML = '<div class="prodcompat__loading"><div class="finder__progress" data-strip-progress aria-hidden="true"><span></span></div><p>' + (note || T('Checking the compatibility database for <strong class="mono">') + esc(match.brand + ' ' + match.model) + '</strong>&hellip;') + '</p></div>' + '<div class="prodcompat__skelrow">' + skeleton(4) + '</div>';
        box.hidden = false;
        progressStart(list.querySelector('[data-strip-progress]'));
      }

      function go() {
      showLoading('');

      var stripWork = runCompatSearch(match.brand, match.model)
        .then(function (payload) { return finderWithin(loadCart(), 2000).catch(function () {}).then(function () { return payload; }); });
      finderWithin(stripWork, 25000)
        .then(function (payload) {
          box.classList.remove('is-loading');
          var products = payload.products || [];

          /* Confirm the CURRENT product against the same proof - if it
             passes, replace the "Does this fit?" question with a
             confirmed-fit banner and remember the model. */
          try {
            var fitSrc = document.querySelector('[data-fitcheck-product]');
            if (fitSrc) {
              var current = readIsland(fitSrc);
              var pseudo = {
                title: current.title,
                tags: current.tags || [],
                _d: { tags: current.tags || [], variants: (current.skus || []).map(function (s) { return { sku: s }; }) }
              };
              var proof = productCompatibilityProof(pseudo, payload.ctx);
              if (proof.accepted) {
                markConfirmedFit(match.brand, match.model);
                renderReviews(match.brand, match.model, (source && source.product_type) || (source && source.title) || document.title);
                memorySave(match.brand, match.model);
              }
            }
          } catch (e) {}

          var others = products.filter(function (p) {
            var handle = String(p.url || '').split('?')[0].split('/').pop();
            return handle !== source.handle;
          });
          if (!others.length) {
            var jw3 = document.querySelector('[data-compat-jumpwait]');
            if (jw3) jw3.hidden = true; box.hidden = true; return; }

          list.innerHTML = '';
          var sub = box.querySelector('.prodcompat__sub');
          if (sub) sub.textContent = T('All {n} confirmed parts for this exact model, shown below.').replace('{n}', others.length);
          /* category COLUMNS side by side: Belts | Gears | Lasers | ... */
          var groups = [], byName = {};
          others.forEach(function (p) {
            var g = productCategoryGroup(p);
            if (!byName[g]) { byName[g] = []; groups.push(g); }
            byName[g].push(p);
          });
          /* universal add-ons ALWAYS last, real parts first */
          groups.sort(function (a, b) {
            var ma = isMaintenanceType(a) ? 1 : 0, mb = isMaintenanceType(b) ? 1 : 0;
            if (ma !== mb) return ma - mb;
            return categoryRankFromType(a) - categoryRankFromType(b);
          });
          var makeCard = function (p) {
            var card = document.createElement('article');
            card.className = 'prodcompat__card';
            var img = productImage(p);
            var title = stripLeadingProductCode(p.title || '');
            var price = fmtPrice(p.price, p._priceFromProductJson);
            var url = String(p.url || '').split('?')[0];
            card.innerHTML =
              '<a class="prodcompat__media' + (img ? '' : ' prodcompat__media--ph') + '" href="' + esc(url) + '" tabindex="-1" aria-hidden="true" data-quick="' + esc(quickKey(p)) + '">' +
                (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title || '') + '" loading="lazy">' : '<svg viewBox="0 0 24 24" fill="none" width="34" height="34" aria-hidden="true"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.6"/><circle cx="12" cy="12" r="3.5" stroke="currentColor" stroke-width="1.6"/></svg>') +
              '</a>' +
              '<div class="prodcompat__body">' +
                '<a class="prodcompat__name" href="' + esc(url) + '" title="' + esc(p.title || '') + '">' + esc(title) + '</a>' +
                '<div class="prodcompat__meta">' + productStockChip(p) + '<span class="prodcompat__price mono">' + esc(price) + '</span></div>' +
                qtyChipHtml(p) +
                '<div class="prodcompat__actions">' +
                  (p.available !== false ? '<button class="btn btn--primary" type="button" data-strip-add>' + T('Add to cart') + '</button>' : '') +
                  '<a class="prodcompat__view" href="' + esc(url) + '" data-quick="' + esc(quickRegister(p, { price: price, img: img, url: url, badge: '' })) + '">' + T('View details') + '</a>' +
                '</div>' +
              '</div>';
            var addBtn = card.querySelector('[data-strip-add]');
            if (addBtn) {
              addBtn.addEventListener('click', function () {
                addBtn.disabled = true;
                addBtn.textContent = T('Adding…');
                addProductToCart(p)
                  .then(function () { return loadCart(); })
                  .then(function (cart) {
                    addBtn.textContent = T('Added OK');
                    bumpCartCount(cart.item_count);
                    var chip = card.querySelector('[data-inqty]');
                    if (chip) {
                      var q = qtyInCart(p);
                      chip.innerHTML = T('In cart:') + ' <strong>' + q + '</strong>';
                      chip.hidden = !q;
                      chip.classList.toggle('inqty--zero', !q);
                    }
                    showRowConfirm(card);
                    setTimeout(function () { addBtn.textContent = T('Add to cart'); addBtn.disabled = false; }, 1800);
                  })
                  .catch(function () {
                    addBtn.textContent = T('Add to cart');
                    addBtn.disabled = false;
                  });
              });
            }
            hydratePriceInto(p, card.querySelector('.prodcompat__price'));
            ensureHoverAlt(p, card);
            return card;
          };
          var realNames = groups.filter(function (g) { return !isMaintenanceType(g); });
          var uniNames = groups.filter(function (g) { return isMaintenanceType(g); });
          /* when the database has no OTHER model-specific parts, saying
             "8 more parts for your model" over a wall of cleaning items
             reads as overselling. Say what it really is. */
          var stripTitle = box.querySelector('.prodcompat__title');
          if (stripTitle && !realNames.length && uniNames.length) {
            var mSpan = stripTitle.querySelector('[data-product-compat-model]');
            var mTxt = mSpan ? mSpan.textContent : T('your model');
            stripTitle.innerHTML = T('Recommended for your {m} repair').replace('{m}', '<span class="mono">' + esc(mTxt) + '</span>');
            var stripNote = box.querySelector('[data-prodcompat-note]');
            if (!stripNote) {
              stripNote = document.createElement('p');
              stripNote.className = 'prodcompat__note';
              stripNote.setAttribute('data-prodcompat-note', '');
              stripTitle.insertAdjacentElement('afterend', stripNote);
            }
            stripNote.textContent = T('This page has the model-specific part. The items below suit any machine and help a fresh repair last: clean the path, lubricate the mechanism, protect the new part.');
          }
          var stripMain = list, stripSide = null;
          if (realNames.length && uniNames.length) {
            list.classList.add('prodcompat__list--withside');
            stripMain = document.createElement('div');
            stripMain.className = 'ccols__main';
            stripSide = document.createElement('aside');
            stripSide.className = 'ccols__side prodcompat__siderail';
            stripSide.setAttribute('aria-label', T('Universal service items'));
            list.appendChild(stripMain);
            list.appendChild(stripSide);
          } else {
            list.classList.remove('prodcompat__list--withside');
          }
          function buildCol(g, isUniversal) {
            var col = document.createElement('div');
            col.className = 'prodcompat__col' + (isUniversal ? ' prodcompat__col--universal' : '');
            var gh = document.createElement('button');
            gh.type = 'button';
            gh.className = 'prodcompat__group prodcompat__group--btn';
            gh.innerHTML = (isUniversal
              ? esc(catLabelI18n(g)) + ' <span class="prodcompat__group-count mono">' + byName[g].length + '</span><span class="prodcompat__group-sub">' + T('Universal add-ons, suit any machine') + '</span>'
              : esc(g) + ' <span class="prodcompat__group-count mono">' + byName[g].length + '</span><span class="prodcompat__group-sub prodcompat__group-sub--confirmed">&#10003; ' + T('Confirmed for your model') + '</span>');
            gh.title = T('Show only') + ' ' + catLabelI18n(g);
            gh.addEventListener('click', function () {
              var solo = list.classList.contains('prodcompat__list--solo') && col.classList.contains('is-active');
              list.classList.toggle('prodcompat__list--solo', !solo);
              list.querySelectorAll('.prodcompat__col').forEach(function (c) { c.classList.remove('is-active'); });
              if (!solo) col.classList.add('is-active');
            });
            col.appendChild(gh);
            var cards = document.createElement('div');
            cards.className = 'prodcompat__cards';
            byName[g].forEach(function (p) { cards.appendChild(makeCard(p)); });
            col.appendChild(cards);
            return col;
          }
          /* same combined-singles behaviour as the main finder: categories
             with one match share a single top row instead of stacking */
          /* mechanical columns always last; single-match categories share
             one combined top row (Belt | Gear | Roller); a LONE single
             keeps its own column but still renders BEFORE mechanical */
          var mechNames = realNames.filter(function (g) { return isMechanicalType(g); });
          var nonMechNames = realNames.filter(function (g) { return !isMechanicalType(g); });
          var singleNames = nonMechNames.filter(function (g) { return byName[g].length === 1; });
          var multiNames = nonMechNames.filter(function (g) { return byName[g].length > 1; });
          if (singleNames.length === 1) { multiNames = nonMechNames.slice(); singleNames = []; }
          multiNames = multiNames.concat(mechNames);
          var queue = [];
          if (singleNames.length) {
            var combo = document.createElement('div');
            combo.className = 'prodcompat__col prodcompat__col--combined';
            var ct = document.createElement('div');
            ct.className = 'prodcompat__group';
            ct.innerHTML = singleNames.map(esc).join(' &middot; ') +
              ' <span class="prodcompat__group-count mono">' + singleNames.length + '</span>' +
              '<span class="prodcompat__group-sub prodcompat__group-sub--confirmed">&#10003; ' + T('Confirmed for your model') + '</span>';
            combo.appendChild(ct);
            var comboCards = document.createElement('div');
            comboCards.className = 'prodcompat__cards prodcompat__cards--combined';
            singleNames.forEach(function (g) {
              var cell = document.createElement('div');
              cell.className = 'csec__single';
              var head = document.createElement('div');
              head.className = 'csec__single-head csec__single-head--static';
              head.textContent = g;
              cell.appendChild(head);
              cell.appendChild(makeCard(byName[g][0]));
              comboCards.appendChild(cell);
            });
            combo.appendChild(comboCards);
            queue.push({ el: combo, count: singleNames.length, label: null });
          }
          multiNames.forEach(function (g) {
            queue.push({ el: buildCol(g, false), count: byName[g].length, label: g });
          });
          queue.forEach(function (entry, qi) {
            stripMain.appendChild(entry.el);
            if (qi < queue.length - 1) {
              var nxt = queue[qi + 1];
              var pcue = document.createElement('div');
              pcue.className = 'seccue';
              pcue.innerHTML = '&darr; ' + T('{n} more below in <strong>{c}</strong>').replace('{n}', nxt.count).replace('{c}', esc(nxt.label || T('more categories')));
              stripMain.appendChild(pcue);
            }
          });
          uniNames.forEach(function (g) {
            (stripSide || stripMain).appendChild(buildCol(g, true));
          });
          list.setAttribute('data-seccount', Math.min(Object.keys(byName).length, 4));
          var realCats = Object.keys(byName).filter(function (k) { return !isMaintenanceType(k); });
          if (!realCats.length && Object.keys(byName).length) {
            var pnote = document.createElement('p');
            pnote.className = 'compat__universal-note';
            pnote.innerHTML = T('No other model-specific wear parts are listed for this model. Below are <strong>universal service items</strong> that suit any machine.');
            list.insertBefore(pnote, list.firstChild);
          }
          /* compact companion row under the buy box: first 3 model-specific parts */
          var mini = document.querySelector('[data-compat-minirow]');
          if (mini) {
            var realMinis = others.filter(function (p) { return !isMaintenanceType(getType(p)); }).slice(0, 3);
            var minis = realMinis.length ? realMinis : others.slice(0, 3);
            var miniLabel = realMinis.length
              ? '&#10003; ' + T('Also confirmed for {m}:').replace('{m}', '<strong class="mono">' + esc(match.brand + ' ' + match.model) + '</strong>')
              : T('Handy universal add-ons, suit any machine:');
            if (minis.length) {
              mini.innerHTML = '<span class="minirow__label">' + miniLabel + '</span>' +
                minis.map(function (p) {
                  var mimg = p.featured_image || p.image || (p.images && p.images[0]) || '';
                  if (typeof mimg === 'object' && mimg) mimg = mimg.src || mimg.url || '';
                  if (mimg && mimg.indexOf('//') === 0) mimg = 'https:' + mimg;
                  return '<a class="minirow__item" href="' + esc(p.url) + '">' +
                    (mimg ? '<img src="' + esc(mimg) + '" alt="" loading="lazy" width="44" height="44" onerror="this.remove()">' : '') +
                    '<span>' + esc(stripLeadingProductCode(p.title)) + '</span></a>';
                }).join('') +
                '<a class="minirow__all" href="#wsp-prodcompat">' + T('All {n}').replace('{n}', others.length) + ' &darr;</a>';
              mini.hidden = false;
            }
          }
          var jw = document.querySelector('[data-compat-jumpwait]');
          if (jw) jw.hidden = true;
          var jump = document.querySelector('[data-compat-jump]');
          if (jump) {
            var jt = jump.querySelector('[data-compat-jump-text]');
            if (jt) {
              var realCount = others.filter(function (p) { return !isMaintenanceType(getType(p)); }).length;
              jt.textContent = realCount
                ? (realCount === 1 ? T('See all {n} part for {m}') : T('See all {n} parts for {m}'))
                    .replace('{n}', realCount).replace('{m}', match.brand + ' ' + match.model)
                : T('See {n} universal service items (suit any machine)').replace('{n}', others.length);
            }
            jump.hidden = false;
          }
        })
        .catch(function (err) {
          try { console.error('[WSP] product strip render error:', err && err.stack || err); } catch (e) {}
          /* Final failure - keep the visitor moving, and let them retry. */
          box.hidden = false;
          box.classList.remove('is-loading');
          var jw2 = document.querySelector('[data-compat-jumpwait]');
          if (jw2) jw2.hidden = true;
          list.innerHTML = '<div class="prodcompat__fallback"><p>' + T('Repairing a <strong class="mono">{m}</strong>? The database is busy right now.').replace('{m}', esc(match.brand + ' ' + match.model)) + '</p><div class="prodcompat__fallback-actions"><button class="btn btn--primary" type="button" data-strip-retry>' + T('Try again') + '</button><a class="btn btn--outline" href="' + esc(COMPAT_URL) + '?brand=' + encodeURIComponent(match.brand) + '&model=' + encodeURIComponent(match.model) + '">' + T('Open the full finder') + '</a></div></div>';
          var rb = list.querySelector('[data-strip-retry]');
          if (rb) rb.addEventListener('click', go);
        });
      }
      go();
    }

    var awaitingIndexRecovery = false;
    function stripIndexFailure() {
      box.hidden = false;
      box.classList.remove('is-loading');
      list.innerHTML = '<div class="prodcompat__fallback"><p>' + ERROR_MSG_T() + '</p><button class="btn btn--outline" type="button" data-strip-db-retry>' + T('Try again') + '</button></div>';
      var retry = list.querySelector('[data-strip-db-retry]');
      if (retry) retry.addEventListener('click', function () {
        retry.disabled = true;
        retry.textContent = T('Checking database…');
        loadDb();
        onDbReady(function (ok) { if (!ok) stripIndexFailure(); });
      });
      if (!awaitingIndexRecovery) {
        awaitingIndexRecovery = true;
        onDbRecovered(function () { awaitingIndexRecovery = false; startStrip(); });
      }
    }
    onDbReady(function (ok) {
      if (ok) startStrip();
      else stripIndexFailure();
    });
  }

  /* ================================================================
     CONTACT PAGE - photo attachments
     Shopify contact forms cannot carry attachments, so photos are
     resized in the browser and posted to the Apps Script backend
     (action=uploadPhotos). The returned reference ID is appended to
     the message body, so the email and the photos can be matched.
     Falls back gracefully: the message always sends.
     ================================================================ */
  function resizeImage(file, maxDim) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onerror = reject;
      reader.onload = function () {
        var img = new Image();
        img.onerror = reject;
        img.onload = function () {
          var scale = Math.min(1, maxDim / Math.max(img.width, img.height));
          var canvas = document.createElement('canvas');
          canvas.width = Math.round(img.width * scale);
          canvas.height = Math.round(img.height * scale);
          canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
          resolve(canvas.toDataURL('image/jpeg', 0.82));
        };
        img.src = reader.result;
      };
      reader.readAsDataURL(file);
    });
  }


  /* cart page: offer cleaning / maintenance add-ons under the summary */
  var CART_UPSELL_CATALOG = [
    { family: 'cdCare', handle: 'cl02-10-laser-lens-cleaner-1-ml', label: 'CL02-10 Laser Lens Cleaner · 1 ml', descriptionKey: 'laser_cleaner_description', requires: 'hasCdRepair' },
    { family: 'videoCare', handle: 'f0023-dat-video-head-cleaner-10-ml', label: 'DAT & Video Head Cleaner · 10 ml', descriptionKey: 'video_head_cleaner_description', requires: 'hasVideoHeadRepair' },
    { family: 'recordingMedia', handle: 'blank-audio-media-recording-cassette-mitsubichi-90-pack-2', label: 'Mitsubishi C90 · Pack of 2', descriptionKey: 'mitsubishi_c90_description', requires: 'hasCassetteRepair' },
    { family: 'recordingMedia', handle: 'blank-audio-media-recording-cassette-maxell-ur90', label: 'Maxell UR90 · 90 min', descriptionKey: 'maxell_ur90_description', requires: 'hasCassetteRepair' },
    { family: 'recordingMedia', handle: 'blank-audio-media-recording-cassette-maxell-ur60', label: 'Maxell UR60 · 60 min', descriptionKey: 'maxell_ur60_description', requires: 'hasCassetteRepair' },
    { family: 'beltCleaning', handle: 'melted-belt-cleaner-spray-50-ml', label: 'Melted Belt Cleaner · 50 ml', descriptionKey: 'belt_cleaner_description', requires: 'hasBeltRepair' },
    { family: 'turntableCare', handle: 'tonearm-cueing-lever-damping-oil-300-000-cst-300k-1-ml', label: 'Tonearm Cueing Damping Oil 300k · 1 ml', descriptionKey: 'tonearm_damping_oil_description', requires: 'hasTurntableRepair' },
    { family: 'lubrication', handle: 'gr002-metal-gears-and-levers-7-ml-shell-gadus', label: 'Shell Gadus Grease · 7 ml', descriptionKey: 'shell_gadus_grease_description', requires: 'always' },
    { family: 'lubrication', handle: 'black-molybdenum-mos-grease-for-audio-metal-gears-mechanism', label: 'Metal Gear & Lever Grease · 10 g', descriptionKey: 'gear_grease_description', requires: 'always' },
    { family: 'lubrication', handle: 'f0035-advanced-fully-synthetic-oil-1-ml', label: 'Full Synthetic Oil · 1 ml', descriptionKey: 'full_synthetic_oil_description', requires: 'always' },
    { family: 'lubrication', handle: 'f0031-advanced-full-synthetic-oil-1-ml', label: 'Titanium Synthetic Oil · 1 ml', descriptionKey: 'titanium_oil_description', requires: 'always' },
    { family: 'lubrication', handle: 'f0036-super-adhesive-oil', label: 'Super Adhesive Oil · 1 ml', descriptionKey: 'adhesive_oil_description', requires: 'always' }
  ];

  var CART_UPSELL_FAMILY_ORDER = ['cdCare', 'videoCare', 'recordingMedia', 'beltCleaning', 'turntableCare', 'lubrication'];

  function cartUpsellNormalizedText(item) {
    if (!item) return '';
    var tags = Array.isArray(item.tags) ? item.tags.join(' ') : (item.tags || '');
    return [item.handle, item.type, tags, item.sku, item.title].join(' ').toLowerCase();
  }

  function classifyCartRepairs(items) {
    var normalizedItems = (items || []).map(cartUpsellNormalizedText);
    var text = normalizedItems.join(' ');
    var hasCdRepair = /(^|[^a-z])(cd\s*player|compact\s*disc|cdp[-\s_]?\w*)/.test(text) || /cleaning_maintenance_cd/.test(text);
    var hasVideoHeadRepair = /(^|[^a-z])(dat\s*(deck|recorder|player)|vcr|vhs|s[-\s]?vhs|vhs[-\s]?c|betamax|video\s*8|video\s*cassette|camcorder)([^a-z]|$)/.test(text);
    var hasTurntableRepair = /(turntable|record\s*player|tonearm|cueing\s*(lever|mechanism)|phonograph)/.test(text);
    var hasCassetteRepair = normalizedItems.some(function (itemText) {
      var isCassetteEquipment = /(cassette|tape\s*deck|boombox|radio[-\s]*cassette)/.test(itemText);
      var isPersonalPlayer = /(walkman|personal\s+cassette\s+player)/.test(itemText);
      return isCassetteEquipment && !isPersonalPlayer;
    });
    var hasBeltRepair = /(belt|riemen|courroie|cinghia|curea|(^|[^a-z])rem([^a-z]|$)|(^|\s)bk[-_])/.test(text);
    return {
      hasCdRepair: hasCdRepair,
      hasVideoHeadRepair: hasVideoHeadRepair,
      hasTurntableRepair: hasTurntableRepair,
      hasCassetteRepair: hasCassetteRepair,
      hasBeltRepair: hasBeltRepair,
      hasGenericRepair: !hasCdRepair && !hasCassetteRepair && !hasBeltRepair
    };
  }

  function buildCartOfferGroups(productsByHandle, cartHandles, flags) {
    var products = productsByHandle || {};
    var handles = cartHandles instanceof Set ? cartHandles : new Set(cartHandles || []);
    var seen = new Set();
    var grouped = {};

    CART_UPSELL_CATALOG.forEach(function (entry) {
      if (entry.requires !== 'always' && !flags[entry.requires]) return;
      if (handles.has(entry.handle) || seen.has(entry.handle)) return;
      var product = products instanceof Map ? products.get(entry.handle) : products[entry.handle];
      if (!product) return;
      var variants = Array.isArray(product.variants) ? product.variants : [];
      var selectedVariant = variants.find(function (variant) { return variant && variant.available !== false; });
      if (product.available === false || !selectedVariant) return;
      seen.add(entry.handle);
      if (!grouped[entry.family]) grouped[entry.family] = [];
      grouped[entry.family].push({
        family: entry.family,
        handle: entry.handle,
        label: entry.label,
        descriptionKey: entry.descriptionKey,
        product: product,
        selectedVariant: selectedVariant
      });
    });

    return CART_UPSELL_FAMILY_ORDER.filter(function (family) {
      return grouped[family] && grouped[family].length;
    }).map(function (family) {
      return { key: family, products: grouped[family] };
    });
  }

  function cartUpsellStoreRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function cartUpsellCopy(box, key, fallback) {
    var camelKey = String(key || '').replace(/[_-]+([a-z])/g, function (_, letter) { return letter.toUpperCase(); });
    var attr = 'copy' + camelKey.charAt(0).toUpperCase() + camelKey.slice(1);
    return (box && box.dataset && box.dataset[attr]) || fallback;
  }

  function cartUpsellContextHeading(box) {
    return cartUpsellCopy(box, 'genericRepairHeading', 'Useful for your repair');
  }

  function cartUpsellDomItems() {
    return Array.prototype.map.call(document.querySelectorAll('[data-cart-line]'), function (line) {
      var d = line.dataset || {};
      return {
        handle: d.cartProductHandle || '',
        type: d.cartProductType || '',
        tags: String(d.cartProductTags || '').split('||').filter(Boolean),
        sku: d.cartProductSku || '',
        title: d.cartProductTitle || ''
      };
    });
  }

  function fetchCartUpsellProduct(handle) {
    return fetch(cartUpsellStoreRoot() + 'products/' + encodeURIComponent(handle) + '.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(function (response) {
      if (!response.ok) throw new Error('product_request_failed');
      return response.json();
    }).then(function (product) {
      product.handle = product.handle || handle;
      return product;
    });
  }

  function cartUpsellProductImage(product) {
    var image = product && product.featured_image;
    if (image && typeof image === 'object') image = image.url || image.src;
    if (!image && product && product.images && product.images[0]) {
      image = typeof product.images[0] === 'object' ? (product.images[0].src || product.images[0].url) : product.images[0];
    }
    return image || '';
  }

  function setCartUpsellButtonState(button, state) {
    if (!button) return;
    var labels = {
      idle: button.dataset.labelIdle || '+ Add',
      adding: button.dataset.labelAdding || 'Adding…',
      added: button.dataset.labelAdded || 'Added ✓',
      error: button.dataset.labelUnavailable || 'Unavailable'
    };
    button.dataset.cartUpsellState = state;
    button.disabled = state === 'adding' || state === 'added';
    button.textContent = labels[state] || labels.idle;
  }

  function updateCartCountElements(cart) {
    var count = cart && Number(cart.item_count);
    if (!Number.isFinite(count)) return;
    document.querySelectorAll('[data-cart-count]').forEach(function (element) {
      element.textContent = String(count);
      if (element.classList) element.classList.toggle('is-empty', count === 0);
    });
  }

  var cartRefreshGeneration = 0;
  function refreshCartSection() {
    var generation = ++cartRefreshGeneration;
    var cartRoot = document.querySelector('[data-cart-section-id]');
    var sectionId = cartRoot && cartRoot.getAttribute('data-cart-section-id');
    var root = cartUpsellStoreRoot();
    var sectionRequest = sectionId ? fetch(root + 'cart?sections=' + encodeURIComponent(sectionId), {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(function (response) {
      if (!response.ok) throw new Error('cart_section_request_failed');
      return response.json();
    }).then(function (sections) {
      if (generation !== cartRefreshGeneration) return false;
      var sectionHtml = sections && sections[sectionId];
      var currentSection = document.getElementById('shopify-section-' + sectionId);
      if (!sectionHtml || !currentSection) return false;
      var parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
      var replacement = parsed.getElementById('shopify-section-' + sectionId) || parsed;
      var currentItems = currentSection.querySelector('.carttable tbody');
      var newItems = replacement.querySelector('.carttable tbody');
      if (!currentItems || !newItems) return false;
      /* Keep the actual support/discount/shipping forms and their listeners,
         drafts and photo state. Only replace server-owned items and totals.
         Read quantities at response time so edits made during fetch survive. */
      var drafts = Object.create(null);
      currentItems.querySelectorAll('[data-cart-item-key]').forEach(function (row) {
        var input = row.querySelector('input[name="updates[]"]');
        if (input && input.value !== input.defaultValue) drafts[row.getAttribute('data-cart-item-key')] = input.value;
      });
      newItems.querySelectorAll('[data-cart-item-key]').forEach(function (row) {
        var key = row.getAttribute('data-cart-item-key');
        var input = row.querySelector('input[name="updates[]"]');
        if (input && Object.prototype.hasOwnProperty.call(drafts, key)) input.value = drafts[key];
      });
      currentItems.replaceWith(newItems);
      ['.cartpage__subtotal', '.cartfs'].forEach(function (selector) {
        var current = currentSection.querySelector(selector), next = replacement.querySelector(selector);
        if (current && next) current.replaceWith(next);
      });
      initCartUpsell();
      return true;
    }).catch(function () { return false; }) : Promise.resolve(false);

    var cartRequest = fetch(root + 'cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(function (response) {
      if (!response.ok) throw new Error('cart_request_failed');
      return response.json();
    }).then(function (cart) {
      if (generation !== cartRefreshGeneration) return null;
      updateCartCountElements(cart);
      return cart;
    }).catch(function () { return null; });

    return Promise.all([sectionRequest, cartRequest]);
  }

  function addCartUpsellVariant(variantId, button, refreshFn) {
    if (!button || button.disabled || button.dataset.cartUpsellPending === '1') return Promise.resolve(false);
    button.dataset.cartUpsellPending = '1';
    setCartUpsellButtonState(button, 'adding');
    return fetch(cartUpsellStoreRoot() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    }).then(function (response) {
      if (!response.ok) throw new Error('cart_add_failed');
      return response.json();
    }).then(function () {
      setCartUpsellButtonState(button, 'added');
      var refresh = refreshFn || refreshCartSection;
      return Promise.resolve().then(function () {
        return refresh();
      }).catch(function () {
        return null;
      }).then(function () {
        return true;
      });
    }).catch(function (error) {
      delete button.dataset.cartUpsellPending;
      setCartUpsellButtonState(button, 'error');
      throw error;
    });
  }

  function renderCartUpsellGroups(box, wrap, groups, flags) {
    var addLabel = cartUpsellCopy(box, 'add', '+ Add');
    var addingLabel = cartUpsellCopy(box, 'adding', 'Adding…');
    var addedLabel = cartUpsellCopy(box, 'added', 'Added ✓');
    var unavailableLabel = cartUpsellCopy(box, 'unavailable', 'Unavailable');
    var descriptions = {};
    CART_UPSELL_CATALOG.forEach(function (entry) {
      descriptions[entry.descriptionKey] = cartUpsellCopy(box, entry.descriptionKey, '');
    });

    var offers = groups.reduce(function (items, group) {
      return items.concat(group.products);
    }, []);
    var cards = offers.map(function (entry) {
        var product = entry.product;
        var variant = entry.selectedVariant;
        var image = cartUpsellProductImage(product);
        var url = cartUpsellStoreRoot() + 'products/' + encodeURIComponent(entry.handle);
        return '<article class="cartupsell__item">' +
          '<a class="cartupsell__media" href="' + esc(url) + '">' +
            (image ? '<img src="' + esc(image) + '" alt="' + esc(product.title || T(entry.label)) + '" width="44" height="44" loading="lazy">' : '') +
          '</a>' +
          '<span class="cartupsell__text">' +
            '<a class="cartupsell__name" href="' + esc(url) + '">' + esc(T(entry.label)) + '</a>' +
            '<span class="cartupsell__description">' + esc(descriptions[entry.descriptionKey]) + '</span>' +
          '</span>' +
          '<span class="cartupsell__price mono">' + esc(fmtPrice(variant.price, true)) + '</span>' +
          '<button class="btn btn--outline btn--sm cartupsell__add" type="button" data-cart-upsell-add="' + esc(variant.id) + '"' +
            ' data-label-idle="' + esc(addLabel) + '" data-label-adding="' + esc(addingLabel) + '"' +
            ' data-label-added="' + esc(addedLabel) + '" data-label-unavailable="' + esc(unavailableLabel) + '">' + esc(addLabel) + '</button>' +
        '</article>';
    }).join('');
    var html = '<p class="cartupsell__title">' + esc(cartUpsellContextHeading(box)) + '</p>' +
      '<div class="cartupsell__grid">' + cards + '</div>';
    wrap.innerHTML = html;

    wrap.querySelectorAll('[data-cart-upsell-add]').forEach(function (button) {
      button.addEventListener('click', function () {
        addCartUpsellVariant(button.getAttribute('data-cart-upsell-add'), button).catch(function () {});
      });
    });
  }

  function initCartUpsell() {
    var box = document.querySelector('[data-cart-upsell]');
    var wrap = box && box.querySelector('[data-cart-upsell-items]');
    if (!box || !wrap || box.dataset.cartUpsellLoading === '1') return;

    var cartItems = cartUpsellDomItems();
    var cartHandles = new Set(cartItems.map(function (item) { return item.handle; }).filter(Boolean));
    var flags = classifyCartRepairs(cartItems);
    var eligible = CART_UPSELL_CATALOG.filter(function (entry) {
      return !cartHandles.has(entry.handle) && (entry.requires === 'always' || flags[entry.requires]);
    });
    box.dataset.cartUpsellLoading = '1';

    Promise.all(eligible.map(function (entry) {
      return fetchCartUpsellProduct(entry.handle).catch(function () { return null; });
    })).then(function (results) {
      var products = {};
      results.forEach(function (product, index) {
        if (product) products[eligible[index].handle] = product;
      });
      var groups = buildCartOfferGroups(products, cartHandles, flags);
      if (!groups.length) {
        box.hidden = true;
        return;
      }
      renderCartUpsellGroups(box, wrap, groups, flags);
      box.hidden = false;
    }).catch(function () {
      box.hidden = true;
    }).then(function () {
      delete box.dataset.cartUpsellLoading;
    });
  }

  function initSupportPhotos() {
    var wrap = document.querySelector('[data-support-photos]');
    if (!wrap) return;
    var input = wrap.querySelector('[data-photo-input]');
    var previews = wrap.querySelector('[data-photo-previews]');
    var status = wrap.querySelector('[data-photo-status]');
    var form = wrap.closest('form');
    if (!input || !form) return;
    var MAX = 3;

    function setStatus(text, kind) {
      if (!status) return;
      status.textContent = text || '';
      status.className = 'support__photo-status' + (kind ? ' is-' + kind : '');
    }

    input.addEventListener('change', function () {
      if (input.files.length > MAX) {
        setStatus(T('Please choose up to {n} photos. We kept the first {n}.').split('{n}').join(MAX), 'warn');
      } else {
        setStatus('', '');
      }
      if (!previews) return;
      previews.innerHTML = '';
      Array.prototype.slice.call(input.files, 0, MAX).forEach(function (file) {
        var url = URL.createObjectURL(file);
        var el = document.createElement('span');
        el.className = 'support__photo-thumb';
        el.innerHTML = '<img src="' + url + '" alt="">';
        previews.appendChild(el);
      });
    });

    var uploading = false;
    form.addEventListener('submit', function (e) {
      var files = Array.prototype.slice.call(input.files, 0, MAX);
      if (!files.length || uploading || form.dataset.photosDone) return; /* plain submit */
      if (!BACKEND) {
        appendNote('Customer selected photos but upload is not configured. Ask them to reply to the confirmation email with photos.');
        return; /* let the form submit */
      }
      e.preventDefault();
      uploading = true;
      setStatus('Uploading ' + files.length + ' photo' + (files.length > 1 ? 's' : '') + '&hellip;', 'busy');
      var submitBtn = form.querySelector('[data-support-submit]');
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = T('Uploading photos…'); }

      Promise.all(files.map(function (f) { return resizeImage(f, 1280); }))
        .then(function (images) {
          return fetch(BACKEND, {
            method: 'POST',
            /* text/plain keeps this a "simple" request - no CORS preflight,
               which Apps Script web apps cannot answer */
            headers: { 'Content-Type': 'text/plain;charset=utf-8' },
            body: JSON.stringify({
              action: 'uploadPhotos',
              name: (form.querySelector('[name="contact[name]"]') || {}).value || '',
              email: (form.querySelector('[name="contact[email]"]') || {}).value || '',
              model: (form.querySelector('[name="contact[model]"]') || {}).value || '',
              message: (form.querySelector('[name="contact[body]"]') || {}).value || '',
              images: images
            })
          }).then(function (r) { return r.json(); });
        })
        .then(function (res) {
          if (res && res.id) {
            appendNote('Photos uploaded, reference ' + res.id + '.' + (res.link ? ' ' + res.link : ''));
            setStatus(T('Photos sent to our support inbox.'), 'ok');
          }
          else appendNote('Customer selected photos but the upload could not be confirmed. Ask them to reply to the confirmation email with photos.');
        })
        .catch(function () {
          appendNote('Customer selected photos but the upload failed. Ask them to reply to the confirmation email with photos.');
        })
        .then(function () {
          form.dataset.photosDone = '1';
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = T('Send message'); }
          form.submit();
        });
    });

    function appendNote(note) {
      var body = form.querySelector('[name="contact[body]"]');
      if (body) body.value = body.value.replace(/\n*\[WSP\][^\n]*$/, '') + '\n\n[WSP] ' + note;
    }
  }

  /* ================================================================
     boot
     ================================================================ */
  function boot() {
   try {
    var compatPage = document.querySelector('[data-compat-page]');
    var finders = document.querySelectorAll('[data-finder]');
    var inlineFinder = null;
    finders.forEach(function (root) {
      var isInline = root.getAttribute('data-finder-mode') === 'inline' || (compatPage && compatPage.contains(root));
      if (isInline) inlineFinder = root;
      else initNavigateFinder(root);
    });
    if (compatPage) initCompatPage(inlineFinder);
    initFitcheck();
    initProductCompat();
    initSupportPhotos();
    initHeaderFinder();
    initCartUpsell();
    fillLineArt();
    initCategoryStrip();
    initSubcatGrid();
    (function () {
      var jw = document.querySelector('[data-compat-jumpwait]');
      if (jw && !document.querySelector('[data-product-compat]')) jw.hidden = true;
      /* safety: never let the hint linger forever */
      if (jw) setTimeout(function () { if (!jw.hidden && document.querySelector('[data-compat-jump]') && document.querySelector('[data-compat-jump]').hidden) jw.hidden = true; }, 15000);
    })();
    if (finders.length) {
      loadDb();
    } else if (document.querySelector('[data-fitcheck]') || document.querySelector('[data-product-compat]')) {
      /* product pages: don't block first paint with the full database --
         load it when the person touches the fit checker, or when the
         browser is idle */
      var lazyDone = false;
      function lazyDb() { if (lazyDone) return; lazyDone = true; loadDb(); }
      var fcIn = document.querySelector('[data-fitcheck-input]');
      if (fcIn) {
        fcIn.addEventListener('focus', lazyDb, { once: true });
        fcIn.addEventListener('pointerdown', lazyDb, { once: true });
      }
      if ('requestIdleCallback' in window) {
        requestIdleCallback(lazyDb, { timeout: 5000 });
      } else {
        setTimeout(lazyDb, 3500);
      }
    }
    /* Expose memory reader for global.js */
    initDescToggle();
    window.WSPMemory = { load: memoryLoad, save: memorySave };
   } catch (bootErr) {
     try { console.error('[WSP] finder boot() FAILED:', bootErr && bootErr.stack || bootErr); } catch (e) {}
   }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
